// Template data configurations for preview functionality
export const templateData = {
  pizza: {
    "widgets": [
      {
        "type": "BasicNav",
        "data": {
          "logoUrl": "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=200&h=80&fit=crop",
          "logoText": "The Cozy Corner",
          "items": [
            { "id": "1", "label": "Menu", "url": "/menu", "isEnabled": true },
            { "id": "2", "label": "Our Story", "url": "/our-story", "isEnabled": true },
            { "id": "3", "label": "Blog", "url": "/blog", "isEnabled": true },
            { "id": "4", "label": "Gallery", "url": "/gallery", "isEnabled": true },
            { "id": "5", "label": "Events", "url": "/events", "isEnabled": true },
            { "id": "6", "label": "Contact", "url": "/contact", "isEnabled": true }
          ],
          "backgroundColor": "#000000",
          "textColor": "#ffffff",
          "contactInfo": "Call us: (555) COZY-123",
          "showSearchIcon": true,
          "showCartIcon": true,
          "showOrderButton": true,
          "orderButtonText": "Order Takeout",
          "orderButtonColor": "#EF4322"
        }
      },
      {
        "type": "BasicBanner",
        "data": {
          "slides": [
            {
              "id": "slide-1",
              "title": "Sample Title One",
              "subtitle": "Sample Subtitle One",
              "description": "This is a sample description for slide one. It is placeholder text only.",
              "backgroundImage": "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/2b/25/4b/34/food-menu-assortment.jpg?w=900&h=500&s=1",
              "backgroundColor": "#333333",
              "textAlignment": "center",
              "textColor": "#ffffff",
              "overlayOpacity": 0.5,
              "overlayColor": "rgba(0,0,0,0.5)",
              "ctaButtons": [
                {
                  "id": "cta-1",
                  "text": "Sample Button One",
                  "url": "/sample-one",
                  "variant": "primary",
                  "backgroundColor": "#555555",
                  "color": "#ffffff",
                  "visible": true
                }
              ]
            },
            {
              "id": "slide-2",
              "title": "Sample Title Two",
              "subtitle": "Sample Subtitle Two",
              "description": "This is a sample description for slide two. It is placeholder text only.",
              "backgroundImage": "https://restaurantindia.s3.ap-south-1.amazonaws.com/s3fs-public/2025-02/BeFunky-collage.1%20%2824%29.jpg",
              "backgroundColor": "#444444",
              "textAlignment": "left",
              "textColor": "#ffffff",
              "overlayOpacity": 0.4,
              "overlayColor": "rgba(0,0,0,0.4)",
              "ctaButtons": [
                {
                  "id": "cta-2",
                  "text": "Sample Button Two",
                  "url": "/sample-two",
                  "variant": "secondary",
                  "backgroundColor": "#666666",
                  "color": "#ffffff",
                  "visible": true
                }
              ]
            }
          ]
        }
      },
      {
        "type": "BasicPopularItems",
        "data": {
          "content": "<h2 class=\"text-3xl md:text-4xl font-bold text-gray-900 mb-4\">Family <span class=\"text-orange-600\">Favorites</span></h2><p class=\"text-gray-600 text-lg max-w-2xl mx-auto\">The comfort food classics that keep our guests coming back for more</p>",
          "backgroundColor": "#ffffff",
          "selectedItemIds": [],
          "emptyStateContent": "<h3 class=\"text-lg sm:text-xl font-semibold mb-2\">Comfort Food Coming Soon</h3><p class=\"text-sm sm:text-base max-w-md\">Our beloved family favorites will be featured here.</p>",
          "showRating": true,
          "menuData": [{
            "pk_id": "f03c1c36-597d-4afc-ab37-3700b0f70d35",
            "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
            "restaurant_parent_id": null,
            "sku_id": "PIZ0001",
            "name": "Classic Margherita",
            "category": "Entrees",
            "supplier": "",
            "brand": "",
            "modifiers": "Classic Margherita addon,addon",
            "unit": "",
            "taxable": "",
            "external_id": "",
            "bar_code": "",
            "description": "A Margherita pizza is a classic Italian dish known for its simple yet flavorful ingredients. It typically features a thin, crisp crust topped with a vibrant tomato sauce made from fresh, ripe tomatoes. The pizza is adorned with slices of fresh mozzarella cheese that melt beautifully during baking, creating a creamy texture. Fresh basil leaves are added on top, providing a fragrant, herbal aroma and a splash of color. Often finished with a drizzle of extra virgin olive oil, the Margherita pizza embodies a harmonious balance of fresh, high-quality ingredients, highlighting the essence of traditional Italian cuisine.",
            "comment": "",
            "cost": "",
            "price": "11",
            "large_price": "11",
            "indining_price": "9",
            "indining_large_price": "11",
            "quantity": "",
            "min_quantity": "",
            "max_quantity": "",
            "countable": "",
            "use_weighing_scale": "",
            "item_type": "",
            "duration": "",
            "discounts": "",
            "resources": "",
            "service_providers": "",
            "printer_type": "",
            "deposit": "",
            "visibility": "",
            "favorite": "",
            "sort_index": "",
            "tags": "",
            "out_of_stock": "",
            "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1754577442034-generated-image-1754577438889-2.png",
            "is_enabled": true,
            "product_description": "A Margherita pizza is a classic Italian dish known for its simple yet flavorful ingredients. It typically features a thin, crisp crust topped with a vibrant tomato sauce made from fresh, ripe tomatoes. The pizza is adorned with slices of fresh mozzarella cheese that melt beautifully during baking, creating a creamy texture. Fresh basil leaves are added on top, providing a fragrant, herbal aroma and a splash of color. Often finished with a drizzle of extra virgin olive oil, the Margherita pizza embodies a harmonious balance of fresh, high-quality ingredients, highlighting the essence of traditional Italian cuisine.",
            "level1_category": "Entrees",
            "level2_category": "Vegetable Based Mains",
            "Nutrients": "Rich in calcium, protein, and antioxidants from fresh ingredients.",
            "appearance": "Golden-brown thin crust with vibrant red tomatoes, white mozzarella, and green basil leaves.",
            "ingredients": [
              "Flour",
              " tomatoes",
              " mozzarella cheese",
              " basil",
              " olive oil",
              " salt",
              " yeast"
            ],
            "serving": "Best enjoyed hot with a drizzle of olive oil or fresh basil leaves.",
            "flavors": "Fresh, Savory, Herbaceous",
            "variations": "Add extra toppings like prosciutto or chili flakes for variation.",
            "allergy_info": "Contains gluten, dairy, and basil; may affect allergies.",
            "Calories": "Approximately 250-300 kcal per slice",
            "is_vegan": "No",
            "best_combo": [],
            "is_deleted": false,
            "food_type": "Veg",
            "is_spice_applicable": "Yes",
            "meal_time": "",
            "inventory_status": true,
            "is_item_verified": true,
            "account_id": "",
            "party_orders": [
              {
                "name": "small",
                "serving": "10",
                "price": "109.90"
              },
              {
                "name": "medium",
                "serving": "25",
                "price": "274.75"
              },
              {
                "name": "large",
                "serving": "50",
                "price": "549.50"
              }
            ],
            "pos_item_id": "",
            "modifiers_list": [
              {
                "name": "Classic Margherita addon",
                "is_multi_select": "No",
                "is_forced": "Yes",
                "pk_id": "685b5545-c9cc-48e1-b99b-ce99e7a9a1e5",
                "pos_group_id": "",
                "options": [
                  {
                    "name": "Extra cheese",
                    "price": "$1.25",
                    "isEnabled": true
                  },
                  {
                    "name": "Cherry tomatoes",
                    "price": "$0.75",
                    "isEnabled": true
                  },
                  {
                    "name": "Garlic crust",
                    "price": "$1.50",
                    "isEnabled": true
                  }
                ]
              }
            ],
            "id": "f03c1c36-597d-4afc-ab37-3700b0f70d35",
            "subCategory": "Vegetable Based Mains",
            "dietary": {
              "isVegan": false
            },
            "pairings": [],
            "allergens": [
              "Contains gluten, dairy, and basil; may affect allergies."
            ]
          },
          {
            "pk_id": "70652667-0511-4dd5-9425-3a5e2dc5d5d2",
            "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
            "restaurant_parent_id": null,
            "sku_id": "PIZ0002",
            "name": "Meat Lover's Delight Pizza",
            "category": "Entrees",
            "supplier": "",
            "brand": "",
            "modifiers": "",
            "unit": "",
            "taxable": "",
            "external_id": "",
            "bar_code": "",
            "description": "Meat Lover's Delight Pizza features a crispy crust topped with a rich blend of pepperoni, sausage, ham, and bacon, baked to perfection.",
            "comment": "",
            "cost": "",
            "price": "14.99",
            "large_price": "14.99",
            "indining_price": "8",
            "indining_large_price": "14.99",
            "quantity": "",
            "min_quantity": "",
            "max_quantity": "",
            "countable": "",
            "use_weighing_scale": "",
            "item_type": "",
            "duration": "",
            "discounts": "",
            "resources": "",
            "service_providers": "",
            "printer_type": "",
            "deposit": "",
            "visibility": "",
            "favorite": "",
            "sort_index": "",
            "tags": "",
            "out_of_stock": "",
            "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749534255838-generated-image-1749534255838-1.png",
            "is_enabled": true,
            "product_description": "Meat Lover's Delight Pizza features a crispy crust topped with a rich blend of pepperoni, sausage, ham, and bacon, baked to perfection.",
            "level1_category": "Entrees",
            "level2_category": "Specialty Meat Dishes",
            "Nutrients": "High in protein and fats, moderate carbs, rich in calcium and iron.",
            "appearance": "Golden-brown crust with generous toppings of meats and melted cheese, visually hearty.",
            "ingredients": [
              "Pizza dough",
              " mozzarella cheese",
              " pepperoni",
              " sausage",
              " ham",
              " bacon",
              " tomato sauce",
              " herbs."
            ],
            "serving": "Best enjoyed hot with a side of garlic bread or salad.",
            "flavors": "Savory, smoky, cheesy, with meaty richness.",
            "variations": "Can be made with turkey or plant-based meats for alternatives.",
            "allergy_info": "Contains gluten, dairy, and meat; may cause allergies in sensitive individuals.",
            "Calories": "Approximately 300-400 kcal per slice.",
            "is_vegan": "no",
            "best_combo": {
              "best_name": "Classic Margherita",
              "best_combo": "Complements the meat flavors with a classic, mild pizza.",
              "best_combo_ids": "PIZ0001"
            },
            "is_deleted": false,
            "food_type": "non_veg",
            "is_spice_applicable": "No",
            "meal_time": "",
            "inventory_status": true,
            "is_item_verified": true,
            "account_id": "",
            "party_orders": [
              {
                "name": "small",
                "serving": "10",
                "price": "149.90"
              },
              {
                "name": "medium",
                "serving": "25",
                "price": "374.75"
              },
              {
                "name": "large",
                "serving": "49",
                "price": "749.50"
              }
            ],
            "pos_item_id": "",
            "id": "70652667-0511-4dd5-9425-3a5e2dc5d5d2",
            "subCategory": "Specialty Meat Dishes",
            "dietary": {
              "isVegan": false
            },
            "pairings": [
              "Classic Margherita"
            ],
            "allergens": [
              "Contains gluten, dairy, and meat; may cause allergies in sensitive individuals."
            ]
          },
          {
            "pk_id": "b3d1ed75-e9df-45d0-a393-fbc1109c0aaa",
            "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
            "restaurant_parent_id": null,
            "sku_id": "PIZ0003",
            "name": "Veggie Supreme ",
            "category": "Starters & Small Plates",
            "supplier": "",
            "brand": "",
            "modifiers": "Veggie Supreme addon",
            "unit": "",
            "taxable": "",
            "external_id": "",
            "bar_code": "",
            "description": "Veggie Supreme is a hearty vegetarian pizza topped with a variety of fresh vegetables and melted cheese, offering a flavorful and satisfying meal.",
            "comment": "",
            "cost": "",
            "price": "13",
            "large_price": "12.49",
            "indining_price": "1",
            "indining_large_price": "12.49",
            "quantity": "",
            "min_quantity": "",
            "max_quantity": "",
            "countable": "",
            "use_weighing_scale": "",
            "item_type": "",
            "duration": "",
            "discounts": "",
            "resources": "",
            "service_providers": "",
            "printer_type": "",
            "deposit": "",
            "visibility": "",
            "favorite": "",
            "sort_index": "",
            "tags": "",
            "out_of_stock": "",
            "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749534377844-generated-image-1749534377844-1.png",
            "is_enabled": true,
            "product_description": "Veggie Supreme is a hearty vegetarian pizza topped with a variety of fresh vegetables and melted cheese, offering a flavorful and satisfying meal.",
            "level1_category": "Starters & Small Plates",
            "level2_category": "Breads & Flatbreads",
            "Nutrients": "Rich in vitamins from vegetables and calcium from cheese.",
            "appearance": "Colorful pizza with vibrant vegetable toppings and melted cheese crust.",
            "ingredients": [
              "Tomatoes",
              " bell peppers",
              " onions",
              " olives",
              " cheese",
              " pizza dough",
              " herbs."
            ],
            "serving": "Best enjoyed hot with a side of garlic bread or salad.",
            "flavors": "Savory, cheesy, with fresh vegetable notes.",
            "variations": "Can be made vegan by substituting cheese with plant-based options.",
            "allergy_info": "Contains dairy and gluten; may cause allergies in sensitive individuals.",
            "Calories": "Approximately 250-350 kcal per slice.",
            "is_vegan": "Yes",
            "best_combo": {
              "best_name": "Classic Margherita",
              "best_combo": "Both are vegetarian options with complementary flavors.",
              "best_combo_ids": "PIZ0001"
            },
            "is_deleted": false,
            "food_type": "Veg",
            "is_spice_applicable": "Yes",
            "meal_time": "",
            "inventory_status": true,
            "is_item_verified": true,
            "account_id": "",
            "party_orders": [
              {
                "name": "small",
                "serving": "10",
                "price": "124.90"
              },
              {
                "name": "medium",
                "serving": "25",
                "price": "312.25"
              },
              {
                "name": "large",
                "serving": "50",
                "price": "624.50"
              }
            ],
            "pos_item_id": "",
            "modifiers_list": [
              {
                "name": "Veggie Supreme addon",
                "is_multi_select": "No",
                "is_forced": "Yes",
                "pk_id": "ee381bfd-d4f7-4cd7-a75c-6de41876a4eb",
                "pos_group_id": "",
                "options": [
                  {
                    "name": "Spinach",
                    "price": "$0.75",
                    "isEnabled": true
                  },
                  {
                    "name": "feta",
                    "price": "$1.50",
                    "isEnabled": true
                  },
                  {
                    "name": "pesto swirl",
                    "price": "$1.50",
                    "isEnabled": true
                  }
                ]
              }
            ],
            "id": "b3d1ed75-e9df-45d0-a393-fbc1109c0aaa",
            "subCategory": "Breads & Flatbreads",
            "dietary": {
              "isVegan": true
            },
            "pairings": [
              "Classic Margherita"
            ],
            "allergens": [
              "Contains dairy and gluten; may cause allergies in sensitive individuals."
            ]
          },
          {
            "pk_id": "3874684b-bba8-4b91-b865-91b34e951477",
            "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
            "restaurant_parent_id": null,
            "sku_id": "PIZ0004",
            "name": "Chicken Tikka Pizza",
            "category": "Starters & Small Plates",
            "supplier": "",
            "brand": "",
            "modifiers": "Chicken Tikka Pizza addon",
            "unit": "",
            "taxable": "",
            "external_id": "",
            "bar_code": "",
            "description": "Chicken Tikka Pizza features tender chicken tikka pieces atop a crispy crust, topped with cheese and spices for a flavorful experience.",
            "comment": "",
            "cost": "",
            "price": "13.49",
            "large_price": "13.49",
            "indining_price": "2",
            "indining_large_price": "13.49",
            "quantity": "",
            "min_quantity": "",
            "max_quantity": "",
            "countable": "",
            "use_weighing_scale": "",
            "item_type": "",
            "duration": "",
            "discounts": "",
            "resources": "",
            "service_providers": "",
            "printer_type": "",
            "deposit": "",
            "visibility": "",
            "favorite": "",
            "sort_index": "",
            "tags": "",
            "out_of_stock": "",
            "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749534429912-generated-image-1749534429081-3.png",
            "is_enabled": true,
            "product_description": "Chicken Tikka Pizza features tender chicken tikka pieces atop a crispy crust, topped with cheese and spices for a flavorful experience.",
            "level1_category": "Starters & Small Plates",
            "level2_category": "Appetizers / Starters",
            "Nutrients": "Rich in protein, calcium, and carbs; moderate fat content.",
            "appearance": "Golden-brown crust with chunks of chicken, melted cheese, and visible spices on top.",
            "ingredients": [
              "Pizza dough",
              " chicken tikka",
              " cheese",
              " tomato sauce",
              " spices",
              " herbs."
            ],
            "serving": "Best enjoyed hot with a side of salad or dipping sauces.",
            "flavors": "Spicy, smoky, cheesy, with hints of herbs and spices.",
            "variations": "Can be made vegetarian with paneer or vegetables, or with different spice levels.",
            "allergy_info": "Contains dairy and gluten; may cause allergies in sensitive individuals.",
            "Calories": "Approximately 300-400 kcal per slice.",
            "is_vegan": "no",
            "best_combo": {
              "best_name": "Classic Margherita, Veggie Supreme",
              "best_combo": "Complementary flavors and vegetarian options enhance Chicken Tikka Pizza.",
              "best_combo_ids": "PIZ0001"
            },
            "is_deleted": false,
            "food_type": "non_veg",
            "is_spice_applicable": "No",
            "meal_time": "",
            "inventory_status": true,
            "is_item_verified": true,
            "account_id": "",
            "party_orders": [
              {
                "name": "small",
                "serving": "10",
                "price": "134.90"
              },
              {
                "name": "medium",
                "serving": "25",
                "price": "337.25"
              },
              {
                "name": "large",
                "serving": "50",
                "price": "674.50"
              }
            ],
            "pos_item_id": "",
            "modifiers_list": [
              {
                "name": "Chicken Tikka Pizza addon",
                "is_multi_select": "No",
                "is_forced": "Yes",
                "pk_id": "c4d6c07b-000e-4f08-9bfe-07b758331b3b",
                "pos_group_id": "",
                "options": [
                  {
                    "name": "Spicy mayo",
                    "price": "$1.25",
                    "isEnabled": true
                  },
                  {
                    "name": "Coriander",
                    "price": "$0.60",
                    "isEnabled": true
                  },
                  {
                    "name": "red chili flakes",
                    "price": "$0.60",
                    "isEnabled": true
                  },
                  {
                    "name": "Garlic crust",
                    "price": "$1.25",
                    "isEnabled": true
                  }
                ]
              }
            ],
            "id": "3874684b-bba8-4b91-b865-91b34e951477",
            "subCategory": "Appetizers / Starters",
            "dietary": {
              "isVegan": false
            },
            "pairings": [
              "Classic Margherita",
              " Veggie Supreme"
            ],
            "allergens": [
              "Contains dairy and gluten; may cause allergies in sensitive individuals."
            ]
          },
          {
            "pk_id": "59d63f4e-d5e7-4dce-906b-4645a2e44a1a",
            "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
            "restaurant_parent_id": null,
            "sku_id": "PIZ0005",
            "name": "BBQ Chicken Feast Pizza",
            "category": "Entrees",
            "supplier": "",
            "brand": "",
            "modifiers": "BBQ Chicken Feast addon",
            "unit": "",
            "taxable": "",
            "external_id": "",
            "bar_code": "",
            "description": "BBQ Chicken Feast Pizza features a crispy crust topped with smoky barbecue sauce, tender chicken, cheese, and flavorful toppings, offering a hearty and savory experience.",
            "comment": "",
            "cost": "",
            "price": "13.99",
            "large_price": "13.99",
            "indining_price": "4.99",
            "indining_large_price": "13.99",
            "quantity": "",
            "min_quantity": "",
            "max_quantity": "",
            "countable": "",
            "use_weighing_scale": "",
            "item_type": "",
            "duration": "",
            "discounts": "",
            "resources": "",
            "service_providers": "",
            "printer_type": "",
            "deposit": "",
            "visibility": "",
            "favorite": "",
            "sort_index": "",
            "tags": "",
            "out_of_stock": "",
            "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749534604205-generated-image-1749534602683-3.png",
            "is_enabled": true,
            "product_description": "BBQ Chicken Feast Pizza features a crispy crust topped with smoky barbecue sauce, tender chicken, cheese, and flavorful toppings, offering a hearty and savory experience.",
            "level1_category": "Entrees",
            "level2_category": "Pizzas & Flatbreads",
            "Nutrients": "Rich in protein, calcium, and carbs; moderate fat content.",
            "appearance": "Golden-brown crust with generous toppings of chicken, cheese, and barbecue sauce.",
            "ingredients": [
              "Pizza dough",
              " BBQ sauce",
              " cooked chicken",
              " cheese",
              " onions",
              " cilantro."
            ],
            "serving": "Best enjoyed hot with a side of salad or garlic bread.",
            "flavors": "Smoky, savory, cheesy, with hints of sweetness from BBQ sauce.",
            "variations": "Can add jalapeños, bacon, or different cheeses for customization.",
            "allergy_info": "Contains gluten, dairy, and possible soy; check for allergies.",
            "Calories": "Approximately 300-400 kcal per slice.",
            "is_vegan": "no",
            "best_combo": {
              "best_name": "Meat Lover's Delight Pizza, Chicken Tikka Pizza",
              "best_combo": "Rich, meaty flavors complement BBQ Chicken Feast for a hearty meal",
              "best_combo_ids": "PIZ0002,PIZ0004"
            },
            "is_deleted": false,
            "food_type": "non_veg",
            "is_spice_applicable": "yes",
            "meal_time": "",
            "inventory_status": true,
            "is_item_verified": true,
            "account_id": "",
            "party_orders": [
              {
                "name": "small",
                "serving": "10",
                "price": "139.90"
              },
              {
                "name": "medium",
                "serving": "25",
                "price": "349.75"
              },
              {
                "name": "large",
                "serving": "50",
                "price": "699.50"
              }
            ],
            "pos_item_id": "",
            "modifiers_list": [
              {
                "name": "BBQ Chicken Feast addon",
                "is_multi_select": "No",
                "is_forced": "Yes",
                "pk_id": "07dbff2e-46e9-4079-8db7-f76ba2bd9672",
                "pos_group_id": "",
                "options": [
                  {
                    "name": "Extra BBQ drizzle",
                    "price": "$1.25",
                    "isEnabled": true
                  },
                  {
                    "name": "pineapple",
                    "price": "$0.60",
                    "isEnabled": true
                  },
                  {
                    "name": "smoked cheese",
                    "price": "$1.50",
                    "isEnabled": true
                  },
                  {
                    "name": "Bacon bits",
                    "price": "$1.75",
                    "isEnabled": true
                  }
                ]
              }
            ],
            "id": "59d63f4e-d5e7-4dce-906b-4645a2e44a1a",
            "subCategory": "Pizzas & Flatbreads",
            "dietary": {
              "isVegan": false
            },
            "pairings": [
              "Meat Lover's Delight Pizza",
              " Chicken Tikka Pizza"
            ],
            "allergens": [
              "Contains gluten, dairy, and possible soy; check for allergies."
            ]
          },
          {
            "pk_id": "4f60847b-b066-4754-81c8-330f11095786",
            "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
            "restaurant_parent_id": null,
            "sku_id": "PIZ0007",
            "name": "Hawaiian Classic Pizza",
            "category": "Entrees",
            "supplier": "",
            "brand": "",
            "modifiers": "Hawaiian Classic addon",
            "unit": "",
            "taxable": "",
            "external_id": "",
            "bar_code": "",
            "description": "Hawaiian Classic Pizza features a crispy crust topped with tomato sauce, cheese, ham, and pineapple chunks, offering a sweet and savory flavor profile.",
            "comment": "",
            "cost": "",
            "price": "12.49",
            "large_price": "12.49",
            "indining_price": "12.49",
            "indining_large_price": "12.49",
            "quantity": "",
            "min_quantity": "",
            "max_quantity": "",
            "countable": "",
            "use_weighing_scale": "",
            "item_type": "",
            "duration": "",
            "discounts": "",
            "resources": "",
            "service_providers": "",
            "printer_type": "",
            "deposit": "",
            "visibility": "",
            "favorite": "",
            "sort_index": "",
            "tags": "",
            "out_of_stock": "",
            "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749534761684-generated-image-1749534760104-4.png",
            "is_enabled": true,
            "product_description": "Hawaiian Classic Pizza features a crispy crust topped with tomato sauce, cheese, ham, and pineapple chunks, offering a sweet and savory flavor profile.",
            "level1_category": "Entrees",
            "level2_category": "Pizzas & Flatbreads",
            "Nutrients": "Provides carbs, protein, calcium, and vitamins from toppings.",
            "appearance": "Golden-brown crust with melted cheese, ham slices, and pineapple pieces on top.",
            "ingredients": [
              "Pizza dough",
              " tomato sauce",
              " mozzarella cheese",
              " ham",
              " pineapple",
              " olive oil",
              " herbs."
            ],
            "serving": "Best enjoyed hot with a side of garlic bread or salad.",
            "flavors": "Sweet, savory, cheesy, with a hint of tang from pineapple.",
            "variations": "Can add bacon, jalapeños, or substitute ham with turkey.",
            "allergy_info": "Contains dairy, gluten, and possibly soy; check for allergies.",
            "Calories": "Approximately 250-350 kcal per slice.",
            "is_vegan": "no",
            "best_combo": {
              "best_name": "Meat Lover's Delight Pizza, BBQ Chicken Feast Pizza",
              "best_combo": "Rich, savory flavors complement the sweet and savory Hawaiian pizza",
              "best_combo_ids": "PIZ0002,PIZ0005"
            },
            "is_deleted": false,
            "food_type": "non_veg",
            "is_spice_applicable": "no",
            "meal_time": "",
            "inventory_status": true,
            "is_item_verified": true,
            "account_id": "",
            "party_orders": [
              {
                "name": "small",
                "serving": "10",
                "price": "124.90"
              },
              {
                "name": "medium",
                "serving": "25",
                "price": "312.25"
              },
              {
                "name": "large",
                "serving": "50",
                "price": "624.50"
              }
            ],
            "pos_item_id": "",
            "modifiers_list": [
              {
                "name": "Hawaiian Classic addon",
                "is_multi_select": "No",
                "is_forced": "Yes",
                "pk_id": "840bed41-05ef-47c8-bca9-41c264ae37d9",
                "pos_group_id": "",
                "options": [
                  {
                    "name": "Bacon",
                    "price": "$1.75",
                    "isEnabled": true
                  },
                  {
                    "name": "red onions",
                    "price": "$0.60",
                    "isEnabled": true
                  },
                  {
                    "name": "sweet chili drizzle",
                    "price": "$0.60",
                    "isEnabled": true
                  },
                  {
                    "name": "spicy crust",
                    "price": "$1.25",
                    "isEnabled": true
                  }
                ]
              }
            ],
            "id": "4f60847b-b066-4754-81c8-330f11095786",
            "subCategory": "Pizzas & Flatbreads",
            "dietary": {
              "isVegan": false
            },
            "pairings": [
              "Meat Lover's Delight Pizza",
              " BBQ Chicken Feast Pizza"
            ],
            "allergens": [
              "Contains dairy, gluten, and possibly soy; check for allergies."
            ]
          },
          {
            "pk_id": "173e050c-de20-48d6-8f00-f6f4999601ec",
            "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
            "restaurant_parent_id": null,
            "sku_id": "PIZ0008",
            "name": "Spicy Veggie Volcano",
            "category": "Entrees",
            "supplier": "",
            "brand": "",
            "modifiers": "Spicy Veggie Volcano addon",
            "unit": "",
            "taxable": "",
            "external_id": "",
            "bar_code": "",
            "description": "Spicy Veggie Volcano is a vibrant, spicy dish featuring a medley of fresh vegetables topped with a fiery sauce, served hot and visually striking.",
            "comment": "",
            "cost": "",
            "price": "12.99",
            "large_price": "12.99",
            "indining_price": "12.99",
            "indining_large_price": "12.99",
            "quantity": "",
            "min_quantity": "",
            "max_quantity": "",
            "countable": "",
            "use_weighing_scale": "",
            "item_type": "",
            "duration": "",
            "discounts": "",
            "resources": "",
            "service_providers": "",
            "printer_type": "",
            "deposit": "",
            "visibility": "",
            "favorite": "",
            "sort_index": "",
            "tags": "",
            "out_of_stock": "",
            "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749534852285-generated-image-1749534851526-3.png",
            "is_enabled": true,
            "product_description": "Spicy Veggie Volcano is a vibrant, spicy dish featuring a medley of fresh vegetables topped with a fiery sauce, served hot and visually striking.",
            "level1_category": "Entrees",
            "level2_category": "Vegetable Based Mains",
            "Nutrients": "Rich in vitamins, antioxidants, and dietary fiber from vegetables.",
            "appearance": "Colorful vegetable medley topped with a bright red spicy sauce, resembling a volcano eruption.",
            "ingredients": [
              "Mixed vegetables",
              " chili sauce",
              " garlic",
              " soy sauce",
              " spices",
              " oil"
            ],
            "serving": "Best enjoyed with steamed rice or flatbreads for a complete meal.",
            "flavors": "Spicy, Savory, Umami with a hint of sweetness",
            "variations": "Adjust spice level, add tofu or mushrooms for variation",
            "allergy_info": "Contains soy and chili; may affect those with soy or chili allergies.",
            "Calories": "Approximately 150-200 kcal per serving",
            "is_vegan": "yes",
            "best_combo": {
              "best_name": "Veggie Supreme",
              "best_combo": "Complements the spicy veggie flavor with a hearty veggie option",
              "best_combo_ids": ""
            },
            "is_deleted": false,
            "food_type": "vegan",
            "is_spice_applicable": "yes",
            "meal_time": "",
            "inventory_status": true,
            "is_item_verified": true,
            "account_id": "",
            "party_orders": [
              {
                "name": "small",
                "serving": "10",
                "price": "129.90"
              },
              {
                "name": "medium",
                "serving": "25",
                "price": "324.75"
              },
              {
                "name": "large",
                "serving": "49",
                "price": "649.50"
              }
            ],
            "pos_item_id": "",
            "modifiers_list": [
              {
                "name": "Spicy Veggie Volcano addon",
                "is_multi_select": "Yes",
                "is_forced": "No",
                "pk_id": "7a4a7fc7-af5e-4cb3-9ec8-64f446905edd",
                "pos_group_id": "",
                "options": [
                  {
                    "name": "Paneer cubes",
                    "price": "$1.50",
                    "isEnabled": true
                  },
                  {
                    "name": "Extra chili",
                    "price": "$0.99",
                    "isEnabled": true
                  },
                  {
                    "name": "Hot sauce swirl",
                    "price": "$1.50",
                    "isEnabled": true
                  },
                  {
                    "name": "Sesame crust",
                    "price": "$1.75",
                    "isEnabled": true
                  },
                  {
                    "name": "chicken toast",
                    "price": "$1",
                    "isEnabled": true
                  }
                ]
              }
            ],
            "id": "173e050c-de20-48d6-8f00-f6f4999601ec",
            "subCategory": "Vegetable Based Mains",
            "dietary": {
              "isVegan": true
            },
            "pairings": [
              "Veggie Supreme"
            ],
            "allergens": [
              "Contains soy and chili; may affect those with soy or chili allergies."
            ]
          },
          {
            "pk_id": "e7f3210a-5564-4b08-9bfd-283ff68eedb2",
            "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
            "restaurant_parent_id": null,
            "sku_id": "PIZ0010",
            "name": "Philly Steak Pizza",
            "category": "Entrees",
            "supplier": "",
            "brand": "",
            "modifiers": "Philly Steak Pizza addon",
            "unit": "",
            "taxable": "",
            "external_id": "",
            "bar_code": "",
            "description": "Philly Steak Pizza features tender sliced steak, melted cheese, and savory toppings on a crispy crust, blending Italian and American flavors.",
            "comment": "",
            "cost": "",
            "price": "14.99",
            "large_price": "14.99",
            "indining_price": "14.99",
            "indining_large_price": "14.99",
            "quantity": "",
            "min_quantity": "",
            "max_quantity": "",
            "countable": "",
            "use_weighing_scale": "",
            "item_type": "",
            "duration": "",
            "discounts": "",
            "resources": "",
            "service_providers": "",
            "printer_type": "",
            "deposit": "",
            "visibility": "",
            "favorite": "",
            "sort_index": "",
            "tags": "",
            "out_of_stock": "",
            "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749535594783-generated-image-1749535586777-4.png",
            "is_enabled": true,
            "product_description": "Philly Steak Pizza features tender sliced steak, melted cheese, and savory toppings on a crispy crust, blending Italian and American flavors.",
            "level1_category": "Entrees",
            "level2_category": "Noodles & Pasta",
            "Nutrients": "Rich in protein, calcium, and carbohydrates for energy and muscle repair.",
            "appearance": "Golden-brown crust topped with melted cheese, sliced steak, and vegetables.",
            "ingredients": [
              "Sliced steak",
              " mozzarella cheese",
              " pizza dough",
              " bell peppers",
              " onions",
              " tomato sauce."
            ],
            "serving": "Best enjoyed hot with a side of garlic bread or salad.",
            "flavors": "Savory, cheesy, meaty, with hints of smoky spices.",
            "variations": "Can add mushrooms, jalapeños, or substitute steak with chicken or plant-based options.",
            "allergy_info": "Contains dairy and gluten; may contain traces of soy or nuts.",
            "Calories": "Approximately 800-1000 kcal per slice.",
            "is_vegan": "no",
            "best_combo": {
              "best_name": "Meat Lover's Delight Pizza,BBQ Chicken Feast Pizza",
              "best_combo": "Rich, meaty flavors complement the hearty Philly Steak Pizza well",
              "best_combo_ids": "PIZ0002,PIZ0005"
            },
            "is_deleted": false,
            "food_type": "non_veg",
            "is_spice_applicable": "yes",
            "meal_time": "",
            "inventory_status": true,
            "is_item_verified": true,
            "account_id": "",
            "party_orders": [
              {
                "name": "small",
                "serving": "10",
                "price": "149.90"
              },
              {
                "name": "medium",
                "serving": "25",
                "price": "374.75"
              },
              {
                "name": "large",
                "serving": "50",
                "price": "749.50"
              }
            ],
            "pos_item_id": "",
            "modifiers_list": [
              {
                "name": "Philly Steak Pizza addon",
                "is_multi_select": "No",
                "is_forced": "Yes",
                "pk_id": "989bf89f-91b4-49fa-851f-a85d585046c5",
                "pos_group_id": "",
                "options": [
                  {
                    "name": "Blue cheese",
                    "price": "$1.25",
                    "isEnabled": true
                  },
                  {
                    "name": "Extra steak",
                    "price": "$2.25",
                    "isEnabled": true
                  },
                  {
                    "name": "BBQ swirl",
                    "price": "$0.99",
                    "isEnabled": true
                  },
                  {
                    "name": "Cheesy crust",
                    "price": "$2",
                    "isEnabled": true
                  }
                ]
              }
            ],
            "id": "e7f3210a-5564-4b08-9bfd-283ff68eedb2",
            "subCategory": "Noodles & Pasta",
            "dietary": {
              "isVegan": false
            },
            "pairings": [
              "Meat Lover's Delight Pizza",
              "BBQ Chicken Feast Pizza"
            ],
            "allergens": [
              "Contains dairy and gluten; may contain traces of soy or nuts."
            ]
          },
          {
            "pk_id": "ac33445d-18ae-4be2-942a-b0e65c7b44a4",
            "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
            "restaurant_parent_id": null,
            "sku_id": "PIZ0014",
            "name": "Truffle Mushroom Delight Pizza",
            "category": "Starters & Small Plates",
            "supplier": "",
            "brand": "",
            "modifiers": "Truffle Mushroom Delight addon",
            "unit": "",
            "taxable": "",
            "external_id": "",
            "bar_code": "",
            "description": "A gourmet pizza topped with savory mushrooms and aromatic truffle oil, offering a rich, earthy flavor in a crispy crust.",
            "comment": "",
            "cost": "",
            "price": "14.49",
            "large_price": "14.49",
            "indining_price": "14.49",
            "indining_large_price": "14.49",
            "quantity": "",
            "min_quantity": "",
            "max_quantity": "",
            "countable": "",
            "use_weighing_scale": "",
            "item_type": "",
            "duration": "",
            "discounts": "",
            "resources": "",
            "service_providers": "",
            "printer_type": "",
            "deposit": "",
            "visibility": "",
            "favorite": "",
            "sort_index": "",
            "tags": "",
            "out_of_stock": "",
            "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749536724052-generated-image-1749536723486-2.png",
            "is_enabled": true,
            "product_description": "A gourmet pizza topped with savory mushrooms and aromatic truffle oil, offering a rich, earthy flavor in a crispy crust.",
            "level1_category": "Starters & Small Plates",
            "level2_category": "Breads & Flatbreads",
            "Nutrients": "Rich in antioxidants from mushrooms and healthy fats from truffle oil.",
            "appearance": "Golden-brown crust with melted cheese, sliced mushrooms, and drizzled truffle oil on top.",
            "ingredients": [
              "Pizza dough",
              " mushrooms",
              " truffle oil",
              " cheese",
              " garlic",
              " herbs",
              " olive oil."
            ],
            "serving": "Best enjoyed hot with a side of mixed greens or a light salad.",
            "flavors": "Earthy, umami, aromatic, slightly cheesy.",
            "variations": "Vegan version with plant-based cheese, or add prosciutto for non-veg.",
            "allergy_info": "Contains dairy and mushrooms; may cause allergies in sensitive individuals.",
            "Calories": "Approximately 300-400 kcal per slice.",
            "is_vegan": "no",
            "best_combo": {
              "best_name": "Veggie Supreme, Mediterranean Veggie, Spicy Veggie Volcano",
              "best_combo": "Complementary veggie flavors enhance the mushroom truffle profile.",
              "best_combo_ids": "PIZ0011,PIZ0008"
            },
            "is_deleted": false,
            "food_type": "non_veg",
            "is_spice_applicable": "no",
            "meal_time": "",
            "inventory_status": true,
            "is_item_verified": true,
            "account_id": "",
            "party_orders": [
              {
                "name": "small",
                "serving": "10",
                "price": "144.90"
              },
              {
                "name": "medium",
                "serving": "25",
                "price": "362.25"
              },
              {
                "name": "large",
                "serving": "50",
                "price": "724.50"
              }
            ],
            "pos_item_id": "",
            "modifiers_list": [
              {
                "name": "Truffle Mushroom Delight addon",
                "is_multi_select": "No",
                "is_forced": "Yes",
                "pk_id": "c95a1603-adc7-43da-9b05-c549a3e964c2",
                "pos_group_id": "",
                "options": [
                  {
                    "name": "Caramelized onions",
                    "price": "$0.99",
                    "isEnabled": true
                  },
                  {
                    "name": "Goat cheese",
                    "price": "$1.50",
                    "isEnabled": true
                  },
                  {
                    "name": "Garlic crust",
                    "price": "$1.25",
                    "isEnabled": true
                  },
                  {
                    "name": "pine nuts",
                    "price": "$0.99",
                    "isEnabled": true
                  }
                ]
              }
            ],
            "id": "ac33445d-18ae-4be2-942a-b0e65c7b44a4",
            "subCategory": "Breads & Flatbreads",
            "dietary": {
              "isVegan": false
            },
            "pairings": [
              "Veggie Supreme",
              " Mediterranean Veggie",
              " Spicy Veggie Volcano"
            ],
            "allergens": [
              "Contains dairy and mushrooms; may cause allergies in sensitive individuals."
            ]
          },
          {
            "pk_id": "02d9711e-2365-476c-9174-2ba463aa3636",
            "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
            "restaurant_parent_id": null,
            "sku_id": "PIZ0015",
            "name": "Loaded Paneer Paradise Pizza",
            "category": "Starters & Small Plates",
            "supplier": "",
            "brand": "",
            "modifiers": "Loaded Paneer Paradise",
            "unit": "",
            "taxable": "",
            "external_id": "",
            "bar_code": "",
            "description": "Loaded Paneer Paradise Pizza features a crispy crust topped with spiced paneer, fresh vegetables, and melted cheese, offering a flavorful vegetarian delight.",
            "comment": "",
            "cost": "",
            "price": "13.99",
            "large_price": "13.99",
            "indining_price": "13.99",
            "indining_large_price": "13.99",
            "quantity": "",
            "min_quantity": "",
            "max_quantity": "",
            "countable": "",
            "use_weighing_scale": "",
            "item_type": "",
            "duration": "",
            "discounts": "",
            "resources": "",
            "service_providers": "",
            "printer_type": "",
            "deposit": "",
            "visibility": "",
            "favorite": "",
            "sort_index": "",
            "tags": "",
            "out_of_stock": "",
            "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749536855344-generated-image-1749536854924-2.png",
            "is_enabled": true,
            "product_description": "Loaded Paneer Paradise Pizza features a crispy crust topped with spiced paneer, fresh vegetables, and melted cheese, offering a flavorful vegetarian delight.",
            "level1_category": "Starters & Small Plates",
            "level2_category": "Breads & Flatbreads",
            "Nutrients": "Rich in protein from paneer, calcium, vitamins from vegetables",
            "appearance": "Golden-brown crust with colorful toppings and melted cheese, garnished with herbs.",
            "ingredients": [
              "Paneer",
              " cheese",
              " bell peppers",
              " onions",
              " tomato sauce",
              " spices",
              " herbs",
              " dough"
            ],
            "serving": "Best enjoyed hot with a side of green chutney or salad.",
            "flavors": "Savory, cheesy, mildly spicy with aromatic herbs",
            "variations": "Vegan cheese, gluten-free crust, extra vegetables",
            "allergy_info": "Contains dairy and gluten; may cause allergies in sensitive individuals.",
            "Calories": "Approximately 300-400 kcal per slice",
            "is_vegan": "no",
            "best_combo": {
              "best_name": "Veggie Supreme, Mediterranean Veggie, Spicy Veggie Volcano",
              "best_combo": "Complementary veggie flavors enhance the paneer pizza experience.",
              "best_combo_ids": "PIZ0011,PIZ0008"
            },
            "is_deleted": false,
            "food_type": "veg",
            "is_spice_applicable": "yes",
            "meal_time": "",
            "inventory_status": true,
            "is_item_verified": true,
            "account_id": "",
            "party_orders": [
              {
                "name": "small",
                "serving": "10",
                "price": "139.90"
              },
              {
                "name": "medium",
                "serving": "25",
                "price": "349.75"
              },
              {
                "name": "large",
                "serving": "50",
                "price": "699.50"
              }
            ],
            "pos_item_id": "",
            "modifiers_list": [
              {
                "name": "Loaded Paneer Paradise",
                "is_multi_select": "No",
                "is_forced": "Yes",
                "pk_id": "efcadd5a-5cf5-4645-a387-5a6323981e1c",
                "pos_group_id": "",
                "options": [
                  {
                    "name": "Mint mayo swirl",
                    "price": "$0.99",
                    "isEnabled": true
                  },
                  {
                    "name": "Extra paneer",
                    "price": "$1.75",
                    "isEnabled": true
                  },
                  {
                    "name": "Tikka crust",
                    "price": "$1.50",
                    "isEnabled": true
                  },
                  {
                    "name": "Chili flakes",
                    "price": "$0.99",
                    "isEnabled": true
                  }
                ]
              }
            ],
            "id": "02d9711e-2365-476c-9174-2ba463aa3636",
            "subCategory": "Breads & Flatbreads",
            "dietary": {
              "isVegan": false
            },
            "pairings": [
              "Veggie Supreme",
              " Mediterranean Veggie",
              " Spicy Veggie Volcano"
            ],
            "allergens": [
              "Contains dairy and gluten; may cause allergies in sensitive individuals."
            ]
          }]
        }
      },
      {
        "type": "BasicCombo",
        "data": {
          "content": "<h2 class=\"text-3xl md:text-4xl font-bold text-gray-900 mb-4\">Family <span class=\"text-orange-600\">Meal Deals</span></h2><p class=\"text-gray-600 text-lg max-w-2xl mx-auto\">Perfect portions for sharing around the table - because the best meals bring people together</p>",
          "backgroundColor": "#fef5e7",
          "emptyStateContent": "<h3 class=\"text-lg sm:text-xl font-semibold mb-2\">Family Meals Coming Soon</h3><p class=\"text-sm sm:text-base max-w-md\">Great value family meal combinations will be available here.</p>",
          "combos": [{
            "combo_id": "96f8cdcb-e7dd-4355-9178-5652f6d82f84",
            "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
            "title": "Party Time Pack",
            "description": "A delightful mix of classic, flavorful, and satisfying dishes including pizzas, sides, beverages, and desserts, perfect for celebrating with friends and family in a lively, delicious party setting.",
            "products": [
              {
                "pk_id": "dcbe286c-43c2-4f27-b9aa-8a339344f0c7",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0016",
                "name": "Buffalo Chicken Blast Pizza",
                "category": "Starters & Small Plates",
                "supplier": "",
                "brand": "",
                "modifiers": "Buffalo Chicken Blast addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Buffalo Chicken Blast Pizza features a crispy crust topped with spicy buffalo sauce, tender chicken, and melty cheese, offering a bold flavor experience.",
                "comment": "",
                "cost": "",
                "price": "13.49",
                "large_price": "13.49",
                "indining_price": "13.49",
                "indining_large_price": "13.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749536945765-generated-image-1749536944781-3.png",
                "is_enabled": "true",
                "product_description": "Buffalo Chicken Blast Pizza features a crispy crust topped with spicy buffalo sauce, tender chicken, and melty cheese, offering a bold flavor experience.",
                "level1_category": "Starters & Small Plates",
                "level2_category": "Appetizers / Starters",
                "Nutrients": "Rich in protein and calcium, moderate in fats and carbs.",
                "appearance": "Golden-brown crust with vibrant red buffalo sauce, chicken pieces, and melted cheese topping.",
                "ingredients": "Pizza dough, chicken, buffalo sauce, cheese, blue cheese, celery, ranch dressing",
                "serving": "Best enjoyed hot with a side of celery sticks or ranch dressing.",
                "flavors": "Spicy, tangy, cheesy, savory",
                "variations": "Can be made with plant-based chicken or less spicy sauce.",
                "allergy_info": "Contains dairy, gluten, and possible soy; may cause allergies in sensitive individuals.",
                "Calories": "Approximately 300-400 kcal per slice",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Meat Lover's Delight Pizza,BBQ Chicken Feast Pizza,Spicy Veggie Volcano\",\"best_combo\":\"Enhances spicy and meaty flavors, creating a bold, satisfying combo.\",\"best_combo_ids\":\"PIZ0002,PIZ0005,PIZ0008\"}",
                "is_deleted": "false",
                "food_type": "non_veg",
                "is_spice_applicable": "yes",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "ee2aa8fb-01ae-4cdc-8824-843577ea49cd",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0022",
                "name": "Potato Wedges",
                "category": "Sides & Accompaniments",
                "supplier": "",
                "brand": "",
                "modifiers": "Potato Wedges addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Crispy potato wedges are thick-cut potatoes seasoned and baked or fried until golden and crunchy, perfect as a snack or side.",
                "comment": "",
                "cost": "",
                "price": "4.99",
                "large_price": "4.99",
                "indining_price": "4.99",
                "indining_large_price": "4.99",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749538548266-generated-image-1749538548266-1.png",
                "is_enabled": "true",
                "product_description": "Crispy potato wedges are thick-cut potatoes seasoned and baked or fried until golden and crunchy, perfect as a snack or side.",
                "level1_category": "Sides & Accompaniments",
                "level2_category": "Side Dishes",
                "Nutrients": "Rich in carbohydrates and vitamin C, moderate in fiber.",
                "appearance": "Golden-brown, wedge-shaped potatoes with a crispy exterior and fluffy interior.",
                "ingredients": "Potatoes, Olive oil, Salt, Pepper, Paprika, Garlic powder, Herbs",
                "serving": "Best enjoyed with ketchup, aioli, or spicy dips.",
                "flavors": "Savory, Crispy, Slightly smoky with hints of herbs.",
                "variations": "Can be seasoned with cheese, chili, or served with different dips.",
                "allergy_info": "Contains potatoes; check for cross-contamination with gluten or dairy if applicable.",
                "Calories": "Approximately 150-250 kcal per serving",
                "is_vegan": "yes",
                "best_combo": "{\"best_name\":\"Garlic Bread Supreme, Chicken Wings (6 pcs)\",\"best_combo\":\"Perfect sides with potato wedges for added flavor and variety.\",\"best_combo_ids\":\"PIZ0021\"}",
                "is_deleted": "false",
                "food_type": "veg",
                "is_spice_applicable": "yes",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "bdd585f1-40bf-43f4-adad-9e212ca583fa",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0027",
                "name": "Choco Cold Coffee",
                "category": "Beverages",
                "supplier": "",
                "brand": "",
                "modifiers": "Choco Cold Coffee addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Choco Cold Coffee is a refreshing beverage blending rich coffee, chocolate syrup, milk, and ice for a sweet, chilled drink.",
                "comment": "",
                "cost": "",
                "price": "4.49",
                "large_price": "4.49",
                "indining_price": "4.49",
                "indining_large_price": "4.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749538880748-generated-image-1749538880345-2.png",
                "is_enabled": "true",
                "product_description": "Choco Cold Coffee is a refreshing beverage blending rich coffee, chocolate syrup, milk, and ice for a sweet, chilled drink.",
                "level1_category": "Beverages",
                "level2_category": "Beverages",
                "Nutrients": "Provides energy from caffeine, sugars, and calcium from milk.",
                "appearance": "Dark brown coffee with a frothy top, topped with chocolate shavings or whipped cream.",
                "ingredients": "Coffee, chocolate syrup, milk, ice, sugar, whipped cream (optional).",
                "serving": "Best enjoyed chilled in a tall glass with a straw.",
                "flavors": "Rich chocolate, bold coffee, sweet and creamy.",
                "variations": "Can add whipped cream, chocolate chips, or caramel drizzle.",
                "allergy_info": "Contains dairy and caffeine; may affect lactose intolerant or sensitive individuals.",
                "Calories": "Approximately 150-250 kcal per serving.",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Garlic Bread Supreme, Chicken Wings (6 pcs), Potato Wedges\",\"best_combo\":\"Savory sides and wings complement the sweet, rich flavor of Choco Cold Coffee.\",\"best_combo_ids\":\"PIZ0021,PIZ0022\"}",
                "is_deleted": "false",
                "food_type": "non_veg",
                "is_spice_applicable": "no",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "d71ea6a1-cb05-4449-8495-a7fa492b6f82",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0028",
                "name": "Choco Lava Cake",
                "category": "Desserts & Sweets",
                "supplier": "",
                "brand": "",
                "modifiers": "Choco Lava Cake addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Choco Lava Cake is a rich, warm chocolate dessert with a gooey, molten center that oozes out when cut, offering a decadent treat.",
                "comment": "",
                "cost": "",
                "price": "4.99",
                "large_price": "4.99",
                "indining_price": "4.99",
                "indining_large_price": "4.99",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749538934939-generated-image-1749538934939-1.png",
                "is_enabled": "true",
                "product_description": "Choco Lava Cake is a rich, warm chocolate dessert with a gooey, molten center that oozes out when cut, offering a decadent treat.",
                "level1_category": "Desserts & Sweets",
                "level2_category": "Pastries & Cakes",
                "Nutrients": "Rich in calories and fats, provides energy and mood-boosting compounds.",
                "appearance": "Small, round cake with a slightly cracked top and a flowing chocolate center.",
                "ingredients": "Chocolate, Butter, Eggs, Sugar, Flour, Cocoa powder, Vanilla extract",
                "serving": "Best enjoyed warm with vanilla ice cream or whipped cream.",
                "flavors": "Intensely chocolatey, Sweet, Slightly bitter from cocoa",
                "variations": "Can be made dairy-free, gluten-free, or with added nuts or caramel",
                "allergy_info": "Contains dairy, eggs, and gluten; may cause allergies in sensitive individuals.",
                "Calories": "Approximately 350-450 kcal per serving",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Classic Cheeseburger Pizza, Garlic Bread Supreme, Classic Coke\",\"best_combo\":\"Savory and crunchy sides with a refreshing drink complement the sweet, rich Choco Lava Cake.\",\"best_combo_ids\":\"PIZ0025\"}",
                "is_deleted": "false",
                "food_type": "non_veg",
                "is_spice_applicable": "no",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "d3f3a400-9e90-4098-a991-33969ff1b6ea",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0030",
                "name": "Cinnamon Breadsticks",
                "category": "Starters & Small Plates",
                "supplier": "",
                "brand": "",
                "modifiers": "Cinnamon Breadsticks aadon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Cinnamon Breadsticks are soft, warm breadsticks coated with cinnamon sugar, offering a sweet and aromatic treat.",
                "comment": "",
                "cost": "",
                "price": "4.49",
                "large_price": "4.49",
                "indining_price": "4.49",
                "indining_large_price": "4.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749539017225-generated-image-1749539016801-2.png",
                "is_enabled": "true",
                "product_description": "Cinnamon Breadsticks are soft, warm breadsticks coated with cinnamon sugar, offering a sweet and aromatic treat.",
                "level1_category": "Starters & Small Plates",
                "level2_category": "Breads & Flatbreads",
                "Nutrients": "Provides carbohydrates, fats, and some protein.",
                "appearance": "Golden-brown breadsticks topped with cinnamon sugar, slightly glossy surface.",
                "ingredients": "Flour, yeast, butter, cinnamon, sugar, salt, milk, eggs.",
                "serving": "Best enjoyed warm with coffee or hot chocolate.",
                "flavors": "Sweet, spicy cinnamon, buttery notes.",
                "variations": "Can add icing or nuts for extra flavor.",
                "allergy_info": "Contains gluten, dairy, and eggs; may cause allergies.",
                "Calories": "Approximately 150-200 kcal per breadstick.",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Garlic Bread Supreme, Chicken Wings (6 pcs), Potato Wedges\",\"best_combo\":\"Rich, savory sides enhance the sweetness of cinnamon breadsticks.\",\"best_combo_ids\":\"PIZ0021,PIZ0022\"}",
                "is_deleted": "false",
                "food_type": "non_veg",
                "is_spice_applicable": "yes",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "ac33445d-18ae-4be2-942a-b0e65c7b44a4",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0014",
                "name": "Truffle Mushroom Delight Pizza",
                "category": "Starters & Small Plates",
                "supplier": "",
                "brand": "",
                "modifiers": "Truffle Mushroom Delight addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "A gourmet pizza topped with savory mushrooms and aromatic truffle oil, offering a rich, earthy flavor in a crispy crust.",
                "comment": "",
                "cost": "",
                "price": "14.49",
                "large_price": "14.49",
                "indining_price": "14.49",
                "indining_large_price": "14.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749536724052-generated-image-1749536723486-2.png",
                "is_enabled": "true",
                "product_description": "A gourmet pizza topped with savory mushrooms and aromatic truffle oil, offering a rich, earthy flavor in a crispy crust.",
                "level1_category": "Starters & Small Plates",
                "level2_category": "Breads & Flatbreads",
                "Nutrients": "Rich in antioxidants from mushrooms and healthy fats from truffle oil.",
                "appearance": "Golden-brown crust with melted cheese, sliced mushrooms, and drizzled truffle oil on top.",
                "ingredients": "Pizza dough, mushrooms, truffle oil, cheese, garlic, herbs, olive oil.",
                "serving": "Best enjoyed hot with a side of mixed greens or a light salad.",
                "flavors": "Earthy, umami, aromatic, slightly cheesy.",
                "variations": "Vegan version with plant-based cheese, or add prosciutto for non-veg.",
                "allergy_info": "Contains dairy and mushrooms; may cause allergies in sensitive individuals.",
                "Calories": "Approximately 300-400 kcal per slice.",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Veggie Supreme, Mediterranean Veggie, Spicy Veggie Volcano\",\"best_combo\":\"Complementary veggie flavors enhance the mushroom truffle profile.\",\"best_combo_ids\":\"PIZ0011,PIZ0008\"}",
                "is_deleted": "false",
                "food_type": "non_veg",
                "is_spice_applicable": "no",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "c8dee61d-9d99-407d-85c8-a2ebe87e9a14",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0006",
                "name": "Pepperoni Passion ",
                "category": "Starters & Small Plates",
                "supplier": "",
                "brand": "",
                "modifiers": "Pepperoni Passion addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Pepperoni Passion is a classic pizza topped with spicy pepperoni slices, melted cheese, and savory tomato sauce, offering a flavorful and satisfying experience.",
                "comment": "",
                "cost": "",
                "price": "12.99",
                "large_price": "12.99",
                "indining_price": "12.99",
                "indining_large_price": "12.99",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749534684345-generated-image-1749534684345-1.png",
                "is_enabled": "true",
                "product_description": "Pepperoni Passion is a classic pizza topped with spicy pepperoni slices, melted cheese, and savory tomato sauce, offering a flavorful and satisfying experience.",
                "level1_category": "Starters & Small Plates",
                "level2_category": "Appetizers / Starters",
                "Nutrients": "Rich in protein, calcium, and fats from cheese and meat toppings.",
                "appearance": "Golden-brown crust topped with vibrant red pepperoni slices and melted cheese.",
                "ingredients": "Dough, tomato sauce, mozzarella cheese, pepperoni slices, herbs.",
                "serving": "Best enjoyed hot with a side of garlic bread or salad.",
                "flavors": "Savory, spicy, cheesy, and slightly smoky.",
                "variations": "Can be made with different cheeses or vegetarian toppings.",
                "allergy_info": "Contains gluten, dairy, and processed meats; may cause allergies in sensitive individuals.",
                "Calories": "Approximately 300-400 kcal per slice.",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Meat Lover's Delight Pizza, BBQ Chicken Feast Pizza\",\"best_combo\":\"Rich, meaty flavors complement Pepperoni Passion well\",\"best_combo_ids\":\"PIZ0002,PIZ0005\"}",
                "is_deleted": "false",
                "food_type": "non_veg",
                "is_spice_applicable": "yes",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "fd637abf-0dc6-4253-b172-014f43c225cc",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0020",
                "name": " Garlic Bread Supreme",
                "category": "Starters & Small Plates",
                "supplier": "",
                "brand": "",
                "modifiers": "Garlic Bread Supreme addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Garlic Bread Supreme features toasted bread topped with garlic, herbs, melted cheese, and optional toppings for a flavorful appetizer.",
                "comment": "",
                "cost": "",
                "price": "5.49",
                "large_price": "5.49",
                "indining_price": "5.49",
                "indining_large_price": "5.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749538417077-generated-image-1749538417077-1.png",
                "is_enabled": "true",
                "product_description": "Garlic Bread Supreme features toasted bread topped with garlic, herbs, melted cheese, and optional toppings for a flavorful appetizer.",
                "level1_category": "Starters & Small Plates",
                "level2_category": "Breads & Flatbreads",
                "Nutrients": "Rich in carbohydrates, fats, and calcium from cheese.",
                "appearance": "Golden-brown toasted bread with melted cheese and sprinkled herbs on top.",
                "ingredients": "Bread, garlic, butter, cheese, herbs, optional toppings like olives or peppers.",
                "serving": "Best enjoyed warm with dips or as a side to pasta dishes.",
                "flavors": "Garlic, buttery, cheesy, herby with savory notes.",
                "variations": "Can include additional toppings like olives, peppers, or extra cheese.",
                "allergy_info": "Contains gluten, dairy, and garlic; may cause allergies in sensitive individuals.",
                "Calories": "Approximately 250-350 kcal per serving",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Classic Margherita, Four Cheese Melt Pizza, Veggie Supreme\",\"best_combo\":\"Complementary flavors and vegetarian options enhance garlic bread.\",\"best_combo_ids\":\"PIZ0001\"}",
                "is_deleted": "false",
                "food_type": "non_veg",
                "is_spice_applicable": "yes",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "3ee80a6b-a932-4ccb-a02f-377a91683824",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0024",
                "name": "Classic Pepsi ",
                "category": "Beverages",
                "supplier": "",
                "brand": "",
                "modifiers": "Classic Pepsi addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Classic Pepsi is a carbonated soft drink with a sweet, crisp flavor, known for its refreshing taste and iconic branding.",
                "comment": "",
                "cost": "",
                "price": "2.49",
                "large_price": "2.49",
                "indining_price": "2.49",
                "indining_large_price": "2.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749538665032-generated-image-1749538665032-1.png",
                "is_enabled": "true",
                "product_description": "Classic Pepsi is a carbonated soft drink with a sweet, crisp flavor, known for its refreshing taste and iconic branding.",
                "level1_category": "Beverages",
                "level2_category": "Beverages",
                "Nutrients": "Provides quick energy from sugars; no significant nutrients.",
                "appearance": "Clear, dark caramel-colored liquid in a transparent bottle or can.",
                "ingredients": "Carbonated water, high fructose corn syrup, caramel color, phosphoric acid, caffeine, natural flavors.",
                "serving": "Best served chilled in a glass or can, often with ice.",
                "flavors": "Sweet, caramel, slightly citrusy, fizzy.",
                "variations": "Diet Pepsi, Pepsi Max, flavored variants like cherry or vanilla.",
                "allergy_info": "Contains caffeine; may cause sensitivity in some individuals.",
                "Calories": "Approximately 150 kcal per 12 oz can.",
                "is_vegan": "yes",
                "best_combo": "{\"best_name\":\"Garlic Bread Supreme, Chicken Wings (6 pcs), Potato Wedges\",\"best_combo\":\"Classic Pepsi complements savory sides and crispy appetizers well.\",\"best_combo_ids\":\"PIZ0021,PIZ0022\"}",
                "is_deleted": "false",
                "food_type": "veg",
                "is_spice_applicable": "no",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "3c127c52-479a-4f61-b36f-9365af4bd8bb",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0025",
                "name": "Classic Coke",
                "category": "Beverages",
                "supplier": "",
                "brand": "",
                "modifiers": "Classic  Coke addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Classic Coke is a carbonated soft drink with a sweet, caramel flavor, known for its refreshing and bubbly taste.",
                "comment": "",
                "cost": "",
                "price": "2.49",
                "large_price": "2.49",
                "indining_price": "2.49",
                "indining_large_price": "2.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749538739474-generated-image-1749538739474-1.png",
                "is_enabled": "true",
                "product_description": "Classic Coke is a carbonated soft drink with a sweet, caramel flavor, known for its refreshing and bubbly taste.",
                "level1_category": "Beverages",
                "level2_category": "Beverages",
                "Nutrients": "Provides quick energy from sugars; no significant nutrients.",
                "appearance": "Clear, dark brown liquid with a fizzy, bubbly effervescence.",
                "ingredients": "Carbonated water, caramel color, high fructose corn syrup, phosphoric acid, natural flavors, caffeine",
                "serving": "Best served chilled in a glass or can, with ice if desired.",
                "flavors": "Sweet, caramel, slightly acidic, fizzy",
                "variations": "Diet Coke, Coca-Cola Zero Sugar, flavored variants like cherry or vanilla",
                "allergy_info": "Contains caffeine; no common allergens but not suitable for caffeine-sensitive individuals.",
                "Calories": "Approximately 140 kcal per 12 oz (355 ml) can",
                "is_vegan": "yes",
                "best_combo": "{\"best_name\":\"Classic Margherita, Garlic Bread Supreme, Chicken Wings (6 pcs)\",\"best_combo\":\"Light, savory, and crispy options complement the refreshing Classic Coke.\",\"best_combo_ids\":\"PIZ0001,PIZ0021\"}",
                "is_deleted": "false",
                "food_type": "veg",
                "is_spice_applicable": "no",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "b3d1ed75-e9df-45d0-a393-fbc1109c0aaa",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0003",
                "name": "Veggie Supreme ",
                "category": "Starters & Small Plates",
                "supplier": "",
                "brand": "",
                "modifiers": "Veggie Supreme addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Veggie Supreme is a hearty vegetarian pizza topped with a variety of fresh vegetables and melted cheese, offering a flavorful and satisfying meal.",
                "comment": "",
                "cost": "",
                "price": "12.49",
                "large_price": "12.49",
                "indining_price": "12.49",
                "indining_large_price": "12.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749534377844-generated-image-1749534377844-1.png",
                "is_enabled": "true",
                "product_description": "Veggie Supreme is a hearty vegetarian pizza topped with a variety of fresh vegetables and melted cheese, offering a flavorful and satisfying meal.",
                "level1_category": "Starters & Small Plates",
                "level2_category": "Breads & Flatbreads",
                "Nutrients": "Rich in vitamins from vegetables and calcium from cheese.",
                "appearance": "Colorful pizza with vibrant vegetable toppings and melted cheese crust.",
                "ingredients": "Tomatoes, bell peppers, onions, olives, cheese, pizza dough, herbs.",
                "serving": "Best enjoyed hot with a side of garlic bread or salad.",
                "flavors": "Savory, cheesy, with fresh vegetable notes.",
                "variations": "Can be made vegan by substituting cheese with plant-based options.",
                "allergy_info": "Contains dairy and gluten; may cause allergies in sensitive individuals.",
                "Calories": "Approximately 250-350 kcal per slice.",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Classic Margherita\",\"best_combo\":\"Both are vegetarian options with complementary flavors.\",\"best_combo_ids\":\"PIZ0001\"}",
                "is_deleted": "false",
                "food_type": "veg",
                "is_spice_applicable": "no",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              }
            ],
            "combo_price": "$74.60",
            "offer_percentage": "10.0",
            "combo_image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1750248161811-generated-image-1750248161811-1.png",
            "item_id": "",
            "is_enabled": true,
            "created_date": "2025-09-09 12-35-13"
          },
          {
            "combo_id": "50ca99a0-b58f-4761-874e-9cab164af716",
            "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
            "title": "Hunger Buster Combo",
            "description": "A satisfying selection of flavorful pizzas, crispy sides, and refreshing beverages, perfect for a hearty meal. Includes cheesy, meaty, vegetarian, and spicy options complemented by classic drinks and sides for a complete dining experience.",
            "products": [
              {
                "pk_id": "c8dee61d-9d99-407d-85c8-a2ebe87e9a14",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0006",
                "name": "Pepperoni Passion ",
                "category": "Starters & Small Plates",
                "supplier": "",
                "brand": "",
                "modifiers": "Pepperoni Passion addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Pepperoni Passion is a classic pizza topped with spicy pepperoni slices, melted cheese, and savory tomato sauce, offering a flavorful and satisfying experience.",
                "comment": "",
                "cost": "",
                "price": "12.99",
                "large_price": "12.99",
                "indining_price": "12.99",
                "indining_large_price": "12.99",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749534684345-generated-image-1749534684345-1.png",
                "is_enabled": "true",
                "product_description": "Pepperoni Passion is a classic pizza topped with spicy pepperoni slices, melted cheese, and savory tomato sauce, offering a flavorful and satisfying experience.",
                "level1_category": "Starters & Small Plates",
                "level2_category": "Appetizers / Starters",
                "Nutrients": "Rich in protein, calcium, and fats from cheese and meat toppings.",
                "appearance": "Golden-brown crust topped with vibrant red pepperoni slices and melted cheese.",
                "ingredients": "Dough, tomato sauce, mozzarella cheese, pepperoni slices, herbs.",
                "serving": "Best enjoyed hot with a side of garlic bread or salad.",
                "flavors": "Savory, spicy, cheesy, and slightly smoky.",
                "variations": "Can be made with different cheeses or vegetarian toppings.",
                "allergy_info": "Contains gluten, dairy, and processed meats; may cause allergies in sensitive individuals.",
                "Calories": "Approximately 300-400 kcal per slice.",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Meat Lover's Delight Pizza, BBQ Chicken Feast Pizza\",\"best_combo\":\"Rich, meaty flavors complement Pepperoni Passion well\",\"best_combo_ids\":\"PIZ0002,PIZ0005\"}",
                "is_deleted": "false",
                "food_type": "non_veg",
                "is_spice_applicable": "yes",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "0a3516ef-4805-4352-bc77-2c7a5c521167",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0019",
                "name": "Cheeseburger Pizza ",
                "category": "Starters & Small Plates",
                "supplier": "",
                "brand": "",
                "modifiers": "Cheeseburger Pizza addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Cheeseburger Pizza combines the flavors of a classic cheeseburger with a crispy pizza crust, topped with beef, cheese, and condiments for a savory experience.",
                "comment": "",
                "cost": "",
                "price": "14.99",
                "large_price": "14.99",
                "indining_price": "14.989",
                "indining_large_price": "14.99",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749537181694-generated-image-1749537179953-4.png",
                "is_enabled": "true",
                "product_description": "Cheeseburger Pizza combines the flavors of a classic cheeseburger with a crispy pizza crust, topped with beef, cheese, and condiments for a savory experience.",
                "level1_category": "Starters & Small Plates",
                "level2_category": "Appetizers / Starters",
                "Nutrients": "Rich in protein, calcium, and fats; provides energy and muscle support.",
                "appearance": "Golden-brown pizza crust topped with melted cheese, beef patties, and burger toppings.",
                "ingredients": "Pizza dough, beef patties, cheese, ketchup, mustard, pickles, onions, lettuce.",
                "serving": "Best enjoyed hot with a side of fries or salad.",
                "flavors": "Savory, cheesy, tangy, with beefy richness.",
                "variations": "Add bacon, jalapeños, or switch to plant-based patties.",
                "allergy_info": "Contains dairy, gluten, and beef; may cause allergies in sensitive individuals.",
                "Calories": "Approximately 600-800 kcal per slice.",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Loaded Paneer Paradise Pizza, Four Cheese Melt Pizza\",\"best_combo\":\"Rich cheesy and flavorful options complement the cheeseburger pizza well.\",\"best_combo_ids\":\"PIZ0015\"}",
                "is_deleted": "false",
                "food_type": "non_veg",
                "is_spice_applicable": "yes",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "02d9711e-2365-476c-9174-2ba463aa3636",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0015",
                "name": "Loaded Paneer Paradise Pizza",
                "category": "Starters & Small Plates",
                "supplier": "",
                "brand": "",
                "modifiers": "Loaded Paneer Paradise",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Loaded Paneer Paradise Pizza features a crispy crust topped with spiced paneer, fresh vegetables, and melted cheese, offering a flavorful vegetarian delight.",
                "comment": "",
                "cost": "",
                "price": "13.99",
                "large_price": "13.99",
                "indining_price": "13.99",
                "indining_large_price": "13.99",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749536855344-generated-image-1749536854924-2.png",
                "is_enabled": "true",
                "product_description": "Loaded Paneer Paradise Pizza features a crispy crust topped with spiced paneer, fresh vegetables, and melted cheese, offering a flavorful vegetarian delight.",
                "level1_category": "Starters & Small Plates",
                "level2_category": "Breads & Flatbreads",
                "Nutrients": "Rich in protein from paneer, calcium, vitamins from vegetables",
                "appearance": "Golden-brown crust with colorful toppings and melted cheese, garnished with herbs.",
                "ingredients": "Paneer, cheese, bell peppers, onions, tomato sauce, spices, herbs, dough",
                "serving": "Best enjoyed hot with a side of green chutney or salad.",
                "flavors": "Savory, cheesy, mildly spicy with aromatic herbs",
                "variations": "Vegan cheese, gluten-free crust, extra vegetables",
                "allergy_info": "Contains dairy and gluten; may cause allergies in sensitive individuals.",
                "Calories": "Approximately 300-400 kcal per slice",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Veggie Supreme, Mediterranean Veggie, Spicy Veggie Volcano\",\"best_combo\":\"Complementary veggie flavors enhance the paneer pizza experience.\",\"best_combo_ids\":\"PIZ0011,PIZ0008\"}",
                "is_deleted": "false",
                "food_type": "veg",
                "is_spice_applicable": "yes",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "ee2aa8fb-01ae-4cdc-8824-843577ea49cd",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0022",
                "name": "Potato Wedges",
                "category": "Sides & Accompaniments",
                "supplier": "",
                "brand": "",
                "modifiers": "Potato Wedges addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Crispy potato wedges are thick-cut potatoes seasoned and baked or fried until golden and crunchy, perfect as a snack or side.",
                "comment": "",
                "cost": "",
                "price": "4.99",
                "large_price": "4.99",
                "indining_price": "4.99",
                "indining_large_price": "4.99",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749538548266-generated-image-1749538548266-1.png",
                "is_enabled": "true",
                "product_description": "Crispy potato wedges are thick-cut potatoes seasoned and baked or fried until golden and crunchy, perfect as a snack or side.",
                "level1_category": "Sides & Accompaniments",
                "level2_category": "Side Dishes",
                "Nutrients": "Rich in carbohydrates and vitamin C, moderate in fiber.",
                "appearance": "Golden-brown, wedge-shaped potatoes with a crispy exterior and fluffy interior.",
                "ingredients": "Potatoes, Olive oil, Salt, Pepper, Paprika, Garlic powder, Herbs",
                "serving": "Best enjoyed with ketchup, aioli, or spicy dips.",
                "flavors": "Savory, Crispy, Slightly smoky with hints of herbs.",
                "variations": "Can be seasoned with cheese, chili, or served with different dips.",
                "allergy_info": "Contains potatoes; check for cross-contamination with gluten or dairy if applicable.",
                "Calories": "Approximately 150-250 kcal per serving",
                "is_vegan": "yes",
                "best_combo": "{\"best_name\":\"Garlic Bread Supreme, Chicken Wings (6 pcs)\",\"best_combo\":\"Perfect sides with potato wedges for added flavor and variety.\",\"best_combo_ids\":\"PIZ0021\"}",
                "is_deleted": "false",
                "food_type": "veg",
                "is_spice_applicable": "yes",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "7f25523c-9de7-4112-a346-55c0acefc8da",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0023",
                "name": "Tandoori Chicken Bites",
                "category": "Entrees",
                "supplier": "",
                "brand": "",
                "modifiers": "Tandoori Chicken Bites addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Tandoori Chicken Bites are tender, marinated chicken pieces cooked in a traditional tandoor, offering smoky and spicy flavors in bite-sized form.",
                "comment": "",
                "cost": "",
                "price": "7.49",
                "large_price": "7.49",
                "indining_price": "7.49",
                "indining_large_price": "7.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749538600422-generated-image-1749538599121-4.png",
                "is_enabled": "true",
                "product_description": "Tandoori Chicken Bites are tender, marinated chicken pieces cooked in a traditional tandoor, offering smoky and spicy flavors in bite-sized form.",
                "level1_category": "Entrees",
                "level2_category": "Specialty Meat Dishes",
                "Nutrients": "High in protein, rich in vitamins and minerals from spices.",
                "appearance": "Golden-brown, charred edges with vibrant red spice coating, served in small pieces.",
                "ingredients": "Chicken,Yogurt,Spices,Garlic,Ginger,Salt,Oil,Red chili powder",
                "serving": "Best enjoyed with mint chutney or yogurt dip.",
                "flavors": "Spicy,Smoky,Tangy",
                "variations": "Can be made vegan with plant-based chicken substitutes.",
                "allergy_info": "Contains dairy and spices; may cause allergies in sensitive individuals.",
                "Calories": "Approximately 150-200 kcal per serving",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Chicken Tikka Pizza, Garlic Bread Supreme\",\"best_combo\":\"Complementary flavors of tandoori spices and garlic bread enhance the meal.\",\"best_combo_ids\":\"PIZ0004\"}",
                "is_deleted": "false",
                "food_type": "non_veg",
                "is_spice_applicable": "yes",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "3ee80a6b-a932-4ccb-a02f-377a91683824",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0024",
                "name": "Classic Pepsi ",
                "category": "Beverages",
                "supplier": "",
                "brand": "",
                "modifiers": "Classic Pepsi addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Classic Pepsi is a carbonated soft drink with a sweet, crisp flavor, known for its refreshing taste and iconic branding.",
                "comment": "",
                "cost": "",
                "price": "2.49",
                "large_price": "2.49",
                "indining_price": "2.49",
                "indining_large_price": "2.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749538665032-generated-image-1749538665032-1.png",
                "is_enabled": "true",
                "product_description": "Classic Pepsi is a carbonated soft drink with a sweet, crisp flavor, known for its refreshing taste and iconic branding.",
                "level1_category": "Beverages",
                "level2_category": "Beverages",
                "Nutrients": "Provides quick energy from sugars; no significant nutrients.",
                "appearance": "Clear, dark caramel-colored liquid in a transparent bottle or can.",
                "ingredients": "Carbonated water, high fructose corn syrup, caramel color, phosphoric acid, caffeine, natural flavors.",
                "serving": "Best served chilled in a glass or can, often with ice.",
                "flavors": "Sweet, caramel, slightly citrusy, fizzy.",
                "variations": "Diet Pepsi, Pepsi Max, flavored variants like cherry or vanilla.",
                "allergy_info": "Contains caffeine; may cause sensitivity in some individuals.",
                "Calories": "Approximately 150 kcal per 12 oz can.",
                "is_vegan": "yes",
                "best_combo": "{\"best_name\":\"Garlic Bread Supreme, Chicken Wings (6 pcs), Potato Wedges\",\"best_combo\":\"Classic Pepsi complements savory sides and crispy appetizers well.\",\"best_combo_ids\":\"PIZ0021,PIZ0022\"}",
                "is_deleted": "false",
                "food_type": "veg",
                "is_spice_applicable": "no",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "aa22f37a-04c0-457c-a9d8-65a1c3abcd9e",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0032",
                "name": "Brownie Bites (4 pcs)",
                "category": "Desserts & Sweets",
                "supplier": "",
                "brand": "",
                "modifiers": "Brownie Bites",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Delicious mini chocolate brownies, moist and fudgy, served in bite-sized pieces perfect for snacking or dessert.",
                "comment": "",
                "cost": "",
                "price": "5.99",
                "large_price": "5.99",
                "indining_price": "5.99",
                "indining_large_price": "5.99",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749539240250-generated-image-1749539231138-4.png",
                "is_enabled": "true",
                "product_description": "Delicious mini chocolate brownies, moist and fudgy, served in bite-sized pieces perfect for snacking or dessert.",
                "level1_category": "Desserts & Sweets",
                "level2_category": "Pastries & Cakes",
                "Nutrients": "Provides energy from sugars and fats, contains antioxidants from chocolate.",
                "appearance": "Small, square, rich brown bites with a glossy chocolate glaze on top.",
                "ingredients": "Chocolate, Flour, Butter, Sugar, Eggs, Cocoa powder, Vanilla extract",
                "serving": "Best enjoyed with a scoop of ice cream or a glass of milk.",
                "flavors": "Rich, Chocolatey, Sweet, Fudgy",
                "variations": "Add nuts, caramel swirls, or vegan chocolate options.",
                "allergy_info": "Contains gluten, dairy, and eggs; may cause allergic reactions.",
                "Calories": "Approximately 150-200 kcal per piece",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Choco Lava Cake, Ice Cream Sundae\",\"best_combo\":\"Rich desserts complement the chocolatey brownie bites perfectly.\",\"best_combo_ids\":\"PIZ0028,PIZ0029\"}",
                "is_deleted": "false",
                "food_type": "non_veg",
                "is_spice_applicable": "no",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "179e17e7-da1c-4b6f-a792-d984cdc177fa",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0031",
                "name": " Cheesecake Slice",
                "category": "Desserts & Sweets",
                "supplier": "",
                "brand": "",
                "modifiers": "Cheesecake Slice",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "A rich, creamy dessert with a smooth cheese filling on a buttery crust, topped with fruit or glaze for added flavor.",
                "comment": "",
                "cost": "",
                "price": "5.99",
                "large_price": "5.99",
                "indining_price": "5.99",
                "indining_large_price": "5.99",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749539157355-generated-image-1749539156897-2.png",
                "is_enabled": "true",
                "product_description": "A rich, creamy dessert with a smooth cheese filling on a buttery crust, topped with fruit or glaze for added flavor.",
                "level1_category": "Desserts & Sweets",
                "level2_category": "Pastries & Cakes",
                "Nutrients": "Rich in calcium, protein, and fats; high in calories",
                "appearance": "A triangular slice with a smooth, creamy surface and a graham cracker crust base.",
                "ingredients": "Cream cheese, sugar, eggs, graham cracker crust, vanilla extract, sour cream",
                "serving": "Best enjoyed chilled, topped with fresh fruit or fruit compote.",
                "flavors": "Sweet, tangy, creamy with hints of vanilla and buttery crust",
                "variations": "Chocolate, fruit-topped, no-bake, vegan options available",
                "allergy_info": "Contains dairy and eggs; may cause allergies in sensitive individuals",
                "Calories": "Approximately 300-400 kcal per slice",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Choco Lava Cake, Ice Cream Sundae\",\"best_combo\":\"Rich desserts complement the creamy cheesecake perfectly.\",\"best_combo_ids\":\"PIZ0028,PIZ0029\"}",
                "is_deleted": "false",
                "food_type": "non_veg",
                "is_spice_applicable": "no",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "dcbe286c-43c2-4f27-b9aa-8a339344f0c7",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0016",
                "name": "Buffalo Chicken Blast Pizza",
                "category": "Starters & Small Plates",
                "supplier": "",
                "brand": "",
                "modifiers": "Buffalo Chicken Blast addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Buffalo Chicken Blast Pizza features a crispy crust topped with spicy buffalo sauce, tender chicken, and melty cheese, offering a bold flavor experience.",
                "comment": "",
                "cost": "",
                "price": "13.49",
                "large_price": "13.49",
                "indining_price": "13.49",
                "indining_large_price": "13.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749536945765-generated-image-1749536944781-3.png",
                "is_enabled": "true",
                "product_description": "Buffalo Chicken Blast Pizza features a crispy crust topped with spicy buffalo sauce, tender chicken, and melty cheese, offering a bold flavor experience.",
                "level1_category": "Starters & Small Plates",
                "level2_category": "Appetizers / Starters",
                "Nutrients": "Rich in protein and calcium, moderate in fats and carbs.",
                "appearance": "Golden-brown crust with vibrant red buffalo sauce, chicken pieces, and melted cheese topping.",
                "ingredients": "Pizza dough, chicken, buffalo sauce, cheese, blue cheese, celery, ranch dressing",
                "serving": "Best enjoyed hot with a side of celery sticks or ranch dressing.",
                "flavors": "Spicy, tangy, cheesy, savory",
                "variations": "Can be made with plant-based chicken or less spicy sauce.",
                "allergy_info": "Contains dairy, gluten, and possible soy; may cause allergies in sensitive individuals.",
                "Calories": "Approximately 300-400 kcal per slice",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Meat Lover's Delight Pizza,BBQ Chicken Feast Pizza,Spicy Veggie Volcano\",\"best_combo\":\"Enhances spicy and meaty flavors, creating a bold, satisfying combo.\",\"best_combo_ids\":\"PIZ0002,PIZ0005,PIZ0008\"}",
                "is_deleted": "false",
                "food_type": "non_veg",
                "is_spice_applicable": "yes",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              }
            ],
            "combo_price": "$74.17",
            "offer_percentage": "10.0",
            "combo_image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1750249766723-generated-image-1750249761907-3.png",
            "item_id": "",
            "is_enabled": true,
            "created_date": "2025-09-09 12-35-13"
          },
          {
            "combo_id": "b902f691-9bfd-4225-aa32-aa701786bbf4",
            "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
            "title": "Spicy Crust Combo",
            "description": "The Spicy Crust Combo typically features a pizza with a flavorful, spicy crust that adds an extra kick to your favorite toppings. It often includes a variety of ingredients like spicy sausage, jalapeños, pepperoni, or other bold flavors, all served on a crust that’s seasoned with spices to enhance the heat and taste. This combo is perfect for those who enjoy a fiery twist on their pizza. For specific details or to customize your order, please check with your local pizzeria or restaurant.",
            "products": [
              {
                "pk_id": "f03c1c36-597d-4afc-ab37-3700b0f70d35",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0001",
                "name": "Classic Margherita",
                "category": "Starters & Small Plates",
                "supplier": "",
                "brand": "",
                "modifiers": "Classic Margherita addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Classic Margherita is a traditional Italian pizza featuring a thin crust topped with fresh tomatoes, mozzarella, basil, and olive oil, offering a simple yet flavorful experience.",
                "comment": "",
                "cost": "",
                "price": "10.99",
                "large_price": "10.99",
                "indining_price": "10.99",
                "indining_large_price": "10.99",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1750428613430-generated-image-1750428613430-1.png",
                "is_enabled": true,
                "product_description": "A Margherita pizza is a classic Italian dish known for its simple yet flavorful ingredients. It typically features a thin, crisp crust topped with a vibrant tomato sauce made from fresh, ripe tomatoes. The pizza is adorned with slices of fresh mozzarella cheese that melt beautifully during baking, creating a creamy texture. Fresh basil leaves are added on top, providing a fragrant, herbal aroma and a splash of color. Often finished with a drizzle of extra virgin olive oil, the Margherita pizza embodies a harmonious balance of fresh, high-quality ingredients, highlighting the essence of traditional Italian cuisine.",
                "level1_category": "Starters & Small Plates",
                "level2_category": "Breads & Flatbreads",
                "Nutrients": "Rich in calcium, protein, and antioxidants from fresh ingredients.",
                "appearance": "Golden-brown thin crust with vibrant red tomatoes, white mozzarella, and green basil leaves.",
                "ingredients": "Flour, tomatoes, mozzarella cheese, basil, olive oil, salt, yeast",
                "serving": "Best enjoyed hot with a drizzle of olive oil or fresh basil leaves.",
                "flavors": "Fresh, Savory, Herbaceous",
                "variations": "Add extra toppings like prosciutto or chili flakes for variation.",
                "allergy_info": "Contains gluten, dairy, and basil; may affect allergies.",
                "Calories": "Approximately 250-300 kcal per slice",
                "is_vegan": "no",
                "best_combo": [],
                "is_deleted": false,
                "food_type": "veg",
                "is_spice_applicable": "no",
                "meal_time": "",
                "inventory_status": true,
                "is_item_verified": true,
                "account_id": "",
                "party_orders": [
                  {
                    "name": "small",
                    "serving": "10",
                    "price": "109.90"
                  },
                  {
                    "name": "medium",
                    "serving": "25",
                    "price": "274.75"
                  },
                  {
                    "name": "large",
                    "serving": "50",
                    "price": "549.50"
                  }
                ],
                "modifiers_list": [
                  {
                    "name": "Classic Margherita addon",
                    "is_multi_select": "No",
                    "is_forced": "Yes",
                    "options": [
                      {
                        "name": "Extra cheese",
                        "price": "$1.25",
                        "isEnabled": true
                      },
                      {
                        "name": "Cherry tomatoes",
                        "price": "$0.75",
                        "isEnabled": true
                      },
                      {
                        "name": "Garlic crust",
                        "price": "$1.50",
                        "isEnabled": true
                      },
                      {
                        "name": "Arugula",
                        "price": "$0.75",
                        "isEnabled": true
                      }
                    ]
                  }
                ]
              },
              {
                "pk_id": "b3d1ed75-e9df-45d0-a393-fbc1109c0aaa",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0003",
                "name": "Veggie Supreme ",
                "category": "Starters & Small Plates",
                "supplier": "",
                "brand": "",
                "modifiers": "Veggie Supreme addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Veggie Supreme is a hearty vegetarian pizza topped with a variety of fresh vegetables and melted cheese, offering a flavorful and satisfying meal.",
                "comment": "",
                "cost": "",
                "price": "12.49",
                "large_price": "12.49",
                "indining_price": "12.49",
                "indining_large_price": "12.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749534377844-generated-image-1749534377844-1.png",
                "is_enabled": true,
                "product_description": "Veggie Supreme is a hearty vegetarian pizza topped with a variety of fresh vegetables and melted cheese, offering a flavorful and satisfying meal.",
                "level1_category": "Starters & Small Plates",
                "level2_category": "Breads & Flatbreads",
                "Nutrients": "Rich in vitamins from vegetables and calcium from cheese.",
                "appearance": "Colorful pizza with vibrant vegetable toppings and melted cheese crust.",
                "ingredients": "Tomatoes, bell peppers, onions, olives, cheese, pizza dough, herbs.",
                "serving": "Best enjoyed hot with a side of garlic bread or salad.",
                "flavors": "Savory, cheesy, with fresh vegetable notes.",
                "variations": "Can be made vegan by substituting cheese with plant-based options.",
                "allergy_info": "Contains dairy and gluten; may cause allergies in sensitive individuals.",
                "Calories": "Approximately 250-350 kcal per slice.",
                "is_vegan": "no",
                "best_combo": {
                  "best_name": "Classic Margherita",
                  "best_combo": "Both are vegetarian options with complementary flavors.",
                  "best_combo_ids": "PIZ0001"
                },
                "is_deleted": false,
                "food_type": "veg",
                "is_spice_applicable": "no",
                "meal_time": "",
                "inventory_status": true,
                "is_item_verified": true,
                "account_id": "",
                "party_orders": [
                  {
                    "name": "small",
                    "serving": "10",
                    "price": "124.90"
                  },
                  {
                    "name": "medium",
                    "serving": "25",
                    "price": "312.25"
                  },
                  {
                    "name": "large",
                    "serving": "50",
                    "price": "624.50"
                  }
                ],
                "modifiers_list": [
                  {
                    "name": "Veggie Supreme addon",
                    "is_multi_select": "No",
                    "is_forced": "Yes",
                    "options": [
                      {
                        "name": "Spinach",
                        "price": "$0.75",
                        "isEnabled": true
                      },
                      {
                        "name": "feta",
                        "price": "$1.50",
                        "isEnabled": true
                      },
                      {
                        "name": "pesto swirl",
                        "price": "$1.50",
                        "isEnabled": true
                      }
                    ]
                  }
                ]
              },
              {
                "pk_id": "4f60847b-b066-4754-81c8-330f11095786",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0007",
                "name": "Hawaiian Classic Pizza",
                "category": "Entrees",
                "supplier": "",
                "brand": "",
                "modifiers": "Hawaiian Classic addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Hawaiian Classic Pizza features a crispy crust topped with tomato sauce, cheese, ham, and pineapple chunks, offering a sweet and savory flavor profile.",
                "comment": "",
                "cost": "",
                "price": "12.49",
                "large_price": "12.49",
                "indining_price": "12.49",
                "indining_large_price": "12.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749534761684-generated-image-1749534760104-4.png",
                "is_enabled": true,
                "product_description": "Hawaiian Classic Pizza features a crispy crust topped with tomato sauce, cheese, ham, and pineapple chunks, offering a sweet and savory flavor profile.",
                "level1_category": "Entrees",
                "level2_category": "Pizzas & Flatbreads",
                "Nutrients": "Provides carbs, protein, calcium, and vitamins from toppings.",
                "appearance": "Golden-brown crust with melted cheese, ham slices, and pineapple pieces on top.",
                "ingredients": "Pizza dough, tomato sauce, mozzarella cheese, ham, pineapple, olive oil, herbs.",
                "serving": "Best enjoyed hot with a side of garlic bread or salad.",
                "flavors": "Sweet, savory, cheesy, with a hint of tang from pineapple.",
                "variations": "Can add bacon, jalapeños, or substitute ham with turkey.",
                "allergy_info": "Contains dairy, gluten, and possibly soy; check for allergies.",
                "Calories": "Approximately 250-350 kcal per slice.",
                "is_vegan": "no",
                "best_combo": {
                  "best_name": "Meat Lover's Delight Pizza, BBQ Chicken Feast Pizza",
                  "best_combo": "Rich, savory flavors complement the sweet and savory Hawaiian pizza",
                  "best_combo_ids": "PIZ0002,PIZ0005"
                },
                "is_deleted": false,
                "food_type": "non_veg",
                "is_spice_applicable": "no",
                "meal_time": "",
                "inventory_status": true,
                "is_item_verified": true,
                "account_id": "",
                "party_orders": [
                  {
                    "name": "small",
                    "serving": "10",
                    "price": "124.90"
                  },
                  {
                    "name": "medium",
                    "serving": "25",
                    "price": "312.25"
                  },
                  {
                    "name": "large",
                    "serving": "50",
                    "price": "624.50"
                  }
                ],
                "modifiers_list": [
                  {
                    "name": "Hawaiian Classic addon",
                    "is_multi_select": "No",
                    "is_forced": "Yes",
                    "options": [
                      {
                        "name": "Bacon",
                        "price": "$1.75",
                        "isEnabled": true
                      },
                      {
                        "name": "red onions",
                        "price": "$0.60",
                        "isEnabled": true
                      },
                      {
                        "name": "sweet chili drizzle",
                        "price": "$0.60",
                        "isEnabled": true
                      },
                      {
                        "name": "spicy crust",
                        "price": "$1.25",
                        "isEnabled": true
                      }
                    ]
                  }
                ]
              }
            ],
            "combo_price": "$34.17",
            "offer_percentage": "5.0",
            "combo_image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1752215177271-generated-image-1752215176604-2.png",
            "item_id": "",
            "is_enabled": true,
            "created_date": "2025-09-09 12-35-13"
          },
          {
            "combo_id": "8a1b8f6b-00cc-46e7-b54f-53e98c404317",
            "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
            "title": "Veggie supreme",
            "description": "Introducing our Veggie Supreme Pizza Combo—an irresistible feast for your senses! Dive into a flavorful medley of fresh, crisp vegetables topped with gooey, melted cheese and our signature sauce, all nestled on a perfectly baked crust. The Veggie Supreme is a vibrant celebration of wholesome ingredients, crafted to satisfy both your cravings and your health-conscious choices. Paired with our refreshing, chilled Coke, this combo offers the perfect harmony of savory and fizzy delight. Whether you're sharing with friends or treating yourself, the Veggie Supreme Pizza Combo promises a deliciously satisfying experience that will leave you craving more!",
            "products": [
              {
                "pk_id": "3c127c52-479a-4f61-b36f-9365af4bd8bb",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0025",
                "name": "Classic Coke",
                "category": "Beverages",
                "supplier": "",
                "brand": "",
                "modifiers": "Classic  Coke addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Classic Coke is a carbonated soft drink with a sweet, caramel flavor, known for its refreshing and bubbly taste.",
                "comment": "",
                "cost": "",
                "price": "2.49",
                "large_price": "2.49",
                "indining_price": "2.49",
                "indining_large_price": "2.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749538739474-generated-image-1749538739474-1.png",
                "is_enabled": true,
                "product_description": "Classic Coke is a carbonated soft drink with a sweet, caramel flavor, known for its refreshing and bubbly taste.",
                "level1_category": "Beverages",
                "level2_category": "Beverages",
                "Nutrients": "Provides quick energy from sugars; no significant nutrients.",
                "appearance": "Clear, dark brown liquid with a fizzy, bubbly effervescence.",
                "ingredients": "Carbonated water, caramel color, high fructose corn syrup, phosphoric acid, natural flavors, caffeine",
                "serving": "Best served chilled in a glass or can, with ice if desired.",
                "flavors": "Sweet, caramel, slightly acidic, fizzy",
                "variations": "Diet Coke, Coca-Cola Zero Sugar, flavored variants like cherry or vanilla",
                "allergy_info": "Contains caffeine; no common allergens but not suitable for caffeine-sensitive individuals.",
                "Calories": "Approximately 140 kcal per 12 oz (355 ml) can",
                "is_vegan": "yes",
                "best_combo": {
                  "best_name": "Classic Margherita, Garlic Bread Supreme, Chicken Wings (6 pcs)",
                  "best_combo": "Light, savory, and crispy options complement the refreshing Classic Coke.",
                  "best_combo_ids": "PIZ0001,PIZ0021"
                },
                "is_deleted": false,
                "food_type": "veg",
                "is_spice_applicable": "no",
                "meal_time": "",
                "inventory_status": true,
                "is_item_verified": true,
                "account_id": "",
                "party_orders": [
                  {
                    "name": "small",
                    "serving": "12",
                    "price": "29.88"
                  },
                  {
                    "name": "medium",
                    "serving": "50",
                    "price": "124.50"
                  },
                  {
                    "name": "large",
                    "serving": "100",
                    "price": "249.00"
                  }
                ],
                "modifiers_list": [
                  {
                    "name": "Classic  Coke addon",
                    "is_multi_select": "No",
                    "is_forced": "Yes",
                    "pk_id": "f7b73e50-eae9-4329-9a7c-82aac702a1ab",
                    "options": [
                      {
                        "name": "Ice-free option",
                        "price": "$0",
                        "isEnabled": true
                      },
                      {
                        "name": "lemon twist",
                        "price": "$0.50",
                        "isEnabled": true
                      }
                    ]
                  }
                ]
              },
              {
                "pk_id": "b3d1ed75-e9df-45d0-a393-fbc1109c0aaa",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0003",
                "name": "Veggie Supreme ",
                "category": "Starters & Small Plates",
                "supplier": "",
                "brand": "",
                "modifiers": "",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Veggie Supreme is a hearty vegetarian pizza topped with a variety of fresh vegetables and melted cheese, offering a flavorful and satisfying meal.",
                "comment": "",
                "cost": "",
                "price": "13",
                "large_price": "12.49",
                "indining_price": "1",
                "indining_large_price": "12.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749534377844-generated-image-1749534377844-1.png",
                "is_enabled": true,
                "product_description": "Veggie Supreme is a hearty vegetarian pizza topped with a variety of fresh vegetables and melted cheese, offering a flavorful and satisfying meal.",
                "level1_category": "Starters & Small Plates",
                "level2_category": "Breads & Flatbreads",
                "Nutrients": "Rich in vitamins from vegetables and calcium from cheese.",
                "appearance": "Colorful pizza with vibrant vegetable toppings and melted cheese crust.",
                "ingredients": "Tomatoes, bell peppers, onions, olives, cheese, pizza dough, herbs.",
                "serving": "Best enjoyed hot with a side of garlic bread or salad.",
                "flavors": "Savory, cheesy, with fresh vegetable notes.",
                "variations": "Can be made vegan by substituting cheese with plant-based options.",
                "allergy_info": "Contains dairy and gluten; may cause allergies in sensitive individuals.",
                "Calories": "Approximately 250-350 kcal per slice.",
                "is_vegan": "no",
                "best_combo": {
                  "best_name": "Classic Margherita",
                  "best_combo": "Both are vegetarian options with complementary flavors.",
                  "best_combo_ids": "PIZ0001"
                },
                "is_deleted": false,
                "food_type": "veg",
                "is_spice_applicable": "Yes",
                "meal_time": "",
                "inventory_status": true,
                "is_item_verified": true,
                "account_id": "",
                "party_orders": [
                  {
                    "name": "small",
                    "serving": "10",
                    "price": "124.90"
                  },
                  {
                    "name": "medium",
                    "serving": "25",
                    "price": "312.25"
                  },
                  {
                    "name": "large",
                    "serving": "50",
                    "price": "624.50"
                  }
                ]
              }
            ],
            "combo_price": "$14.72",
            "offer_percentage": "5.0",
            "combo_image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1754874940426-generated-image-1754874932453-4.png",
            "item_id": "",
            "is_enabled": true,
            "created_date": "2025-09-09 12-35-13"
          }]
        }
      },
      {
        "type": "BasicExperienceCard",
        "data": {
          "headerContent": "<h2 class='text-3xl md:text-4xl font-bold text-gray-900 text-center mb-6'>Our Experience</h2><p class='text-lg text-gray-600 text-center max-w-3xl mx-auto leading-relaxed'>Discover what makes our sample business special through our approach and dedication.</p>",
          "cards": [
            {
              "id": "1",
              "title": "Quality Service",
              "description": "We provide sample service to demonstrate the layout and structure for your website.",
              "icon": "⭐"
            },
            {
              "id": "2",
              "title": "Expert Team",
              "description": "Our sample team consists of placeholder professionals showcasing this section.",
              "icon": "👥"
            },
            {
              "id": "3",
              "title": "Innovation",
              "description": "This card shows how to highlight features like innovation using placeholder text.",
              "icon": "💡"
            },
            {
              "id": "4",
              "title": "Customer Focus",
              "description": "Your satisfaction is important; this is generic text demonstrating customer focus.",
              "icon": "🎯"
            }
          ],
          "backgroundColor": "#f9fafb"
        }

      },
      {
        "type": "BasicStory",
        "data": {
          "hero": {
            "image": "https://thumbs.dreamstime.com/b/unhealthy-fast-food-delivery-menu-featuring-assorted-burgers-cheeseburgers-nuggets-french-fries-soda-high-calorie-low-356045884.jpg",
            "title": "Our Story"
          },
          "title": "The Story of Our Sample Restaurant",
          "storyContent": "<p>Once upon a time, in a small bustling town, there was a cozy little sample restaurant. This is placeholder text describing the beginnings of the restaurant for demonstration purposes.</p><p>The chef had a passion for creating delicious meals and providing a warm atmosphere. With care and dedication, they opened this sample restaurant to share good food and joy with the community.</p><p>Our approach is simple: use fresh ingredients, prepare each dish thoughtfully, and serve it with a smile. This is sample content for the story section and can be replaced with real information later.</p>"
        }

      },
      {
        "type": "BasicBlog",
        "data": {
          "title": "<h2 class='text-3xl font-bold text-gray-900 mb-4'>Latest Blog Posts</h2>",
          "subtitle": "<p class='text-gray-600 text-lg'>Discover our latest stories and insights</p>",
          "posts": [
            {
              "id": "1",
              "title": "<h3 class='text-xl font-bold text-gray-900'>Sample Blog Post One</h3>",
              "content": "<p class='text-gray-700 leading-relaxed'>This is a placeholder content for a sample blog post. Replace it with your own text for actual blog entries.</p>",
              "excerpt": "<p class='text-gray-600'>This is a sample excerpt for the blog post.</p>",
              "image": "https://images.unsplash.com/photo-1499750310107-5fef28a66643?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8YmxvZ3xlbnwwfHwwfHx8MA%3D%3D",
              "date": "2024-01-01T00:00:00.000Z",
              "readTime": "5 min",
              "category": "Sample",
              "isEnabled": true
            },
            {
              "id": "2",
              "title": "<h3 class='text-xl font-bold text-gray-900'>Sample Blog Post Two</h3>",
              "content": "<p class='text-gray-700 leading-relaxed'>Another placeholder content for a sample blog post. Use this format to display blog content in preview mode.</p>",
              "excerpt": "<p class='text-gray-600'>This is a sample excerpt for the second blog post.</p>",
              "image": "https://images.unsplash.com/photo-1488190211105-8b0e65b80b4e?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
              "date": "2024-01-02T00:00:00.000Z",
              "readTime": "3 min",
              "category": "Sample",
              "isEnabled": true
            }
          ],
          "postsPerPage": 6,
          "showCategory": true,
          "showReadTime": true,
          "showAuthor": false,
          "backgroundColor": "#ffffff",
          "textColor": "#1f2937",
          "cardBackgroundColor": "#ffffff",
          "primaryColor": "#EF4444"
        }

      },
      {
        "type": "BasicGallery",
        "data": {
          "section": {
            "title": "Culinary Artistry",
            "subtitle": "A visual celebration of our gastronomic creations",
            "description": "Each dish is a canvas where flavors, textures, and visual beauty come together in perfect harmony."
          },
          "images": [
            {
              "id": "1",
              "url": "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=500&h=500&fit=crop",
              "title": "Elegant Presentation",
              "description": "Where artistry meets gastronomy",
              "isVisible": true
            },
            {
              "id": "2",
              "url": "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=500&h=500&fit=crop",
              "title": "Chef's Precision",
              "description": "Meticulous attention to every detail",
              "isVisible": true
            },
            {
              "id": "3",
              "url": "https://images.unsplash.com/photo-1540420773420-3366772f4999?w=500&h=500&fit=crop",
              "title": "Premium Ingredients",
              "description": "Only the finest seasonal selections",
              "isVisible": true
            },
            {
              "id": "4",
              "url": "https://images.unsplash.com/photo-1574071318508-1cdbab80d002?w=500&h=500&fit=crop",
              "title": "Sophisticated Ambiance",
              "description": "An atmosphere of refined elegance",
              "isVisible": true
            }
          ],
          "cta": {
            "text": "Follow @CulinaryJourney",
            "link": "https://instagram.com/culinaryjourney"
          }
        }

      },
      {
        "type": "BasicEvents",
        "data": {
          "isEnabled": true,
          "section": {
            "title": "Upcoming Events",
            "subtitle": "Stay tuned for our upcoming events!",
            "primaryColor": "#EF4444",
            "secondaryColor": "#DC2626",
            "accentColor": "#B91C1C",
            "textColor": "#374151"
          },
          "items": [
            {
              "id": "event-1",
              "title": "Sample Event",
              "description": "This is a placeholder description for a sample event. Event details will be updated soon.",
              "image": "https://thumbs.dreamstime.com/b/buffet-dinner-restaurant-catering-food-concept-66884106.jpg",
              "date": "2024-01-01",
              "time": "18:00",
              "location": "Sample Venue",
              "isVisible": true
            }
          ]
        }

      },
      {
        "type": "BasicContactForm",
        "data": {
          "title": "Contact Us",
          "subtitle": "We’d love to hear from you. This is sample text for demonstration purposes.",
          "primaryColor": "#E7000B",
          "textColor": "#1F2937",
          "backgroundColor": "#FFFFFF",
          "formBackgroundColor": "#F9FAFB",
          "cardBackgroundColor": "#FFFFFF",
          "submitButtonText": "SUBMIT",
          "successMessage": "Thank you for reaching out! This is a sample success message.",
          "errorMessage": "Oops! Something went wrong. Please try again later.",
          "contactInfo": {
            "email": {
              "title": "Email Us",
              "description": "Send us an email",
              "address": "info@sample.com"
            },
            "phone": {
              "title": "Call Us",
              "description": "Call us directly",
              "number": "(000) 000-0000"
            },
            "address": {
              "title": "Visit Us",
              "description": "Visit our office",
              "full": "123 Sample Street, Sample City, Country"
            }
          },
          "formFields": {
            "name": {
              "enabled": true,
              "required": true,
              "label": "Name",
              "placeholder": "Your Name"
            },
            "email": {
              "enabled": true,
              "required": true,
              "label": "Email",
              "placeholder": "Your Email"
            },
            "phone": {
              "enabled": true,
              "required": false,
              "label": "Phone",
              "placeholder": "Your Phone"
            },
            "message": {
              "enabled": true,
              "required": true,
              "label": "Message",
              "placeholder": "Your Message"
            }
          }
        }

      },
      {
        "type": "BasicFooter",
        "data": {
          "restaurantName": "Sample Restaurant",
          "description": "<p>Welcome to our <strong>sample restaurant</strong>. Enjoy a delightful dining experience with <em>delicious meals</em>, friendly service, and a cozy atmosphere.</p>",
          "phone": "(000) 000-0000",
          "email": "info@samplerestaurant.com",
          "address": "123 Sample Street, Sample City, Country 00000",
          "hours": "Opening hours not available",
          "quickLinks": [
            { "id": "1", "label": "Menu", "url": "/menu" },
            { "id": "2", "label": "About Us", "url": "/about" },
            { "id": "3", "label": "Blog", "url": "/blog" },
            { "id": "4", "label": "Gallery", "url": "/gallery" },
            { "id": "5", "label": "Events", "url": "/events" },
            { "id": "6", "label": "Contact", "url": "/contact" }
          ],
          "socialLinks": [
            { "id": "1", "platform": "facebook", "url": "https://facebook.com/sample" },
            { "id": "2", "platform": "instagram", "url": "https://instagram.com/sample" },
            { "id": "3", "platform": "twitter", "url": "https://twitter.com/sample" }
          ],
          "newsletterTitle": "<h4 class=\"text-lg font-semibold\">Stay <span class=\"text-yellow-400\">Connected</span></h4>",
          "newsletterDescription": "<p>Subscribe to our newsletter for <strong>updates</strong>, <em>special offers</em>, and <strong>news</strong>.</p>",
          "showNewsletter": true,
          "copyrightText": "<p>© 2024 <strong>Sample Restaurant</strong>. All rights reserved.</p>",
          "legalLinks": [
            {
              "id": "1",
              "label": "Privacy Policy",
              "url": "/privacy",
              "content": "<p>This is a <strong>sample privacy policy</strong>. It explains how your data might be collected and used in a demo environment.</p>"
            },
            {
              "id": "2",
              "label": "Terms of Service",
              "url": "/terms",
              "content": "<p>These are <strong>sample terms of service</strong>. By using this demo, you agree to placeholder terms.</p>"
            },
            {
              "id": "3",
              "label": "Cookie Policy",
              "url": "/cookies",
              "content": "<p>This is a <strong>sample cookie policy</strong>. It describes the use of cookies in a demo context.</p>"
            }
          ],
          "backgroundColor": "#0f172a",
          "textColor": "#f1f5f9",
          "linkColor": "#f59e0b",
          "borderColor": "#EF4322"
        }

      }
    ]
  },

  culinary_journey: {
    "widgets": [
      {
        "type": "ClassicNav",
        "data": {
          "logoUrl": "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=200&h=80&fit=crop",
          "logoText": "The Cozy Corner",
          "items": [
            { "id": "1", "label": "Menu", "url": "/menu", "isEnabled": true },
            { "id": "2", "label": "Our Story", "url": "/our-story", "isEnabled": true },
            { "id": "3", "label": "Blog", "url": "/blog", "isEnabled": true },
            { "id": "4", "label": "Gallery", "url": "/gallery", "isEnabled": true },
            { "id": "5", "label": "Events", "url": "/events", "isEnabled": true },
            { "id": "6", "label": "Contact", "url": "/contact", "isEnabled": true }
          ],
          "backgroundColor": "#000000",
          "textColor": "#ffffff",
          "contactInfo": "Call us: (555) COZY-123",
          "showSearchIcon": true,
          "showCartIcon": true,
          "showOrderButton": true,
          "orderButtonText": "Order Takeout",
        "orderButtonColor": "#EF4322"
        }
      },
      {
        "type": "ClassicBanner",
        "data": {
          "slides": [
            {
              "id": "slide-1",
              "title": "Sample Title One",
              "subtitle": "Sample Subtitle One",
              "description": "This is a sample description for slide one. It is placeholder text only.",
              "backgroundImage": "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/2b/25/4b/34/food-menu-assortment.jpg?w=900&h=500&s=1",
              "backgroundColor": "#333333",
              "textAlignment": "center",
              "textColor": "#ffffff",
              "overlayOpacity": 0.5,
              "overlayColor": "rgba(0,0,0,0.5)",
              "ctaButtons": [
                {
                  "id": "cta-1",
                  "text": "Sample Button One",
                  "url": "/sample-one",
                  "variant": "primary",
                  "backgroundColor": "#555555",
                  "color": "#ffffff",
                  "visible": true
                }
              ]
            },
            {
              "id": "slide-2",
              "title": "Sample Title Two",
              "subtitle": "Sample Subtitle Two",
              "description": "This is a sample description for slide two. It is placeholder text only.",
              "backgroundImage": "https://restaurantindia.s3.ap-south-1.amazonaws.com/s3fs-public/2025-02/BeFunky-collage.1%20%2824%29.jpg",
              "backgroundColor": "#444444",
              "textAlignment": "left",
              "textColor": "#ffffff",
              "overlayOpacity": 0.4,
              "overlayColor": "rgba(0,0,0,0.4)",
              "ctaButtons": [
                {
                  "id": "cta-2",
                  "text": "Sample Button Two",
                  "url": "/sample-two",
                  "variant": "secondary",
                  "backgroundColor": "#666666",
                  "color": "#ffffff",
                  "visible": true
                }
              ]
            }
          ]
        }
      },
      {
        "type": "ClassicPopularItems",
        "data": {
          "content": "<h2 class=\"text-3xl md:text-4xl font-bold text-gray-900 mb-4\">Family <span class=\"text-orange-600\">Favorites</span></h2><p class=\"text-gray-600 text-lg max-w-2xl mx-auto\">The comfort food classics that keep our guests coming back for more</p>",
          "backgroundColor": "#ffffff",
          "selectedItemIds": [],
          "emptyStateContent": "<h3 class=\"text-lg sm:text-xl font-semibold mb-2\">Comfort Food Coming Soon</h3><p class=\"text-sm sm:text-base max-w-md\">Our beloved family favorites will be featured here.</p>",
          "showRating": true,
          "menuData": [{
            "pk_id": "f03c1c36-597d-4afc-ab37-3700b0f70d35",
            "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
            "restaurant_parent_id": null,
            "sku_id": "PIZ0001",
            "name": "Classic Margherita",
            "category": "Entrees",
            "supplier": "",
            "brand": "",
            "modifiers": "Classic Margherita addon,addon",
            "unit": "",
            "taxable": "",
            "external_id": "",
            "bar_code": "",
            "description": "A Margherita pizza is a classic Italian dish known for its simple yet flavorful ingredients. It typically features a thin, crisp crust topped with a vibrant tomato sauce made from fresh, ripe tomatoes. The pizza is adorned with slices of fresh mozzarella cheese that melt beautifully during baking, creating a creamy texture. Fresh basil leaves are added on top, providing a fragrant, herbal aroma and a splash of color. Often finished with a drizzle of extra virgin olive oil, the Margherita pizza embodies a harmonious balance of fresh, high-quality ingredients, highlighting the essence of traditional Italian cuisine.",
            "comment": "",
            "cost": "",
            "price": "11",
            "large_price": "11",
            "indining_price": "9",
            "indining_large_price": "11",
            "quantity": "",
            "min_quantity": "",
            "max_quantity": "",
            "countable": "",
            "use_weighing_scale": "",
            "item_type": "",
            "duration": "",
            "discounts": "",
            "resources": "",
            "service_providers": "",
            "printer_type": "",
            "deposit": "",
            "visibility": "",
            "favorite": "",
            "sort_index": "",
            "tags": "",
            "out_of_stock": "",
            "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1754577442034-generated-image-1754577438889-2.png",
            "is_enabled": true,
            "product_description": "A Margherita pizza is a classic Italian dish known for its simple yet flavorful ingredients. It typically features a thin, crisp crust topped with a vibrant tomato sauce made from fresh, ripe tomatoes. The pizza is adorned with slices of fresh mozzarella cheese that melt beautifully during baking, creating a creamy texture. Fresh basil leaves are added on top, providing a fragrant, herbal aroma and a splash of color. Often finished with a drizzle of extra virgin olive oil, the Margherita pizza embodies a harmonious balance of fresh, high-quality ingredients, highlighting the essence of traditional Italian cuisine.",
            "level1_category": "Entrees",
            "level2_category": "Vegetable Based Mains",
            "Nutrients": "Rich in calcium, protein, and antioxidants from fresh ingredients.",
            "appearance": "Golden-brown thin crust with vibrant red tomatoes, white mozzarella, and green basil leaves.",
            "ingredients": [
              "Flour",
              " tomatoes",
              " mozzarella cheese",
              " basil",
              " olive oil",
              " salt",
              " yeast"
            ],
            "serving": "Best enjoyed hot with a drizzle of olive oil or fresh basil leaves.",
            "flavors": "Fresh, Savory, Herbaceous",
            "variations": "Add extra toppings like prosciutto or chili flakes for variation.",
            "allergy_info": "Contains gluten, dairy, and basil; may affect allergies.",
            "Calories": "Approximately 250-300 kcal per slice",
            "is_vegan": "No",
            "best_combo": [],
            "is_deleted": false,
            "food_type": "Veg",
            "is_spice_applicable": "Yes",
            "meal_time": "",
            "inventory_status": true,
            "is_item_verified": true,
            "account_id": "",
            "party_orders": [
              {
                "name": "small",
                "serving": "10",
                "price": "109.90"
              },
              {
                "name": "medium",
                "serving": "25",
                "price": "274.75"
              },
              {
                "name": "large",
                "serving": "50",
                "price": "549.50"
              }
            ],
            "pos_item_id": "",
            "modifiers_list": [
              {
                "name": "Classic Margherita addon",
                "is_multi_select": "No",
                "is_forced": "Yes",
                "pk_id": "685b5545-c9cc-48e1-b99b-ce99e7a9a1e5",
                "pos_group_id": "",
                "options": [
                  {
                    "name": "Extra cheese",
                    "price": "$1.25",
                    "isEnabled": true
                  },
                  {
                    "name": "Cherry tomatoes",
                    "price": "$0.75",
                    "isEnabled": true
                  },
                  {
                    "name": "Garlic crust",
                    "price": "$1.50",
                    "isEnabled": true
                  }
                ]
              }
            ],
            "id": "f03c1c36-597d-4afc-ab37-3700b0f70d35",
            "subCategory": "Vegetable Based Mains",
            "dietary": {
              "isVegan": false
            },
            "pairings": [],
            "allergens": [
              "Contains gluten, dairy, and basil; may affect allergies."
            ]
          },
          {
            "pk_id": "70652667-0511-4dd5-9425-3a5e2dc5d5d2",
            "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
            "restaurant_parent_id": null,
            "sku_id": "PIZ0002",
            "name": "Meat Lover's Delight Pizza",
            "category": "Entrees",
            "supplier": "",
            "brand": "",
            "modifiers": "",
            "unit": "",
            "taxable": "",
            "external_id": "",
            "bar_code": "",
            "description": "Meat Lover's Delight Pizza features a crispy crust topped with a rich blend of pepperoni, sausage, ham, and bacon, baked to perfection.",
            "comment": "",
            "cost": "",
            "price": "14.99",
            "large_price": "14.99",
            "indining_price": "8",
            "indining_large_price": "14.99",
            "quantity": "",
            "min_quantity": "",
            "max_quantity": "",
            "countable": "",
            "use_weighing_scale": "",
            "item_type": "",
            "duration": "",
            "discounts": "",
            "resources": "",
            "service_providers": "",
            "printer_type": "",
            "deposit": "",
            "visibility": "",
            "favorite": "",
            "sort_index": "",
            "tags": "",
            "out_of_stock": "",
            "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749534255838-generated-image-1749534255838-1.png",
            "is_enabled": true,
            "product_description": "Meat Lover's Delight Pizza features a crispy crust topped with a rich blend of pepperoni, sausage, ham, and bacon, baked to perfection.",
            "level1_category": "Entrees",
            "level2_category": "Specialty Meat Dishes",
            "Nutrients": "High in protein and fats, moderate carbs, rich in calcium and iron.",
            "appearance": "Golden-brown crust with generous toppings of meats and melted cheese, visually hearty.",
            "ingredients": [
              "Pizza dough",
              " mozzarella cheese",
              " pepperoni",
              " sausage",
              " ham",
              " bacon",
              " tomato sauce",
              " herbs."
            ],
            "serving": "Best enjoyed hot with a side of garlic bread or salad.",
            "flavors": "Savory, smoky, cheesy, with meaty richness.",
            "variations": "Can be made with turkey or plant-based meats for alternatives.",
            "allergy_info": "Contains gluten, dairy, and meat; may cause allergies in sensitive individuals.",
            "Calories": "Approximately 300-400 kcal per slice.",
            "is_vegan": "no",
            "best_combo": {
              "best_name": "Classic Margherita",
              "best_combo": "Complements the meat flavors with a classic, mild pizza.",
              "best_combo_ids": "PIZ0001"
            },
            "is_deleted": false,
            "food_type": "non_veg",
            "is_spice_applicable": "No",
            "meal_time": "",
            "inventory_status": true,
            "is_item_verified": true,
            "account_id": "",
            "party_orders": [
              {
                "name": "small",
                "serving": "10",
                "price": "149.90"
              },
              {
                "name": "medium",
                "serving": "25",
                "price": "374.75"
              },
              {
                "name": "large",
                "serving": "49",
                "price": "749.50"
              }
            ],
            "pos_item_id": "",
            "id": "70652667-0511-4dd5-9425-3a5e2dc5d5d2",
            "subCategory": "Specialty Meat Dishes",
            "dietary": {
              "isVegan": false
            },
            "pairings": [
              "Classic Margherita"
            ],
            "allergens": [
              "Contains gluten, dairy, and meat; may cause allergies in sensitive individuals."
            ]
          },
          {
            "pk_id": "b3d1ed75-e9df-45d0-a393-fbc1109c0aaa",
            "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
            "restaurant_parent_id": null,
            "sku_id": "PIZ0003",
            "name": "Veggie Supreme ",
            "category": "Starters & Small Plates",
            "supplier": "",
            "brand": "",
            "modifiers": "Veggie Supreme addon",
            "unit": "",
            "taxable": "",
            "external_id": "",
            "bar_code": "",
            "description": "Veggie Supreme is a hearty vegetarian pizza topped with a variety of fresh vegetables and melted cheese, offering a flavorful and satisfying meal.",
            "comment": "",
            "cost": "",
            "price": "13",
            "large_price": "12.49",
            "indining_price": "1",
            "indining_large_price": "12.49",
            "quantity": "",
            "min_quantity": "",
            "max_quantity": "",
            "countable": "",
            "use_weighing_scale": "",
            "item_type": "",
            "duration": "",
            "discounts": "",
            "resources": "",
            "service_providers": "",
            "printer_type": "",
            "deposit": "",
            "visibility": "",
            "favorite": "",
            "sort_index": "",
            "tags": "",
            "out_of_stock": "",
            "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749534377844-generated-image-1749534377844-1.png",
            "is_enabled": true,
            "product_description": "Veggie Supreme is a hearty vegetarian pizza topped with a variety of fresh vegetables and melted cheese, offering a flavorful and satisfying meal.",
            "level1_category": "Starters & Small Plates",
            "level2_category": "Breads & Flatbreads",
            "Nutrients": "Rich in vitamins from vegetables and calcium from cheese.",
            "appearance": "Colorful pizza with vibrant vegetable toppings and melted cheese crust.",
            "ingredients": [
              "Tomatoes",
              " bell peppers",
              " onions",
              " olives",
              " cheese",
              " pizza dough",
              " herbs."
            ],
            "serving": "Best enjoyed hot with a side of garlic bread or salad.",
            "flavors": "Savory, cheesy, with fresh vegetable notes.",
            "variations": "Can be made vegan by substituting cheese with plant-based options.",
            "allergy_info": "Contains dairy and gluten; may cause allergies in sensitive individuals.",
            "Calories": "Approximately 250-350 kcal per slice.",
            "is_vegan": "Yes",
            "best_combo": {
              "best_name": "Classic Margherita",
              "best_combo": "Both are vegetarian options with complementary flavors.",
              "best_combo_ids": "PIZ0001"
            },
            "is_deleted": false,
            "food_type": "Veg",
            "is_spice_applicable": "Yes",
            "meal_time": "",
            "inventory_status": true,
            "is_item_verified": true,
            "account_id": "",
            "party_orders": [
              {
                "name": "small",
                "serving": "10",
                "price": "124.90"
              },
              {
                "name": "medium",
                "serving": "25",
                "price": "312.25"
              },
              {
                "name": "large",
                "serving": "50",
                "price": "624.50"
              }
            ],
            "pos_item_id": "",
            "modifiers_list": [
              {
                "name": "Veggie Supreme addon",
                "is_multi_select": "No",
                "is_forced": "Yes",
                "pk_id": "ee381bfd-d4f7-4cd7-a75c-6de41876a4eb",
                "pos_group_id": "",
                "options": [
                  {
                    "name": "Spinach",
                    "price": "$0.75",
                    "isEnabled": true
                  },
                  {
                    "name": "feta",
                    "price": "$1.50",
                    "isEnabled": true
                  },
                  {
                    "name": "pesto swirl",
                    "price": "$1.50",
                    "isEnabled": true
                  }
                ]
              }
            ],
            "id": "b3d1ed75-e9df-45d0-a393-fbc1109c0aaa",
            "subCategory": "Breads & Flatbreads",
            "dietary": {
              "isVegan": true
            },
            "pairings": [
              "Classic Margherita"
            ],
            "allergens": [
              "Contains dairy and gluten; may cause allergies in sensitive individuals."
            ]
          },
          {
            "pk_id": "3874684b-bba8-4b91-b865-91b34e951477",
            "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
            "restaurant_parent_id": null,
            "sku_id": "PIZ0004",
            "name": "Chicken Tikka Pizza",
            "category": "Starters & Small Plates",
            "supplier": "",
            "brand": "",
            "modifiers": "Chicken Tikka Pizza addon",
            "unit": "",
            "taxable": "",
            "external_id": "",
            "bar_code": "",
            "description": "Chicken Tikka Pizza features tender chicken tikka pieces atop a crispy crust, topped with cheese and spices for a flavorful experience.",
            "comment": "",
            "cost": "",
            "price": "13.49",
            "large_price": "13.49",
            "indining_price": "2",
            "indining_large_price": "13.49",
            "quantity": "",
            "min_quantity": "",
            "max_quantity": "",
            "countable": "",
            "use_weighing_scale": "",
            "item_type": "",
            "duration": "",
            "discounts": "",
            "resources": "",
            "service_providers": "",
            "printer_type": "",
            "deposit": "",
            "visibility": "",
            "favorite": "",
            "sort_index": "",
            "tags": "",
            "out_of_stock": "",
            "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749534429912-generated-image-1749534429081-3.png",
            "is_enabled": true,
            "product_description": "Chicken Tikka Pizza features tender chicken tikka pieces atop a crispy crust, topped with cheese and spices for a flavorful experience.",
            "level1_category": "Starters & Small Plates",
            "level2_category": "Appetizers / Starters",
            "Nutrients": "Rich in protein, calcium, and carbs; moderate fat content.",
            "appearance": "Golden-brown crust with chunks of chicken, melted cheese, and visible spices on top.",
            "ingredients": [
              "Pizza dough",
              " chicken tikka",
              " cheese",
              " tomato sauce",
              " spices",
              " herbs."
            ],
            "serving": "Best enjoyed hot with a side of salad or dipping sauces.",
            "flavors": "Spicy, smoky, cheesy, with hints of herbs and spices.",
            "variations": "Can be made vegetarian with paneer or vegetables, or with different spice levels.",
            "allergy_info": "Contains dairy and gluten; may cause allergies in sensitive individuals.",
            "Calories": "Approximately 300-400 kcal per slice.",
            "is_vegan": "no",
            "best_combo": {
              "best_name": "Classic Margherita, Veggie Supreme",
              "best_combo": "Complementary flavors and vegetarian options enhance Chicken Tikka Pizza.",
              "best_combo_ids": "PIZ0001"
            },
            "is_deleted": false,
            "food_type": "non_veg",
            "is_spice_applicable": "No",
            "meal_time": "",
            "inventory_status": true,
            "is_item_verified": true,
            "account_id": "",
            "party_orders": [
              {
                "name": "small",
                "serving": "10",
                "price": "134.90"
              },
              {
                "name": "medium",
                "serving": "25",
                "price": "337.25"
              },
              {
                "name": "large",
                "serving": "50",
                "price": "674.50"
              }
            ],
            "pos_item_id": "",
            "modifiers_list": [
              {
                "name": "Chicken Tikka Pizza addon",
                "is_multi_select": "No",
                "is_forced": "Yes",
                "pk_id": "c4d6c07b-000e-4f08-9bfe-07b758331b3b",
                "pos_group_id": "",
                "options": [
                  {
                    "name": "Spicy mayo",
                    "price": "$1.25",
                    "isEnabled": true
                  },
                  {
                    "name": "Coriander",
                    "price": "$0.60",
                    "isEnabled": true
                  },
                  {
                    "name": "red chili flakes",
                    "price": "$0.60",
                    "isEnabled": true
                  },
                  {
                    "name": "Garlic crust",
                    "price": "$1.25",
                    "isEnabled": true
                  }
                ]
              }
            ],
            "id": "3874684b-bba8-4b91-b865-91b34e951477",
            "subCategory": "Appetizers / Starters",
            "dietary": {
              "isVegan": false
            },
            "pairings": [
              "Classic Margherita",
              " Veggie Supreme"
            ],
            "allergens": [
              "Contains dairy and gluten; may cause allergies in sensitive individuals."
            ]
          },
          {
            "pk_id": "59d63f4e-d5e7-4dce-906b-4645a2e44a1a",
            "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
            "restaurant_parent_id": null,
            "sku_id": "PIZ0005",
            "name": "BBQ Chicken Feast Pizza",
            "category": "Entrees",
            "supplier": "",
            "brand": "",
            "modifiers": "BBQ Chicken Feast addon",
            "unit": "",
            "taxable": "",
            "external_id": "",
            "bar_code": "",
            "description": "BBQ Chicken Feast Pizza features a crispy crust topped with smoky barbecue sauce, tender chicken, cheese, and flavorful toppings, offering a hearty and savory experience.",
            "comment": "",
            "cost": "",
            "price": "13.99",
            "large_price": "13.99",
            "indining_price": "4.99",
            "indining_large_price": "13.99",
            "quantity": "",
            "min_quantity": "",
            "max_quantity": "",
            "countable": "",
            "use_weighing_scale": "",
            "item_type": "",
            "duration": "",
            "discounts": "",
            "resources": "",
            "service_providers": "",
            "printer_type": "",
            "deposit": "",
            "visibility": "",
            "favorite": "",
            "sort_index": "",
            "tags": "",
            "out_of_stock": "",
            "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749534604205-generated-image-1749534602683-3.png",
            "is_enabled": true,
            "product_description": "BBQ Chicken Feast Pizza features a crispy crust topped with smoky barbecue sauce, tender chicken, cheese, and flavorful toppings, offering a hearty and savory experience.",
            "level1_category": "Entrees",
            "level2_category": "Pizzas & Flatbreads",
            "Nutrients": "Rich in protein, calcium, and carbs; moderate fat content.",
            "appearance": "Golden-brown crust with generous toppings of chicken, cheese, and barbecue sauce.",
            "ingredients": [
              "Pizza dough",
              " BBQ sauce",
              " cooked chicken",
              " cheese",
              " onions",
              " cilantro."
            ],
            "serving": "Best enjoyed hot with a side of salad or garlic bread.",
            "flavors": "Smoky, savory, cheesy, with hints of sweetness from BBQ sauce.",
            "variations": "Can add jalapeños, bacon, or different cheeses for customization.",
            "allergy_info": "Contains gluten, dairy, and possible soy; check for allergies.",
            "Calories": "Approximately 300-400 kcal per slice.",
            "is_vegan": "no",
            "best_combo": {
              "best_name": "Meat Lover's Delight Pizza, Chicken Tikka Pizza",
              "best_combo": "Rich, meaty flavors complement BBQ Chicken Feast for a hearty meal",
              "best_combo_ids": "PIZ0002,PIZ0004"
            },
            "is_deleted": false,
            "food_type": "non_veg",
            "is_spice_applicable": "yes",
            "meal_time": "",
            "inventory_status": true,
            "is_item_verified": true,
            "account_id": "",
            "party_orders": [
              {
                "name": "small",
                "serving": "10",
                "price": "139.90"
              },
              {
                "name": "medium",
                "serving": "25",
                "price": "349.75"
              },
              {
                "name": "large",
                "serving": "50",
                "price": "699.50"
              }
            ],
            "pos_item_id": "",
            "modifiers_list": [
              {
                "name": "BBQ Chicken Feast addon",
                "is_multi_select": "No",
                "is_forced": "Yes",
                "pk_id": "07dbff2e-46e9-4079-8db7-f76ba2bd9672",
                "pos_group_id": "",
                "options": [
                  {
                    "name": "Extra BBQ drizzle",
                    "price": "$1.25",
                    "isEnabled": true
                  },
                  {
                    "name": "pineapple",
                    "price": "$0.60",
                    "isEnabled": true
                  },
                  {
                    "name": "smoked cheese",
                    "price": "$1.50",
                    "isEnabled": true
                  },
                  {
                    "name": "Bacon bits",
                    "price": "$1.75",
                    "isEnabled": true
                  }
                ]
              }
            ],
            "id": "59d63f4e-d5e7-4dce-906b-4645a2e44a1a",
            "subCategory": "Pizzas & Flatbreads",
            "dietary": {
              "isVegan": false
            },
            "pairings": [
              "Meat Lover's Delight Pizza",
              " Chicken Tikka Pizza"
            ],
            "allergens": [
              "Contains gluten, dairy, and possible soy; check for allergies."
            ]
          },
          {
            "pk_id": "4f60847b-b066-4754-81c8-330f11095786",
            "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
            "restaurant_parent_id": null,
            "sku_id": "PIZ0007",
            "name": "Hawaiian Classic Pizza",
            "category": "Entrees",
            "supplier": "",
            "brand": "",
            "modifiers": "Hawaiian Classic addon",
            "unit": "",
            "taxable": "",
            "external_id": "",
            "bar_code": "",
            "description": "Hawaiian Classic Pizza features a crispy crust topped with tomato sauce, cheese, ham, and pineapple chunks, offering a sweet and savory flavor profile.",
            "comment": "",
            "cost": "",
            "price": "12.49",
            "large_price": "12.49",
            "indining_price": "12.49",
            "indining_large_price": "12.49",
            "quantity": "",
            "min_quantity": "",
            "max_quantity": "",
            "countable": "",
            "use_weighing_scale": "",
            "item_type": "",
            "duration": "",
            "discounts": "",
            "resources": "",
            "service_providers": "",
            "printer_type": "",
            "deposit": "",
            "visibility": "",
            "favorite": "",
            "sort_index": "",
            "tags": "",
            "out_of_stock": "",
            "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749534761684-generated-image-1749534760104-4.png",
            "is_enabled": true,
            "product_description": "Hawaiian Classic Pizza features a crispy crust topped with tomato sauce, cheese, ham, and pineapple chunks, offering a sweet and savory flavor profile.",
            "level1_category": "Entrees",
            "level2_category": "Pizzas & Flatbreads",
            "Nutrients": "Provides carbs, protein, calcium, and vitamins from toppings.",
            "appearance": "Golden-brown crust with melted cheese, ham slices, and pineapple pieces on top.",
            "ingredients": [
              "Pizza dough",
              " tomato sauce",
              " mozzarella cheese",
              " ham",
              " pineapple",
              " olive oil",
              " herbs."
            ],
            "serving": "Best enjoyed hot with a side of garlic bread or salad.",
            "flavors": "Sweet, savory, cheesy, with a hint of tang from pineapple.",
            "variations": "Can add bacon, jalapeños, or substitute ham with turkey.",
            "allergy_info": "Contains dairy, gluten, and possibly soy; check for allergies.",
            "Calories": "Approximately 250-350 kcal per slice.",
            "is_vegan": "no",
            "best_combo": {
              "best_name": "Meat Lover's Delight Pizza, BBQ Chicken Feast Pizza",
              "best_combo": "Rich, savory flavors complement the sweet and savory Hawaiian pizza",
              "best_combo_ids": "PIZ0002,PIZ0005"
            },
            "is_deleted": false,
            "food_type": "non_veg",
            "is_spice_applicable": "no",
            "meal_time": "",
            "inventory_status": true,
            "is_item_verified": true,
            "account_id": "",
            "party_orders": [
              {
                "name": "small",
                "serving": "10",
                "price": "124.90"
              },
              {
                "name": "medium",
                "serving": "25",
                "price": "312.25"
              },
              {
                "name": "large",
                "serving": "50",
                "price": "624.50"
              }
            ],
            "pos_item_id": "",
            "modifiers_list": [
              {
                "name": "Hawaiian Classic addon",
                "is_multi_select": "No",
                "is_forced": "Yes",
                "pk_id": "840bed41-05ef-47c8-bca9-41c264ae37d9",
                "pos_group_id": "",
                "options": [
                  {
                    "name": "Bacon",
                    "price": "$1.75",
                    "isEnabled": true
                  },
                  {
                    "name": "red onions",
                    "price": "$0.60",
                    "isEnabled": true
                  },
                  {
                    "name": "sweet chili drizzle",
                    "price": "$0.60",
                    "isEnabled": true
                  },
                  {
                    "name": "spicy crust",
                    "price": "$1.25",
                    "isEnabled": true
                  }
                ]
              }
            ],
            "id": "4f60847b-b066-4754-81c8-330f11095786",
            "subCategory": "Pizzas & Flatbreads",
            "dietary": {
              "isVegan": false
            },
            "pairings": [
              "Meat Lover's Delight Pizza",
              " BBQ Chicken Feast Pizza"
            ],
            "allergens": [
              "Contains dairy, gluten, and possibly soy; check for allergies."
            ]
          },
          {
            "pk_id": "173e050c-de20-48d6-8f00-f6f4999601ec",
            "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
            "restaurant_parent_id": null,
            "sku_id": "PIZ0008",
            "name": "Spicy Veggie Volcano",
            "category": "Entrees",
            "supplier": "",
            "brand": "",
            "modifiers": "Spicy Veggie Volcano addon",
            "unit": "",
            "taxable": "",
            "external_id": "",
            "bar_code": "",
            "description": "Spicy Veggie Volcano is a vibrant, spicy dish featuring a medley of fresh vegetables topped with a fiery sauce, served hot and visually striking.",
            "comment": "",
            "cost": "",
            "price": "12.99",
            "large_price": "12.99",
            "indining_price": "12.99",
            "indining_large_price": "12.99",
            "quantity": "",
            "min_quantity": "",
            "max_quantity": "",
            "countable": "",
            "use_weighing_scale": "",
            "item_type": "",
            "duration": "",
            "discounts": "",
            "resources": "",
            "service_providers": "",
            "printer_type": "",
            "deposit": "",
            "visibility": "",
            "favorite": "",
            "sort_index": "",
            "tags": "",
            "out_of_stock": "",
            "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749534852285-generated-image-1749534851526-3.png",
            "is_enabled": true,
            "product_description": "Spicy Veggie Volcano is a vibrant, spicy dish featuring a medley of fresh vegetables topped with a fiery sauce, served hot and visually striking.",
            "level1_category": "Entrees",
            "level2_category": "Vegetable Based Mains",
            "Nutrients": "Rich in vitamins, antioxidants, and dietary fiber from vegetables.",
            "appearance": "Colorful vegetable medley topped with a bright red spicy sauce, resembling a volcano eruption.",
            "ingredients": [
              "Mixed vegetables",
              " chili sauce",
              " garlic",
              " soy sauce",
              " spices",
              " oil"
            ],
            "serving": "Best enjoyed with steamed rice or flatbreads for a complete meal.",
            "flavors": "Spicy, Savory, Umami with a hint of sweetness",
            "variations": "Adjust spice level, add tofu or mushrooms for variation",
            "allergy_info": "Contains soy and chili; may affect those with soy or chili allergies.",
            "Calories": "Approximately 150-200 kcal per serving",
            "is_vegan": "yes",
            "best_combo": {
              "best_name": "Veggie Supreme",
              "best_combo": "Complements the spicy veggie flavor with a hearty veggie option",
              "best_combo_ids": ""
            },
            "is_deleted": false,
            "food_type": "vegan",
            "is_spice_applicable": "yes",
            "meal_time": "",
            "inventory_status": true,
            "is_item_verified": true,
            "account_id": "",
            "party_orders": [
              {
                "name": "small",
                "serving": "10",
                "price": "129.90"
              },
              {
                "name": "medium",
                "serving": "25",
                "price": "324.75"
              },
              {
                "name": "large",
                "serving": "49",
                "price": "649.50"
              }
            ],
            "pos_item_id": "",
            "modifiers_list": [
              {
                "name": "Spicy Veggie Volcano addon",
                "is_multi_select": "Yes",
                "is_forced": "No",
                "pk_id": "7a4a7fc7-af5e-4cb3-9ec8-64f446905edd",
                "pos_group_id": "",
                "options": [
                  {
                    "name": "Paneer cubes",
                    "price": "$1.50",
                    "isEnabled": true
                  },
                  {
                    "name": "Extra chili",
                    "price": "$0.99",
                    "isEnabled": true
                  },
                  {
                    "name": "Hot sauce swirl",
                    "price": "$1.50",
                    "isEnabled": true
                  },
                  {
                    "name": "Sesame crust",
                    "price": "$1.75",
                    "isEnabled": true
                  },
                  {
                    "name": "chicken toast",
                    "price": "$1",
                    "isEnabled": true
                  }
                ]
              }
            ],
            "id": "173e050c-de20-48d6-8f00-f6f4999601ec",
            "subCategory": "Vegetable Based Mains",
            "dietary": {
              "isVegan": true
            },
            "pairings": [
              "Veggie Supreme"
            ],
            "allergens": [
              "Contains soy and chili; may affect those with soy or chili allergies."
            ]
          },
          {
            "pk_id": "e7f3210a-5564-4b08-9bfd-283ff68eedb2",
            "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
            "restaurant_parent_id": null,
            "sku_id": "PIZ0010",
            "name": "Philly Steak Pizza",
            "category": "Entrees",
            "supplier": "",
            "brand": "",
            "modifiers": "Philly Steak Pizza addon",
            "unit": "",
            "taxable": "",
            "external_id": "",
            "bar_code": "",
            "description": "Philly Steak Pizza features tender sliced steak, melted cheese, and savory toppings on a crispy crust, blending Italian and American flavors.",
            "comment": "",
            "cost": "",
            "price": "14.99",
            "large_price": "14.99",
            "indining_price": "14.99",
            "indining_large_price": "14.99",
            "quantity": "",
            "min_quantity": "",
            "max_quantity": "",
            "countable": "",
            "use_weighing_scale": "",
            "item_type": "",
            "duration": "",
            "discounts": "",
            "resources": "",
            "service_providers": "",
            "printer_type": "",
            "deposit": "",
            "visibility": "",
            "favorite": "",
            "sort_index": "",
            "tags": "",
            "out_of_stock": "",
            "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749535594783-generated-image-1749535586777-4.png",
            "is_enabled": true,
            "product_description": "Philly Steak Pizza features tender sliced steak, melted cheese, and savory toppings on a crispy crust, blending Italian and American flavors.",
            "level1_category": "Entrees",
            "level2_category": "Noodles & Pasta",
            "Nutrients": "Rich in protein, calcium, and carbohydrates for energy and muscle repair.",
            "appearance": "Golden-brown crust topped with melted cheese, sliced steak, and vegetables.",
            "ingredients": [
              "Sliced steak",
              " mozzarella cheese",
              " pizza dough",
              " bell peppers",
              " onions",
              " tomato sauce."
            ],
            "serving": "Best enjoyed hot with a side of garlic bread or salad.",
            "flavors": "Savory, cheesy, meaty, with hints of smoky spices.",
            "variations": "Can add mushrooms, jalapeños, or substitute steak with chicken or plant-based options.",
            "allergy_info": "Contains dairy and gluten; may contain traces of soy or nuts.",
            "Calories": "Approximately 800-1000 kcal per slice.",
            "is_vegan": "no",
            "best_combo": {
              "best_name": "Meat Lover's Delight Pizza,BBQ Chicken Feast Pizza",
              "best_combo": "Rich, meaty flavors complement the hearty Philly Steak Pizza well",
              "best_combo_ids": "PIZ0002,PIZ0005"
            },
            "is_deleted": false,
            "food_type": "non_veg",
            "is_spice_applicable": "yes",
            "meal_time": "",
            "inventory_status": true,
            "is_item_verified": true,
            "account_id": "",
            "party_orders": [
              {
                "name": "small",
                "serving": "10",
                "price": "149.90"
              },
              {
                "name": "medium",
                "serving": "25",
                "price": "374.75"
              },
              {
                "name": "large",
                "serving": "50",
                "price": "749.50"
              }
            ],
            "pos_item_id": "",
            "modifiers_list": [
              {
                "name": "Philly Steak Pizza addon",
                "is_multi_select": "No",
                "is_forced": "Yes",
                "pk_id": "989bf89f-91b4-49fa-851f-a85d585046c5",
                "pos_group_id": "",
                "options": [
                  {
                    "name": "Blue cheese",
                    "price": "$1.25",
                    "isEnabled": true
                  },
                  {
                    "name": "Extra steak",
                    "price": "$2.25",
                    "isEnabled": true
                  },
                  {
                    "name": "BBQ swirl",
                    "price": "$0.99",
                    "isEnabled": true
                  },
                  {
                    "name": "Cheesy crust",
                    "price": "$2",
                    "isEnabled": true
                  }
                ]
              }
            ],
            "id": "e7f3210a-5564-4b08-9bfd-283ff68eedb2",
            "subCategory": "Noodles & Pasta",
            "dietary": {
              "isVegan": false
            },
            "pairings": [
              "Meat Lover's Delight Pizza",
              "BBQ Chicken Feast Pizza"
            ],
            "allergens": [
              "Contains dairy and gluten; may contain traces of soy or nuts."
            ]
          },
          {
            "pk_id": "ac33445d-18ae-4be2-942a-b0e65c7b44a4",
            "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
            "restaurant_parent_id": null,
            "sku_id": "PIZ0014",
            "name": "Truffle Mushroom Delight Pizza",
            "category": "Starters & Small Plates",
            "supplier": "",
            "brand": "",
            "modifiers": "Truffle Mushroom Delight addon",
            "unit": "",
            "taxable": "",
            "external_id": "",
            "bar_code": "",
            "description": "A gourmet pizza topped with savory mushrooms and aromatic truffle oil, offering a rich, earthy flavor in a crispy crust.",
            "comment": "",
            "cost": "",
            "price": "14.49",
            "large_price": "14.49",
            "indining_price": "14.49",
            "indining_large_price": "14.49",
            "quantity": "",
            "min_quantity": "",
            "max_quantity": "",
            "countable": "",
            "use_weighing_scale": "",
            "item_type": "",
            "duration": "",
            "discounts": "",
            "resources": "",
            "service_providers": "",
            "printer_type": "",
            "deposit": "",
            "visibility": "",
            "favorite": "",
            "sort_index": "",
            "tags": "",
            "out_of_stock": "",
            "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749536724052-generated-image-1749536723486-2.png",
            "is_enabled": true,
            "product_description": "A gourmet pizza topped with savory mushrooms and aromatic truffle oil, offering a rich, earthy flavor in a crispy crust.",
            "level1_category": "Starters & Small Plates",
            "level2_category": "Breads & Flatbreads",
            "Nutrients": "Rich in antioxidants from mushrooms and healthy fats from truffle oil.",
            "appearance": "Golden-brown crust with melted cheese, sliced mushrooms, and drizzled truffle oil on top.",
            "ingredients": [
              "Pizza dough",
              " mushrooms",
              " truffle oil",
              " cheese",
              " garlic",
              " herbs",
              " olive oil."
            ],
            "serving": "Best enjoyed hot with a side of mixed greens or a light salad.",
            "flavors": "Earthy, umami, aromatic, slightly cheesy.",
            "variations": "Vegan version with plant-based cheese, or add prosciutto for non-veg.",
            "allergy_info": "Contains dairy and mushrooms; may cause allergies in sensitive individuals.",
            "Calories": "Approximately 300-400 kcal per slice.",
            "is_vegan": "no",
            "best_combo": {
              "best_name": "Veggie Supreme, Mediterranean Veggie, Spicy Veggie Volcano",
              "best_combo": "Complementary veggie flavors enhance the mushroom truffle profile.",
              "best_combo_ids": "PIZ0011,PIZ0008"
            },
            "is_deleted": false,
            "food_type": "non_veg",
            "is_spice_applicable": "no",
            "meal_time": "",
            "inventory_status": true,
            "is_item_verified": true,
            "account_id": "",
            "party_orders": [
              {
                "name": "small",
                "serving": "10",
                "price": "144.90"
              },
              {
                "name": "medium",
                "serving": "25",
                "price": "362.25"
              },
              {
                "name": "large",
                "serving": "50",
                "price": "724.50"
              }
            ],
            "pos_item_id": "",
            "modifiers_list": [
              {
                "name": "Truffle Mushroom Delight addon",
                "is_multi_select": "No",
                "is_forced": "Yes",
                "pk_id": "c95a1603-adc7-43da-9b05-c549a3e964c2",
                "pos_group_id": "",
                "options": [
                  {
                    "name": "Caramelized onions",
                    "price": "$0.99",
                    "isEnabled": true
                  },
                  {
                    "name": "Goat cheese",
                    "price": "$1.50",
                    "isEnabled": true
                  },
                  {
                    "name": "Garlic crust",
                    "price": "$1.25",
                    "isEnabled": true
                  },
                  {
                    "name": "pine nuts",
                    "price": "$0.99",
                    "isEnabled": true
                  }
                ]
              }
            ],
            "id": "ac33445d-18ae-4be2-942a-b0e65c7b44a4",
            "subCategory": "Breads & Flatbreads",
            "dietary": {
              "isVegan": false
            },
            "pairings": [
              "Veggie Supreme",
              " Mediterranean Veggie",
              " Spicy Veggie Volcano"
            ],
            "allergens": [
              "Contains dairy and mushrooms; may cause allergies in sensitive individuals."
            ]
          },
          {
            "pk_id": "02d9711e-2365-476c-9174-2ba463aa3636",
            "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
            "restaurant_parent_id": null,
            "sku_id": "PIZ0015",
            "name": "Loaded Paneer Paradise Pizza",
            "category": "Starters & Small Plates",
            "supplier": "",
            "brand": "",
            "modifiers": "Loaded Paneer Paradise",
            "unit": "",
            "taxable": "",
            "external_id": "",
            "bar_code": "",
            "description": "Loaded Paneer Paradise Pizza features a crispy crust topped with spiced paneer, fresh vegetables, and melted cheese, offering a flavorful vegetarian delight.",
            "comment": "",
            "cost": "",
            "price": "13.99",
            "large_price": "13.99",
            "indining_price": "13.99",
            "indining_large_price": "13.99",
            "quantity": "",
            "min_quantity": "",
            "max_quantity": "",
            "countable": "",
            "use_weighing_scale": "",
            "item_type": "",
            "duration": "",
            "discounts": "",
            "resources": "",
            "service_providers": "",
            "printer_type": "",
            "deposit": "",
            "visibility": "",
            "favorite": "",
            "sort_index": "",
            "tags": "",
            "out_of_stock": "",
            "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749536855344-generated-image-1749536854924-2.png",
            "is_enabled": true,
            "product_description": "Loaded Paneer Paradise Pizza features a crispy crust topped with spiced paneer, fresh vegetables, and melted cheese, offering a flavorful vegetarian delight.",
            "level1_category": "Starters & Small Plates",
            "level2_category": "Breads & Flatbreads",
            "Nutrients": "Rich in protein from paneer, calcium, vitamins from vegetables",
            "appearance": "Golden-brown crust with colorful toppings and melted cheese, garnished with herbs.",
            "ingredients": [
              "Paneer",
              " cheese",
              " bell peppers",
              " onions",
              " tomato sauce",
              " spices",
              " herbs",
              " dough"
            ],
            "serving": "Best enjoyed hot with a side of green chutney or salad.",
            "flavors": "Savory, cheesy, mildly spicy with aromatic herbs",
            "variations": "Vegan cheese, gluten-free crust, extra vegetables",
            "allergy_info": "Contains dairy and gluten; may cause allergies in sensitive individuals.",
            "Calories": "Approximately 300-400 kcal per slice",
            "is_vegan": "no",
            "best_combo": {
              "best_name": "Veggie Supreme, Mediterranean Veggie, Spicy Veggie Volcano",
              "best_combo": "Complementary veggie flavors enhance the paneer pizza experience.",
              "best_combo_ids": "PIZ0011,PIZ0008"
            },
            "is_deleted": false,
            "food_type": "veg",
            "is_spice_applicable": "yes",
            "meal_time": "",
            "inventory_status": true,
            "is_item_verified": true,
            "account_id": "",
            "party_orders": [
              {
                "name": "small",
                "serving": "10",
                "price": "139.90"
              },
              {
                "name": "medium",
                "serving": "25",
                "price": "349.75"
              },
              {
                "name": "large",
                "serving": "50",
                "price": "699.50"
              }
            ],
            "pos_item_id": "",
            "modifiers_list": [
              {
                "name": "Loaded Paneer Paradise",
                "is_multi_select": "No",
                "is_forced": "Yes",
                "pk_id": "efcadd5a-5cf5-4645-a387-5a6323981e1c",
                "pos_group_id": "",
                "options": [
                  {
                    "name": "Mint mayo swirl",
                    "price": "$0.99",
                    "isEnabled": true
                  },
                  {
                    "name": "Extra paneer",
                    "price": "$1.75",
                    "isEnabled": true
                  },
                  {
                    "name": "Tikka crust",
                    "price": "$1.50",
                    "isEnabled": true
                  },
                  {
                    "name": "Chili flakes",
                    "price": "$0.99",
                    "isEnabled": true
                  }
                ]
              }
            ],
            "id": "02d9711e-2365-476c-9174-2ba463aa3636",
            "subCategory": "Breads & Flatbreads",
            "dietary": {
              "isVegan": false
            },
            "pairings": [
              "Veggie Supreme",
              " Mediterranean Veggie",
              " Spicy Veggie Volcano"
            ],
            "allergens": [
              "Contains dairy and gluten; may cause allergies in sensitive individuals."
            ]
          }]
        }
      },
      {
        "type": "ClassicCombo",
        "data": {
          "content": "<h2 class=\"text-3xl md:text-4xl font-bold text-gray-900 mb-4\">Family <span class=\"text-orange-600\">Meal Deals</span></h2><p class=\"text-gray-600 text-lg max-w-2xl mx-auto\">Perfect portions for sharing around the table - because the best meals bring people together</p>",
          "backgroundColor": "#fef5e7",
          "emptyStateContent": "<h3 class=\"text-lg sm:text-xl font-semibold mb-2\">Family Meals Coming Soon</h3><p class=\"text-sm sm:text-base max-w-md\">Great value family meal combinations will be available here.</p>",
          "combos": [{
            "combo_id": "96f8cdcb-e7dd-4355-9178-5652f6d82f84",
            "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
            "title": "Party Time Pack",
            "description": "A delightful mix of classic, flavorful, and satisfying dishes including pizzas, sides, beverages, and desserts, perfect for celebrating with friends and family in a lively, delicious party setting.",
            "products": [
              {
                "pk_id": "dcbe286c-43c2-4f27-b9aa-8a339344f0c7",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0016",
                "name": "Buffalo Chicken Blast Pizza",
                "category": "Starters & Small Plates",
                "supplier": "",
                "brand": "",
                "modifiers": "Buffalo Chicken Blast addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Buffalo Chicken Blast Pizza features a crispy crust topped with spicy buffalo sauce, tender chicken, and melty cheese, offering a bold flavor experience.",
                "comment": "",
                "cost": "",
                "price": "13.49",
                "large_price": "13.49",
                "indining_price": "13.49",
                "indining_large_price": "13.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749536945765-generated-image-1749536944781-3.png",
                "is_enabled": "true",
                "product_description": "Buffalo Chicken Blast Pizza features a crispy crust topped with spicy buffalo sauce, tender chicken, and melty cheese, offering a bold flavor experience.",
                "level1_category": "Starters & Small Plates",
                "level2_category": "Appetizers / Starters",
                "Nutrients": "Rich in protein and calcium, moderate in fats and carbs.",
                "appearance": "Golden-brown crust with vibrant red buffalo sauce, chicken pieces, and melted cheese topping.",
                "ingredients": "Pizza dough, chicken, buffalo sauce, cheese, blue cheese, celery, ranch dressing",
                "serving": "Best enjoyed hot with a side of celery sticks or ranch dressing.",
                "flavors": "Spicy, tangy, cheesy, savory",
                "variations": "Can be made with plant-based chicken or less spicy sauce.",
                "allergy_info": "Contains dairy, gluten, and possible soy; may cause allergies in sensitive individuals.",
                "Calories": "Approximately 300-400 kcal per slice",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Meat Lover's Delight Pizza,BBQ Chicken Feast Pizza,Spicy Veggie Volcano\",\"best_combo\":\"Enhances spicy and meaty flavors, creating a bold, satisfying combo.\",\"best_combo_ids\":\"PIZ0002,PIZ0005,PIZ0008\"}",
                "is_deleted": "false",
                "food_type": "non_veg",
                "is_spice_applicable": "yes",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "ee2aa8fb-01ae-4cdc-8824-843577ea49cd",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0022",
                "name": "Potato Wedges",
                "category": "Sides & Accompaniments",
                "supplier": "",
                "brand": "",
                "modifiers": "Potato Wedges addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Crispy potato wedges are thick-cut potatoes seasoned and baked or fried until golden and crunchy, perfect as a snack or side.",
                "comment": "",
                "cost": "",
                "price": "4.99",
                "large_price": "4.99",
                "indining_price": "4.99",
                "indining_large_price": "4.99",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749538548266-generated-image-1749538548266-1.png",
                "is_enabled": "true",
                "product_description": "Crispy potato wedges are thick-cut potatoes seasoned and baked or fried until golden and crunchy, perfect as a snack or side.",
                "level1_category": "Sides & Accompaniments",
                "level2_category": "Side Dishes",
                "Nutrients": "Rich in carbohydrates and vitamin C, moderate in fiber.",
                "appearance": "Golden-brown, wedge-shaped potatoes with a crispy exterior and fluffy interior.",
                "ingredients": "Potatoes, Olive oil, Salt, Pepper, Paprika, Garlic powder, Herbs",
                "serving": "Best enjoyed with ketchup, aioli, or spicy dips.",
                "flavors": "Savory, Crispy, Slightly smoky with hints of herbs.",
                "variations": "Can be seasoned with cheese, chili, or served with different dips.",
                "allergy_info": "Contains potatoes; check for cross-contamination with gluten or dairy if applicable.",
                "Calories": "Approximately 150-250 kcal per serving",
                "is_vegan": "yes",
                "best_combo": "{\"best_name\":\"Garlic Bread Supreme, Chicken Wings (6 pcs)\",\"best_combo\":\"Perfect sides with potato wedges for added flavor and variety.\",\"best_combo_ids\":\"PIZ0021\"}",
                "is_deleted": "false",
                "food_type": "veg",
                "is_spice_applicable": "yes",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "bdd585f1-40bf-43f4-adad-9e212ca583fa",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0027",
                "name": "Choco Cold Coffee",
                "category": "Beverages",
                "supplier": "",
                "brand": "",
                "modifiers": "Choco Cold Coffee addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Choco Cold Coffee is a refreshing beverage blending rich coffee, chocolate syrup, milk, and ice for a sweet, chilled drink.",
                "comment": "",
                "cost": "",
                "price": "4.49",
                "large_price": "4.49",
                "indining_price": "4.49",
                "indining_large_price": "4.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749538880748-generated-image-1749538880345-2.png",
                "is_enabled": "true",
                "product_description": "Choco Cold Coffee is a refreshing beverage blending rich coffee, chocolate syrup, milk, and ice for a sweet, chilled drink.",
                "level1_category": "Beverages",
                "level2_category": "Beverages",
                "Nutrients": "Provides energy from caffeine, sugars, and calcium from milk.",
                "appearance": "Dark brown coffee with a frothy top, topped with chocolate shavings or whipped cream.",
                "ingredients": "Coffee, chocolate syrup, milk, ice, sugar, whipped cream (optional).",
                "serving": "Best enjoyed chilled in a tall glass with a straw.",
                "flavors": "Rich chocolate, bold coffee, sweet and creamy.",
                "variations": "Can add whipped cream, chocolate chips, or caramel drizzle.",
                "allergy_info": "Contains dairy and caffeine; may affect lactose intolerant or sensitive individuals.",
                "Calories": "Approximately 150-250 kcal per serving.",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Garlic Bread Supreme, Chicken Wings (6 pcs), Potato Wedges\",\"best_combo\":\"Savory sides and wings complement the sweet, rich flavor of Choco Cold Coffee.\",\"best_combo_ids\":\"PIZ0021,PIZ0022\"}",
                "is_deleted": "false",
                "food_type": "non_veg",
                "is_spice_applicable": "no",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "d71ea6a1-cb05-4449-8495-a7fa492b6f82",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0028",
                "name": "Choco Lava Cake",
                "category": "Desserts & Sweets",
                "supplier": "",
                "brand": "",
                "modifiers": "Choco Lava Cake addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Choco Lava Cake is a rich, warm chocolate dessert with a gooey, molten center that oozes out when cut, offering a decadent treat.",
                "comment": "",
                "cost": "",
                "price": "4.99",
                "large_price": "4.99",
                "indining_price": "4.99",
                "indining_large_price": "4.99",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749538934939-generated-image-1749538934939-1.png",
                "is_enabled": "true",
                "product_description": "Choco Lava Cake is a rich, warm chocolate dessert with a gooey, molten center that oozes out when cut, offering a decadent treat.",
                "level1_category": "Desserts & Sweets",
                "level2_category": "Pastries & Cakes",
                "Nutrients": "Rich in calories and fats, provides energy and mood-boosting compounds.",
                "appearance": "Small, round cake with a slightly cracked top and a flowing chocolate center.",
                "ingredients": "Chocolate, Butter, Eggs, Sugar, Flour, Cocoa powder, Vanilla extract",
                "serving": "Best enjoyed warm with vanilla ice cream or whipped cream.",
                "flavors": "Intensely chocolatey, Sweet, Slightly bitter from cocoa",
                "variations": "Can be made dairy-free, gluten-free, or with added nuts or caramel",
                "allergy_info": "Contains dairy, eggs, and gluten; may cause allergies in sensitive individuals.",
                "Calories": "Approximately 350-450 kcal per serving",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Classic Cheeseburger Pizza, Garlic Bread Supreme, Classic Coke\",\"best_combo\":\"Savory and crunchy sides with a refreshing drink complement the sweet, rich Choco Lava Cake.\",\"best_combo_ids\":\"PIZ0025\"}",
                "is_deleted": "false",
                "food_type": "non_veg",
                "is_spice_applicable": "no",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "d3f3a400-9e90-4098-a991-33969ff1b6ea",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0030",
                "name": "Cinnamon Breadsticks",
                "category": "Starters & Small Plates",
                "supplier": "",
                "brand": "",
                "modifiers": "Cinnamon Breadsticks aadon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Cinnamon Breadsticks are soft, warm breadsticks coated with cinnamon sugar, offering a sweet and aromatic treat.",
                "comment": "",
                "cost": "",
                "price": "4.49",
                "large_price": "4.49",
                "indining_price": "4.49",
                "indining_large_price": "4.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749539017225-generated-image-1749539016801-2.png",
                "is_enabled": "true",
                "product_description": "Cinnamon Breadsticks are soft, warm breadsticks coated with cinnamon sugar, offering a sweet and aromatic treat.",
                "level1_category": "Starters & Small Plates",
                "level2_category": "Breads & Flatbreads",
                "Nutrients": "Provides carbohydrates, fats, and some protein.",
                "appearance": "Golden-brown breadsticks topped with cinnamon sugar, slightly glossy surface.",
                "ingredients": "Flour, yeast, butter, cinnamon, sugar, salt, milk, eggs.",
                "serving": "Best enjoyed warm with coffee or hot chocolate.",
                "flavors": "Sweet, spicy cinnamon, buttery notes.",
                "variations": "Can add icing or nuts for extra flavor.",
                "allergy_info": "Contains gluten, dairy, and eggs; may cause allergies.",
                "Calories": "Approximately 150-200 kcal per breadstick.",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Garlic Bread Supreme, Chicken Wings (6 pcs), Potato Wedges\",\"best_combo\":\"Rich, savory sides enhance the sweetness of cinnamon breadsticks.\",\"best_combo_ids\":\"PIZ0021,PIZ0022\"}",
                "is_deleted": "false",
                "food_type": "non_veg",
                "is_spice_applicable": "yes",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "ac33445d-18ae-4be2-942a-b0e65c7b44a4",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0014",
                "name": "Truffle Mushroom Delight Pizza",
                "category": "Starters & Small Plates",
                "supplier": "",
                "brand": "",
                "modifiers": "Truffle Mushroom Delight addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "A gourmet pizza topped with savory mushrooms and aromatic truffle oil, offering a rich, earthy flavor in a crispy crust.",
                "comment": "",
                "cost": "",
                "price": "14.49",
                "large_price": "14.49",
                "indining_price": "14.49",
                "indining_large_price": "14.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749536724052-generated-image-1749536723486-2.png",
                "is_enabled": "true",
                "product_description": "A gourmet pizza topped with savory mushrooms and aromatic truffle oil, offering a rich, earthy flavor in a crispy crust.",
                "level1_category": "Starters & Small Plates",
                "level2_category": "Breads & Flatbreads",
                "Nutrients": "Rich in antioxidants from mushrooms and healthy fats from truffle oil.",
                "appearance": "Golden-brown crust with melted cheese, sliced mushrooms, and drizzled truffle oil on top.",
                "ingredients": "Pizza dough, mushrooms, truffle oil, cheese, garlic, herbs, olive oil.",
                "serving": "Best enjoyed hot with a side of mixed greens or a light salad.",
                "flavors": "Earthy, umami, aromatic, slightly cheesy.",
                "variations": "Vegan version with plant-based cheese, or add prosciutto for non-veg.",
                "allergy_info": "Contains dairy and mushrooms; may cause allergies in sensitive individuals.",
                "Calories": "Approximately 300-400 kcal per slice.",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Veggie Supreme, Mediterranean Veggie, Spicy Veggie Volcano\",\"best_combo\":\"Complementary veggie flavors enhance the mushroom truffle profile.\",\"best_combo_ids\":\"PIZ0011,PIZ0008\"}",
                "is_deleted": "false",
                "food_type": "non_veg",
                "is_spice_applicable": "no",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "c8dee61d-9d99-407d-85c8-a2ebe87e9a14",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0006",
                "name": "Pepperoni Passion ",
                "category": "Starters & Small Plates",
                "supplier": "",
                "brand": "",
                "modifiers": "Pepperoni Passion addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Pepperoni Passion is a classic pizza topped with spicy pepperoni slices, melted cheese, and savory tomato sauce, offering a flavorful and satisfying experience.",
                "comment": "",
                "cost": "",
                "price": "12.99",
                "large_price": "12.99",
                "indining_price": "12.99",
                "indining_large_price": "12.99",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749534684345-generated-image-1749534684345-1.png",
                "is_enabled": "true",
                "product_description": "Pepperoni Passion is a classic pizza topped with spicy pepperoni slices, melted cheese, and savory tomato sauce, offering a flavorful and satisfying experience.",
                "level1_category": "Starters & Small Plates",
                "level2_category": "Appetizers / Starters",
                "Nutrients": "Rich in protein, calcium, and fats from cheese and meat toppings.",
                "appearance": "Golden-brown crust topped with vibrant red pepperoni slices and melted cheese.",
                "ingredients": "Dough, tomato sauce, mozzarella cheese, pepperoni slices, herbs.",
                "serving": "Best enjoyed hot with a side of garlic bread or salad.",
                "flavors": "Savory, spicy, cheesy, and slightly smoky.",
                "variations": "Can be made with different cheeses or vegetarian toppings.",
                "allergy_info": "Contains gluten, dairy, and processed meats; may cause allergies in sensitive individuals.",
                "Calories": "Approximately 300-400 kcal per slice.",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Meat Lover's Delight Pizza, BBQ Chicken Feast Pizza\",\"best_combo\":\"Rich, meaty flavors complement Pepperoni Passion well\",\"best_combo_ids\":\"PIZ0002,PIZ0005\"}",
                "is_deleted": "false",
                "food_type": "non_veg",
                "is_spice_applicable": "yes",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "fd637abf-0dc6-4253-b172-014f43c225cc",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0020",
                "name": " Garlic Bread Supreme",
                "category": "Starters & Small Plates",
                "supplier": "",
                "brand": "",
                "modifiers": "Garlic Bread Supreme addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Garlic Bread Supreme features toasted bread topped with garlic, herbs, melted cheese, and optional toppings for a flavorful appetizer.",
                "comment": "",
                "cost": "",
                "price": "5.49",
                "large_price": "5.49",
                "indining_price": "5.49",
                "indining_large_price": "5.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749538417077-generated-image-1749538417077-1.png",
                "is_enabled": "true",
                "product_description": "Garlic Bread Supreme features toasted bread topped with garlic, herbs, melted cheese, and optional toppings for a flavorful appetizer.",
                "level1_category": "Starters & Small Plates",
                "level2_category": "Breads & Flatbreads",
                "Nutrients": "Rich in carbohydrates, fats, and calcium from cheese.",
                "appearance": "Golden-brown toasted bread with melted cheese and sprinkled herbs on top.",
                "ingredients": "Bread, garlic, butter, cheese, herbs, optional toppings like olives or peppers.",
                "serving": "Best enjoyed warm with dips or as a side to pasta dishes.",
                "flavors": "Garlic, buttery, cheesy, herby with savory notes.",
                "variations": "Can include additional toppings like olives, peppers, or extra cheese.",
                "allergy_info": "Contains gluten, dairy, and garlic; may cause allergies in sensitive individuals.",
                "Calories": "Approximately 250-350 kcal per serving",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Classic Margherita, Four Cheese Melt Pizza, Veggie Supreme\",\"best_combo\":\"Complementary flavors and vegetarian options enhance garlic bread.\",\"best_combo_ids\":\"PIZ0001\"}",
                "is_deleted": "false",
                "food_type": "non_veg",
                "is_spice_applicable": "yes",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "3ee80a6b-a932-4ccb-a02f-377a91683824",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0024",
                "name": "Classic Pepsi ",
                "category": "Beverages",
                "supplier": "",
                "brand": "",
                "modifiers": "Classic Pepsi addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Classic Pepsi is a carbonated soft drink with a sweet, crisp flavor, known for its refreshing taste and iconic branding.",
                "comment": "",
                "cost": "",
                "price": "2.49",
                "large_price": "2.49",
                "indining_price": "2.49",
                "indining_large_price": "2.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749538665032-generated-image-1749538665032-1.png",
                "is_enabled": "true",
                "product_description": "Classic Pepsi is a carbonated soft drink with a sweet, crisp flavor, known for its refreshing taste and iconic branding.",
                "level1_category": "Beverages",
                "level2_category": "Beverages",
                "Nutrients": "Provides quick energy from sugars; no significant nutrients.",
                "appearance": "Clear, dark caramel-colored liquid in a transparent bottle or can.",
                "ingredients": "Carbonated water, high fructose corn syrup, caramel color, phosphoric acid, caffeine, natural flavors.",
                "serving": "Best served chilled in a glass or can, often with ice.",
                "flavors": "Sweet, caramel, slightly citrusy, fizzy.",
                "variations": "Diet Pepsi, Pepsi Max, flavored variants like cherry or vanilla.",
                "allergy_info": "Contains caffeine; may cause sensitivity in some individuals.",
                "Calories": "Approximately 150 kcal per 12 oz can.",
                "is_vegan": "yes",
                "best_combo": "{\"best_name\":\"Garlic Bread Supreme, Chicken Wings (6 pcs), Potato Wedges\",\"best_combo\":\"Classic Pepsi complements savory sides and crispy appetizers well.\",\"best_combo_ids\":\"PIZ0021,PIZ0022\"}",
                "is_deleted": "false",
                "food_type": "veg",
                "is_spice_applicable": "no",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "3c127c52-479a-4f61-b36f-9365af4bd8bb",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0025",
                "name": "Classic Coke",
                "category": "Beverages",
                "supplier": "",
                "brand": "",
                "modifiers": "Classic  Coke addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Classic Coke is a carbonated soft drink with a sweet, caramel flavor, known for its refreshing and bubbly taste.",
                "comment": "",
                "cost": "",
                "price": "2.49",
                "large_price": "2.49",
                "indining_price": "2.49",
                "indining_large_price": "2.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749538739474-generated-image-1749538739474-1.png",
                "is_enabled": "true",
                "product_description": "Classic Coke is a carbonated soft drink with a sweet, caramel flavor, known for its refreshing and bubbly taste.",
                "level1_category": "Beverages",
                "level2_category": "Beverages",
                "Nutrients": "Provides quick energy from sugars; no significant nutrients.",
                "appearance": "Clear, dark brown liquid with a fizzy, bubbly effervescence.",
                "ingredients": "Carbonated water, caramel color, high fructose corn syrup, phosphoric acid, natural flavors, caffeine",
                "serving": "Best served chilled in a glass or can, with ice if desired.",
                "flavors": "Sweet, caramel, slightly acidic, fizzy",
                "variations": "Diet Coke, Coca-Cola Zero Sugar, flavored variants like cherry or vanilla",
                "allergy_info": "Contains caffeine; no common allergens but not suitable for caffeine-sensitive individuals.",
                "Calories": "Approximately 140 kcal per 12 oz (355 ml) can",
                "is_vegan": "yes",
                "best_combo": "{\"best_name\":\"Classic Margherita, Garlic Bread Supreme, Chicken Wings (6 pcs)\",\"best_combo\":\"Light, savory, and crispy options complement the refreshing Classic Coke.\",\"best_combo_ids\":\"PIZ0001,PIZ0021\"}",
                "is_deleted": "false",
                "food_type": "veg",
                "is_spice_applicable": "no",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "b3d1ed75-e9df-45d0-a393-fbc1109c0aaa",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0003",
                "name": "Veggie Supreme ",
                "category": "Starters & Small Plates",
                "supplier": "",
                "brand": "",
                "modifiers": "Veggie Supreme addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Veggie Supreme is a hearty vegetarian pizza topped with a variety of fresh vegetables and melted cheese, offering a flavorful and satisfying meal.",
                "comment": "",
                "cost": "",
                "price": "12.49",
                "large_price": "12.49",
                "indining_price": "12.49",
                "indining_large_price": "12.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749534377844-generated-image-1749534377844-1.png",
                "is_enabled": "true",
                "product_description": "Veggie Supreme is a hearty vegetarian pizza topped with a variety of fresh vegetables and melted cheese, offering a flavorful and satisfying meal.",
                "level1_category": "Starters & Small Plates",
                "level2_category": "Breads & Flatbreads",
                "Nutrients": "Rich in vitamins from vegetables and calcium from cheese.",
                "appearance": "Colorful pizza with vibrant vegetable toppings and melted cheese crust.",
                "ingredients": "Tomatoes, bell peppers, onions, olives, cheese, pizza dough, herbs.",
                "serving": "Best enjoyed hot with a side of garlic bread or salad.",
                "flavors": "Savory, cheesy, with fresh vegetable notes.",
                "variations": "Can be made vegan by substituting cheese with plant-based options.",
                "allergy_info": "Contains dairy and gluten; may cause allergies in sensitive individuals.",
                "Calories": "Approximately 250-350 kcal per slice.",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Classic Margherita\",\"best_combo\":\"Both are vegetarian options with complementary flavors.\",\"best_combo_ids\":\"PIZ0001\"}",
                "is_deleted": "false",
                "food_type": "veg",
                "is_spice_applicable": "no",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              }
            ],
            "combo_price": "$74.60",
            "offer_percentage": "10.0",
            "combo_image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1750248161811-generated-image-1750248161811-1.png",
            "item_id": "",
            "is_enabled": true,
            "created_date": "2025-09-09 12-35-13"
          },
          {
            "combo_id": "50ca99a0-b58f-4761-874e-9cab164af716",
            "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
            "title": "Hunger Buster Combo",
            "description": "A satisfying selection of flavorful pizzas, crispy sides, and refreshing beverages, perfect for a hearty meal. Includes cheesy, meaty, vegetarian, and spicy options complemented by classic drinks and sides for a complete dining experience.",
            "products": [
              {
                "pk_id": "c8dee61d-9d99-407d-85c8-a2ebe87e9a14",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0006",
                "name": "Pepperoni Passion ",
                "category": "Starters & Small Plates",
                "supplier": "",
                "brand": "",
                "modifiers": "Pepperoni Passion addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Pepperoni Passion is a classic pizza topped with spicy pepperoni slices, melted cheese, and savory tomato sauce, offering a flavorful and satisfying experience.",
                "comment": "",
                "cost": "",
                "price": "12.99",
                "large_price": "12.99",
                "indining_price": "12.99",
                "indining_large_price": "12.99",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749534684345-generated-image-1749534684345-1.png",
                "is_enabled": "true",
                "product_description": "Pepperoni Passion is a classic pizza topped with spicy pepperoni slices, melted cheese, and savory tomato sauce, offering a flavorful and satisfying experience.",
                "level1_category": "Starters & Small Plates",
                "level2_category": "Appetizers / Starters",
                "Nutrients": "Rich in protein, calcium, and fats from cheese and meat toppings.",
                "appearance": "Golden-brown crust topped with vibrant red pepperoni slices and melted cheese.",
                "ingredients": "Dough, tomato sauce, mozzarella cheese, pepperoni slices, herbs.",
                "serving": "Best enjoyed hot with a side of garlic bread or salad.",
                "flavors": "Savory, spicy, cheesy, and slightly smoky.",
                "variations": "Can be made with different cheeses or vegetarian toppings.",
                "allergy_info": "Contains gluten, dairy, and processed meats; may cause allergies in sensitive individuals.",
                "Calories": "Approximately 300-400 kcal per slice.",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Meat Lover's Delight Pizza, BBQ Chicken Feast Pizza\",\"best_combo\":\"Rich, meaty flavors complement Pepperoni Passion well\",\"best_combo_ids\":\"PIZ0002,PIZ0005\"}",
                "is_deleted": "false",
                "food_type": "non_veg",
                "is_spice_applicable": "yes",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "0a3516ef-4805-4352-bc77-2c7a5c521167",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0019",
                "name": "Cheeseburger Pizza ",
                "category": "Starters & Small Plates",
                "supplier": "",
                "brand": "",
                "modifiers": "Cheeseburger Pizza addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Cheeseburger Pizza combines the flavors of a classic cheeseburger with a crispy pizza crust, topped with beef, cheese, and condiments for a savory experience.",
                "comment": "",
                "cost": "",
                "price": "14.99",
                "large_price": "14.99",
                "indining_price": "14.989",
                "indining_large_price": "14.99",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749537181694-generated-image-1749537179953-4.png",
                "is_enabled": "true",
                "product_description": "Cheeseburger Pizza combines the flavors of a classic cheeseburger with a crispy pizza crust, topped with beef, cheese, and condiments for a savory experience.",
                "level1_category": "Starters & Small Plates",
                "level2_category": "Appetizers / Starters",
                "Nutrients": "Rich in protein, calcium, and fats; provides energy and muscle support.",
                "appearance": "Golden-brown pizza crust topped with melted cheese, beef patties, and burger toppings.",
                "ingredients": "Pizza dough, beef patties, cheese, ketchup, mustard, pickles, onions, lettuce.",
                "serving": "Best enjoyed hot with a side of fries or salad.",
                "flavors": "Savory, cheesy, tangy, with beefy richness.",
                "variations": "Add bacon, jalapeños, or switch to plant-based patties.",
                "allergy_info": "Contains dairy, gluten, and beef; may cause allergies in sensitive individuals.",
                "Calories": "Approximately 600-800 kcal per slice.",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Loaded Paneer Paradise Pizza, Four Cheese Melt Pizza\",\"best_combo\":\"Rich cheesy and flavorful options complement the cheeseburger pizza well.\",\"best_combo_ids\":\"PIZ0015\"}",
                "is_deleted": "false",
                "food_type": "non_veg",
                "is_spice_applicable": "yes",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "02d9711e-2365-476c-9174-2ba463aa3636",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0015",
                "name": "Loaded Paneer Paradise Pizza",
                "category": "Starters & Small Plates",
                "supplier": "",
                "brand": "",
                "modifiers": "Loaded Paneer Paradise",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Loaded Paneer Paradise Pizza features a crispy crust topped with spiced paneer, fresh vegetables, and melted cheese, offering a flavorful vegetarian delight.",
                "comment": "",
                "cost": "",
                "price": "13.99",
                "large_price": "13.99",
                "indining_price": "13.99",
                "indining_large_price": "13.99",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749536855344-generated-image-1749536854924-2.png",
                "is_enabled": "true",
                "product_description": "Loaded Paneer Paradise Pizza features a crispy crust topped with spiced paneer, fresh vegetables, and melted cheese, offering a flavorful vegetarian delight.",
                "level1_category": "Starters & Small Plates",
                "level2_category": "Breads & Flatbreads",
                "Nutrients": "Rich in protein from paneer, calcium, vitamins from vegetables",
                "appearance": "Golden-brown crust with colorful toppings and melted cheese, garnished with herbs.",
                "ingredients": "Paneer, cheese, bell peppers, onions, tomato sauce, spices, herbs, dough",
                "serving": "Best enjoyed hot with a side of green chutney or salad.",
                "flavors": "Savory, cheesy, mildly spicy with aromatic herbs",
                "variations": "Vegan cheese, gluten-free crust, extra vegetables",
                "allergy_info": "Contains dairy and gluten; may cause allergies in sensitive individuals.",
                "Calories": "Approximately 300-400 kcal per slice",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Veggie Supreme, Mediterranean Veggie, Spicy Veggie Volcano\",\"best_combo\":\"Complementary veggie flavors enhance the paneer pizza experience.\",\"best_combo_ids\":\"PIZ0011,PIZ0008\"}",
                "is_deleted": "false",
                "food_type": "veg",
                "is_spice_applicable": "yes",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "ee2aa8fb-01ae-4cdc-8824-843577ea49cd",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0022",
                "name": "Potato Wedges",
                "category": "Sides & Accompaniments",
                "supplier": "",
                "brand": "",
                "modifiers": "Potato Wedges addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Crispy potato wedges are thick-cut potatoes seasoned and baked or fried until golden and crunchy, perfect as a snack or side.",
                "comment": "",
                "cost": "",
                "price": "4.99",
                "large_price": "4.99",
                "indining_price": "4.99",
                "indining_large_price": "4.99",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749538548266-generated-image-1749538548266-1.png",
                "is_enabled": "true",
                "product_description": "Crispy potato wedges are thick-cut potatoes seasoned and baked or fried until golden and crunchy, perfect as a snack or side.",
                "level1_category": "Sides & Accompaniments",
                "level2_category": "Side Dishes",
                "Nutrients": "Rich in carbohydrates and vitamin C, moderate in fiber.",
                "appearance": "Golden-brown, wedge-shaped potatoes with a crispy exterior and fluffy interior.",
                "ingredients": "Potatoes, Olive oil, Salt, Pepper, Paprika, Garlic powder, Herbs",
                "serving": "Best enjoyed with ketchup, aioli, or spicy dips.",
                "flavors": "Savory, Crispy, Slightly smoky with hints of herbs.",
                "variations": "Can be seasoned with cheese, chili, or served with different dips.",
                "allergy_info": "Contains potatoes; check for cross-contamination with gluten or dairy if applicable.",
                "Calories": "Approximately 150-250 kcal per serving",
                "is_vegan": "yes",
                "best_combo": "{\"best_name\":\"Garlic Bread Supreme, Chicken Wings (6 pcs)\",\"best_combo\":\"Perfect sides with potato wedges for added flavor and variety.\",\"best_combo_ids\":\"PIZ0021\"}",
                "is_deleted": "false",
                "food_type": "veg",
                "is_spice_applicable": "yes",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "7f25523c-9de7-4112-a346-55c0acefc8da",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0023",
                "name": "Tandoori Chicken Bites",
                "category": "Entrees",
                "supplier": "",
                "brand": "",
                "modifiers": "Tandoori Chicken Bites addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Tandoori Chicken Bites are tender, marinated chicken pieces cooked in a traditional tandoor, offering smoky and spicy flavors in bite-sized form.",
                "comment": "",
                "cost": "",
                "price": "7.49",
                "large_price": "7.49",
                "indining_price": "7.49",
                "indining_large_price": "7.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749538600422-generated-image-1749538599121-4.png",
                "is_enabled": "true",
                "product_description": "Tandoori Chicken Bites are tender, marinated chicken pieces cooked in a traditional tandoor, offering smoky and spicy flavors in bite-sized form.",
                "level1_category": "Entrees",
                "level2_category": "Specialty Meat Dishes",
                "Nutrients": "High in protein, rich in vitamins and minerals from spices.",
                "appearance": "Golden-brown, charred edges with vibrant red spice coating, served in small pieces.",
                "ingredients": "Chicken,Yogurt,Spices,Garlic,Ginger,Salt,Oil,Red chili powder",
                "serving": "Best enjoyed with mint chutney or yogurt dip.",
                "flavors": "Spicy,Smoky,Tangy",
                "variations": "Can be made vegan with plant-based chicken substitutes.",
                "allergy_info": "Contains dairy and spices; may cause allergies in sensitive individuals.",
                "Calories": "Approximately 150-200 kcal per serving",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Chicken Tikka Pizza, Garlic Bread Supreme\",\"best_combo\":\"Complementary flavors of tandoori spices and garlic bread enhance the meal.\",\"best_combo_ids\":\"PIZ0004\"}",
                "is_deleted": "false",
                "food_type": "non_veg",
                "is_spice_applicable": "yes",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "3ee80a6b-a932-4ccb-a02f-377a91683824",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0024",
                "name": "Classic Pepsi ",
                "category": "Beverages",
                "supplier": "",
                "brand": "",
                "modifiers": "Classic Pepsi addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Classic Pepsi is a carbonated soft drink with a sweet, crisp flavor, known for its refreshing taste and iconic branding.",
                "comment": "",
                "cost": "",
                "price": "2.49",
                "large_price": "2.49",
                "indining_price": "2.49",
                "indining_large_price": "2.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749538665032-generated-image-1749538665032-1.png",
                "is_enabled": "true",
                "product_description": "Classic Pepsi is a carbonated soft drink with a sweet, crisp flavor, known for its refreshing taste and iconic branding.",
                "level1_category": "Beverages",
                "level2_category": "Beverages",
                "Nutrients": "Provides quick energy from sugars; no significant nutrients.",
                "appearance": "Clear, dark caramel-colored liquid in a transparent bottle or can.",
                "ingredients": "Carbonated water, high fructose corn syrup, caramel color, phosphoric acid, caffeine, natural flavors.",
                "serving": "Best served chilled in a glass or can, often with ice.",
                "flavors": "Sweet, caramel, slightly citrusy, fizzy.",
                "variations": "Diet Pepsi, Pepsi Max, flavored variants like cherry or vanilla.",
                "allergy_info": "Contains caffeine; may cause sensitivity in some individuals.",
                "Calories": "Approximately 150 kcal per 12 oz can.",
                "is_vegan": "yes",
                "best_combo": "{\"best_name\":\"Garlic Bread Supreme, Chicken Wings (6 pcs), Potato Wedges\",\"best_combo\":\"Classic Pepsi complements savory sides and crispy appetizers well.\",\"best_combo_ids\":\"PIZ0021,PIZ0022\"}",
                "is_deleted": "false",
                "food_type": "veg",
                "is_spice_applicable": "no",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "aa22f37a-04c0-457c-a9d8-65a1c3abcd9e",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0032",
                "name": "Brownie Bites (4 pcs)",
                "category": "Desserts & Sweets",
                "supplier": "",
                "brand": "",
                "modifiers": "Brownie Bites",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Delicious mini chocolate brownies, moist and fudgy, served in bite-sized pieces perfect for snacking or dessert.",
                "comment": "",
                "cost": "",
                "price": "5.99",
                "large_price": "5.99",
                "indining_price": "5.99",
                "indining_large_price": "5.99",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749539240250-generated-image-1749539231138-4.png",
                "is_enabled": "true",
                "product_description": "Delicious mini chocolate brownies, moist and fudgy, served in bite-sized pieces perfect for snacking or dessert.",
                "level1_category": "Desserts & Sweets",
                "level2_category": "Pastries & Cakes",
                "Nutrients": "Provides energy from sugars and fats, contains antioxidants from chocolate.",
                "appearance": "Small, square, rich brown bites with a glossy chocolate glaze on top.",
                "ingredients": "Chocolate, Flour, Butter, Sugar, Eggs, Cocoa powder, Vanilla extract",
                "serving": "Best enjoyed with a scoop of ice cream or a glass of milk.",
                "flavors": "Rich, Chocolatey, Sweet, Fudgy",
                "variations": "Add nuts, caramel swirls, or vegan chocolate options.",
                "allergy_info": "Contains gluten, dairy, and eggs; may cause allergic reactions.",
                "Calories": "Approximately 150-200 kcal per piece",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Choco Lava Cake, Ice Cream Sundae\",\"best_combo\":\"Rich desserts complement the chocolatey brownie bites perfectly.\",\"best_combo_ids\":\"PIZ0028,PIZ0029\"}",
                "is_deleted": "false",
                "food_type": "non_veg",
                "is_spice_applicable": "no",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "179e17e7-da1c-4b6f-a792-d984cdc177fa",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0031",
                "name": " Cheesecake Slice",
                "category": "Desserts & Sweets",
                "supplier": "",
                "brand": "",
                "modifiers": "Cheesecake Slice",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "A rich, creamy dessert with a smooth cheese filling on a buttery crust, topped with fruit or glaze for added flavor.",
                "comment": "",
                "cost": "",
                "price": "5.99",
                "large_price": "5.99",
                "indining_price": "5.99",
                "indining_large_price": "5.99",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749539157355-generated-image-1749539156897-2.png",
                "is_enabled": "true",
                "product_description": "A rich, creamy dessert with a smooth cheese filling on a buttery crust, topped with fruit or glaze for added flavor.",
                "level1_category": "Desserts & Sweets",
                "level2_category": "Pastries & Cakes",
                "Nutrients": "Rich in calcium, protein, and fats; high in calories",
                "appearance": "A triangular slice with a smooth, creamy surface and a graham cracker crust base.",
                "ingredients": "Cream cheese, sugar, eggs, graham cracker crust, vanilla extract, sour cream",
                "serving": "Best enjoyed chilled, topped with fresh fruit or fruit compote.",
                "flavors": "Sweet, tangy, creamy with hints of vanilla and buttery crust",
                "variations": "Chocolate, fruit-topped, no-bake, vegan options available",
                "allergy_info": "Contains dairy and eggs; may cause allergies in sensitive individuals",
                "Calories": "Approximately 300-400 kcal per slice",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Choco Lava Cake, Ice Cream Sundae\",\"best_combo\":\"Rich desserts complement the creamy cheesecake perfectly.\",\"best_combo_ids\":\"PIZ0028,PIZ0029\"}",
                "is_deleted": "false",
                "food_type": "non_veg",
                "is_spice_applicable": "no",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "dcbe286c-43c2-4f27-b9aa-8a339344f0c7",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0016",
                "name": "Buffalo Chicken Blast Pizza",
                "category": "Starters & Small Plates",
                "supplier": "",
                "brand": "",
                "modifiers": "Buffalo Chicken Blast addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Buffalo Chicken Blast Pizza features a crispy crust topped with spicy buffalo sauce, tender chicken, and melty cheese, offering a bold flavor experience.",
                "comment": "",
                "cost": "",
                "price": "13.49",
                "large_price": "13.49",
                "indining_price": "13.49",
                "indining_large_price": "13.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749536945765-generated-image-1749536944781-3.png",
                "is_enabled": "true",
                "product_description": "Buffalo Chicken Blast Pizza features a crispy crust topped with spicy buffalo sauce, tender chicken, and melty cheese, offering a bold flavor experience.",
                "level1_category": "Starters & Small Plates",
                "level2_category": "Appetizers / Starters",
                "Nutrients": "Rich in protein and calcium, moderate in fats and carbs.",
                "appearance": "Golden-brown crust with vibrant red buffalo sauce, chicken pieces, and melted cheese topping.",
                "ingredients": "Pizza dough, chicken, buffalo sauce, cheese, blue cheese, celery, ranch dressing",
                "serving": "Best enjoyed hot with a side of celery sticks or ranch dressing.",
                "flavors": "Spicy, tangy, cheesy, savory",
                "variations": "Can be made with plant-based chicken or less spicy sauce.",
                "allergy_info": "Contains dairy, gluten, and possible soy; may cause allergies in sensitive individuals.",
                "Calories": "Approximately 300-400 kcal per slice",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Meat Lover's Delight Pizza,BBQ Chicken Feast Pizza,Spicy Veggie Volcano\",\"best_combo\":\"Enhances spicy and meaty flavors, creating a bold, satisfying combo.\",\"best_combo_ids\":\"PIZ0002,PIZ0005,PIZ0008\"}",
                "is_deleted": "false",
                "food_type": "non_veg",
                "is_spice_applicable": "yes",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              }
            ],
            "combo_price": "$74.17",
            "offer_percentage": "10.0",
            "combo_image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1750249766723-generated-image-1750249761907-3.png",
            "item_id": "",
            "is_enabled": true,
            "created_date": "2025-09-09 12-35-13"
          },
          {
            "combo_id": "b902f691-9bfd-4225-aa32-aa701786bbf4",
            "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
            "title": "Spicy Crust Combo",
            "description": "The Spicy Crust Combo typically features a pizza with a flavorful, spicy crust that adds an extra kick to your favorite toppings. It often includes a variety of ingredients like spicy sausage, jalapeños, pepperoni, or other bold flavors, all served on a crust that’s seasoned with spices to enhance the heat and taste. This combo is perfect for those who enjoy a fiery twist on their pizza. For specific details or to customize your order, please check with your local pizzeria or restaurant.",
            "products": [
              {
                "pk_id": "f03c1c36-597d-4afc-ab37-3700b0f70d35",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0001",
                "name": "Classic Margherita",
                "category": "Starters & Small Plates",
                "supplier": "",
                "brand": "",
                "modifiers": "Classic Margherita addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Classic Margherita is a traditional Italian pizza featuring a thin crust topped with fresh tomatoes, mozzarella, basil, and olive oil, offering a simple yet flavorful experience.",
                "comment": "",
                "cost": "",
                "price": "10.99",
                "large_price": "10.99",
                "indining_price": "10.99",
                "indining_large_price": "10.99",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1750428613430-generated-image-1750428613430-1.png",
                "is_enabled": true,
                "product_description": "A Margherita pizza is a classic Italian dish known for its simple yet flavorful ingredients. It typically features a thin, crisp crust topped with a vibrant tomato sauce made from fresh, ripe tomatoes. The pizza is adorned with slices of fresh mozzarella cheese that melt beautifully during baking, creating a creamy texture. Fresh basil leaves are added on top, providing a fragrant, herbal aroma and a splash of color. Often finished with a drizzle of extra virgin olive oil, the Margherita pizza embodies a harmonious balance of fresh, high-quality ingredients, highlighting the essence of traditional Italian cuisine.",
                "level1_category": "Starters & Small Plates",
                "level2_category": "Breads & Flatbreads",
                "Nutrients": "Rich in calcium, protein, and antioxidants from fresh ingredients.",
                "appearance": "Golden-brown thin crust with vibrant red tomatoes, white mozzarella, and green basil leaves.",
                "ingredients": "Flour, tomatoes, mozzarella cheese, basil, olive oil, salt, yeast",
                "serving": "Best enjoyed hot with a drizzle of olive oil or fresh basil leaves.",
                "flavors": "Fresh, Savory, Herbaceous",
                "variations": "Add extra toppings like prosciutto or chili flakes for variation.",
                "allergy_info": "Contains gluten, dairy, and basil; may affect allergies.",
                "Calories": "Approximately 250-300 kcal per slice",
                "is_vegan": "no",
                "best_combo": [],
                "is_deleted": false,
                "food_type": "veg",
                "is_spice_applicable": "no",
                "meal_time": "",
                "inventory_status": true,
                "is_item_verified": true,
                "account_id": "",
                "party_orders": [
                  {
                    "name": "small",
                    "serving": "10",
                    "price": "109.90"
                  },
                  {
                    "name": "medium",
                    "serving": "25",
                    "price": "274.75"
                  },
                  {
                    "name": "large",
                    "serving": "50",
                    "price": "549.50"
                  }
                ],
                "modifiers_list": [
                  {
                    "name": "Classic Margherita addon",
                    "is_multi_select": "No",
                    "is_forced": "Yes",
                    "options": [
                      {
                        "name": "Extra cheese",
                        "price": "$1.25",
                        "isEnabled": true
                      },
                      {
                        "name": "Cherry tomatoes",
                        "price": "$0.75",
                        "isEnabled": true
                      },
                      {
                        "name": "Garlic crust",
                        "price": "$1.50",
                        "isEnabled": true
                      },
                      {
                        "name": "Arugula",
                        "price": "$0.75",
                        "isEnabled": true
                      }
                    ]
                  }
                ]
              },
              {
                "pk_id": "b3d1ed75-e9df-45d0-a393-fbc1109c0aaa",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0003",
                "name": "Veggie Supreme ",
                "category": "Starters & Small Plates",
                "supplier": "",
                "brand": "",
                "modifiers": "Veggie Supreme addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Veggie Supreme is a hearty vegetarian pizza topped with a variety of fresh vegetables and melted cheese, offering a flavorful and satisfying meal.",
                "comment": "",
                "cost": "",
                "price": "12.49",
                "large_price": "12.49",
                "indining_price": "12.49",
                "indining_large_price": "12.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749534377844-generated-image-1749534377844-1.png",
                "is_enabled": true,
                "product_description": "Veggie Supreme is a hearty vegetarian pizza topped with a variety of fresh vegetables and melted cheese, offering a flavorful and satisfying meal.",
                "level1_category": "Starters & Small Plates",
                "level2_category": "Breads & Flatbreads",
                "Nutrients": "Rich in vitamins from vegetables and calcium from cheese.",
                "appearance": "Colorful pizza with vibrant vegetable toppings and melted cheese crust.",
                "ingredients": "Tomatoes, bell peppers, onions, olives, cheese, pizza dough, herbs.",
                "serving": "Best enjoyed hot with a side of garlic bread or salad.",
                "flavors": "Savory, cheesy, with fresh vegetable notes.",
                "variations": "Can be made vegan by substituting cheese with plant-based options.",
                "allergy_info": "Contains dairy and gluten; may cause allergies in sensitive individuals.",
                "Calories": "Approximately 250-350 kcal per slice.",
                "is_vegan": "no",
                "best_combo": {
                  "best_name": "Classic Margherita",
                  "best_combo": "Both are vegetarian options with complementary flavors.",
                  "best_combo_ids": "PIZ0001"
                },
                "is_deleted": false,
                "food_type": "veg",
                "is_spice_applicable": "no",
                "meal_time": "",
                "inventory_status": true,
                "is_item_verified": true,
                "account_id": "",
                "party_orders": [
                  {
                    "name": "small",
                    "serving": "10",
                    "price": "124.90"
                  },
                  {
                    "name": "medium",
                    "serving": "25",
                    "price": "312.25"
                  },
                  {
                    "name": "large",
                    "serving": "50",
                    "price": "624.50"
                  }
                ],
                "modifiers_list": [
                  {
                    "name": "Veggie Supreme addon",
                    "is_multi_select": "No",
                    "is_forced": "Yes",
                    "options": [
                      {
                        "name": "Spinach",
                        "price": "$0.75",
                        "isEnabled": true
                      },
                      {
                        "name": "feta",
                        "price": "$1.50",
                        "isEnabled": true
                      },
                      {
                        "name": "pesto swirl",
                        "price": "$1.50",
                        "isEnabled": true
                      }
                    ]
                  }
                ]
              },
              {
                "pk_id": "4f60847b-b066-4754-81c8-330f11095786",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0007",
                "name": "Hawaiian Classic Pizza",
                "category": "Entrees",
                "supplier": "",
                "brand": "",
                "modifiers": "Hawaiian Classic addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Hawaiian Classic Pizza features a crispy crust topped with tomato sauce, cheese, ham, and pineapple chunks, offering a sweet and savory flavor profile.",
                "comment": "",
                "cost": "",
                "price": "12.49",
                "large_price": "12.49",
                "indining_price": "12.49",
                "indining_large_price": "12.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749534761684-generated-image-1749534760104-4.png",
                "is_enabled": true,
                "product_description": "Hawaiian Classic Pizza features a crispy crust topped with tomato sauce, cheese, ham, and pineapple chunks, offering a sweet and savory flavor profile.",
                "level1_category": "Entrees",
                "level2_category": "Pizzas & Flatbreads",
                "Nutrients": "Provides carbs, protein, calcium, and vitamins from toppings.",
                "appearance": "Golden-brown crust with melted cheese, ham slices, and pineapple pieces on top.",
                "ingredients": "Pizza dough, tomato sauce, mozzarella cheese, ham, pineapple, olive oil, herbs.",
                "serving": "Best enjoyed hot with a side of garlic bread or salad.",
                "flavors": "Sweet, savory, cheesy, with a hint of tang from pineapple.",
                "variations": "Can add bacon, jalapeños, or substitute ham with turkey.",
                "allergy_info": "Contains dairy, gluten, and possibly soy; check for allergies.",
                "Calories": "Approximately 250-350 kcal per slice.",
                "is_vegan": "no",
                "best_combo": {
                  "best_name": "Meat Lover's Delight Pizza, BBQ Chicken Feast Pizza",
                  "best_combo": "Rich, savory flavors complement the sweet and savory Hawaiian pizza",
                  "best_combo_ids": "PIZ0002,PIZ0005"
                },
                "is_deleted": false,
                "food_type": "non_veg",
                "is_spice_applicable": "no",
                "meal_time": "",
                "inventory_status": true,
                "is_item_verified": true,
                "account_id": "",
                "party_orders": [
                  {
                    "name": "small",
                    "serving": "10",
                    "price": "124.90"
                  },
                  {
                    "name": "medium",
                    "serving": "25",
                    "price": "312.25"
                  },
                  {
                    "name": "large",
                    "serving": "50",
                    "price": "624.50"
                  }
                ],
                "modifiers_list": [
                  {
                    "name": "Hawaiian Classic addon",
                    "is_multi_select": "No",
                    "is_forced": "Yes",
                    "options": [
                      {
                        "name": "Bacon",
                        "price": "$1.75",
                        "isEnabled": true
                      },
                      {
                        "name": "red onions",
                        "price": "$0.60",
                        "isEnabled": true
                      },
                      {
                        "name": "sweet chili drizzle",
                        "price": "$0.60",
                        "isEnabled": true
                      },
                      {
                        "name": "spicy crust",
                        "price": "$1.25",
                        "isEnabled": true
                      }
                    ]
                  }
                ]
              }
            ],
            "combo_price": "$34.17",
            "offer_percentage": "5.0",
            "combo_image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1752215177271-generated-image-1752215176604-2.png",
            "item_id": "",
            "is_enabled": true,
            "created_date": "2025-09-09 12-35-13"
          },
          {
            "combo_id": "8a1b8f6b-00cc-46e7-b54f-53e98c404317",
            "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
            "title": "Veggie supreme",
            "description": "Introducing our Veggie Supreme Pizza Combo—an irresistible feast for your senses! Dive into a flavorful medley of fresh, crisp vegetables topped with gooey, melted cheese and our signature sauce, all nestled on a perfectly baked crust. The Veggie Supreme is a vibrant celebration of wholesome ingredients, crafted to satisfy both your cravings and your health-conscious choices. Paired with our refreshing, chilled Coke, this combo offers the perfect harmony of savory and fizzy delight. Whether you're sharing with friends or treating yourself, the Veggie Supreme Pizza Combo promises a deliciously satisfying experience that will leave you craving more!",
            "products": [
              {
                "pk_id": "3c127c52-479a-4f61-b36f-9365af4bd8bb",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0025",
                "name": "Classic Coke",
                "category": "Beverages",
                "supplier": "",
                "brand": "",
                "modifiers": "Classic  Coke addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Classic Coke is a carbonated soft drink with a sweet, caramel flavor, known for its refreshing and bubbly taste.",
                "comment": "",
                "cost": "",
                "price": "2.49",
                "large_price": "2.49",
                "indining_price": "2.49",
                "indining_large_price": "2.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749538739474-generated-image-1749538739474-1.png",
                "is_enabled": true,
                "product_description": "Classic Coke is a carbonated soft drink with a sweet, caramel flavor, known for its refreshing and bubbly taste.",
                "level1_category": "Beverages",
                "level2_category": "Beverages",
                "Nutrients": "Provides quick energy from sugars; no significant nutrients.",
                "appearance": "Clear, dark brown liquid with a fizzy, bubbly effervescence.",
                "ingredients": "Carbonated water, caramel color, high fructose corn syrup, phosphoric acid, natural flavors, caffeine",
                "serving": "Best served chilled in a glass or can, with ice if desired.",
                "flavors": "Sweet, caramel, slightly acidic, fizzy",
                "variations": "Diet Coke, Coca-Cola Zero Sugar, flavored variants like cherry or vanilla",
                "allergy_info": "Contains caffeine; no common allergens but not suitable for caffeine-sensitive individuals.",
                "Calories": "Approximately 140 kcal per 12 oz (355 ml) can",
                "is_vegan": "yes",
                "best_combo": {
                  "best_name": "Classic Margherita, Garlic Bread Supreme, Chicken Wings (6 pcs)",
                  "best_combo": "Light, savory, and crispy options complement the refreshing Classic Coke.",
                  "best_combo_ids": "PIZ0001,PIZ0021"
                },
                "is_deleted": false,
                "food_type": "veg",
                "is_spice_applicable": "no",
                "meal_time": "",
                "inventory_status": true,
                "is_item_verified": true,
                "account_id": "",
                "party_orders": [
                  {
                    "name": "small",
                    "serving": "12",
                    "price": "29.88"
                  },
                  {
                    "name": "medium",
                    "serving": "50",
                    "price": "124.50"
                  },
                  {
                    "name": "large",
                    "serving": "100",
                    "price": "249.00"
                  }
                ],
                "modifiers_list": [
                  {
                    "name": "Classic  Coke addon",
                    "is_multi_select": "No",
                    "is_forced": "Yes",
                    "pk_id": "f7b73e50-eae9-4329-9a7c-82aac702a1ab",
                    "options": [
                      {
                        "name": "Ice-free option",
                        "price": "$0",
                        "isEnabled": true
                      },
                      {
                        "name": "lemon twist",
                        "price": "$0.50",
                        "isEnabled": true
                      }
                    ]
                  }
                ]
              },
              {
                "pk_id": "b3d1ed75-e9df-45d0-a393-fbc1109c0aaa",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0003",
                "name": "Veggie Supreme ",
                "category": "Starters & Small Plates",
                "supplier": "",
                "brand": "",
                "modifiers": "",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Veggie Supreme is a hearty vegetarian pizza topped with a variety of fresh vegetables and melted cheese, offering a flavorful and satisfying meal.",
                "comment": "",
                "cost": "",
                "price": "13",
                "large_price": "12.49",
                "indining_price": "1",
                "indining_large_price": "12.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749534377844-generated-image-1749534377844-1.png",
                "is_enabled": true,
                "product_description": "Veggie Supreme is a hearty vegetarian pizza topped with a variety of fresh vegetables and melted cheese, offering a flavorful and satisfying meal.",
                "level1_category": "Starters & Small Plates",
                "level2_category": "Breads & Flatbreads",
                "Nutrients": "Rich in vitamins from vegetables and calcium from cheese.",
                "appearance": "Colorful pizza with vibrant vegetable toppings and melted cheese crust.",
                "ingredients": "Tomatoes, bell peppers, onions, olives, cheese, pizza dough, herbs.",
                "serving": "Best enjoyed hot with a side of garlic bread or salad.",
                "flavors": "Savory, cheesy, with fresh vegetable notes.",
                "variations": "Can be made vegan by substituting cheese with plant-based options.",
                "allergy_info": "Contains dairy and gluten; may cause allergies in sensitive individuals.",
                "Calories": "Approximately 250-350 kcal per slice.",
                "is_vegan": "no",
                "best_combo": {
                  "best_name": "Classic Margherita",
                  "best_combo": "Both are vegetarian options with complementary flavors.",
                  "best_combo_ids": "PIZ0001"
                },
                "is_deleted": false,
                "food_type": "veg",
                "is_spice_applicable": "Yes",
                "meal_time": "",
                "inventory_status": true,
                "is_item_verified": true,
                "account_id": "",
                "party_orders": [
                  {
                    "name": "small",
                    "serving": "10",
                    "price": "124.90"
                  },
                  {
                    "name": "medium",
                    "serving": "25",
                    "price": "312.25"
                  },
                  {
                    "name": "large",
                    "serving": "50",
                    "price": "624.50"
                  }
                ]
              }
            ],
            "combo_price": "$14.72",
            "offer_percentage": "5.0",
            "combo_image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1754874940426-generated-image-1754874932453-4.png",
            "item_id": "",
            "is_enabled": true,
            "created_date": "2025-09-09 12-35-13"
          }]
        }
      },
      {
        "type": "ClassicExperienceCard",
        "data": {
          "headerContent": "<h2 class='text-3xl md:text-4xl font-bold text-gray-900 text-center mb-6'>Our Experience</h2><p class='text-lg text-gray-600 text-center max-w-3xl mx-auto leading-relaxed'>Discover what makes our sample business special through our approach and dedication.</p>",
          "cards": [
            {
              "id": "1",
              "title": "Quality Service",
              "description": "We provide sample service to demonstrate the layout and structure for your website.",
              "icon": "⭐"
            },
            {
              "id": "2",
              "title": "Expert Team",
              "description": "Our sample team consists of placeholder professionals showcasing this section.",
              "icon": "👥"
            },
            {
              "id": "3",
              "title": "Innovation",
              "description": "This card shows how to highlight features like innovation using placeholder text.",
              "icon": "💡"
            },
            {
              "id": "4",
              "title": "Customer Focus",
              "description": "Your satisfaction is important; this is generic text demonstrating customer focus.",
              "icon": "🎯"
            }
          ],
          "backgroundColor": "#f9fafb"
        }

      },
      {
        "type": "BasicStory",
        "data": {
          "hero": {
            "image": "https://thumbs.dreamstime.com/b/unhealthy-fast-food-delivery-menu-featuring-assorted-burgers-cheeseburgers-nuggets-french-fries-soda-high-calorie-low-356045884.jpg",
            "title": "Our Story"
          },
          "title": "The Story of Our Sample Restaurant",
          "storyContent": "<p>Once upon a time, in a small bustling town, there was a cozy little sample restaurant. This is placeholder text describing the beginnings of the restaurant for demonstration purposes.</p><p>The chef had a passion for creating delicious meals and providing a warm atmosphere. With care and dedication, they opened this sample restaurant to share good food and joy with the community.</p><p>Our approach is simple: use fresh ingredients, prepare each dish thoughtfully, and serve it with a smile. This is sample content for the story section and can be replaced with real information later.</p>"
        }

      },
      {
        "type": "BasicBlog",
        "data": {
          "title": "<h2 class='text-3xl font-bold text-gray-900 mb-4'>Latest Blog Posts</h2>",
          "subtitle": "<p class='text-gray-600 text-lg'>Discover our latest stories and insights</p>",
          "posts": [
            {
              "id": "1",
              "title": "<h3 class='text-xl font-bold text-gray-900'>Sample Blog Post One</h3>",
              "content": "<p class='text-gray-700 leading-relaxed'>This is a placeholder content for a sample blog post. Replace it with your own text for actual blog entries.</p>",
              "excerpt": "<p class='text-gray-600'>This is a sample excerpt for the blog post.</p>",
              "image": "https://images.unsplash.com/photo-1499750310107-5fef28a66643?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8YmxvZ3xlbnwwfHwwfHx8MA%3D%3D",
              "date": "2024-01-01T00:00:00.000Z",
              "readTime": "5 min",
              "category": "Sample",
              "isEnabled": true
            },
            {
              "id": "2",
              "title": "<h3 class='text-xl font-bold text-gray-900'>Sample Blog Post Two</h3>",
              "content": "<p class='text-gray-700 leading-relaxed'>Another placeholder content for a sample blog post. Use this format to display blog content in preview mode.</p>",
              "excerpt": "<p class='text-gray-600'>This is a sample excerpt for the second blog post.</p>",
              "image": "https://images.unsplash.com/photo-1488190211105-8b0e65b80b4e?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
              "date": "2024-01-02T00:00:00.000Z",
              "readTime": "3 min",
              "category": "Sample",
              "isEnabled": true
            }
          ],
          "postsPerPage": 6,
          "showCategory": true,
          "showReadTime": true,
          "showAuthor": false,
          "backgroundColor": "#ffffff",
          "textColor": "#1f2937",
          "cardBackgroundColor": "#ffffff",
          "primaryColor": "#EF4444"
        }

      },
      {
        "type": "ClassicGallery",
        "data": {
          "section": {
            "title": "Culinary Artistry",
            "subtitle": "A visual celebration of our gastronomic creations",
            "description": "Each dish is a canvas where flavors, textures, and visual beauty come together in perfect harmony."
          },
          "images": [
            {
              "id": "1",
              "url": "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=500&h=500&fit=crop",
              "title": "Elegant Presentation",
              "description": "Where artistry meets gastronomy",
              "isVisible": true
            },
            {
              "id": "2",
              "url": "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=500&h=500&fit=crop",
              "title": "Chef's Precision",
              "description": "Meticulous attention to every detail",
              "isVisible": true
            },
            {
              "id": "3",
              "url": "https://images.unsplash.com/photo-1540420773420-3366772f4999?w=500&h=500&fit=crop",
              "title": "Premium Ingredients",
              "description": "Only the finest seasonal selections",
              "isVisible": true
            },
            {
              "id": "4",
              "url": "https://images.unsplash.com/photo-1574071318508-1cdbab80d002?w=500&h=500&fit=crop",
              "title": "Sophisticated Ambiance",
              "description": "An atmosphere of refined elegance",
              "isVisible": true
            }
          ],
          "cta": {
            "text": "Follow @CulinaryJourney",
            "link": "https://instagram.com/culinaryjourney"
          }
        }

      },
      {
        "type": "ClassicEvents",
        "data": {
          "isEnabled": true,
          "section": {
            "title": "Upcoming Events",
            "subtitle": "Stay tuned for our upcoming events!",
            "primaryColor": "#EF4444",
            "secondaryColor": "#DC2626",
            "accentColor": "#B91C1C",
            "textColor": "#374151"
          },
          "items": [
            {
              "id": "event-1",
              "title": "Sample Event",
              "description": "This is a placeholder description for a sample event. Event details will be updated soon.",
              "image": "https://thumbs.dreamstime.com/b/buffet-dinner-restaurant-catering-food-concept-66884106.jpg",
              "date": "2024-01-01",
              "time": "18:00",
              "location": "Sample Venue",
              "isVisible": true
            }
          ]
        }

      },
      {
        "type": "ClassicContactForm",
        "data": {
          "title": "Contact Us",
          "subtitle": "We’d love to hear from you. This is sample text for demonstration purposes.",
          "primaryColor": "#E7000B",
          "textColor": "#1F2937",
          "backgroundColor": "#FFFFFF",
          "formBackgroundColor": "#F9FAFB",
          "cardBackgroundColor": "#FFFFFF",
          "submitButtonText": "SUBMIT",
          "successMessage": "Thank you for reaching out! This is a sample success message.",
          "errorMessage": "Oops! Something went wrong. Please try again later.",
          "contactInfo": {
            "email": {
              "title": "Email Us",
              "description": "Send us an email",
              "address": "info@sample.com"
            },
            "phone": {
              "title": "Call Us",
              "description": "Call us directly",
              "number": "(000) 000-0000"
            },
            "address": {
              "title": "Visit Us",
              "description": "Visit our office",
              "full": "123 Sample Street, Sample City, Country"
            }
          },
          "formFields": {
            "name": {
              "enabled": true,
              "required": true,
              "label": "Name",
              "placeholder": "Your Name"
            },
            "email": {
              "enabled": true,
              "required": true,
              "label": "Email",
              "placeholder": "Your Email"
            },
            "phone": {
              "enabled": true,
              "required": false,
              "label": "Phone",
              "placeholder": "Your Phone"
            },
            "message": {
              "enabled": true,
              "required": true,
              "label": "Message",
              "placeholder": "Your Message"
            }
          }
        }

      },
      {
        "type": "ClassicFooter",
        "data": {
          "restaurantName": "Sample Restaurant",
          "description": "<p>Welcome to our <strong>sample restaurant</strong>. Enjoy a delightful dining experience with <em>delicious meals</em>, friendly service, and a cozy atmosphere.</p>",
          "phone": "(000) 000-0000",
          "email": "info@samplerestaurant.com",
          "address": "123 Sample Street, Sample City, Country 00000",
          "hours": "Opening hours not available",
          "quickLinks": [
            { "id": "1", "label": "Menu", "url": "/menu" },
            { "id": "2", "label": "About Us", "url": "/about" },
            { "id": "3", "label": "Blog", "url": "/blog" },
            { "id": "4", "label": "Gallery", "url": "/gallery" },
            { "id": "5", "label": "Events", "url": "/events" },
            { "id": "6", "label": "Contact", "url": "/contact" }
          ],
          "socialLinks": [
            { "id": "1", "platform": "facebook", "url": "https://facebook.com/sample" },
            { "id": "2", "platform": "instagram", "url": "https://instagram.com/sample" },
            { "id": "3", "platform": "twitter", "url": "https://twitter.com/sample" }
          ],
          "newsletterTitle": "<h4 class=\"text-lg font-semibold\">Stay <span class=\"text-yellow-400\">Connected</span></h4>",
          "newsletterDescription": "<p>Subscribe to our newsletter for <strong>updates</strong>, <em>special offers</em>, and <strong>news</strong>.</p>",
          "showNewsletter": true,
          "copyrightText": "<p>© 2024 <strong>Sample Restaurant</strong>. All rights reserved.</p>",
          "legalLinks": [
            {
              "id": "1",
              "label": "Privacy Policy",
              "url": "/privacy",
              "content": "<p>This is a <strong>sample privacy policy</strong>. It explains how your data might be collected and used in a demo environment.</p>"
            },
            {
              "id": "2",
              "label": "Terms of Service",
              "url": "/terms",
              "content": "<p>These are <strong>sample terms of service</strong>. By using this demo, you agree to placeholder terms.</p>"
            },
            {
              "id": "3",
              "label": "Cookie Policy",
              "url": "/cookies",
              "content": "<p>This is a <strong>sample cookie policy</strong>. It describes the use of cookies in a demo context.</p>"
            }
          ],
            "backgroundColor": "#0f172a",
          "textColor": "#f1f5f9",
          "linkColor": "#f59e0b",
          "borderColor": "#EF4322"
        }

      }
    ]
  },

  eatflow: {
    "widgets": [
      {
        "type": "EssentialNav",
        "data": {
          "logoUrl": "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=200&h=80&fit=crop",
          "logoText": "The Cozy Corner",
          "items": [
            { "id": "1", "label": "Menu", "url": "/menu", "isEnabled": true },
            { "id": "2", "label": "Our Story", "url": "/our-story", "isEnabled": true },
            { "id": "3", "label": "Blog", "url": "/blog", "isEnabled": true },
            { "id": "4", "label": "Gallery", "url": "/gallery", "isEnabled": true },
            { "id": "5", "label": "Events", "url": "/events", "isEnabled": true },
            { "id": "6", "label": "Contact", "url": "/contact", "isEnabled": true }
          ],
          "backgroundColor": "#000000",
          "textColor": "#ffffff",
          "contactInfo": "Call us: (555) COZY-123",
          "showSearchIcon": true,
          "showCartIcon": true,
          "showOrderButton": true,
          "orderButtonText": "Order Takeout",
         "orderButtonColor": "#EF4322"
        }
      },
      {
        "type": "EssentialBanner",
        "data": {
          "slides": [
            {
              "id": "slide-1",
              "title": "Sample Title One",
              "subtitle": "Sample Subtitle One",
              "description": "This is a sample description for slide one. It is placeholder text only.",
              "backgroundImage": "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/2b/25/4b/34/food-menu-assortment.jpg?w=900&h=500&s=1",
              "backgroundColor": "#333333",
              "textAlignment": "center",
              "textColor": "#ffffff",
              "overlayOpacity": 0.5,
              "overlayColor": "rgba(0,0,0,0.5)",
              "ctaButtons": [
                {
                  "id": "cta-1",
                  "text": "Sample Button One",
                  "url": "/sample-one",
                  "variant": "primary",
                  "backgroundColor": "#555555",
                  "color": "#ffffff",
                  "visible": true
                }
              ]
            },
            {
              "id": "slide-2",
              "title": "Sample Title Two",
              "subtitle": "Sample Subtitle Two",
              "description": "This is a sample description for slide two. It is placeholder text only.",
              "backgroundImage": "https://restaurantindia.s3.ap-south-1.amazonaws.com/s3fs-public/2025-02/BeFunky-collage.1%20%2824%29.jpg",
              "backgroundColor": "#444444",
              "textAlignment": "left",
              "textColor": "#ffffff",
              "overlayOpacity": 0.4,
              "overlayColor": "rgba(0,0,0,0.4)",
              "ctaButtons": [
                {
                  "id": "cta-2",
                  "text": "Sample Button Two",
                  "url": "/sample-two",
                  "variant": "secondary",
                  "backgroundColor": "#666666",
                  "color": "#ffffff",
                  "visible": true
                }
              ]
            }
          ]
        }
      },
      {
        "type": "EssentialPopularItems",
        "data": {
          "content": "<h2 class=\"text-3xl md:text-4xl font-bold text-gray-900 mb-4\">Family <span class=\"text-orange-600\">Favorites</span></h2><p class=\"text-gray-600 text-lg max-w-2xl mx-auto\">The comfort food classics that keep our guests coming back for more</p>",
          "backgroundColor": "#ffffff",
          "selectedItemIds": [],
          "emptyStateContent": "<h3 class=\"text-lg sm:text-xl font-semibold mb-2\">Comfort Food Coming Soon</h3><p class=\"text-sm sm:text-base max-w-md\">Our beloved family favorites will be featured here.</p>",
          "showRating": true,
          "menuData": [{
            "pk_id": "f03c1c36-597d-4afc-ab37-3700b0f70d35",
            "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
            "restaurant_parent_id": null,
            "sku_id": "PIZ0001",
            "name": "Classic Margherita",
            "category": "Entrees",
            "supplier": "",
            "brand": "",
            "modifiers": "Classic Margherita addon,addon",
            "unit": "",
            "taxable": "",
            "external_id": "",
            "bar_code": "",
            "description": "A Margherita pizza is a classic Italian dish known for its simple yet flavorful ingredients. It typically features a thin, crisp crust topped with a vibrant tomato sauce made from fresh, ripe tomatoes. The pizza is adorned with slices of fresh mozzarella cheese that melt beautifully during baking, creating a creamy texture. Fresh basil leaves are added on top, providing a fragrant, herbal aroma and a splash of color. Often finished with a drizzle of extra virgin olive oil, the Margherita pizza embodies a harmonious balance of fresh, high-quality ingredients, highlighting the essence of traditional Italian cuisine.",
            "comment": "",
            "cost": "",
            "price": "11",
            "large_price": "11",
            "indining_price": "9",
            "indining_large_price": "11",
            "quantity": "",
            "min_quantity": "",
            "max_quantity": "",
            "countable": "",
            "use_weighing_scale": "",
            "item_type": "",
            "duration": "",
            "discounts": "",
            "resources": "",
            "service_providers": "",
            "printer_type": "",
            "deposit": "",
            "visibility": "",
            "favorite": "",
            "sort_index": "",
            "tags": "",
            "out_of_stock": "",
            "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1754577442034-generated-image-1754577438889-2.png",
            "is_enabled": true,
            "product_description": "A Margherita pizza is a classic Italian dish known for its simple yet flavorful ingredients. It typically features a thin, crisp crust topped with a vibrant tomato sauce made from fresh, ripe tomatoes. The pizza is adorned with slices of fresh mozzarella cheese that melt beautifully during baking, creating a creamy texture. Fresh basil leaves are added on top, providing a fragrant, herbal aroma and a splash of color. Often finished with a drizzle of extra virgin olive oil, the Margherita pizza embodies a harmonious balance of fresh, high-quality ingredients, highlighting the essence of traditional Italian cuisine.",
            "level1_category": "Entrees",
            "level2_category": "Vegetable Based Mains",
            "Nutrients": "Rich in calcium, protein, and antioxidants from fresh ingredients.",
            "appearance": "Golden-brown thin crust with vibrant red tomatoes, white mozzarella, and green basil leaves.",
            "ingredients": [
              "Flour",
              " tomatoes",
              " mozzarella cheese",
              " basil",
              " olive oil",
              " salt",
              " yeast"
            ],
            "serving": "Best enjoyed hot with a drizzle of olive oil or fresh basil leaves.",
            "flavors": "Fresh, Savory, Herbaceous",
            "variations": "Add extra toppings like prosciutto or chili flakes for variation.",
            "allergy_info": "Contains gluten, dairy, and basil; may affect allergies.",
            "Calories": "Approximately 250-300 kcal per slice",
            "is_vegan": "No",
            "best_combo": [],
            "is_deleted": false,
            "food_type": "Veg",
            "is_spice_applicable": "Yes",
            "meal_time": "",
            "inventory_status": true,
            "is_item_verified": true,
            "account_id": "",
            "party_orders": [
              {
                "name": "small",
                "serving": "10",
                "price": "109.90"
              },
              {
                "name": "medium",
                "serving": "25",
                "price": "274.75"
              },
              {
                "name": "large",
                "serving": "50",
                "price": "549.50"
              }
            ],
            "pos_item_id": "",
            "modifiers_list": [
              {
                "name": "Classic Margherita addon",
                "is_multi_select": "No",
                "is_forced": "Yes",
                "pk_id": "685b5545-c9cc-48e1-b99b-ce99e7a9a1e5",
                "pos_group_id": "",
                "options": [
                  {
                    "name": "Extra cheese",
                    "price": "$1.25",
                    "isEnabled": true
                  },
                  {
                    "name": "Cherry tomatoes",
                    "price": "$0.75",
                    "isEnabled": true
                  },
                  {
                    "name": "Garlic crust",
                    "price": "$1.50",
                    "isEnabled": true
                  }
                ]
              }
            ],
            "id": "f03c1c36-597d-4afc-ab37-3700b0f70d35",
            "subCategory": "Vegetable Based Mains",
            "dietary": {
              "isVegan": false
            },
            "pairings": [],
            "allergens": [
              "Contains gluten, dairy, and basil; may affect allergies."
            ]
          },
          {
            "pk_id": "70652667-0511-4dd5-9425-3a5e2dc5d5d2",
            "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
            "restaurant_parent_id": null,
            "sku_id": "PIZ0002",
            "name": "Meat Lover's Delight Pizza",
            "category": "Entrees",
            "supplier": "",
            "brand": "",
            "modifiers": "",
            "unit": "",
            "taxable": "",
            "external_id": "",
            "bar_code": "",
            "description": "Meat Lover's Delight Pizza features a crispy crust topped with a rich blend of pepperoni, sausage, ham, and bacon, baked to perfection.",
            "comment": "",
            "cost": "",
            "price": "14.99",
            "large_price": "14.99",
            "indining_price": "8",
            "indining_large_price": "14.99",
            "quantity": "",
            "min_quantity": "",
            "max_quantity": "",
            "countable": "",
            "use_weighing_scale": "",
            "item_type": "",
            "duration": "",
            "discounts": "",
            "resources": "",
            "service_providers": "",
            "printer_type": "",
            "deposit": "",
            "visibility": "",
            "favorite": "",
            "sort_index": "",
            "tags": "",
            "out_of_stock": "",
            "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749534255838-generated-image-1749534255838-1.png",
            "is_enabled": true,
            "product_description": "Meat Lover's Delight Pizza features a crispy crust topped with a rich blend of pepperoni, sausage, ham, and bacon, baked to perfection.",
            "level1_category": "Entrees",
            "level2_category": "Specialty Meat Dishes",
            "Nutrients": "High in protein and fats, moderate carbs, rich in calcium and iron.",
            "appearance": "Golden-brown crust with generous toppings of meats and melted cheese, visually hearty.",
            "ingredients": [
              "Pizza dough",
              " mozzarella cheese",
              " pepperoni",
              " sausage",
              " ham",
              " bacon",
              " tomato sauce",
              " herbs."
            ],
            "serving": "Best enjoyed hot with a side of garlic bread or salad.",
            "flavors": "Savory, smoky, cheesy, with meaty richness.",
            "variations": "Can be made with turkey or plant-based meats for alternatives.",
            "allergy_info": "Contains gluten, dairy, and meat; may cause allergies in sensitive individuals.",
            "Calories": "Approximately 300-400 kcal per slice.",
            "is_vegan": "no",
            "best_combo": {
              "best_name": "Classic Margherita",
              "best_combo": "Complements the meat flavors with a classic, mild pizza.",
              "best_combo_ids": "PIZ0001"
            },
            "is_deleted": false,
            "food_type": "non_veg",
            "is_spice_applicable": "No",
            "meal_time": "",
            "inventory_status": true,
            "is_item_verified": true,
            "account_id": "",
            "party_orders": [
              {
                "name": "small",
                "serving": "10",
                "price": "149.90"
              },
              {
                "name": "medium",
                "serving": "25",
                "price": "374.75"
              },
              {
                "name": "large",
                "serving": "49",
                "price": "749.50"
              }
            ],
            "pos_item_id": "",
            "id": "70652667-0511-4dd5-9425-3a5e2dc5d5d2",
            "subCategory": "Specialty Meat Dishes",
            "dietary": {
              "isVegan": false
            },
            "pairings": [
              "Classic Margherita"
            ],
            "allergens": [
              "Contains gluten, dairy, and meat; may cause allergies in sensitive individuals."
            ]
          },
          {
            "pk_id": "b3d1ed75-e9df-45d0-a393-fbc1109c0aaa",
            "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
            "restaurant_parent_id": null,
            "sku_id": "PIZ0003",
            "name": "Veggie Supreme ",
            "category": "Starters & Small Plates",
            "supplier": "",
            "brand": "",
            "modifiers": "Veggie Supreme addon",
            "unit": "",
            "taxable": "",
            "external_id": "",
            "bar_code": "",
            "description": "Veggie Supreme is a hearty vegetarian pizza topped with a variety of fresh vegetables and melted cheese, offering a flavorful and satisfying meal.",
            "comment": "",
            "cost": "",
            "price": "13",
            "large_price": "12.49",
            "indining_price": "1",
            "indining_large_price": "12.49",
            "quantity": "",
            "min_quantity": "",
            "max_quantity": "",
            "countable": "",
            "use_weighing_scale": "",
            "item_type": "",
            "duration": "",
            "discounts": "",
            "resources": "",
            "service_providers": "",
            "printer_type": "",
            "deposit": "",
            "visibility": "",
            "favorite": "",
            "sort_index": "",
            "tags": "",
            "out_of_stock": "",
            "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749534377844-generated-image-1749534377844-1.png",
            "is_enabled": true,
            "product_description": "Veggie Supreme is a hearty vegetarian pizza topped with a variety of fresh vegetables and melted cheese, offering a flavorful and satisfying meal.",
            "level1_category": "Starters & Small Plates",
            "level2_category": "Breads & Flatbreads",
            "Nutrients": "Rich in vitamins from vegetables and calcium from cheese.",
            "appearance": "Colorful pizza with vibrant vegetable toppings and melted cheese crust.",
            "ingredients": [
              "Tomatoes",
              " bell peppers",
              " onions",
              " olives",
              " cheese",
              " pizza dough",
              " herbs."
            ],
            "serving": "Best enjoyed hot with a side of garlic bread or salad.",
            "flavors": "Savory, cheesy, with fresh vegetable notes.",
            "variations": "Can be made vegan by substituting cheese with plant-based options.",
            "allergy_info": "Contains dairy and gluten; may cause allergies in sensitive individuals.",
            "Calories": "Approximately 250-350 kcal per slice.",
            "is_vegan": "Yes",
            "best_combo": {
              "best_name": "Classic Margherita",
              "best_combo": "Both are vegetarian options with complementary flavors.",
              "best_combo_ids": "PIZ0001"
            },
            "is_deleted": false,
            "food_type": "Veg",
            "is_spice_applicable": "Yes",
            "meal_time": "",
            "inventory_status": true,
            "is_item_verified": true,
            "account_id": "",
            "party_orders": [
              {
                "name": "small",
                "serving": "10",
                "price": "124.90"
              },
              {
                "name": "medium",
                "serving": "25",
                "price": "312.25"
              },
              {
                "name": "large",
                "serving": "50",
                "price": "624.50"
              }
            ],
            "pos_item_id": "",
            "modifiers_list": [
              {
                "name": "Veggie Supreme addon",
                "is_multi_select": "No",
                "is_forced": "Yes",
                "pk_id": "ee381bfd-d4f7-4cd7-a75c-6de41876a4eb",
                "pos_group_id": "",
                "options": [
                  {
                    "name": "Spinach",
                    "price": "$0.75",
                    "isEnabled": true
                  },
                  {
                    "name": "feta",
                    "price": "$1.50",
                    "isEnabled": true
                  },
                  {
                    "name": "pesto swirl",
                    "price": "$1.50",
                    "isEnabled": true
                  }
                ]
              }
            ],
            "id": "b3d1ed75-e9df-45d0-a393-fbc1109c0aaa",
            "subCategory": "Breads & Flatbreads",
            "dietary": {
              "isVegan": true
            },
            "pairings": [
              "Classic Margherita"
            ],
            "allergens": [
              "Contains dairy and gluten; may cause allergies in sensitive individuals."
            ]
          },
          {
            "pk_id": "3874684b-bba8-4b91-b865-91b34e951477",
            "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
            "restaurant_parent_id": null,
            "sku_id": "PIZ0004",
            "name": "Chicken Tikka Pizza",
            "category": "Starters & Small Plates",
            "supplier": "",
            "brand": "",
            "modifiers": "Chicken Tikka Pizza addon",
            "unit": "",
            "taxable": "",
            "external_id": "",
            "bar_code": "",
            "description": "Chicken Tikka Pizza features tender chicken tikka pieces atop a crispy crust, topped with cheese and spices for a flavorful experience.",
            "comment": "",
            "cost": "",
            "price": "13.49",
            "large_price": "13.49",
            "indining_price": "2",
            "indining_large_price": "13.49",
            "quantity": "",
            "min_quantity": "",
            "max_quantity": "",
            "countable": "",
            "use_weighing_scale": "",
            "item_type": "",
            "duration": "",
            "discounts": "",
            "resources": "",
            "service_providers": "",
            "printer_type": "",
            "deposit": "",
            "visibility": "",
            "favorite": "",
            "sort_index": "",
            "tags": "",
            "out_of_stock": "",
            "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749534429912-generated-image-1749534429081-3.png",
            "is_enabled": true,
            "product_description": "Chicken Tikka Pizza features tender chicken tikka pieces atop a crispy crust, topped with cheese and spices for a flavorful experience.",
            "level1_category": "Starters & Small Plates",
            "level2_category": "Appetizers / Starters",
            "Nutrients": "Rich in protein, calcium, and carbs; moderate fat content.",
            "appearance": "Golden-brown crust with chunks of chicken, melted cheese, and visible spices on top.",
            "ingredients": [
              "Pizza dough",
              " chicken tikka",
              " cheese",
              " tomato sauce",
              " spices",
              " herbs."
            ],
            "serving": "Best enjoyed hot with a side of salad or dipping sauces.",
            "flavors": "Spicy, smoky, cheesy, with hints of herbs and spices.",
            "variations": "Can be made vegetarian with paneer or vegetables, or with different spice levels.",
            "allergy_info": "Contains dairy and gluten; may cause allergies in sensitive individuals.",
            "Calories": "Approximately 300-400 kcal per slice.",
            "is_vegan": "no",
            "best_combo": {
              "best_name": "Classic Margherita, Veggie Supreme",
              "best_combo": "Complementary flavors and vegetarian options enhance Chicken Tikka Pizza.",
              "best_combo_ids": "PIZ0001"
            },
            "is_deleted": false,
            "food_type": "non_veg",
            "is_spice_applicable": "No",
            "meal_time": "",
            "inventory_status": true,
            "is_item_verified": true,
            "account_id": "",
            "party_orders": [
              {
                "name": "small",
                "serving": "10",
                "price": "134.90"
              },
              {
                "name": "medium",
                "serving": "25",
                "price": "337.25"
              },
              {
                "name": "large",
                "serving": "50",
                "price": "674.50"
              }
            ],
            "pos_item_id": "",
            "modifiers_list": [
              {
                "name": "Chicken Tikka Pizza addon",
                "is_multi_select": "No",
                "is_forced": "Yes",
                "pk_id": "c4d6c07b-000e-4f08-9bfe-07b758331b3b",
                "pos_group_id": "",
                "options": [
                  {
                    "name": "Spicy mayo",
                    "price": "$1.25",
                    "isEnabled": true
                  },
                  {
                    "name": "Coriander",
                    "price": "$0.60",
                    "isEnabled": true
                  },
                  {
                    "name": "red chili flakes",
                    "price": "$0.60",
                    "isEnabled": true
                  },
                  {
                    "name": "Garlic crust",
                    "price": "$1.25",
                    "isEnabled": true
                  }
                ]
              }
            ],
            "id": "3874684b-bba8-4b91-b865-91b34e951477",
            "subCategory": "Appetizers / Starters",
            "dietary": {
              "isVegan": false
            },
            "pairings": [
              "Classic Margherita",
              " Veggie Supreme"
            ],
            "allergens": [
              "Contains dairy and gluten; may cause allergies in sensitive individuals."
            ]
          },
          {
            "pk_id": "59d63f4e-d5e7-4dce-906b-4645a2e44a1a",
            "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
            "restaurant_parent_id": null,
            "sku_id": "PIZ0005",
            "name": "BBQ Chicken Feast Pizza",
            "category": "Entrees",
            "supplier": "",
            "brand": "",
            "modifiers": "BBQ Chicken Feast addon",
            "unit": "",
            "taxable": "",
            "external_id": "",
            "bar_code": "",
            "description": "BBQ Chicken Feast Pizza features a crispy crust topped with smoky barbecue sauce, tender chicken, cheese, and flavorful toppings, offering a hearty and savory experience.",
            "comment": "",
            "cost": "",
            "price": "13.99",
            "large_price": "13.99",
            "indining_price": "4.99",
            "indining_large_price": "13.99",
            "quantity": "",
            "min_quantity": "",
            "max_quantity": "",
            "countable": "",
            "use_weighing_scale": "",
            "item_type": "",
            "duration": "",
            "discounts": "",
            "resources": "",
            "service_providers": "",
            "printer_type": "",
            "deposit": "",
            "visibility": "",
            "favorite": "",
            "sort_index": "",
            "tags": "",
            "out_of_stock": "",
            "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749534604205-generated-image-1749534602683-3.png",
            "is_enabled": true,
            "product_description": "BBQ Chicken Feast Pizza features a crispy crust topped with smoky barbecue sauce, tender chicken, cheese, and flavorful toppings, offering a hearty and savory experience.",
            "level1_category": "Entrees",
            "level2_category": "Pizzas & Flatbreads",
            "Nutrients": "Rich in protein, calcium, and carbs; moderate fat content.",
            "appearance": "Golden-brown crust with generous toppings of chicken, cheese, and barbecue sauce.",
            "ingredients": [
              "Pizza dough",
              " BBQ sauce",
              " cooked chicken",
              " cheese",
              " onions",
              " cilantro."
            ],
            "serving": "Best enjoyed hot with a side of salad or garlic bread.",
            "flavors": "Smoky, savory, cheesy, with hints of sweetness from BBQ sauce.",
            "variations": "Can add jalapeños, bacon, or different cheeses for customization.",
            "allergy_info": "Contains gluten, dairy, and possible soy; check for allergies.",
            "Calories": "Approximately 300-400 kcal per slice.",
            "is_vegan": "no",
            "best_combo": {
              "best_name": "Meat Lover's Delight Pizza, Chicken Tikka Pizza",
              "best_combo": "Rich, meaty flavors complement BBQ Chicken Feast for a hearty meal",
              "best_combo_ids": "PIZ0002,PIZ0004"
            },
            "is_deleted": false,
            "food_type": "non_veg",
            "is_spice_applicable": "yes",
            "meal_time": "",
            "inventory_status": true,
            "is_item_verified": true,
            "account_id": "",
            "party_orders": [
              {
                "name": "small",
                "serving": "10",
                "price": "139.90"
              },
              {
                "name": "medium",
                "serving": "25",
                "price": "349.75"
              },
              {
                "name": "large",
                "serving": "50",
                "price": "699.50"
              }
            ],
            "pos_item_id": "",
            "modifiers_list": [
              {
                "name": "BBQ Chicken Feast addon",
                "is_multi_select": "No",
                "is_forced": "Yes",
                "pk_id": "07dbff2e-46e9-4079-8db7-f76ba2bd9672",
                "pos_group_id": "",
                "options": [
                  {
                    "name": "Extra BBQ drizzle",
                    "price": "$1.25",
                    "isEnabled": true
                  },
                  {
                    "name": "pineapple",
                    "price": "$0.60",
                    "isEnabled": true
                  },
                  {
                    "name": "smoked cheese",
                    "price": "$1.50",
                    "isEnabled": true
                  },
                  {
                    "name": "Bacon bits",
                    "price": "$1.75",
                    "isEnabled": true
                  }
                ]
              }
            ],
            "id": "59d63f4e-d5e7-4dce-906b-4645a2e44a1a",
            "subCategory": "Pizzas & Flatbreads",
            "dietary": {
              "isVegan": false
            },
            "pairings": [
              "Meat Lover's Delight Pizza",
              " Chicken Tikka Pizza"
            ],
            "allergens": [
              "Contains gluten, dairy, and possible soy; check for allergies."
            ]
          },
          {
            "pk_id": "4f60847b-b066-4754-81c8-330f11095786",
            "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
            "restaurant_parent_id": null,
            "sku_id": "PIZ0007",
            "name": "Hawaiian Classic Pizza",
            "category": "Entrees",
            "supplier": "",
            "brand": "",
            "modifiers": "Hawaiian Classic addon",
            "unit": "",
            "taxable": "",
            "external_id": "",
            "bar_code": "",
            "description": "Hawaiian Classic Pizza features a crispy crust topped with tomato sauce, cheese, ham, and pineapple chunks, offering a sweet and savory flavor profile.",
            "comment": "",
            "cost": "",
            "price": "12.49",
            "large_price": "12.49",
            "indining_price": "12.49",
            "indining_large_price": "12.49",
            "quantity": "",
            "min_quantity": "",
            "max_quantity": "",
            "countable": "",
            "use_weighing_scale": "",
            "item_type": "",
            "duration": "",
            "discounts": "",
            "resources": "",
            "service_providers": "",
            "printer_type": "",
            "deposit": "",
            "visibility": "",
            "favorite": "",
            "sort_index": "",
            "tags": "",
            "out_of_stock": "",
            "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749534761684-generated-image-1749534760104-4.png",
            "is_enabled": true,
            "product_description": "Hawaiian Classic Pizza features a crispy crust topped with tomato sauce, cheese, ham, and pineapple chunks, offering a sweet and savory flavor profile.",
            "level1_category": "Entrees",
            "level2_category": "Pizzas & Flatbreads",
            "Nutrients": "Provides carbs, protein, calcium, and vitamins from toppings.",
            "appearance": "Golden-brown crust with melted cheese, ham slices, and pineapple pieces on top.",
            "ingredients": [
              "Pizza dough",
              " tomato sauce",
              " mozzarella cheese",
              " ham",
              " pineapple",
              " olive oil",
              " herbs."
            ],
            "serving": "Best enjoyed hot with a side of garlic bread or salad.",
            "flavors": "Sweet, savory, cheesy, with a hint of tang from pineapple.",
            "variations": "Can add bacon, jalapeños, or substitute ham with turkey.",
            "allergy_info": "Contains dairy, gluten, and possibly soy; check for allergies.",
            "Calories": "Approximately 250-350 kcal per slice.",
            "is_vegan": "no",
            "best_combo": {
              "best_name": "Meat Lover's Delight Pizza, BBQ Chicken Feast Pizza",
              "best_combo": "Rich, savory flavors complement the sweet and savory Hawaiian pizza",
              "best_combo_ids": "PIZ0002,PIZ0005"
            },
            "is_deleted": false,
            "food_type": "non_veg",
            "is_spice_applicable": "no",
            "meal_time": "",
            "inventory_status": true,
            "is_item_verified": true,
            "account_id": "",
            "party_orders": [
              {
                "name": "small",
                "serving": "10",
                "price": "124.90"
              },
              {
                "name": "medium",
                "serving": "25",
                "price": "312.25"
              },
              {
                "name": "large",
                "serving": "50",
                "price": "624.50"
              }
            ],
            "pos_item_id": "",
            "modifiers_list": [
              {
                "name": "Hawaiian Classic addon",
                "is_multi_select": "No",
                "is_forced": "Yes",
                "pk_id": "840bed41-05ef-47c8-bca9-41c264ae37d9",
                "pos_group_id": "",
                "options": [
                  {
                    "name": "Bacon",
                    "price": "$1.75",
                    "isEnabled": true
                  },
                  {
                    "name": "red onions",
                    "price": "$0.60",
                    "isEnabled": true
                  },
                  {
                    "name": "sweet chili drizzle",
                    "price": "$0.60",
                    "isEnabled": true
                  },
                  {
                    "name": "spicy crust",
                    "price": "$1.25",
                    "isEnabled": true
                  }
                ]
              }
            ],
            "id": "4f60847b-b066-4754-81c8-330f11095786",
            "subCategory": "Pizzas & Flatbreads",
            "dietary": {
              "isVegan": false
            },
            "pairings": [
              "Meat Lover's Delight Pizza",
              " BBQ Chicken Feast Pizza"
            ],
            "allergens": [
              "Contains dairy, gluten, and possibly soy; check for allergies."
            ]
          },
          {
            "pk_id": "173e050c-de20-48d6-8f00-f6f4999601ec",
            "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
            "restaurant_parent_id": null,
            "sku_id": "PIZ0008",
            "name": "Spicy Veggie Volcano",
            "category": "Entrees",
            "supplier": "",
            "brand": "",
            "modifiers": "Spicy Veggie Volcano addon",
            "unit": "",
            "taxable": "",
            "external_id": "",
            "bar_code": "",
            "description": "Spicy Veggie Volcano is a vibrant, spicy dish featuring a medley of fresh vegetables topped with a fiery sauce, served hot and visually striking.",
            "comment": "",
            "cost": "",
            "price": "12.99",
            "large_price": "12.99",
            "indining_price": "12.99",
            "indining_large_price": "12.99",
            "quantity": "",
            "min_quantity": "",
            "max_quantity": "",
            "countable": "",
            "use_weighing_scale": "",
            "item_type": "",
            "duration": "",
            "discounts": "",
            "resources": "",
            "service_providers": "",
            "printer_type": "",
            "deposit": "",
            "visibility": "",
            "favorite": "",
            "sort_index": "",
            "tags": "",
            "out_of_stock": "",
            "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749534852285-generated-image-1749534851526-3.png",
            "is_enabled": true,
            "product_description": "Spicy Veggie Volcano is a vibrant, spicy dish featuring a medley of fresh vegetables topped with a fiery sauce, served hot and visually striking.",
            "level1_category": "Entrees",
            "level2_category": "Vegetable Based Mains",
            "Nutrients": "Rich in vitamins, antioxidants, and dietary fiber from vegetables.",
            "appearance": "Colorful vegetable medley topped with a bright red spicy sauce, resembling a volcano eruption.",
            "ingredients": [
              "Mixed vegetables",
              " chili sauce",
              " garlic",
              " soy sauce",
              " spices",
              " oil"
            ],
            "serving": "Best enjoyed with steamed rice or flatbreads for a complete meal.",
            "flavors": "Spicy, Savory, Umami with a hint of sweetness",
            "variations": "Adjust spice level, add tofu or mushrooms for variation",
            "allergy_info": "Contains soy and chili; may affect those with soy or chili allergies.",
            "Calories": "Approximately 150-200 kcal per serving",
            "is_vegan": "yes",
            "best_combo": {
              "best_name": "Veggie Supreme",
              "best_combo": "Complements the spicy veggie flavor with a hearty veggie option",
              "best_combo_ids": ""
            },
            "is_deleted": false,
            "food_type": "vegan",
            "is_spice_applicable": "yes",
            "meal_time": "",
            "inventory_status": true,
            "is_item_verified": true,
            "account_id": "",
            "party_orders": [
              {
                "name": "small",
                "serving": "10",
                "price": "129.90"
              },
              {
                "name": "medium",
                "serving": "25",
                "price": "324.75"
              },
              {
                "name": "large",
                "serving": "49",
                "price": "649.50"
              }
            ],
            "pos_item_id": "",
            "modifiers_list": [
              {
                "name": "Spicy Veggie Volcano addon",
                "is_multi_select": "Yes",
                "is_forced": "No",
                "pk_id": "7a4a7fc7-af5e-4cb3-9ec8-64f446905edd",
                "pos_group_id": "",
                "options": [
                  {
                    "name": "Paneer cubes",
                    "price": "$1.50",
                    "isEnabled": true
                  },
                  {
                    "name": "Extra chili",
                    "price": "$0.99",
                    "isEnabled": true
                  },
                  {
                    "name": "Hot sauce swirl",
                    "price": "$1.50",
                    "isEnabled": true
                  },
                  {
                    "name": "Sesame crust",
                    "price": "$1.75",
                    "isEnabled": true
                  },
                  {
                    "name": "chicken toast",
                    "price": "$1",
                    "isEnabled": true
                  }
                ]
              }
            ],
            "id": "173e050c-de20-48d6-8f00-f6f4999601ec",
            "subCategory": "Vegetable Based Mains",
            "dietary": {
              "isVegan": true
            },
            "pairings": [
              "Veggie Supreme"
            ],
            "allergens": [
              "Contains soy and chili; may affect those with soy or chili allergies."
            ]
          },
          {
            "pk_id": "e7f3210a-5564-4b08-9bfd-283ff68eedb2",
            "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
            "restaurant_parent_id": null,
            "sku_id": "PIZ0010",
            "name": "Philly Steak Pizza",
            "category": "Entrees",
            "supplier": "",
            "brand": "",
            "modifiers": "Philly Steak Pizza addon",
            "unit": "",
            "taxable": "",
            "external_id": "",
            "bar_code": "",
            "description": "Philly Steak Pizza features tender sliced steak, melted cheese, and savory toppings on a crispy crust, blending Italian and American flavors.",
            "comment": "",
            "cost": "",
            "price": "14.99",
            "large_price": "14.99",
            "indining_price": "14.99",
            "indining_large_price": "14.99",
            "quantity": "",
            "min_quantity": "",
            "max_quantity": "",
            "countable": "",
            "use_weighing_scale": "",
            "item_type": "",
            "duration": "",
            "discounts": "",
            "resources": "",
            "service_providers": "",
            "printer_type": "",
            "deposit": "",
            "visibility": "",
            "favorite": "",
            "sort_index": "",
            "tags": "",
            "out_of_stock": "",
            "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749535594783-generated-image-1749535586777-4.png",
            "is_enabled": true,
            "product_description": "Philly Steak Pizza features tender sliced steak, melted cheese, and savory toppings on a crispy crust, blending Italian and American flavors.",
            "level1_category": "Entrees",
            "level2_category": "Noodles & Pasta",
            "Nutrients": "Rich in protein, calcium, and carbohydrates for energy and muscle repair.",
            "appearance": "Golden-brown crust topped with melted cheese, sliced steak, and vegetables.",
            "ingredients": [
              "Sliced steak",
              " mozzarella cheese",
              " pizza dough",
              " bell peppers",
              " onions",
              " tomato sauce."
            ],
            "serving": "Best enjoyed hot with a side of garlic bread or salad.",
            "flavors": "Savory, cheesy, meaty, with hints of smoky spices.",
            "variations": "Can add mushrooms, jalapeños, or substitute steak with chicken or plant-based options.",
            "allergy_info": "Contains dairy and gluten; may contain traces of soy or nuts.",
            "Calories": "Approximately 800-1000 kcal per slice.",
            "is_vegan": "no",
            "best_combo": {
              "best_name": "Meat Lover's Delight Pizza,BBQ Chicken Feast Pizza",
              "best_combo": "Rich, meaty flavors complement the hearty Philly Steak Pizza well",
              "best_combo_ids": "PIZ0002,PIZ0005"
            },
            "is_deleted": false,
            "food_type": "non_veg",
            "is_spice_applicable": "yes",
            "meal_time": "",
            "inventory_status": true,
            "is_item_verified": true,
            "account_id": "",
            "party_orders": [
              {
                "name": "small",
                "serving": "10",
                "price": "149.90"
              },
              {
                "name": "medium",
                "serving": "25",
                "price": "374.75"
              },
              {
                "name": "large",
                "serving": "50",
                "price": "749.50"
              }
            ],
            "pos_item_id": "",
            "modifiers_list": [
              {
                "name": "Philly Steak Pizza addon",
                "is_multi_select": "No",
                "is_forced": "Yes",
                "pk_id": "989bf89f-91b4-49fa-851f-a85d585046c5",
                "pos_group_id": "",
                "options": [
                  {
                    "name": "Blue cheese",
                    "price": "$1.25",
                    "isEnabled": true
                  },
                  {
                    "name": "Extra steak",
                    "price": "$2.25",
                    "isEnabled": true
                  },
                  {
                    "name": "BBQ swirl",
                    "price": "$0.99",
                    "isEnabled": true
                  },
                  {
                    "name": "Cheesy crust",
                    "price": "$2",
                    "isEnabled": true
                  }
                ]
              }
            ],
            "id": "e7f3210a-5564-4b08-9bfd-283ff68eedb2",
            "subCategory": "Noodles & Pasta",
            "dietary": {
              "isVegan": false
            },
            "pairings": [
              "Meat Lover's Delight Pizza",
              "BBQ Chicken Feast Pizza"
            ],
            "allergens": [
              "Contains dairy and gluten; may contain traces of soy or nuts."
            ]
          },
          {
            "pk_id": "ac33445d-18ae-4be2-942a-b0e65c7b44a4",
            "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
            "restaurant_parent_id": null,
            "sku_id": "PIZ0014",
            "name": "Truffle Mushroom Delight Pizza",
            "category": "Starters & Small Plates",
            "supplier": "",
            "brand": "",
            "modifiers": "Truffle Mushroom Delight addon",
            "unit": "",
            "taxable": "",
            "external_id": "",
            "bar_code": "",
            "description": "A gourmet pizza topped with savory mushrooms and aromatic truffle oil, offering a rich, earthy flavor in a crispy crust.",
            "comment": "",
            "cost": "",
            "price": "14.49",
            "large_price": "14.49",
            "indining_price": "14.49",
            "indining_large_price": "14.49",
            "quantity": "",
            "min_quantity": "",
            "max_quantity": "",
            "countable": "",
            "use_weighing_scale": "",
            "item_type": "",
            "duration": "",
            "discounts": "",
            "resources": "",
            "service_providers": "",
            "printer_type": "",
            "deposit": "",
            "visibility": "",
            "favorite": "",
            "sort_index": "",
            "tags": "",
            "out_of_stock": "",
            "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749536724052-generated-image-1749536723486-2.png",
            "is_enabled": true,
            "product_description": "A gourmet pizza topped with savory mushrooms and aromatic truffle oil, offering a rich, earthy flavor in a crispy crust.",
            "level1_category": "Starters & Small Plates",
            "level2_category": "Breads & Flatbreads",
            "Nutrients": "Rich in antioxidants from mushrooms and healthy fats from truffle oil.",
            "appearance": "Golden-brown crust with melted cheese, sliced mushrooms, and drizzled truffle oil on top.",
            "ingredients": [
              "Pizza dough",
              " mushrooms",
              " truffle oil",
              " cheese",
              " garlic",
              " herbs",
              " olive oil."
            ],
            "serving": "Best enjoyed hot with a side of mixed greens or a light salad.",
            "flavors": "Earthy, umami, aromatic, slightly cheesy.",
            "variations": "Vegan version with plant-based cheese, or add prosciutto for non-veg.",
            "allergy_info": "Contains dairy and mushrooms; may cause allergies in sensitive individuals.",
            "Calories": "Approximately 300-400 kcal per slice.",
            "is_vegan": "no",
            "best_combo": {
              "best_name": "Veggie Supreme, Mediterranean Veggie, Spicy Veggie Volcano",
              "best_combo": "Complementary veggie flavors enhance the mushroom truffle profile.",
              "best_combo_ids": "PIZ0011,PIZ0008"
            },
            "is_deleted": false,
            "food_type": "non_veg",
            "is_spice_applicable": "no",
            "meal_time": "",
            "inventory_status": true,
            "is_item_verified": true,
            "account_id": "",
            "party_orders": [
              {
                "name": "small",
                "serving": "10",
                "price": "144.90"
              },
              {
                "name": "medium",
                "serving": "25",
                "price": "362.25"
              },
              {
                "name": "large",
                "serving": "50",
                "price": "724.50"
              }
            ],
            "pos_item_id": "",
            "modifiers_list": [
              {
                "name": "Truffle Mushroom Delight addon",
                "is_multi_select": "No",
                "is_forced": "Yes",
                "pk_id": "c95a1603-adc7-43da-9b05-c549a3e964c2",
                "pos_group_id": "",
                "options": [
                  {
                    "name": "Caramelized onions",
                    "price": "$0.99",
                    "isEnabled": true
                  },
                  {
                    "name": "Goat cheese",
                    "price": "$1.50",
                    "isEnabled": true
                  },
                  {
                    "name": "Garlic crust",
                    "price": "$1.25",
                    "isEnabled": true
                  },
                  {
                    "name": "pine nuts",
                    "price": "$0.99",
                    "isEnabled": true
                  }
                ]
              }
            ],
            "id": "ac33445d-18ae-4be2-942a-b0e65c7b44a4",
            "subCategory": "Breads & Flatbreads",
            "dietary": {
              "isVegan": false
            },
            "pairings": [
              "Veggie Supreme",
              " Mediterranean Veggie",
              " Spicy Veggie Volcano"
            ],
            "allergens": [
              "Contains dairy and mushrooms; may cause allergies in sensitive individuals."
            ]
          },
          {
            "pk_id": "02d9711e-2365-476c-9174-2ba463aa3636",
            "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
            "restaurant_parent_id": null,
            "sku_id": "PIZ0015",
            "name": "Loaded Paneer Paradise Pizza",
            "category": "Starters & Small Plates",
            "supplier": "",
            "brand": "",
            "modifiers": "Loaded Paneer Paradise",
            "unit": "",
            "taxable": "",
            "external_id": "",
            "bar_code": "",
            "description": "Loaded Paneer Paradise Pizza features a crispy crust topped with spiced paneer, fresh vegetables, and melted cheese, offering a flavorful vegetarian delight.",
            "comment": "",
            "cost": "",
            "price": "13.99",
            "large_price": "13.99",
            "indining_price": "13.99",
            "indining_large_price": "13.99",
            "quantity": "",
            "min_quantity": "",
            "max_quantity": "",
            "countable": "",
            "use_weighing_scale": "",
            "item_type": "",
            "duration": "",
            "discounts": "",
            "resources": "",
            "service_providers": "",
            "printer_type": "",
            "deposit": "",
            "visibility": "",
            "favorite": "",
            "sort_index": "",
            "tags": "",
            "out_of_stock": "",
            "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749536855344-generated-image-1749536854924-2.png",
            "is_enabled": true,
            "product_description": "Loaded Paneer Paradise Pizza features a crispy crust topped with spiced paneer, fresh vegetables, and melted cheese, offering a flavorful vegetarian delight.",
            "level1_category": "Starters & Small Plates",
            "level2_category": "Breads & Flatbreads",
            "Nutrients": "Rich in protein from paneer, calcium, vitamins from vegetables",
            "appearance": "Golden-brown crust with colorful toppings and melted cheese, garnished with herbs.",
            "ingredients": [
              "Paneer",
              " cheese",
              " bell peppers",
              " onions",
              " tomato sauce",
              " spices",
              " herbs",
              " dough"
            ],
            "serving": "Best enjoyed hot with a side of green chutney or salad.",
            "flavors": "Savory, cheesy, mildly spicy with aromatic herbs",
            "variations": "Vegan cheese, gluten-free crust, extra vegetables",
            "allergy_info": "Contains dairy and gluten; may cause allergies in sensitive individuals.",
            "Calories": "Approximately 300-400 kcal per slice",
            "is_vegan": "no",
            "best_combo": {
              "best_name": "Veggie Supreme, Mediterranean Veggie, Spicy Veggie Volcano",
              "best_combo": "Complementary veggie flavors enhance the paneer pizza experience.",
              "best_combo_ids": "PIZ0011,PIZ0008"
            },
            "is_deleted": false,
            "food_type": "veg",
            "is_spice_applicable": "yes",
            "meal_time": "",
            "inventory_status": true,
            "is_item_verified": true,
            "account_id": "",
            "party_orders": [
              {
                "name": "small",
                "serving": "10",
                "price": "139.90"
              },
              {
                "name": "medium",
                "serving": "25",
                "price": "349.75"
              },
              {
                "name": "large",
                "serving": "50",
                "price": "699.50"
              }
            ],
            "pos_item_id": "",
            "modifiers_list": [
              {
                "name": "Loaded Paneer Paradise",
                "is_multi_select": "No",
                "is_forced": "Yes",
                "pk_id": "efcadd5a-5cf5-4645-a387-5a6323981e1c",
                "pos_group_id": "",
                "options": [
                  {
                    "name": "Mint mayo swirl",
                    "price": "$0.99",
                    "isEnabled": true
                  },
                  {
                    "name": "Extra paneer",
                    "price": "$1.75",
                    "isEnabled": true
                  },
                  {
                    "name": "Tikka crust",
                    "price": "$1.50",
                    "isEnabled": true
                  },
                  {
                    "name": "Chili flakes",
                    "price": "$0.99",
                    "isEnabled": true
                  }
                ]
              }
            ],
            "id": "02d9711e-2365-476c-9174-2ba463aa3636",
            "subCategory": "Breads & Flatbreads",
            "dietary": {
              "isVegan": false
            },
            "pairings": [
              "Veggie Supreme",
              " Mediterranean Veggie",
              " Spicy Veggie Volcano"
            ],
            "allergens": [
              "Contains dairy and gluten; may cause allergies in sensitive individuals."
            ]
          }]
        }
      },
      {
        "type": "EssentialCombo",
        "data": {
          "content": "<h2 class=\"text-3xl md:text-4xl font-bold text-gray-900 mb-4\">Family <span class=\"text-orange-600\">Meal Deals</span></h2><p class=\"text-gray-600 text-lg max-w-2xl mx-auto\">Perfect portions for sharing around the table - because the best meals bring people together</p>",
          "backgroundColor": "#fef5e7",
          "emptyStateContent": "<h3 class=\"text-lg sm:text-xl font-semibold mb-2\">Family Meals Coming Soon</h3><p class=\"text-sm sm:text-base max-w-md\">Great value family meal combinations will be available here.</p>",
          "combos": [{
            "combo_id": "96f8cdcb-e7dd-4355-9178-5652f6d82f84",
            "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
            "title": "Party Time Pack",
            "description": "A delightful mix of classic, flavorful, and satisfying dishes including pizzas, sides, beverages, and desserts, perfect for celebrating with friends and family in a lively, delicious party setting.",
            "products": [
              {
                "pk_id": "dcbe286c-43c2-4f27-b9aa-8a339344f0c7",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0016",
                "name": "Buffalo Chicken Blast Pizza",
                "category": "Starters & Small Plates",
                "supplier": "",
                "brand": "",
                "modifiers": "Buffalo Chicken Blast addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Buffalo Chicken Blast Pizza features a crispy crust topped with spicy buffalo sauce, tender chicken, and melty cheese, offering a bold flavor experience.",
                "comment": "",
                "cost": "",
                "price": "13.49",
                "large_price": "13.49",
                "indining_price": "13.49",
                "indining_large_price": "13.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749536945765-generated-image-1749536944781-3.png",
                "is_enabled": "true",
                "product_description": "Buffalo Chicken Blast Pizza features a crispy crust topped with spicy buffalo sauce, tender chicken, and melty cheese, offering a bold flavor experience.",
                "level1_category": "Starters & Small Plates",
                "level2_category": "Appetizers / Starters",
                "Nutrients": "Rich in protein and calcium, moderate in fats and carbs.",
                "appearance": "Golden-brown crust with vibrant red buffalo sauce, chicken pieces, and melted cheese topping.",
                "ingredients": "Pizza dough, chicken, buffalo sauce, cheese, blue cheese, celery, ranch dressing",
                "serving": "Best enjoyed hot with a side of celery sticks or ranch dressing.",
                "flavors": "Spicy, tangy, cheesy, savory",
                "variations": "Can be made with plant-based chicken or less spicy sauce.",
                "allergy_info": "Contains dairy, gluten, and possible soy; may cause allergies in sensitive individuals.",
                "Calories": "Approximately 300-400 kcal per slice",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Meat Lover's Delight Pizza,BBQ Chicken Feast Pizza,Spicy Veggie Volcano\",\"best_combo\":\"Enhances spicy and meaty flavors, creating a bold, satisfying combo.\",\"best_combo_ids\":\"PIZ0002,PIZ0005,PIZ0008\"}",
                "is_deleted": "false",
                "food_type": "non_veg",
                "is_spice_applicable": "yes",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "ee2aa8fb-01ae-4cdc-8824-843577ea49cd",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0022",
                "name": "Potato Wedges",
                "category": "Sides & Accompaniments",
                "supplier": "",
                "brand": "",
                "modifiers": "Potato Wedges addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Crispy potato wedges are thick-cut potatoes seasoned and baked or fried until golden and crunchy, perfect as a snack or side.",
                "comment": "",
                "cost": "",
                "price": "4.99",
                "large_price": "4.99",
                "indining_price": "4.99",
                "indining_large_price": "4.99",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749538548266-generated-image-1749538548266-1.png",
                "is_enabled": "true",
                "product_description": "Crispy potato wedges are thick-cut potatoes seasoned and baked or fried until golden and crunchy, perfect as a snack or side.",
                "level1_category": "Sides & Accompaniments",
                "level2_category": "Side Dishes",
                "Nutrients": "Rich in carbohydrates and vitamin C, moderate in fiber.",
                "appearance": "Golden-brown, wedge-shaped potatoes with a crispy exterior and fluffy interior.",
                "ingredients": "Potatoes, Olive oil, Salt, Pepper, Paprika, Garlic powder, Herbs",
                "serving": "Best enjoyed with ketchup, aioli, or spicy dips.",
                "flavors": "Savory, Crispy, Slightly smoky with hints of herbs.",
                "variations": "Can be seasoned with cheese, chili, or served with different dips.",
                "allergy_info": "Contains potatoes; check for cross-contamination with gluten or dairy if applicable.",
                "Calories": "Approximately 150-250 kcal per serving",
                "is_vegan": "yes",
                "best_combo": "{\"best_name\":\"Garlic Bread Supreme, Chicken Wings (6 pcs)\",\"best_combo\":\"Perfect sides with potato wedges for added flavor and variety.\",\"best_combo_ids\":\"PIZ0021\"}",
                "is_deleted": "false",
                "food_type": "veg",
                "is_spice_applicable": "yes",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "bdd585f1-40bf-43f4-adad-9e212ca583fa",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0027",
                "name": "Choco Cold Coffee",
                "category": "Beverages",
                "supplier": "",
                "brand": "",
                "modifiers": "Choco Cold Coffee addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Choco Cold Coffee is a refreshing beverage blending rich coffee, chocolate syrup, milk, and ice for a sweet, chilled drink.",
                "comment": "",
                "cost": "",
                "price": "4.49",
                "large_price": "4.49",
                "indining_price": "4.49",
                "indining_large_price": "4.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749538880748-generated-image-1749538880345-2.png",
                "is_enabled": "true",
                "product_description": "Choco Cold Coffee is a refreshing beverage blending rich coffee, chocolate syrup, milk, and ice for a sweet, chilled drink.",
                "level1_category": "Beverages",
                "level2_category": "Beverages",
                "Nutrients": "Provides energy from caffeine, sugars, and calcium from milk.",
                "appearance": "Dark brown coffee with a frothy top, topped with chocolate shavings or whipped cream.",
                "ingredients": "Coffee, chocolate syrup, milk, ice, sugar, whipped cream (optional).",
                "serving": "Best enjoyed chilled in a tall glass with a straw.",
                "flavors": "Rich chocolate, bold coffee, sweet and creamy.",
                "variations": "Can add whipped cream, chocolate chips, or caramel drizzle.",
                "allergy_info": "Contains dairy and caffeine; may affect lactose intolerant or sensitive individuals.",
                "Calories": "Approximately 150-250 kcal per serving.",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Garlic Bread Supreme, Chicken Wings (6 pcs), Potato Wedges\",\"best_combo\":\"Savory sides and wings complement the sweet, rich flavor of Choco Cold Coffee.\",\"best_combo_ids\":\"PIZ0021,PIZ0022\"}",
                "is_deleted": "false",
                "food_type": "non_veg",
                "is_spice_applicable": "no",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "d71ea6a1-cb05-4449-8495-a7fa492b6f82",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0028",
                "name": "Choco Lava Cake",
                "category": "Desserts & Sweets",
                "supplier": "",
                "brand": "",
                "modifiers": "Choco Lava Cake addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Choco Lava Cake is a rich, warm chocolate dessert with a gooey, molten center that oozes out when cut, offering a decadent treat.",
                "comment": "",
                "cost": "",
                "price": "4.99",
                "large_price": "4.99",
                "indining_price": "4.99",
                "indining_large_price": "4.99",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749538934939-generated-image-1749538934939-1.png",
                "is_enabled": "true",
                "product_description": "Choco Lava Cake is a rich, warm chocolate dessert with a gooey, molten center that oozes out when cut, offering a decadent treat.",
                "level1_category": "Desserts & Sweets",
                "level2_category": "Pastries & Cakes",
                "Nutrients": "Rich in calories and fats, provides energy and mood-boosting compounds.",
                "appearance": "Small, round cake with a slightly cracked top and a flowing chocolate center.",
                "ingredients": "Chocolate, Butter, Eggs, Sugar, Flour, Cocoa powder, Vanilla extract",
                "serving": "Best enjoyed warm with vanilla ice cream or whipped cream.",
                "flavors": "Intensely chocolatey, Sweet, Slightly bitter from cocoa",
                "variations": "Can be made dairy-free, gluten-free, or with added nuts or caramel",
                "allergy_info": "Contains dairy, eggs, and gluten; may cause allergies in sensitive individuals.",
                "Calories": "Approximately 350-450 kcal per serving",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Classic Cheeseburger Pizza, Garlic Bread Supreme, Classic Coke\",\"best_combo\":\"Savory and crunchy sides with a refreshing drink complement the sweet, rich Choco Lava Cake.\",\"best_combo_ids\":\"PIZ0025\"}",
                "is_deleted": "false",
                "food_type": "non_veg",
                "is_spice_applicable": "no",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "d3f3a400-9e90-4098-a991-33969ff1b6ea",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0030",
                "name": "Cinnamon Breadsticks",
                "category": "Starters & Small Plates",
                "supplier": "",
                "brand": "",
                "modifiers": "Cinnamon Breadsticks aadon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Cinnamon Breadsticks are soft, warm breadsticks coated with cinnamon sugar, offering a sweet and aromatic treat.",
                "comment": "",
                "cost": "",
                "price": "4.49",
                "large_price": "4.49",
                "indining_price": "4.49",
                "indining_large_price": "4.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749539017225-generated-image-1749539016801-2.png",
                "is_enabled": "true",
                "product_description": "Cinnamon Breadsticks are soft, warm breadsticks coated with cinnamon sugar, offering a sweet and aromatic treat.",
                "level1_category": "Starters & Small Plates",
                "level2_category": "Breads & Flatbreads",
                "Nutrients": "Provides carbohydrates, fats, and some protein.",
                "appearance": "Golden-brown breadsticks topped with cinnamon sugar, slightly glossy surface.",
                "ingredients": "Flour, yeast, butter, cinnamon, sugar, salt, milk, eggs.",
                "serving": "Best enjoyed warm with coffee or hot chocolate.",
                "flavors": "Sweet, spicy cinnamon, buttery notes.",
                "variations": "Can add icing or nuts for extra flavor.",
                "allergy_info": "Contains gluten, dairy, and eggs; may cause allergies.",
                "Calories": "Approximately 150-200 kcal per breadstick.",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Garlic Bread Supreme, Chicken Wings (6 pcs), Potato Wedges\",\"best_combo\":\"Rich, savory sides enhance the sweetness of cinnamon breadsticks.\",\"best_combo_ids\":\"PIZ0021,PIZ0022\"}",
                "is_deleted": "false",
                "food_type": "non_veg",
                "is_spice_applicable": "yes",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "ac33445d-18ae-4be2-942a-b0e65c7b44a4",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0014",
                "name": "Truffle Mushroom Delight Pizza",
                "category": "Starters & Small Plates",
                "supplier": "",
                "brand": "",
                "modifiers": "Truffle Mushroom Delight addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "A gourmet pizza topped with savory mushrooms and aromatic truffle oil, offering a rich, earthy flavor in a crispy crust.",
                "comment": "",
                "cost": "",
                "price": "14.49",
                "large_price": "14.49",
                "indining_price": "14.49",
                "indining_large_price": "14.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749536724052-generated-image-1749536723486-2.png",
                "is_enabled": "true",
                "product_description": "A gourmet pizza topped with savory mushrooms and aromatic truffle oil, offering a rich, earthy flavor in a crispy crust.",
                "level1_category": "Starters & Small Plates",
                "level2_category": "Breads & Flatbreads",
                "Nutrients": "Rich in antioxidants from mushrooms and healthy fats from truffle oil.",
                "appearance": "Golden-brown crust with melted cheese, sliced mushrooms, and drizzled truffle oil on top.",
                "ingredients": "Pizza dough, mushrooms, truffle oil, cheese, garlic, herbs, olive oil.",
                "serving": "Best enjoyed hot with a side of mixed greens or a light salad.",
                "flavors": "Earthy, umami, aromatic, slightly cheesy.",
                "variations": "Vegan version with plant-based cheese, or add prosciutto for non-veg.",
                "allergy_info": "Contains dairy and mushrooms; may cause allergies in sensitive individuals.",
                "Calories": "Approximately 300-400 kcal per slice.",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Veggie Supreme, Mediterranean Veggie, Spicy Veggie Volcano\",\"best_combo\":\"Complementary veggie flavors enhance the mushroom truffle profile.\",\"best_combo_ids\":\"PIZ0011,PIZ0008\"}",
                "is_deleted": "false",
                "food_type": "non_veg",
                "is_spice_applicable": "no",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "c8dee61d-9d99-407d-85c8-a2ebe87e9a14",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0006",
                "name": "Pepperoni Passion ",
                "category": "Starters & Small Plates",
                "supplier": "",
                "brand": "",
                "modifiers": "Pepperoni Passion addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Pepperoni Passion is a classic pizza topped with spicy pepperoni slices, melted cheese, and savory tomato sauce, offering a flavorful and satisfying experience.",
                "comment": "",
                "cost": "",
                "price": "12.99",
                "large_price": "12.99",
                "indining_price": "12.99",
                "indining_large_price": "12.99",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749534684345-generated-image-1749534684345-1.png",
                "is_enabled": "true",
                "product_description": "Pepperoni Passion is a classic pizza topped with spicy pepperoni slices, melted cheese, and savory tomato sauce, offering a flavorful and satisfying experience.",
                "level1_category": "Starters & Small Plates",
                "level2_category": "Appetizers / Starters",
                "Nutrients": "Rich in protein, calcium, and fats from cheese and meat toppings.",
                "appearance": "Golden-brown crust topped with vibrant red pepperoni slices and melted cheese.",
                "ingredients": "Dough, tomato sauce, mozzarella cheese, pepperoni slices, herbs.",
                "serving": "Best enjoyed hot with a side of garlic bread or salad.",
                "flavors": "Savory, spicy, cheesy, and slightly smoky.",
                "variations": "Can be made with different cheeses or vegetarian toppings.",
                "allergy_info": "Contains gluten, dairy, and processed meats; may cause allergies in sensitive individuals.",
                "Calories": "Approximately 300-400 kcal per slice.",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Meat Lover's Delight Pizza, BBQ Chicken Feast Pizza\",\"best_combo\":\"Rich, meaty flavors complement Pepperoni Passion well\",\"best_combo_ids\":\"PIZ0002,PIZ0005\"}",
                "is_deleted": "false",
                "food_type": "non_veg",
                "is_spice_applicable": "yes",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "fd637abf-0dc6-4253-b172-014f43c225cc",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0020",
                "name": " Garlic Bread Supreme",
                "category": "Starters & Small Plates",
                "supplier": "",
                "brand": "",
                "modifiers": "Garlic Bread Supreme addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Garlic Bread Supreme features toasted bread topped with garlic, herbs, melted cheese, and optional toppings for a flavorful appetizer.",
                "comment": "",
                "cost": "",
                "price": "5.49",
                "large_price": "5.49",
                "indining_price": "5.49",
                "indining_large_price": "5.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749538417077-generated-image-1749538417077-1.png",
                "is_enabled": "true",
                "product_description": "Garlic Bread Supreme features toasted bread topped with garlic, herbs, melted cheese, and optional toppings for a flavorful appetizer.",
                "level1_category": "Starters & Small Plates",
                "level2_category": "Breads & Flatbreads",
                "Nutrients": "Rich in carbohydrates, fats, and calcium from cheese.",
                "appearance": "Golden-brown toasted bread with melted cheese and sprinkled herbs on top.",
                "ingredients": "Bread, garlic, butter, cheese, herbs, optional toppings like olives or peppers.",
                "serving": "Best enjoyed warm with dips or as a side to pasta dishes.",
                "flavors": "Garlic, buttery, cheesy, herby with savory notes.",
                "variations": "Can include additional toppings like olives, peppers, or extra cheese.",
                "allergy_info": "Contains gluten, dairy, and garlic; may cause allergies in sensitive individuals.",
                "Calories": "Approximately 250-350 kcal per serving",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Classic Margherita, Four Cheese Melt Pizza, Veggie Supreme\",\"best_combo\":\"Complementary flavors and vegetarian options enhance garlic bread.\",\"best_combo_ids\":\"PIZ0001\"}",
                "is_deleted": "false",
                "food_type": "non_veg",
                "is_spice_applicable": "yes",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "3ee80a6b-a932-4ccb-a02f-377a91683824",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0024",
                "name": "Classic Pepsi ",
                "category": "Beverages",
                "supplier": "",
                "brand": "",
                "modifiers": "Classic Pepsi addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Classic Pepsi is a carbonated soft drink with a sweet, crisp flavor, known for its refreshing taste and iconic branding.",
                "comment": "",
                "cost": "",
                "price": "2.49",
                "large_price": "2.49",
                "indining_price": "2.49",
                "indining_large_price": "2.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749538665032-generated-image-1749538665032-1.png",
                "is_enabled": "true",
                "product_description": "Classic Pepsi is a carbonated soft drink with a sweet, crisp flavor, known for its refreshing taste and iconic branding.",
                "level1_category": "Beverages",
                "level2_category": "Beverages",
                "Nutrients": "Provides quick energy from sugars; no significant nutrients.",
                "appearance": "Clear, dark caramel-colored liquid in a transparent bottle or can.",
                "ingredients": "Carbonated water, high fructose corn syrup, caramel color, phosphoric acid, caffeine, natural flavors.",
                "serving": "Best served chilled in a glass or can, often with ice.",
                "flavors": "Sweet, caramel, slightly citrusy, fizzy.",
                "variations": "Diet Pepsi, Pepsi Max, flavored variants like cherry or vanilla.",
                "allergy_info": "Contains caffeine; may cause sensitivity in some individuals.",
                "Calories": "Approximately 150 kcal per 12 oz can.",
                "is_vegan": "yes",
                "best_combo": "{\"best_name\":\"Garlic Bread Supreme, Chicken Wings (6 pcs), Potato Wedges\",\"best_combo\":\"Classic Pepsi complements savory sides and crispy appetizers well.\",\"best_combo_ids\":\"PIZ0021,PIZ0022\"}",
                "is_deleted": "false",
                "food_type": "veg",
                "is_spice_applicable": "no",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "3c127c52-479a-4f61-b36f-9365af4bd8bb",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0025",
                "name": "Classic Coke",
                "category": "Beverages",
                "supplier": "",
                "brand": "",
                "modifiers": "Classic  Coke addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Classic Coke is a carbonated soft drink with a sweet, caramel flavor, known for its refreshing and bubbly taste.",
                "comment": "",
                "cost": "",
                "price": "2.49",
                "large_price": "2.49",
                "indining_price": "2.49",
                "indining_large_price": "2.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749538739474-generated-image-1749538739474-1.png",
                "is_enabled": "true",
                "product_description": "Classic Coke is a carbonated soft drink with a sweet, caramel flavor, known for its refreshing and bubbly taste.",
                "level1_category": "Beverages",
                "level2_category": "Beverages",
                "Nutrients": "Provides quick energy from sugars; no significant nutrients.",
                "appearance": "Clear, dark brown liquid with a fizzy, bubbly effervescence.",
                "ingredients": "Carbonated water, caramel color, high fructose corn syrup, phosphoric acid, natural flavors, caffeine",
                "serving": "Best served chilled in a glass or can, with ice if desired.",
                "flavors": "Sweet, caramel, slightly acidic, fizzy",
                "variations": "Diet Coke, Coca-Cola Zero Sugar, flavored variants like cherry or vanilla",
                "allergy_info": "Contains caffeine; no common allergens but not suitable for caffeine-sensitive individuals.",
                "Calories": "Approximately 140 kcal per 12 oz (355 ml) can",
                "is_vegan": "yes",
                "best_combo": "{\"best_name\":\"Classic Margherita, Garlic Bread Supreme, Chicken Wings (6 pcs)\",\"best_combo\":\"Light, savory, and crispy options complement the refreshing Classic Coke.\",\"best_combo_ids\":\"PIZ0001,PIZ0021\"}",
                "is_deleted": "false",
                "food_type": "veg",
                "is_spice_applicable": "no",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "b3d1ed75-e9df-45d0-a393-fbc1109c0aaa",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0003",
                "name": "Veggie Supreme ",
                "category": "Starters & Small Plates",
                "supplier": "",
                "brand": "",
                "modifiers": "Veggie Supreme addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Veggie Supreme is a hearty vegetarian pizza topped with a variety of fresh vegetables and melted cheese, offering a flavorful and satisfying meal.",
                "comment": "",
                "cost": "",
                "price": "12.49",
                "large_price": "12.49",
                "indining_price": "12.49",
                "indining_large_price": "12.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749534377844-generated-image-1749534377844-1.png",
                "is_enabled": "true",
                "product_description": "Veggie Supreme is a hearty vegetarian pizza topped with a variety of fresh vegetables and melted cheese, offering a flavorful and satisfying meal.",
                "level1_category": "Starters & Small Plates",
                "level2_category": "Breads & Flatbreads",
                "Nutrients": "Rich in vitamins from vegetables and calcium from cheese.",
                "appearance": "Colorful pizza with vibrant vegetable toppings and melted cheese crust.",
                "ingredients": "Tomatoes, bell peppers, onions, olives, cheese, pizza dough, herbs.",
                "serving": "Best enjoyed hot with a side of garlic bread or salad.",
                "flavors": "Savory, cheesy, with fresh vegetable notes.",
                "variations": "Can be made vegan by substituting cheese with plant-based options.",
                "allergy_info": "Contains dairy and gluten; may cause allergies in sensitive individuals.",
                "Calories": "Approximately 250-350 kcal per slice.",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Classic Margherita\",\"best_combo\":\"Both are vegetarian options with complementary flavors.\",\"best_combo_ids\":\"PIZ0001\"}",
                "is_deleted": "false",
                "food_type": "veg",
                "is_spice_applicable": "no",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              }
            ],
            "combo_price": "$74.60",
            "offer_percentage": "10.0",
            "combo_image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1750248161811-generated-image-1750248161811-1.png",
            "item_id": "",
            "is_enabled": true,
            "created_date": "2025-09-09 12-35-13"
          },
          {
            "combo_id": "50ca99a0-b58f-4761-874e-9cab164af716",
            "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
            "title": "Hunger Buster Combo",
            "description": "A satisfying selection of flavorful pizzas, crispy sides, and refreshing beverages, perfect for a hearty meal. Includes cheesy, meaty, vegetarian, and spicy options complemented by classic drinks and sides for a complete dining experience.",
            "products": [
              {
                "pk_id": "c8dee61d-9d99-407d-85c8-a2ebe87e9a14",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0006",
                "name": "Pepperoni Passion ",
                "category": "Starters & Small Plates",
                "supplier": "",
                "brand": "",
                "modifiers": "Pepperoni Passion addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Pepperoni Passion is a classic pizza topped with spicy pepperoni slices, melted cheese, and savory tomato sauce, offering a flavorful and satisfying experience.",
                "comment": "",
                "cost": "",
                "price": "12.99",
                "large_price": "12.99",
                "indining_price": "12.99",
                "indining_large_price": "12.99",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749534684345-generated-image-1749534684345-1.png",
                "is_enabled": "true",
                "product_description": "Pepperoni Passion is a classic pizza topped with spicy pepperoni slices, melted cheese, and savory tomato sauce, offering a flavorful and satisfying experience.",
                "level1_category": "Starters & Small Plates",
                "level2_category": "Appetizers / Starters",
                "Nutrients": "Rich in protein, calcium, and fats from cheese and meat toppings.",
                "appearance": "Golden-brown crust topped with vibrant red pepperoni slices and melted cheese.",
                "ingredients": "Dough, tomato sauce, mozzarella cheese, pepperoni slices, herbs.",
                "serving": "Best enjoyed hot with a side of garlic bread or salad.",
                "flavors": "Savory, spicy, cheesy, and slightly smoky.",
                "variations": "Can be made with different cheeses or vegetarian toppings.",
                "allergy_info": "Contains gluten, dairy, and processed meats; may cause allergies in sensitive individuals.",
                "Calories": "Approximately 300-400 kcal per slice.",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Meat Lover's Delight Pizza, BBQ Chicken Feast Pizza\",\"best_combo\":\"Rich, meaty flavors complement Pepperoni Passion well\",\"best_combo_ids\":\"PIZ0002,PIZ0005\"}",
                "is_deleted": "false",
                "food_type": "non_veg",
                "is_spice_applicable": "yes",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "0a3516ef-4805-4352-bc77-2c7a5c521167",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0019",
                "name": "Cheeseburger Pizza ",
                "category": "Starters & Small Plates",
                "supplier": "",
                "brand": "",
                "modifiers": "Cheeseburger Pizza addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Cheeseburger Pizza combines the flavors of a classic cheeseburger with a crispy pizza crust, topped with beef, cheese, and condiments for a savory experience.",
                "comment": "",
                "cost": "",
                "price": "14.99",
                "large_price": "14.99",
                "indining_price": "14.989",
                "indining_large_price": "14.99",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749537181694-generated-image-1749537179953-4.png",
                "is_enabled": "true",
                "product_description": "Cheeseburger Pizza combines the flavors of a classic cheeseburger with a crispy pizza crust, topped with beef, cheese, and condiments for a savory experience.",
                "level1_category": "Starters & Small Plates",
                "level2_category": "Appetizers / Starters",
                "Nutrients": "Rich in protein, calcium, and fats; provides energy and muscle support.",
                "appearance": "Golden-brown pizza crust topped with melted cheese, beef patties, and burger toppings.",
                "ingredients": "Pizza dough, beef patties, cheese, ketchup, mustard, pickles, onions, lettuce.",
                "serving": "Best enjoyed hot with a side of fries or salad.",
                "flavors": "Savory, cheesy, tangy, with beefy richness.",
                "variations": "Add bacon, jalapeños, or switch to plant-based patties.",
                "allergy_info": "Contains dairy, gluten, and beef; may cause allergies in sensitive individuals.",
                "Calories": "Approximately 600-800 kcal per slice.",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Loaded Paneer Paradise Pizza, Four Cheese Melt Pizza\",\"best_combo\":\"Rich cheesy and flavorful options complement the cheeseburger pizza well.\",\"best_combo_ids\":\"PIZ0015\"}",
                "is_deleted": "false",
                "food_type": "non_veg",
                "is_spice_applicable": "yes",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "02d9711e-2365-476c-9174-2ba463aa3636",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0015",
                "name": "Loaded Paneer Paradise Pizza",
                "category": "Starters & Small Plates",
                "supplier": "",
                "brand": "",
                "modifiers": "Loaded Paneer Paradise",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Loaded Paneer Paradise Pizza features a crispy crust topped with spiced paneer, fresh vegetables, and melted cheese, offering a flavorful vegetarian delight.",
                "comment": "",
                "cost": "",
                "price": "13.99",
                "large_price": "13.99",
                "indining_price": "13.99",
                "indining_large_price": "13.99",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749536855344-generated-image-1749536854924-2.png",
                "is_enabled": "true",
                "product_description": "Loaded Paneer Paradise Pizza features a crispy crust topped with spiced paneer, fresh vegetables, and melted cheese, offering a flavorful vegetarian delight.",
                "level1_category": "Starters & Small Plates",
                "level2_category": "Breads & Flatbreads",
                "Nutrients": "Rich in protein from paneer, calcium, vitamins from vegetables",
                "appearance": "Golden-brown crust with colorful toppings and melted cheese, garnished with herbs.",
                "ingredients": "Paneer, cheese, bell peppers, onions, tomato sauce, spices, herbs, dough",
                "serving": "Best enjoyed hot with a side of green chutney or salad.",
                "flavors": "Savory, cheesy, mildly spicy with aromatic herbs",
                "variations": "Vegan cheese, gluten-free crust, extra vegetables",
                "allergy_info": "Contains dairy and gluten; may cause allergies in sensitive individuals.",
                "Calories": "Approximately 300-400 kcal per slice",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Veggie Supreme, Mediterranean Veggie, Spicy Veggie Volcano\",\"best_combo\":\"Complementary veggie flavors enhance the paneer pizza experience.\",\"best_combo_ids\":\"PIZ0011,PIZ0008\"}",
                "is_deleted": "false",
                "food_type": "veg",
                "is_spice_applicable": "yes",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "ee2aa8fb-01ae-4cdc-8824-843577ea49cd",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0022",
                "name": "Potato Wedges",
                "category": "Sides & Accompaniments",
                "supplier": "",
                "brand": "",
                "modifiers": "Potato Wedges addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Crispy potato wedges are thick-cut potatoes seasoned and baked or fried until golden and crunchy, perfect as a snack or side.",
                "comment": "",
                "cost": "",
                "price": "4.99",
                "large_price": "4.99",
                "indining_price": "4.99",
                "indining_large_price": "4.99",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749538548266-generated-image-1749538548266-1.png",
                "is_enabled": "true",
                "product_description": "Crispy potato wedges are thick-cut potatoes seasoned and baked or fried until golden and crunchy, perfect as a snack or side.",
                "level1_category": "Sides & Accompaniments",
                "level2_category": "Side Dishes",
                "Nutrients": "Rich in carbohydrates and vitamin C, moderate in fiber.",
                "appearance": "Golden-brown, wedge-shaped potatoes with a crispy exterior and fluffy interior.",
                "ingredients": "Potatoes, Olive oil, Salt, Pepper, Paprika, Garlic powder, Herbs",
                "serving": "Best enjoyed with ketchup, aioli, or spicy dips.",
                "flavors": "Savory, Crispy, Slightly smoky with hints of herbs.",
                "variations": "Can be seasoned with cheese, chili, or served with different dips.",
                "allergy_info": "Contains potatoes; check for cross-contamination with gluten or dairy if applicable.",
                "Calories": "Approximately 150-250 kcal per serving",
                "is_vegan": "yes",
                "best_combo": "{\"best_name\":\"Garlic Bread Supreme, Chicken Wings (6 pcs)\",\"best_combo\":\"Perfect sides with potato wedges for added flavor and variety.\",\"best_combo_ids\":\"PIZ0021\"}",
                "is_deleted": "false",
                "food_type": "veg",
                "is_spice_applicable": "yes",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "7f25523c-9de7-4112-a346-55c0acefc8da",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0023",
                "name": "Tandoori Chicken Bites",
                "category": "Entrees",
                "supplier": "",
                "brand": "",
                "modifiers": "Tandoori Chicken Bites addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Tandoori Chicken Bites are tender, marinated chicken pieces cooked in a traditional tandoor, offering smoky and spicy flavors in bite-sized form.",
                "comment": "",
                "cost": "",
                "price": "7.49",
                "large_price": "7.49",
                "indining_price": "7.49",
                "indining_large_price": "7.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749538600422-generated-image-1749538599121-4.png",
                "is_enabled": "true",
                "product_description": "Tandoori Chicken Bites are tender, marinated chicken pieces cooked in a traditional tandoor, offering smoky and spicy flavors in bite-sized form.",
                "level1_category": "Entrees",
                "level2_category": "Specialty Meat Dishes",
                "Nutrients": "High in protein, rich in vitamins and minerals from spices.",
                "appearance": "Golden-brown, charred edges with vibrant red spice coating, served in small pieces.",
                "ingredients": "Chicken,Yogurt,Spices,Garlic,Ginger,Salt,Oil,Red chili powder",
                "serving": "Best enjoyed with mint chutney or yogurt dip.",
                "flavors": "Spicy,Smoky,Tangy",
                "variations": "Can be made vegan with plant-based chicken substitutes.",
                "allergy_info": "Contains dairy and spices; may cause allergies in sensitive individuals.",
                "Calories": "Approximately 150-200 kcal per serving",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Chicken Tikka Pizza, Garlic Bread Supreme\",\"best_combo\":\"Complementary flavors of tandoori spices and garlic bread enhance the meal.\",\"best_combo_ids\":\"PIZ0004\"}",
                "is_deleted": "false",
                "food_type": "non_veg",
                "is_spice_applicable": "yes",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "3ee80a6b-a932-4ccb-a02f-377a91683824",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0024",
                "name": "Classic Pepsi ",
                "category": "Beverages",
                "supplier": "",
                "brand": "",
                "modifiers": "Classic Pepsi addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Classic Pepsi is a carbonated soft drink with a sweet, crisp flavor, known for its refreshing taste and iconic branding.",
                "comment": "",
                "cost": "",
                "price": "2.49",
                "large_price": "2.49",
                "indining_price": "2.49",
                "indining_large_price": "2.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749538665032-generated-image-1749538665032-1.png",
                "is_enabled": "true",
                "product_description": "Classic Pepsi is a carbonated soft drink with a sweet, crisp flavor, known for its refreshing taste and iconic branding.",
                "level1_category": "Beverages",
                "level2_category": "Beverages",
                "Nutrients": "Provides quick energy from sugars; no significant nutrients.",
                "appearance": "Clear, dark caramel-colored liquid in a transparent bottle or can.",
                "ingredients": "Carbonated water, high fructose corn syrup, caramel color, phosphoric acid, caffeine, natural flavors.",
                "serving": "Best served chilled in a glass or can, often with ice.",
                "flavors": "Sweet, caramel, slightly citrusy, fizzy.",
                "variations": "Diet Pepsi, Pepsi Max, flavored variants like cherry or vanilla.",
                "allergy_info": "Contains caffeine; may cause sensitivity in some individuals.",
                "Calories": "Approximately 150 kcal per 12 oz can.",
                "is_vegan": "yes",
                "best_combo": "{\"best_name\":\"Garlic Bread Supreme, Chicken Wings (6 pcs), Potato Wedges\",\"best_combo\":\"Classic Pepsi complements savory sides and crispy appetizers well.\",\"best_combo_ids\":\"PIZ0021,PIZ0022\"}",
                "is_deleted": "false",
                "food_type": "veg",
                "is_spice_applicable": "no",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "aa22f37a-04c0-457c-a9d8-65a1c3abcd9e",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0032",
                "name": "Brownie Bites (4 pcs)",
                "category": "Desserts & Sweets",
                "supplier": "",
                "brand": "",
                "modifiers": "Brownie Bites",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Delicious mini chocolate brownies, moist and fudgy, served in bite-sized pieces perfect for snacking or dessert.",
                "comment": "",
                "cost": "",
                "price": "5.99",
                "large_price": "5.99",
                "indining_price": "5.99",
                "indining_large_price": "5.99",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749539240250-generated-image-1749539231138-4.png",
                "is_enabled": "true",
                "product_description": "Delicious mini chocolate brownies, moist and fudgy, served in bite-sized pieces perfect for snacking or dessert.",
                "level1_category": "Desserts & Sweets",
                "level2_category": "Pastries & Cakes",
                "Nutrients": "Provides energy from sugars and fats, contains antioxidants from chocolate.",
                "appearance": "Small, square, rich brown bites with a glossy chocolate glaze on top.",
                "ingredients": "Chocolate, Flour, Butter, Sugar, Eggs, Cocoa powder, Vanilla extract",
                "serving": "Best enjoyed with a scoop of ice cream or a glass of milk.",
                "flavors": "Rich, Chocolatey, Sweet, Fudgy",
                "variations": "Add nuts, caramel swirls, or vegan chocolate options.",
                "allergy_info": "Contains gluten, dairy, and eggs; may cause allergic reactions.",
                "Calories": "Approximately 150-200 kcal per piece",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Choco Lava Cake, Ice Cream Sundae\",\"best_combo\":\"Rich desserts complement the chocolatey brownie bites perfectly.\",\"best_combo_ids\":\"PIZ0028,PIZ0029\"}",
                "is_deleted": "false",
                "food_type": "non_veg",
                "is_spice_applicable": "no",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "179e17e7-da1c-4b6f-a792-d984cdc177fa",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0031",
                "name": " Cheesecake Slice",
                "category": "Desserts & Sweets",
                "supplier": "",
                "brand": "",
                "modifiers": "Cheesecake Slice",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "A rich, creamy dessert with a smooth cheese filling on a buttery crust, topped with fruit or glaze for added flavor.",
                "comment": "",
                "cost": "",
                "price": "5.99",
                "large_price": "5.99",
                "indining_price": "5.99",
                "indining_large_price": "5.99",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749539157355-generated-image-1749539156897-2.png",
                "is_enabled": "true",
                "product_description": "A rich, creamy dessert with a smooth cheese filling on a buttery crust, topped with fruit or glaze for added flavor.",
                "level1_category": "Desserts & Sweets",
                "level2_category": "Pastries & Cakes",
                "Nutrients": "Rich in calcium, protein, and fats; high in calories",
                "appearance": "A triangular slice with a smooth, creamy surface and a graham cracker crust base.",
                "ingredients": "Cream cheese, sugar, eggs, graham cracker crust, vanilla extract, sour cream",
                "serving": "Best enjoyed chilled, topped with fresh fruit or fruit compote.",
                "flavors": "Sweet, tangy, creamy with hints of vanilla and buttery crust",
                "variations": "Chocolate, fruit-topped, no-bake, vegan options available",
                "allergy_info": "Contains dairy and eggs; may cause allergies in sensitive individuals",
                "Calories": "Approximately 300-400 kcal per slice",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Choco Lava Cake, Ice Cream Sundae\",\"best_combo\":\"Rich desserts complement the creamy cheesecake perfectly.\",\"best_combo_ids\":\"PIZ0028,PIZ0029\"}",
                "is_deleted": "false",
                "food_type": "non_veg",
                "is_spice_applicable": "no",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "dcbe286c-43c2-4f27-b9aa-8a339344f0c7",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0016",
                "name": "Buffalo Chicken Blast Pizza",
                "category": "Starters & Small Plates",
                "supplier": "",
                "brand": "",
                "modifiers": "Buffalo Chicken Blast addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Buffalo Chicken Blast Pizza features a crispy crust topped with spicy buffalo sauce, tender chicken, and melty cheese, offering a bold flavor experience.",
                "comment": "",
                "cost": "",
                "price": "13.49",
                "large_price": "13.49",
                "indining_price": "13.49",
                "indining_large_price": "13.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749536945765-generated-image-1749536944781-3.png",
                "is_enabled": "true",
                "product_description": "Buffalo Chicken Blast Pizza features a crispy crust topped with spicy buffalo sauce, tender chicken, and melty cheese, offering a bold flavor experience.",
                "level1_category": "Starters & Small Plates",
                "level2_category": "Appetizers / Starters",
                "Nutrients": "Rich in protein and calcium, moderate in fats and carbs.",
                "appearance": "Golden-brown crust with vibrant red buffalo sauce, chicken pieces, and melted cheese topping.",
                "ingredients": "Pizza dough, chicken, buffalo sauce, cheese, blue cheese, celery, ranch dressing",
                "serving": "Best enjoyed hot with a side of celery sticks or ranch dressing.",
                "flavors": "Spicy, tangy, cheesy, savory",
                "variations": "Can be made with plant-based chicken or less spicy sauce.",
                "allergy_info": "Contains dairy, gluten, and possible soy; may cause allergies in sensitive individuals.",
                "Calories": "Approximately 300-400 kcal per slice",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Meat Lover's Delight Pizza,BBQ Chicken Feast Pizza,Spicy Veggie Volcano\",\"best_combo\":\"Enhances spicy and meaty flavors, creating a bold, satisfying combo.\",\"best_combo_ids\":\"PIZ0002,PIZ0005,PIZ0008\"}",
                "is_deleted": "false",
                "food_type": "non_veg",
                "is_spice_applicable": "yes",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              }
            ],
            "combo_price": "$74.17",
            "offer_percentage": "10.0",
            "combo_image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1750249766723-generated-image-1750249761907-3.png",
            "item_id": "",
            "is_enabled": true,
            "created_date": "2025-09-09 12-35-13"
          },
          {
            "combo_id": "b902f691-9bfd-4225-aa32-aa701786bbf4",
            "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
            "title": "Spicy Crust Combo",
            "description": "The Spicy Crust Combo typically features a pizza with a flavorful, spicy crust that adds an extra kick to your favorite toppings. It often includes a variety of ingredients like spicy sausage, jalapeños, pepperoni, or other bold flavors, all served on a crust that’s seasoned with spices to enhance the heat and taste. This combo is perfect for those who enjoy a fiery twist on their pizza. For specific details or to customize your order, please check with your local pizzeria or restaurant.",
            "products": [
              {
                "pk_id": "f03c1c36-597d-4afc-ab37-3700b0f70d35",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0001",
                "name": "Classic Margherita",
                "category": "Starters & Small Plates",
                "supplier": "",
                "brand": "",
                "modifiers": "Classic Margherita addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Classic Margherita is a traditional Italian pizza featuring a thin crust topped with fresh tomatoes, mozzarella, basil, and olive oil, offering a simple yet flavorful experience.",
                "comment": "",
                "cost": "",
                "price": "10.99",
                "large_price": "10.99",
                "indining_price": "10.99",
                "indining_large_price": "10.99",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1750428613430-generated-image-1750428613430-1.png",
                "is_enabled": true,
                "product_description": "A Margherita pizza is a classic Italian dish known for its simple yet flavorful ingredients. It typically features a thin, crisp crust topped with a vibrant tomato sauce made from fresh, ripe tomatoes. The pizza is adorned with slices of fresh mozzarella cheese that melt beautifully during baking, creating a creamy texture. Fresh basil leaves are added on top, providing a fragrant, herbal aroma and a splash of color. Often finished with a drizzle of extra virgin olive oil, the Margherita pizza embodies a harmonious balance of fresh, high-quality ingredients, highlighting the essence of traditional Italian cuisine.",
                "level1_category": "Starters & Small Plates",
                "level2_category": "Breads & Flatbreads",
                "Nutrients": "Rich in calcium, protein, and antioxidants from fresh ingredients.",
                "appearance": "Golden-brown thin crust with vibrant red tomatoes, white mozzarella, and green basil leaves.",
                "ingredients": "Flour, tomatoes, mozzarella cheese, basil, olive oil, salt, yeast",
                "serving": "Best enjoyed hot with a drizzle of olive oil or fresh basil leaves.",
                "flavors": "Fresh, Savory, Herbaceous",
                "variations": "Add extra toppings like prosciutto or chili flakes for variation.",
                "allergy_info": "Contains gluten, dairy, and basil; may affect allergies.",
                "Calories": "Approximately 250-300 kcal per slice",
                "is_vegan": "no",
                "best_combo": [],
                "is_deleted": false,
                "food_type": "veg",
                "is_spice_applicable": "no",
                "meal_time": "",
                "inventory_status": true,
                "is_item_verified": true,
                "account_id": "",
                "party_orders": [
                  {
                    "name": "small",
                    "serving": "10",
                    "price": "109.90"
                  },
                  {
                    "name": "medium",
                    "serving": "25",
                    "price": "274.75"
                  },
                  {
                    "name": "large",
                    "serving": "50",
                    "price": "549.50"
                  }
                ],
                "modifiers_list": [
                  {
                    "name": "Classic Margherita addon",
                    "is_multi_select": "No",
                    "is_forced": "Yes",
                    "options": [
                      {
                        "name": "Extra cheese",
                        "price": "$1.25",
                        "isEnabled": true
                      },
                      {
                        "name": "Cherry tomatoes",
                        "price": "$0.75",
                        "isEnabled": true
                      },
                      {
                        "name": "Garlic crust",
                        "price": "$1.50",
                        "isEnabled": true
                      },
                      {
                        "name": "Arugula",
                        "price": "$0.75",
                        "isEnabled": true
                      }
                    ]
                  }
                ]
              },
              {
                "pk_id": "b3d1ed75-e9df-45d0-a393-fbc1109c0aaa",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0003",
                "name": "Veggie Supreme ",
                "category": "Starters & Small Plates",
                "supplier": "",
                "brand": "",
                "modifiers": "Veggie Supreme addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Veggie Supreme is a hearty vegetarian pizza topped with a variety of fresh vegetables and melted cheese, offering a flavorful and satisfying meal.",
                "comment": "",
                "cost": "",
                "price": "12.49",
                "large_price": "12.49",
                "indining_price": "12.49",
                "indining_large_price": "12.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749534377844-generated-image-1749534377844-1.png",
                "is_enabled": true,
                "product_description": "Veggie Supreme is a hearty vegetarian pizza topped with a variety of fresh vegetables and melted cheese, offering a flavorful and satisfying meal.",
                "level1_category": "Starters & Small Plates",
                "level2_category": "Breads & Flatbreads",
                "Nutrients": "Rich in vitamins from vegetables and calcium from cheese.",
                "appearance": "Colorful pizza with vibrant vegetable toppings and melted cheese crust.",
                "ingredients": "Tomatoes, bell peppers, onions, olives, cheese, pizza dough, herbs.",
                "serving": "Best enjoyed hot with a side of garlic bread or salad.",
                "flavors": "Savory, cheesy, with fresh vegetable notes.",
                "variations": "Can be made vegan by substituting cheese with plant-based options.",
                "allergy_info": "Contains dairy and gluten; may cause allergies in sensitive individuals.",
                "Calories": "Approximately 250-350 kcal per slice.",
                "is_vegan": "no",
                "best_combo": {
                  "best_name": "Classic Margherita",
                  "best_combo": "Both are vegetarian options with complementary flavors.",
                  "best_combo_ids": "PIZ0001"
                },
                "is_deleted": false,
                "food_type": "veg",
                "is_spice_applicable": "no",
                "meal_time": "",
                "inventory_status": true,
                "is_item_verified": true,
                "account_id": "",
                "party_orders": [
                  {
                    "name": "small",
                    "serving": "10",
                    "price": "124.90"
                  },
                  {
                    "name": "medium",
                    "serving": "25",
                    "price": "312.25"
                  },
                  {
                    "name": "large",
                    "serving": "50",
                    "price": "624.50"
                  }
                ],
                "modifiers_list": [
                  {
                    "name": "Veggie Supreme addon",
                    "is_multi_select": "No",
                    "is_forced": "Yes",
                    "options": [
                      {
                        "name": "Spinach",
                        "price": "$0.75",
                        "isEnabled": true
                      },
                      {
                        "name": "feta",
                        "price": "$1.50",
                        "isEnabled": true
                      },
                      {
                        "name": "pesto swirl",
                        "price": "$1.50",
                        "isEnabled": true
                      }
                    ]
                  }
                ]
              },
              {
                "pk_id": "4f60847b-b066-4754-81c8-330f11095786",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0007",
                "name": "Hawaiian Classic Pizza",
                "category": "Entrees",
                "supplier": "",
                "brand": "",
                "modifiers": "Hawaiian Classic addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Hawaiian Classic Pizza features a crispy crust topped with tomato sauce, cheese, ham, and pineapple chunks, offering a sweet and savory flavor profile.",
                "comment": "",
                "cost": "",
                "price": "12.49",
                "large_price": "12.49",
                "indining_price": "12.49",
                "indining_large_price": "12.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749534761684-generated-image-1749534760104-4.png",
                "is_enabled": true,
                "product_description": "Hawaiian Classic Pizza features a crispy crust topped with tomato sauce, cheese, ham, and pineapple chunks, offering a sweet and savory flavor profile.",
                "level1_category": "Entrees",
                "level2_category": "Pizzas & Flatbreads",
                "Nutrients": "Provides carbs, protein, calcium, and vitamins from toppings.",
                "appearance": "Golden-brown crust with melted cheese, ham slices, and pineapple pieces on top.",
                "ingredients": "Pizza dough, tomato sauce, mozzarella cheese, ham, pineapple, olive oil, herbs.",
                "serving": "Best enjoyed hot with a side of garlic bread or salad.",
                "flavors": "Sweet, savory, cheesy, with a hint of tang from pineapple.",
                "variations": "Can add bacon, jalapeños, or substitute ham with turkey.",
                "allergy_info": "Contains dairy, gluten, and possibly soy; check for allergies.",
                "Calories": "Approximately 250-350 kcal per slice.",
                "is_vegan": "no",
                "best_combo": {
                  "best_name": "Meat Lover's Delight Pizza, BBQ Chicken Feast Pizza",
                  "best_combo": "Rich, savory flavors complement the sweet and savory Hawaiian pizza",
                  "best_combo_ids": "PIZ0002,PIZ0005"
                },
                "is_deleted": false,
                "food_type": "non_veg",
                "is_spice_applicable": "no",
                "meal_time": "",
                "inventory_status": true,
                "is_item_verified": true,
                "account_id": "",
                "party_orders": [
                  {
                    "name": "small",
                    "serving": "10",
                    "price": "124.90"
                  },
                  {
                    "name": "medium",
                    "serving": "25",
                    "price": "312.25"
                  },
                  {
                    "name": "large",
                    "serving": "50",
                    "price": "624.50"
                  }
                ],
                "modifiers_list": [
                  {
                    "name": "Hawaiian Classic addon",
                    "is_multi_select": "No",
                    "is_forced": "Yes",
                    "options": [
                      {
                        "name": "Bacon",
                        "price": "$1.75",
                        "isEnabled": true
                      },
                      {
                        "name": "red onions",
                        "price": "$0.60",
                        "isEnabled": true
                      },
                      {
                        "name": "sweet chili drizzle",
                        "price": "$0.60",
                        "isEnabled": true
                      },
                      {
                        "name": "spicy crust",
                        "price": "$1.25",
                        "isEnabled": true
                      }
                    ]
                  }
                ]
              }
            ],
            "combo_price": "$34.17",
            "offer_percentage": "5.0",
            "combo_image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1752215177271-generated-image-1752215176604-2.png",
            "item_id": "",
            "is_enabled": true,
            "created_date": "2025-09-09 12-35-13"
          },
          {
            "combo_id": "8a1b8f6b-00cc-46e7-b54f-53e98c404317",
            "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
            "title": "Veggie supreme",
            "description": "Introducing our Veggie Supreme Pizza Combo—an irresistible feast for your senses! Dive into a flavorful medley of fresh, crisp vegetables topped with gooey, melted cheese and our signature sauce, all nestled on a perfectly baked crust. The Veggie Supreme is a vibrant celebration of wholesome ingredients, crafted to satisfy both your cravings and your health-conscious choices. Paired with our refreshing, chilled Coke, this combo offers the perfect harmony of savory and fizzy delight. Whether you're sharing with friends or treating yourself, the Veggie Supreme Pizza Combo promises a deliciously satisfying experience that will leave you craving more!",
            "products": [
              {
                "pk_id": "3c127c52-479a-4f61-b36f-9365af4bd8bb",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0025",
                "name": "Classic Coke",
                "category": "Beverages",
                "supplier": "",
                "brand": "",
                "modifiers": "Classic  Coke addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Classic Coke is a carbonated soft drink with a sweet, caramel flavor, known for its refreshing and bubbly taste.",
                "comment": "",
                "cost": "",
                "price": "2.49",
                "large_price": "2.49",
                "indining_price": "2.49",
                "indining_large_price": "2.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749538739474-generated-image-1749538739474-1.png",
                "is_enabled": true,
                "product_description": "Classic Coke is a carbonated soft drink with a sweet, caramel flavor, known for its refreshing and bubbly taste.",
                "level1_category": "Beverages",
                "level2_category": "Beverages",
                "Nutrients": "Provides quick energy from sugars; no significant nutrients.",
                "appearance": "Clear, dark brown liquid with a fizzy, bubbly effervescence.",
                "ingredients": "Carbonated water, caramel color, high fructose corn syrup, phosphoric acid, natural flavors, caffeine",
                "serving": "Best served chilled in a glass or can, with ice if desired.",
                "flavors": "Sweet, caramel, slightly acidic, fizzy",
                "variations": "Diet Coke, Coca-Cola Zero Sugar, flavored variants like cherry or vanilla",
                "allergy_info": "Contains caffeine; no common allergens but not suitable for caffeine-sensitive individuals.",
                "Calories": "Approximately 140 kcal per 12 oz (355 ml) can",
                "is_vegan": "yes",
                "best_combo": {
                  "best_name": "Classic Margherita, Garlic Bread Supreme, Chicken Wings (6 pcs)",
                  "best_combo": "Light, savory, and crispy options complement the refreshing Classic Coke.",
                  "best_combo_ids": "PIZ0001,PIZ0021"
                },
                "is_deleted": false,
                "food_type": "veg",
                "is_spice_applicable": "no",
                "meal_time": "",
                "inventory_status": true,
                "is_item_verified": true,
                "account_id": "",
                "party_orders": [
                  {
                    "name": "small",
                    "serving": "12",
                    "price": "29.88"
                  },
                  {
                    "name": "medium",
                    "serving": "50",
                    "price": "124.50"
                  },
                  {
                    "name": "large",
                    "serving": "100",
                    "price": "249.00"
                  }
                ],
                "modifiers_list": [
                  {
                    "name": "Classic  Coke addon",
                    "is_multi_select": "No",
                    "is_forced": "Yes",
                    "pk_id": "f7b73e50-eae9-4329-9a7c-82aac702a1ab",
                    "options": [
                      {
                        "name": "Ice-free option",
                        "price": "$0",
                        "isEnabled": true
                      },
                      {
                        "name": "lemon twist",
                        "price": "$0.50",
                        "isEnabled": true
                      }
                    ]
                  }
                ]
              },
              {
                "pk_id": "b3d1ed75-e9df-45d0-a393-fbc1109c0aaa",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0003",
                "name": "Veggie Supreme ",
                "category": "Starters & Small Plates",
                "supplier": "",
                "brand": "",
                "modifiers": "",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Veggie Supreme is a hearty vegetarian pizza topped with a variety of fresh vegetables and melted cheese, offering a flavorful and satisfying meal.",
                "comment": "",
                "cost": "",
                "price": "13",
                "large_price": "12.49",
                "indining_price": "1",
                "indining_large_price": "12.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749534377844-generated-image-1749534377844-1.png",
                "is_enabled": true,
                "product_description": "Veggie Supreme is a hearty vegetarian pizza topped with a variety of fresh vegetables and melted cheese, offering a flavorful and satisfying meal.",
                "level1_category": "Starters & Small Plates",
                "level2_category": "Breads & Flatbreads",
                "Nutrients": "Rich in vitamins from vegetables and calcium from cheese.",
                "appearance": "Colorful pizza with vibrant vegetable toppings and melted cheese crust.",
                "ingredients": "Tomatoes, bell peppers, onions, olives, cheese, pizza dough, herbs.",
                "serving": "Best enjoyed hot with a side of garlic bread or salad.",
                "flavors": "Savory, cheesy, with fresh vegetable notes.",
                "variations": "Can be made vegan by substituting cheese with plant-based options.",
                "allergy_info": "Contains dairy and gluten; may cause allergies in sensitive individuals.",
                "Calories": "Approximately 250-350 kcal per slice.",
                "is_vegan": "no",
                "best_combo": {
                  "best_name": "Classic Margherita",
                  "best_combo": "Both are vegetarian options with complementary flavors.",
                  "best_combo_ids": "PIZ0001"
                },
                "is_deleted": false,
                "food_type": "veg",
                "is_spice_applicable": "Yes",
                "meal_time": "",
                "inventory_status": true,
                "is_item_verified": true,
                "account_id": "",
                "party_orders": [
                  {
                    "name": "small",
                    "serving": "10",
                    "price": "124.90"
                  },
                  {
                    "name": "medium",
                    "serving": "25",
                    "price": "312.25"
                  },
                  {
                    "name": "large",
                    "serving": "50",
                    "price": "624.50"
                  }
                ]
              }
            ],
            "combo_price": "$14.72",
            "offer_percentage": "5.0",
            "combo_image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1754874940426-generated-image-1754874932453-4.png",
            "item_id": "",
            "is_enabled": true,
            "created_date": "2025-09-09 12-35-13"
          }]
        }
      },
      {
        "type": "EssentialExperience",
        "data": {
          "headerContent": "<h2 class='text-3xl md:text-4xl font-bold text-gray-900 text-center mb-6'>Our Experience</h2><p class='text-lg text-gray-600 text-center max-w-3xl mx-auto leading-relaxed'>Discover what makes our sample business special through our approach and dedication.</p>",
          "cards": [
            {
              "id": "1",
              "title": "Quality Service",
              "description": "We provide sample service to demonstrate the layout and structure for your website.",
              "icon": "⭐"
            },
            {
              "id": "2",
              "title": "Expert Team",
              "description": "Our sample team consists of placeholder professionals showcasing this section.",
              "icon": "👥"
            },
            {
              "id": "3",
              "title": "Innovation",
              "description": "This card shows how to highlight features like innovation using placeholder text.",
              "icon": "💡"
            },
            {
              "id": "4",
              "title": "Customer Focus",
              "description": "Your satisfaction is important; this is generic text demonstrating customer focus.",
              "icon": "🎯"
            }
          ],
          "backgroundColor": "#f9fafb"
        }

      },
      {
        "type": "BasicStory",
        "data": {
          "hero": {
            "image": "https://thumbs.dreamstime.com/b/unhealthy-fast-food-delivery-menu-featuring-assorted-burgers-cheeseburgers-nuggets-french-fries-soda-high-calorie-low-356045884.jpg",
            "title": "Our Story"
          },
          "title": "The Story of Our Sample Restaurant",
          "storyContent": "<p>Once upon a time, in a small bustling town, there was a cozy little sample restaurant. This is placeholder text describing the beginnings of the restaurant for demonstration purposes.</p><p>The chef had a passion for creating delicious meals and providing a warm atmosphere. With care and dedication, they opened this sample restaurant to share good food and joy with the community.</p><p>Our approach is simple: use fresh ingredients, prepare each dish thoughtfully, and serve it with a smile. This is sample content for the story section and can be replaced with real information later.</p>"
        }

      },
      {
        "type": "BasicBlog",
        "data": {
          "title": "<h2 class='text-3xl font-bold text-gray-900 mb-4'>Latest Blog Posts</h2>",
          "subtitle": "<p class='text-gray-600 text-lg'>Discover our latest stories and insights</p>",
          "posts": [
            {
              "id": "1",
              "title": "<h3 class='text-xl font-bold text-gray-900'>Sample Blog Post One</h3>",
              "content": "<p class='text-gray-700 leading-relaxed'>This is a placeholder content for a sample blog post. Replace it with your own text for actual blog entries.</p>",
              "excerpt": "<p class='text-gray-600'>This is a sample excerpt for the blog post.</p>",
              "image": "https://images.unsplash.com/photo-1499750310107-5fef28a66643?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8YmxvZ3xlbnwwfHwwfHx8MA%3D%3D",
              "date": "2024-01-01T00:00:00.000Z",
              "readTime": "5 min",
              "category": "Sample",
              "isEnabled": true
            },
            {
              "id": "2",
              "title": "<h3 class='text-xl font-bold text-gray-900'>Sample Blog Post Two</h3>",
              "content": "<p class='text-gray-700 leading-relaxed'>Another placeholder content for a sample blog post. Use this format to display blog content in preview mode.</p>",
              "excerpt": "<p class='text-gray-600'>This is a sample excerpt for the second blog post.</p>",
              "image": "https://images.unsplash.com/photo-1488190211105-8b0e65b80b4e?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
              "date": "2024-01-02T00:00:00.000Z",
              "readTime": "3 min",
              "category": "Sample",
              "isEnabled": true
            }
          ],
          "postsPerPage": 6,
          "showCategory": true,
          "showReadTime": true,
          "showAuthor": false,
          "backgroundColor": "#ffffff",
          "textColor": "#1f2937",
          "cardBackgroundColor": "#ffffff",
          "primaryColor": "#EF4444"
        }

      },
      {
        "type": "PrimeGallery",
        "data": {
          "section": {
            "title": "Culinary Artistry",
            "subtitle": "A visual celebration of our gastronomic creations",
            "description": "Each dish is a canvas where flavors, textures, and visual beauty come together in perfect harmony."
          },
          "images": [
            {
              "id": "1",
              "url": "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=500&h=500&fit=crop",
              "title": "Elegant Presentation",
              "description": "Where artistry meets gastronomy",
              "isVisible": true
            },
            {
              "id": "2",
              "url": "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=500&h=500&fit=crop",
              "title": "Chef's Precision",
              "description": "Meticulous attention to every detail",
              "isVisible": true
            },
            {
              "id": "3",
              "url": "https://images.unsplash.com/photo-1540420773420-3366772f4999?w=500&h=500&fit=crop",
              "title": "Premium Ingredients",
              "description": "Only the finest seasonal selections",
              "isVisible": true
            },
            {
              "id": "4",
              "url": "https://images.unsplash.com/photo-1574071318508-1cdbab80d002?w=500&h=500&fit=crop",
              "title": "Sophisticated Ambiance",
              "description": "An atmosphere of refined elegance",
              "isVisible": true
            }
          ],
          "cta": {
            "text": "Follow @CulinaryJourney",
            "link": "https://instagram.com/culinaryjourney"
          }
        }

      },
      {
        "type": "PrimeEvents",
        "data": {
          "isEnabled": true,
          "section": {
            "title": "Upcoming Events",
            "subtitle": "Stay tuned for our upcoming events!",
            "primaryColor": "#EF4444",
            "secondaryColor": "#DC2626",
            "accentColor": "#B91C1C",
            "textColor": "#374151"
          },
          "items": [
            {
              "id": "event-1",
              "title": "Sample Event",
              "description": "This is a placeholder description for a sample event. Event details will be updated soon.",
              "image": "https://thumbs.dreamstime.com/b/buffet-dinner-restaurant-catering-food-concept-66884106.jpg",
              "date": "2024-01-01",
              "time": "18:00",
              "location": "Sample Venue",
              "isVisible": true
            }
          ]
        }

      },
      {
        "type": "PrimeContactForm",
        "data": {
          "title": "Contact Us",
          "subtitle": "We’d love to hear from you. This is sample text for demonstration purposes.",
          "primaryColor": "#E7000B",
          "textColor": "#1F2937",
          "backgroundColor": "#FFFFFF",
          "formBackgroundColor": "#F9FAFB",
          "cardBackgroundColor": "#FFFFFF",
          "submitButtonText": "SUBMIT",
          "successMessage": "Thank you for reaching out! This is a sample success message.",
          "errorMessage": "Oops! Something went wrong. Please try again later.",
          "contactInfo": {
            "email": {
              "title": "Email Us",
              "description": "Send us an email",
              "address": "info@sample.com"
            },
            "phone": {
              "title": "Call Us",
              "description": "Call us directly",
              "number": "(000) 000-0000"
            },
            "address": {
              "title": "Visit Us",
              "description": "Visit our office",
              "full": "123 Sample Street, Sample City, Country"
            }
          },
          "formFields": {
            "name": {
              "enabled": true,
              "required": true,
              "label": "Name",
              "placeholder": "Your Name"
            },
            "email": {
              "enabled": true,
              "required": true,
              "label": "Email",
              "placeholder": "Your Email"
            },
            "phone": {
              "enabled": true,
              "required": false,
              "label": "Phone",
              "placeholder": "Your Phone"
            },
            "message": {
              "enabled": true,
              "required": true,
              "label": "Message",
              "placeholder": "Your Message"
            }
          }
        }

      },
      {
        "type": "EssentialFooter",
        "data": {
          "restaurantName": "Sample Restaurant",
          "description": "<p>Welcome to our <strong>sample restaurant</strong>. Enjoy a delightful dining experience with <em>delicious meals</em>, friendly service, and a cozy atmosphere.</p>",
          "phone": "(000) 000-0000",
          "email": "info@samplerestaurant.com",
          "address": "123 Sample Street, Sample City, Country 00000",
          "hours": "Opening hours not available",
          "quickLinks": [
            { "id": "1", "label": "Menu", "url": "/menu" },
            { "id": "2", "label": "About Us", "url": "/about" },
            { "id": "3", "label": "Blog", "url": "/blog" },
            { "id": "4", "label": "Gallery", "url": "/gallery" },
            { "id": "5", "label": "Events", "url": "/events" },
            { "id": "6", "label": "Contact", "url": "/contact" }
          ],
          "socialLinks": [
            { "id": "1", "platform": "facebook", "url": "https://facebook.com/sample" },
            { "id": "2", "platform": "instagram", "url": "https://instagram.com/sample" },
            { "id": "3", "platform": "twitter", "url": "https://twitter.com/sample" }
          ],
          "newsletterTitle": "<h4 class=\"text-lg font-semibold\">Stay <span class=\"text-yellow-400\">Connected</span></h4>",
          "newsletterDescription": "<p>Subscribe to our newsletter for <strong>updates</strong>, <em>special offers</em>, and <strong>news</strong>.</p>",
          "showNewsletter": true,
          "copyrightText": "<p>© 2024 <strong>Sample Restaurant</strong>. All rights reserved.</p>",
          "legalLinks": [
            {
              "id": "1",
              "label": "Privacy Policy",
              "url": "/privacy",
              "content": "<p>This is a <strong>sample privacy policy</strong>. It explains how your data might be collected and used in a demo environment.</p>"
            },
            {
              "id": "2",
              "label": "Terms of Service",
              "url": "/terms",
              "content": "<p>These are <strong>sample terms of service</strong>. By using this demo, you agree to placeholder terms.</p>"
            },
            {
              "id": "3",
              "label": "Cookie Policy",
              "url": "/cookies",
              "content": "<p>This is a <strong>sample cookie policy</strong>. It describes the use of cookies in a demo context.</p>"
            }
          ],
           "backgroundColor": "#0f172a",
          "textColor": "#f1f5f9",
          "linkColor": "#f59e0b",
          "borderColor": "#EF4322"
        }

      }
    ]
  },

  casual_dining: {
    "widgets": [
      {
        "type": "PrimeNav",
        "data": {
          "logoUrl": "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=200&h=80&fit=crop",
          "logoText": "The Cozy Corner",
          "items": [
            { "id": "1", "label": "Menu", "url": "/menu", "isEnabled": true },
            { "id": "2", "label": "Our Story", "url": "/our-story", "isEnabled": true },
            { "id": "3", "label": "Blog", "url": "/blog", "isEnabled": true },
            { "id": "4", "label": "Gallery", "url": "/gallery", "isEnabled": true },
            { "id": "5", "label": "Events", "url": "/events", "isEnabled": true },
            { "id": "6", "label": "Contact", "url": "/contact", "isEnabled": true }
          ],
          "backgroundColor": "#000000",
          "textColor": "#ffffff",
          "contactInfo": "Call us: (555) COZY-123",
          "showSearchIcon": true,
          "showCartIcon": true,
          "showOrderButton": true,
          "orderButtonText": "Order Takeout",
         "orderButtonColor": "#EF4322"
        }
      },
      {
        "type": "PrimeBanner",

        "data": {
          "slides": [
            {
              "id": "slide-1",
              "title": "Sample Title One",
              "subtitle": "Sample Subtitle One",
              "description": "This is a sample description for slide one. It is placeholder text only.",
              "backgroundImage": "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/2b/25/4b/34/food-menu-assortment.jpg?w=900&h=500&s=1",
              "backgroundColor": "#333333",
              "textAlignment": "center",
              "textColor": "#ffffff",
              "overlayOpacity": 0.5,
              "overlayColor": "rgba(0,0,0,0.5)",
              "ctaButtons": [
                {
                  "id": "cta-1",
                  "text": "Sample Button One",
                  "url": "/sample-one",
                  "variant": "primary",
                  "backgroundColor": "#555555",
                  "color": "#ffffff",
                  "visible": true
                }
              ]
            },
            {
              "id": "slide-2",
              "title": "Sample Title Two",
              "subtitle": "Sample Subtitle Two",
              "description": "This is a sample description for slide two. It is placeholder text only.",
              "backgroundImage": "https://restaurantindia.s3.ap-south-1.amazonaws.com/s3fs-public/2025-02/BeFunky-collage.1%20%2824%29.jpg",
              "backgroundColor": "#444444",
              "textAlignment": "left",
              "textColor": "#ffffff",
              "overlayOpacity": 0.4,
              "overlayColor": "rgba(0,0,0,0.4)",
              "ctaButtons": [
                {
                  "id": "cta-2",
                  "text": "Sample Button Two",
                  "url": "/sample-two",
                  "variant": "secondary",
                  "backgroundColor": "#666666",
                  "color": "#ffffff",
                  "visible": true
                }
              ]
            }
          ]

        }

      },
      {
        "type": "PrimePopularItems",
        "data": {
          "content": "<h2 class=\"text-3xl md:text-4xl font-bold text-gray-900 mb-4\">Family <span class=\"text-orange-600\">Favorites</span></h2><p class=\"text-gray-600 text-lg max-w-2xl mx-auto\">The comfort food classics that keep our guests coming back for more</p>",
          "backgroundColor": "#ffffff",
          "selectedItemIds": [],
          "emptyStateContent": "<h3 class=\"text-lg sm:text-xl font-semibold mb-2\">Comfort Food Coming Soon</h3><p class=\"text-sm sm:text-base max-w-md\">Our beloved family favorites will be featured here.</p>",
          "showRating": true,
          "menuData": [{
            "pk_id": "f03c1c36-597d-4afc-ab37-3700b0f70d35",
            "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
            "restaurant_parent_id": null,
            "sku_id": "PIZ0001",
            "name": "Classic Margherita",
            "category": "Entrees",
            "supplier": "",
            "brand": "",
            "modifiers": "Classic Margherita addon,addon",
            "unit": "",
            "taxable": "",
            "external_id": "",
            "bar_code": "",
            "description": "A Margherita pizza is a classic Italian dish known for its simple yet flavorful ingredients. It typically features a thin, crisp crust topped with a vibrant tomato sauce made from fresh, ripe tomatoes. The pizza is adorned with slices of fresh mozzarella cheese that melt beautifully during baking, creating a creamy texture. Fresh basil leaves are added on top, providing a fragrant, herbal aroma and a splash of color. Often finished with a drizzle of extra virgin olive oil, the Margherita pizza embodies a harmonious balance of fresh, high-quality ingredients, highlighting the essence of traditional Italian cuisine.",
            "comment": "",
            "cost": "",
            "price": "11",
            "large_price": "11",
            "indining_price": "9",
            "indining_large_price": "11",
            "quantity": "",
            "min_quantity": "",
            "max_quantity": "",
            "countable": "",
            "use_weighing_scale": "",
            "item_type": "",
            "duration": "",
            "discounts": "",
            "resources": "",
            "service_providers": "",
            "printer_type": "",
            "deposit": "",
            "visibility": "",
            "favorite": "",
            "sort_index": "",
            "tags": "",
            "out_of_stock": "",
            "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1754577442034-generated-image-1754577438889-2.png",
            "is_enabled": true,
            "product_description": "A Margherita pizza is a classic Italian dish known for its simple yet flavorful ingredients. It typically features a thin, crisp crust topped with a vibrant tomato sauce made from fresh, ripe tomatoes. The pizza is adorned with slices of fresh mozzarella cheese that melt beautifully during baking, creating a creamy texture. Fresh basil leaves are added on top, providing a fragrant, herbal aroma and a splash of color. Often finished with a drizzle of extra virgin olive oil, the Margherita pizza embodies a harmonious balance of fresh, high-quality ingredients, highlighting the essence of traditional Italian cuisine.",
            "level1_category": "Entrees",
            "level2_category": "Vegetable Based Mains",
            "Nutrients": "Rich in calcium, protein, and antioxidants from fresh ingredients.",
            "appearance": "Golden-brown thin crust with vibrant red tomatoes, white mozzarella, and green basil leaves.",
            "ingredients": [
              "Flour",
              " tomatoes",
              " mozzarella cheese",
              " basil",
              " olive oil",
              " salt",
              " yeast"
            ],
            "serving": "Best enjoyed hot with a drizzle of olive oil or fresh basil leaves.",
            "flavors": "Fresh, Savory, Herbaceous",
            "variations": "Add extra toppings like prosciutto or chili flakes for variation.",
            "allergy_info": "Contains gluten, dairy, and basil; may affect allergies.",
            "Calories": "Approximately 250-300 kcal per slice",
            "is_vegan": "No",
            "best_combo": [],
            "is_deleted": false,
            "food_type": "Veg",
            "is_spice_applicable": "Yes",
            "meal_time": "",
            "inventory_status": true,
            "is_item_verified": true,
            "account_id": "",
            "party_orders": [
              {
                "name": "small",
                "serving": "10",
                "price": "109.90"
              },
              {
                "name": "medium",
                "serving": "25",
                "price": "274.75"
              },
              {
                "name": "large",
                "serving": "50",
                "price": "549.50"
              }
            ],
            "pos_item_id": "",
            "modifiers_list": [
              {
                "name": "Classic Margherita addon",
                "is_multi_select": "No",
                "is_forced": "Yes",
                "pk_id": "685b5545-c9cc-48e1-b99b-ce99e7a9a1e5",
                "pos_group_id": "",
                "options": [
                  {
                    "name": "Extra cheese",
                    "price": "$1.25",
                    "isEnabled": true
                  },
                  {
                    "name": "Cherry tomatoes",
                    "price": "$0.75",
                    "isEnabled": true
                  },
                  {
                    "name": "Garlic crust",
                    "price": "$1.50",
                    "isEnabled": true
                  }
                ]
              }
            ],
            "id": "f03c1c36-597d-4afc-ab37-3700b0f70d35",
            "subCategory": "Vegetable Based Mains",
            "dietary": {
              "isVegan": false
            },
            "pairings": [],
            "allergens": [
              "Contains gluten, dairy, and basil; may affect allergies."
            ]
          },
          {
            "pk_id": "70652667-0511-4dd5-9425-3a5e2dc5d5d2",
            "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
            "restaurant_parent_id": null,
            "sku_id": "PIZ0002",
            "name": "Meat Lover's Delight Pizza",
            "category": "Entrees",
            "supplier": "",
            "brand": "",
            "modifiers": "",
            "unit": "",
            "taxable": "",
            "external_id": "",
            "bar_code": "",
            "description": "Meat Lover's Delight Pizza features a crispy crust topped with a rich blend of pepperoni, sausage, ham, and bacon, baked to perfection.",
            "comment": "",
            "cost": "",
            "price": "14.99",
            "large_price": "14.99",
            "indining_price": "8",
            "indining_large_price": "14.99",
            "quantity": "",
            "min_quantity": "",
            "max_quantity": "",
            "countable": "",
            "use_weighing_scale": "",
            "item_type": "",
            "duration": "",
            "discounts": "",
            "resources": "",
            "service_providers": "",
            "printer_type": "",
            "deposit": "",
            "visibility": "",
            "favorite": "",
            "sort_index": "",
            "tags": "",
            "out_of_stock": "",
            "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749534255838-generated-image-1749534255838-1.png",
            "is_enabled": true,
            "product_description": "Meat Lover's Delight Pizza features a crispy crust topped with a rich blend of pepperoni, sausage, ham, and bacon, baked to perfection.",
            "level1_category": "Entrees",
            "level2_category": "Specialty Meat Dishes",
            "Nutrients": "High in protein and fats, moderate carbs, rich in calcium and iron.",
            "appearance": "Golden-brown crust with generous toppings of meats and melted cheese, visually hearty.",
            "ingredients": [
              "Pizza dough",
              " mozzarella cheese",
              " pepperoni",
              " sausage",
              " ham",
              " bacon",
              " tomato sauce",
              " herbs."
            ],
            "serving": "Best enjoyed hot with a side of garlic bread or salad.",
            "flavors": "Savory, smoky, cheesy, with meaty richness.",
            "variations": "Can be made with turkey or plant-based meats for alternatives.",
            "allergy_info": "Contains gluten, dairy, and meat; may cause allergies in sensitive individuals.",
            "Calories": "Approximately 300-400 kcal per slice.",
            "is_vegan": "no",
            "best_combo": {
              "best_name": "Classic Margherita",
              "best_combo": "Complements the meat flavors with a classic, mild pizza.",
              "best_combo_ids": "PIZ0001"
            },
            "is_deleted": false,
            "food_type": "non_veg",
            "is_spice_applicable": "No",
            "meal_time": "",
            "inventory_status": true,
            "is_item_verified": true,
            "account_id": "",
            "party_orders": [
              {
                "name": "small",
                "serving": "10",
                "price": "149.90"
              },
              {
                "name": "medium",
                "serving": "25",
                "price": "374.75"
              },
              {
                "name": "large",
                "serving": "49",
                "price": "749.50"
              }
            ],
            "pos_item_id": "",
            "id": "70652667-0511-4dd5-9425-3a5e2dc5d5d2",
            "subCategory": "Specialty Meat Dishes",
            "dietary": {
              "isVegan": false
            },
            "pairings": [
              "Classic Margherita"
            ],
            "allergens": [
              "Contains gluten, dairy, and meat; may cause allergies in sensitive individuals."
            ]
          },
          {
            "pk_id": "b3d1ed75-e9df-45d0-a393-fbc1109c0aaa",
            "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
            "restaurant_parent_id": null,
            "sku_id": "PIZ0003",
            "name": "Veggie Supreme ",
            "category": "Starters & Small Plates",
            "supplier": "",
            "brand": "",
            "modifiers": "Veggie Supreme addon",
            "unit": "",
            "taxable": "",
            "external_id": "",
            "bar_code": "",
            "description": "Veggie Supreme is a hearty vegetarian pizza topped with a variety of fresh vegetables and melted cheese, offering a flavorful and satisfying meal.",
            "comment": "",
            "cost": "",
            "price": "13",
            "large_price": "12.49",
            "indining_price": "1",
            "indining_large_price": "12.49",
            "quantity": "",
            "min_quantity": "",
            "max_quantity": "",
            "countable": "",
            "use_weighing_scale": "",
            "item_type": "",
            "duration": "",
            "discounts": "",
            "resources": "",
            "service_providers": "",
            "printer_type": "",
            "deposit": "",
            "visibility": "",
            "favorite": "",
            "sort_index": "",
            "tags": "",
            "out_of_stock": "",
            "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749534377844-generated-image-1749534377844-1.png",
            "is_enabled": true,
            "product_description": "Veggie Supreme is a hearty vegetarian pizza topped with a variety of fresh vegetables and melted cheese, offering a flavorful and satisfying meal.",
            "level1_category": "Starters & Small Plates",
            "level2_category": "Breads & Flatbreads",
            "Nutrients": "Rich in vitamins from vegetables and calcium from cheese.",
            "appearance": "Colorful pizza with vibrant vegetable toppings and melted cheese crust.",
            "ingredients": [
              "Tomatoes",
              " bell peppers",
              " onions",
              " olives",
              " cheese",
              " pizza dough",
              " herbs."
            ],
            "serving": "Best enjoyed hot with a side of garlic bread or salad.",
            "flavors": "Savory, cheesy, with fresh vegetable notes.",
            "variations": "Can be made vegan by substituting cheese with plant-based options.",
            "allergy_info": "Contains dairy and gluten; may cause allergies in sensitive individuals.",
            "Calories": "Approximately 250-350 kcal per slice.",
            "is_vegan": "Yes",
            "best_combo": {
              "best_name": "Classic Margherita",
              "best_combo": "Both are vegetarian options with complementary flavors.",
              "best_combo_ids": "PIZ0001"
            },
            "is_deleted": false,
            "food_type": "Veg",
            "is_spice_applicable": "Yes",
            "meal_time": "",
            "inventory_status": true,
            "is_item_verified": true,
            "account_id": "",
            "party_orders": [
              {
                "name": "small",
                "serving": "10",
                "price": "124.90"
              },
              {
                "name": "medium",
                "serving": "25",
                "price": "312.25"
              },
              {
                "name": "large",
                "serving": "50",
                "price": "624.50"
              }
            ],
            "pos_item_id": "",
            "modifiers_list": [
              {
                "name": "Veggie Supreme addon",
                "is_multi_select": "No",
                "is_forced": "Yes",
                "pk_id": "ee381bfd-d4f7-4cd7-a75c-6de41876a4eb",
                "pos_group_id": "",
                "options": [
                  {
                    "name": "Spinach",
                    "price": "$0.75",
                    "isEnabled": true
                  },
                  {
                    "name": "feta",
                    "price": "$1.50",
                    "isEnabled": true
                  },
                  {
                    "name": "pesto swirl",
                    "price": "$1.50",
                    "isEnabled": true
                  }
                ]
              }
            ],
            "id": "b3d1ed75-e9df-45d0-a393-fbc1109c0aaa",
            "subCategory": "Breads & Flatbreads",
            "dietary": {
              "isVegan": true
            },
            "pairings": [
              "Classic Margherita"
            ],
            "allergens": [
              "Contains dairy and gluten; may cause allergies in sensitive individuals."
            ]
          },
          {
            "pk_id": "3874684b-bba8-4b91-b865-91b34e951477",
            "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
            "restaurant_parent_id": null,
            "sku_id": "PIZ0004",
            "name": "Chicken Tikka Pizza",
            "category": "Starters & Small Plates",
            "supplier": "",
            "brand": "",
            "modifiers": "Chicken Tikka Pizza addon",
            "unit": "",
            "taxable": "",
            "external_id": "",
            "bar_code": "",
            "description": "Chicken Tikka Pizza features tender chicken tikka pieces atop a crispy crust, topped with cheese and spices for a flavorful experience.",
            "comment": "",
            "cost": "",
            "price": "13.49",
            "large_price": "13.49",
            "indining_price": "2",
            "indining_large_price": "13.49",
            "quantity": "",
            "min_quantity": "",
            "max_quantity": "",
            "countable": "",
            "use_weighing_scale": "",
            "item_type": "",
            "duration": "",
            "discounts": "",
            "resources": "",
            "service_providers": "",
            "printer_type": "",
            "deposit": "",
            "visibility": "",
            "favorite": "",
            "sort_index": "",
            "tags": "",
            "out_of_stock": "",
            "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749534429912-generated-image-1749534429081-3.png",
            "is_enabled": true,
            "product_description": "Chicken Tikka Pizza features tender chicken tikka pieces atop a crispy crust, topped with cheese and spices for a flavorful experience.",
            "level1_category": "Starters & Small Plates",
            "level2_category": "Appetizers / Starters",
            "Nutrients": "Rich in protein, calcium, and carbs; moderate fat content.",
            "appearance": "Golden-brown crust with chunks of chicken, melted cheese, and visible spices on top.",
            "ingredients": [
              "Pizza dough",
              " chicken tikka",
              " cheese",
              " tomato sauce",
              " spices",
              " herbs."
            ],
            "serving": "Best enjoyed hot with a side of salad or dipping sauces.",
            "flavors": "Spicy, smoky, cheesy, with hints of herbs and spices.",
            "variations": "Can be made vegetarian with paneer or vegetables, or with different spice levels.",
            "allergy_info": "Contains dairy and gluten; may cause allergies in sensitive individuals.",
            "Calories": "Approximately 300-400 kcal per slice.",
            "is_vegan": "no",
            "best_combo": {
              "best_name": "Classic Margherita, Veggie Supreme",
              "best_combo": "Complementary flavors and vegetarian options enhance Chicken Tikka Pizza.",
              "best_combo_ids": "PIZ0001"
            },
            "is_deleted": false,
            "food_type": "non_veg",
            "is_spice_applicable": "No",
            "meal_time": "",
            "inventory_status": true,
            "is_item_verified": true,
            "account_id": "",
            "party_orders": [
              {
                "name": "small",
                "serving": "10",
                "price": "134.90"
              },
              {
                "name": "medium",
                "serving": "25",
                "price": "337.25"
              },
              {
                "name": "large",
                "serving": "50",
                "price": "674.50"
              }
            ],
            "pos_item_id": "",
            "modifiers_list": [
              {
                "name": "Chicken Tikka Pizza addon",
                "is_multi_select": "No",
                "is_forced": "Yes",
                "pk_id": "c4d6c07b-000e-4f08-9bfe-07b758331b3b",
                "pos_group_id": "",
                "options": [
                  {
                    "name": "Spicy mayo",
                    "price": "$1.25",
                    "isEnabled": true
                  },
                  {
                    "name": "Coriander",
                    "price": "$0.60",
                    "isEnabled": true
                  },
                  {
                    "name": "red chili flakes",
                    "price": "$0.60",
                    "isEnabled": true
                  },
                  {
                    "name": "Garlic crust",
                    "price": "$1.25",
                    "isEnabled": true
                  }
                ]
              }
            ],
            "id": "3874684b-bba8-4b91-b865-91b34e951477",
            "subCategory": "Appetizers / Starters",
            "dietary": {
              "isVegan": false
            },
            "pairings": [
              "Classic Margherita",
              " Veggie Supreme"
            ],
            "allergens": [
              "Contains dairy and gluten; may cause allergies in sensitive individuals."
            ]
          },
          {
            "pk_id": "59d63f4e-d5e7-4dce-906b-4645a2e44a1a",
            "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
            "restaurant_parent_id": null,
            "sku_id": "PIZ0005",
            "name": "BBQ Chicken Feast Pizza",
            "category": "Entrees",
            "supplier": "",
            "brand": "",
            "modifiers": "BBQ Chicken Feast addon",
            "unit": "",
            "taxable": "",
            "external_id": "",
            "bar_code": "",
            "description": "BBQ Chicken Feast Pizza features a crispy crust topped with smoky barbecue sauce, tender chicken, cheese, and flavorful toppings, offering a hearty and savory experience.",
            "comment": "",
            "cost": "",
            "price": "13.99",
            "large_price": "13.99",
            "indining_price": "4.99",
            "indining_large_price": "13.99",
            "quantity": "",
            "min_quantity": "",
            "max_quantity": "",
            "countable": "",
            "use_weighing_scale": "",
            "item_type": "",
            "duration": "",
            "discounts": "",
            "resources": "",
            "service_providers": "",
            "printer_type": "",
            "deposit": "",
            "visibility": "",
            "favorite": "",
            "sort_index": "",
            "tags": "",
            "out_of_stock": "",
            "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749534604205-generated-image-1749534602683-3.png",
            "is_enabled": true,
            "product_description": "BBQ Chicken Feast Pizza features a crispy crust topped with smoky barbecue sauce, tender chicken, cheese, and flavorful toppings, offering a hearty and savory experience.",
            "level1_category": "Entrees",
            "level2_category": "Pizzas & Flatbreads",
            "Nutrients": "Rich in protein, calcium, and carbs; moderate fat content.",
            "appearance": "Golden-brown crust with generous toppings of chicken, cheese, and barbecue sauce.",
            "ingredients": [
              "Pizza dough",
              " BBQ sauce",
              " cooked chicken",
              " cheese",
              " onions",
              " cilantro."
            ],
            "serving": "Best enjoyed hot with a side of salad or garlic bread.",
            "flavors": "Smoky, savory, cheesy, with hints of sweetness from BBQ sauce.",
            "variations": "Can add jalapeños, bacon, or different cheeses for customization.",
            "allergy_info": "Contains gluten, dairy, and possible soy; check for allergies.",
            "Calories": "Approximately 300-400 kcal per slice.",
            "is_vegan": "no",
            "best_combo": {
              "best_name": "Meat Lover's Delight Pizza, Chicken Tikka Pizza",
              "best_combo": "Rich, meaty flavors complement BBQ Chicken Feast for a hearty meal",
              "best_combo_ids": "PIZ0002,PIZ0004"
            },
            "is_deleted": false,
            "food_type": "non_veg",
            "is_spice_applicable": "yes",
            "meal_time": "",
            "inventory_status": true,
            "is_item_verified": true,
            "account_id": "",
            "party_orders": [
              {
                "name": "small",
                "serving": "10",
                "price": "139.90"
              },
              {
                "name": "medium",
                "serving": "25",
                "price": "349.75"
              },
              {
                "name": "large",
                "serving": "50",
                "price": "699.50"
              }
            ],
            "pos_item_id": "",
            "modifiers_list": [
              {
                "name": "BBQ Chicken Feast addon",
                "is_multi_select": "No",
                "is_forced": "Yes",
                "pk_id": "07dbff2e-46e9-4079-8db7-f76ba2bd9672",
                "pos_group_id": "",
                "options": [
                  {
                    "name": "Extra BBQ drizzle",
                    "price": "$1.25",
                    "isEnabled": true
                  },
                  {
                    "name": "pineapple",
                    "price": "$0.60",
                    "isEnabled": true
                  },
                  {
                    "name": "smoked cheese",
                    "price": "$1.50",
                    "isEnabled": true
                  },
                  {
                    "name": "Bacon bits",
                    "price": "$1.75",
                    "isEnabled": true
                  }
                ]
              }
            ],
            "id": "59d63f4e-d5e7-4dce-906b-4645a2e44a1a",
            "subCategory": "Pizzas & Flatbreads",
            "dietary": {
              "isVegan": false
            },
            "pairings": [
              "Meat Lover's Delight Pizza",
              " Chicken Tikka Pizza"
            ],
            "allergens": [
              "Contains gluten, dairy, and possible soy; check for allergies."
            ]
          },
          {
            "pk_id": "4f60847b-b066-4754-81c8-330f11095786",
            "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
            "restaurant_parent_id": null,
            "sku_id": "PIZ0007",
            "name": "Hawaiian Classic Pizza",
            "category": "Entrees",
            "supplier": "",
            "brand": "",
            "modifiers": "Hawaiian Classic addon",
            "unit": "",
            "taxable": "",
            "external_id": "",
            "bar_code": "",
            "description": "Hawaiian Classic Pizza features a crispy crust topped with tomato sauce, cheese, ham, and pineapple chunks, offering a sweet and savory flavor profile.",
            "comment": "",
            "cost": "",
            "price": "12.49",
            "large_price": "12.49",
            "indining_price": "12.49",
            "indining_large_price": "12.49",
            "quantity": "",
            "min_quantity": "",
            "max_quantity": "",
            "countable": "",
            "use_weighing_scale": "",
            "item_type": "",
            "duration": "",
            "discounts": "",
            "resources": "",
            "service_providers": "",
            "printer_type": "",
            "deposit": "",
            "visibility": "",
            "favorite": "",
            "sort_index": "",
            "tags": "",
            "out_of_stock": "",
            "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749534761684-generated-image-1749534760104-4.png",
            "is_enabled": true,
            "product_description": "Hawaiian Classic Pizza features a crispy crust topped with tomato sauce, cheese, ham, and pineapple chunks, offering a sweet and savory flavor profile.",
            "level1_category": "Entrees",
            "level2_category": "Pizzas & Flatbreads",
            "Nutrients": "Provides carbs, protein, calcium, and vitamins from toppings.",
            "appearance": "Golden-brown crust with melted cheese, ham slices, and pineapple pieces on top.",
            "ingredients": [
              "Pizza dough",
              " tomato sauce",
              " mozzarella cheese",
              " ham",
              " pineapple",
              " olive oil",
              " herbs."
            ],
            "serving": "Best enjoyed hot with a side of garlic bread or salad.",
            "flavors": "Sweet, savory, cheesy, with a hint of tang from pineapple.",
            "variations": "Can add bacon, jalapeños, or substitute ham with turkey.",
            "allergy_info": "Contains dairy, gluten, and possibly soy; check for allergies.",
            "Calories": "Approximately 250-350 kcal per slice.",
            "is_vegan": "no",
            "best_combo": {
              "best_name": "Meat Lover's Delight Pizza, BBQ Chicken Feast Pizza",
              "best_combo": "Rich, savory flavors complement the sweet and savory Hawaiian pizza",
              "best_combo_ids": "PIZ0002,PIZ0005"
            },
            "is_deleted": false,
            "food_type": "non_veg",
            "is_spice_applicable": "no",
            "meal_time": "",
            "inventory_status": true,
            "is_item_verified": true,
            "account_id": "",
            "party_orders": [
              {
                "name": "small",
                "serving": "10",
                "price": "124.90"
              },
              {
                "name": "medium",
                "serving": "25",
                "price": "312.25"
              },
              {
                "name": "large",
                "serving": "50",
                "price": "624.50"
              }
            ],
            "pos_item_id": "",
            "modifiers_list": [
              {
                "name": "Hawaiian Classic addon",
                "is_multi_select": "No",
                "is_forced": "Yes",
                "pk_id": "840bed41-05ef-47c8-bca9-41c264ae37d9",
                "pos_group_id": "",
                "options": [
                  {
                    "name": "Bacon",
                    "price": "$1.75",
                    "isEnabled": true
                  },
                  {
                    "name": "red onions",
                    "price": "$0.60",
                    "isEnabled": true
                  },
                  {
                    "name": "sweet chili drizzle",
                    "price": "$0.60",
                    "isEnabled": true
                  },
                  {
                    "name": "spicy crust",
                    "price": "$1.25",
                    "isEnabled": true
                  }
                ]
              }
            ],
            "id": "4f60847b-b066-4754-81c8-330f11095786",
            "subCategory": "Pizzas & Flatbreads",
            "dietary": {
              "isVegan": false
            },
            "pairings": [
              "Meat Lover's Delight Pizza",
              " BBQ Chicken Feast Pizza"
            ],
            "allergens": [
              "Contains dairy, gluten, and possibly soy; check for allergies."
            ]
          },
          {
            "pk_id": "173e050c-de20-48d6-8f00-f6f4999601ec",
            "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
            "restaurant_parent_id": null,
            "sku_id": "PIZ0008",
            "name": "Spicy Veggie Volcano",
            "category": "Entrees",
            "supplier": "",
            "brand": "",
            "modifiers": "Spicy Veggie Volcano addon",
            "unit": "",
            "taxable": "",
            "external_id": "",
            "bar_code": "",
            "description": "Spicy Veggie Volcano is a vibrant, spicy dish featuring a medley of fresh vegetables topped with a fiery sauce, served hot and visually striking.",
            "comment": "",
            "cost": "",
            "price": "12.99",
            "large_price": "12.99",
            "indining_price": "12.99",
            "indining_large_price": "12.99",
            "quantity": "",
            "min_quantity": "",
            "max_quantity": "",
            "countable": "",
            "use_weighing_scale": "",
            "item_type": "",
            "duration": "",
            "discounts": "",
            "resources": "",
            "service_providers": "",
            "printer_type": "",
            "deposit": "",
            "visibility": "",
            "favorite": "",
            "sort_index": "",
            "tags": "",
            "out_of_stock": "",
            "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749534852285-generated-image-1749534851526-3.png",
            "is_enabled": true,
            "product_description": "Spicy Veggie Volcano is a vibrant, spicy dish featuring a medley of fresh vegetables topped with a fiery sauce, served hot and visually striking.",
            "level1_category": "Entrees",
            "level2_category": "Vegetable Based Mains",
            "Nutrients": "Rich in vitamins, antioxidants, and dietary fiber from vegetables.",
            "appearance": "Colorful vegetable medley topped with a bright red spicy sauce, resembling a volcano eruption.",
            "ingredients": [
              "Mixed vegetables",
              " chili sauce",
              " garlic",
              " soy sauce",
              " spices",
              " oil"
            ],
            "serving": "Best enjoyed with steamed rice or flatbreads for a complete meal.",
            "flavors": "Spicy, Savory, Umami with a hint of sweetness",
            "variations": "Adjust spice level, add tofu or mushrooms for variation",
            "allergy_info": "Contains soy and chili; may affect those with soy or chili allergies.",
            "Calories": "Approximately 150-200 kcal per serving",
            "is_vegan": "yes",
            "best_combo": {
              "best_name": "Veggie Supreme",
              "best_combo": "Complements the spicy veggie flavor with a hearty veggie option",
              "best_combo_ids": ""
            },
            "is_deleted": false,
            "food_type": "vegan",
            "is_spice_applicable": "yes",
            "meal_time": "",
            "inventory_status": true,
            "is_item_verified": true,
            "account_id": "",
            "party_orders": [
              {
                "name": "small",
                "serving": "10",
                "price": "129.90"
              },
              {
                "name": "medium",
                "serving": "25",
                "price": "324.75"
              },
              {
                "name": "large",
                "serving": "49",
                "price": "649.50"
              }
            ],
            "pos_item_id": "",
            "modifiers_list": [
              {
                "name": "Spicy Veggie Volcano addon",
                "is_multi_select": "Yes",
                "is_forced": "No",
                "pk_id": "7a4a7fc7-af5e-4cb3-9ec8-64f446905edd",
                "pos_group_id": "",
                "options": [
                  {
                    "name": "Paneer cubes",
                    "price": "$1.50",
                    "isEnabled": true
                  },
                  {
                    "name": "Extra chili",
                    "price": "$0.99",
                    "isEnabled": true
                  },
                  {
                    "name": "Hot sauce swirl",
                    "price": "$1.50",
                    "isEnabled": true
                  },
                  {
                    "name": "Sesame crust",
                    "price": "$1.75",
                    "isEnabled": true
                  },
                  {
                    "name": "chicken toast",
                    "price": "$1",
                    "isEnabled": true
                  }
                ]
              }
            ],
            "id": "173e050c-de20-48d6-8f00-f6f4999601ec",
            "subCategory": "Vegetable Based Mains",
            "dietary": {
              "isVegan": true
            },
            "pairings": [
              "Veggie Supreme"
            ],
            "allergens": [
              "Contains soy and chili; may affect those with soy or chili allergies."
            ]
          },
          {
            "pk_id": "e7f3210a-5564-4b08-9bfd-283ff68eedb2",
            "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
            "restaurant_parent_id": null,
            "sku_id": "PIZ0010",
            "name": "Philly Steak Pizza",
            "category": "Entrees",
            "supplier": "",
            "brand": "",
            "modifiers": "Philly Steak Pizza addon",
            "unit": "",
            "taxable": "",
            "external_id": "",
            "bar_code": "",
            "description": "Philly Steak Pizza features tender sliced steak, melted cheese, and savory toppings on a crispy crust, blending Italian and American flavors.",
            "comment": "",
            "cost": "",
            "price": "14.99",
            "large_price": "14.99",
            "indining_price": "14.99",
            "indining_large_price": "14.99",
            "quantity": "",
            "min_quantity": "",
            "max_quantity": "",
            "countable": "",
            "use_weighing_scale": "",
            "item_type": "",
            "duration": "",
            "discounts": "",
            "resources": "",
            "service_providers": "",
            "printer_type": "",
            "deposit": "",
            "visibility": "",
            "favorite": "",
            "sort_index": "",
            "tags": "",
            "out_of_stock": "",
            "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749535594783-generated-image-1749535586777-4.png",
            "is_enabled": true,
            "product_description": "Philly Steak Pizza features tender sliced steak, melted cheese, and savory toppings on a crispy crust, blending Italian and American flavors.",
            "level1_category": "Entrees",
            "level2_category": "Noodles & Pasta",
            "Nutrients": "Rich in protein, calcium, and carbohydrates for energy and muscle repair.",
            "appearance": "Golden-brown crust topped with melted cheese, sliced steak, and vegetables.",
            "ingredients": [
              "Sliced steak",
              " mozzarella cheese",
              " pizza dough",
              " bell peppers",
              " onions",
              " tomato sauce."
            ],
            "serving": "Best enjoyed hot with a side of garlic bread or salad.",
            "flavors": "Savory, cheesy, meaty, with hints of smoky spices.",
            "variations": "Can add mushrooms, jalapeños, or substitute steak with chicken or plant-based options.",
            "allergy_info": "Contains dairy and gluten; may contain traces of soy or nuts.",
            "Calories": "Approximately 800-1000 kcal per slice.",
            "is_vegan": "no",
            "best_combo": {
              "best_name": "Meat Lover's Delight Pizza,BBQ Chicken Feast Pizza",
              "best_combo": "Rich, meaty flavors complement the hearty Philly Steak Pizza well",
              "best_combo_ids": "PIZ0002,PIZ0005"
            },
            "is_deleted": false,
            "food_type": "non_veg",
            "is_spice_applicable": "yes",
            "meal_time": "",
            "inventory_status": true,
            "is_item_verified": true,
            "account_id": "",
            "party_orders": [
              {
                "name": "small",
                "serving": "10",
                "price": "149.90"
              },
              {
                "name": "medium",
                "serving": "25",
                "price": "374.75"
              },
              {
                "name": "large",
                "serving": "50",
                "price": "749.50"
              }
            ],
            "pos_item_id": "",
            "modifiers_list": [
              {
                "name": "Philly Steak Pizza addon",
                "is_multi_select": "No",
                "is_forced": "Yes",
                "pk_id": "989bf89f-91b4-49fa-851f-a85d585046c5",
                "pos_group_id": "",
                "options": [
                  {
                    "name": "Blue cheese",
                    "price": "$1.25",
                    "isEnabled": true
                  },
                  {
                    "name": "Extra steak",
                    "price": "$2.25",
                    "isEnabled": true
                  },
                  {
                    "name": "BBQ swirl",
                    "price": "$0.99",
                    "isEnabled": true
                  },
                  {
                    "name": "Cheesy crust",
                    "price": "$2",
                    "isEnabled": true
                  }
                ]
              }
            ],
            "id": "e7f3210a-5564-4b08-9bfd-283ff68eedb2",
            "subCategory": "Noodles & Pasta",
            "dietary": {
              "isVegan": false
            },
            "pairings": [
              "Meat Lover's Delight Pizza",
              "BBQ Chicken Feast Pizza"
            ],
            "allergens": [
              "Contains dairy and gluten; may contain traces of soy or nuts."
            ]
          },
          {
            "pk_id": "ac33445d-18ae-4be2-942a-b0e65c7b44a4",
            "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
            "restaurant_parent_id": null,
            "sku_id": "PIZ0014",
            "name": "Truffle Mushroom Delight Pizza",
            "category": "Starters & Small Plates",
            "supplier": "",
            "brand": "",
            "modifiers": "Truffle Mushroom Delight addon",
            "unit": "",
            "taxable": "",
            "external_id": "",
            "bar_code": "",
            "description": "A gourmet pizza topped with savory mushrooms and aromatic truffle oil, offering a rich, earthy flavor in a crispy crust.",
            "comment": "",
            "cost": "",
            "price": "14.49",
            "large_price": "14.49",
            "indining_price": "14.49",
            "indining_large_price": "14.49",
            "quantity": "",
            "min_quantity": "",
            "max_quantity": "",
            "countable": "",
            "use_weighing_scale": "",
            "item_type": "",
            "duration": "",
            "discounts": "",
            "resources": "",
            "service_providers": "",
            "printer_type": "",
            "deposit": "",
            "visibility": "",
            "favorite": "",
            "sort_index": "",
            "tags": "",
            "out_of_stock": "",
            "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749536724052-generated-image-1749536723486-2.png",
            "is_enabled": true,
            "product_description": "A gourmet pizza topped with savory mushrooms and aromatic truffle oil, offering a rich, earthy flavor in a crispy crust.",
            "level1_category": "Starters & Small Plates",
            "level2_category": "Breads & Flatbreads",
            "Nutrients": "Rich in antioxidants from mushrooms and healthy fats from truffle oil.",
            "appearance": "Golden-brown crust with melted cheese, sliced mushrooms, and drizzled truffle oil on top.",
            "ingredients": [
              "Pizza dough",
              " mushrooms",
              " truffle oil",
              " cheese",
              " garlic",
              " herbs",
              " olive oil."
            ],
            "serving": "Best enjoyed hot with a side of mixed greens or a light salad.",
            "flavors": "Earthy, umami, aromatic, slightly cheesy.",
            "variations": "Vegan version with plant-based cheese, or add prosciutto for non-veg.",
            "allergy_info": "Contains dairy and mushrooms; may cause allergies in sensitive individuals.",
            "Calories": "Approximately 300-400 kcal per slice.",
            "is_vegan": "no",
            "best_combo": {
              "best_name": "Veggie Supreme, Mediterranean Veggie, Spicy Veggie Volcano",
              "best_combo": "Complementary veggie flavors enhance the mushroom truffle profile.",
              "best_combo_ids": "PIZ0011,PIZ0008"
            },
            "is_deleted": false,
            "food_type": "non_veg",
            "is_spice_applicable": "no",
            "meal_time": "",
            "inventory_status": true,
            "is_item_verified": true,
            "account_id": "",
            "party_orders": [
              {
                "name": "small",
                "serving": "10",
                "price": "144.90"
              },
              {
                "name": "medium",
                "serving": "25",
                "price": "362.25"
              },
              {
                "name": "large",
                "serving": "50",
                "price": "724.50"
              }
            ],
            "pos_item_id": "",
            "modifiers_list": [
              {
                "name": "Truffle Mushroom Delight addon",
                "is_multi_select": "No",
                "is_forced": "Yes",
                "pk_id": "c95a1603-adc7-43da-9b05-c549a3e964c2",
                "pos_group_id": "",
                "options": [
                  {
                    "name": "Caramelized onions",
                    "price": "$0.99",
                    "isEnabled": true
                  },
                  {
                    "name": "Goat cheese",
                    "price": "$1.50",
                    "isEnabled": true
                  },
                  {
                    "name": "Garlic crust",
                    "price": "$1.25",
                    "isEnabled": true
                  },
                  {
                    "name": "pine nuts",
                    "price": "$0.99",
                    "isEnabled": true
                  }
                ]
              }
            ],
            "id": "ac33445d-18ae-4be2-942a-b0e65c7b44a4",
            "subCategory": "Breads & Flatbreads",
            "dietary": {
              "isVegan": false
            },
            "pairings": [
              "Veggie Supreme",
              " Mediterranean Veggie",
              " Spicy Veggie Volcano"
            ],
            "allergens": [
              "Contains dairy and mushrooms; may cause allergies in sensitive individuals."
            ]
          },
          {
            "pk_id": "02d9711e-2365-476c-9174-2ba463aa3636",
            "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
            "restaurant_parent_id": null,
            "sku_id": "PIZ0015",
            "name": "Loaded Paneer Paradise Pizza",
            "category": "Starters & Small Plates",
            "supplier": "",
            "brand": "",
            "modifiers": "Loaded Paneer Paradise",
            "unit": "",
            "taxable": "",
            "external_id": "",
            "bar_code": "",
            "description": "Loaded Paneer Paradise Pizza features a crispy crust topped with spiced paneer, fresh vegetables, and melted cheese, offering a flavorful vegetarian delight.",
            "comment": "",
            "cost": "",
            "price": "13.99",
            "large_price": "13.99",
            "indining_price": "13.99",
            "indining_large_price": "13.99",
            "quantity": "",
            "min_quantity": "",
            "max_quantity": "",
            "countable": "",
            "use_weighing_scale": "",
            "item_type": "",
            "duration": "",
            "discounts": "",
            "resources": "",
            "service_providers": "",
            "printer_type": "",
            "deposit": "",
            "visibility": "",
            "favorite": "",
            "sort_index": "",
            "tags": "",
            "out_of_stock": "",
            "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749536855344-generated-image-1749536854924-2.png",
            "is_enabled": true,
            "product_description": "Loaded Paneer Paradise Pizza features a crispy crust topped with spiced paneer, fresh vegetables, and melted cheese, offering a flavorful vegetarian delight.",
            "level1_category": "Starters & Small Plates",
            "level2_category": "Breads & Flatbreads",
            "Nutrients": "Rich in protein from paneer, calcium, vitamins from vegetables",
            "appearance": "Golden-brown crust with colorful toppings and melted cheese, garnished with herbs.",
            "ingredients": [
              "Paneer",
              " cheese",
              " bell peppers",
              " onions",
              " tomato sauce",
              " spices",
              " herbs",
              " dough"
            ],
            "serving": "Best enjoyed hot with a side of green chutney or salad.",
            "flavors": "Savory, cheesy, mildly spicy with aromatic herbs",
            "variations": "Vegan cheese, gluten-free crust, extra vegetables",
            "allergy_info": "Contains dairy and gluten; may cause allergies in sensitive individuals.",
            "Calories": "Approximately 300-400 kcal per slice",
            "is_vegan": "no",
            "best_combo": {
              "best_name": "Veggie Supreme, Mediterranean Veggie, Spicy Veggie Volcano",
              "best_combo": "Complementary veggie flavors enhance the paneer pizza experience.",
              "best_combo_ids": "PIZ0011,PIZ0008"
            },
            "is_deleted": false,
            "food_type": "veg",
            "is_spice_applicable": "yes",
            "meal_time": "",
            "inventory_status": true,
            "is_item_verified": true,
            "account_id": "",
            "party_orders": [
              {
                "name": "small",
                "serving": "10",
                "price": "139.90"
              },
              {
                "name": "medium",
                "serving": "25",
                "price": "349.75"
              },
              {
                "name": "large",
                "serving": "50",
                "price": "699.50"
              }
            ],
            "pos_item_id": "",
            "modifiers_list": [
              {
                "name": "Loaded Paneer Paradise",
                "is_multi_select": "No",
                "is_forced": "Yes",
                "pk_id": "efcadd5a-5cf5-4645-a387-5a6323981e1c",
                "pos_group_id": "",
                "options": [
                  {
                    "name": "Mint mayo swirl",
                    "price": "$0.99",
                    "isEnabled": true
                  },
                  {
                    "name": "Extra paneer",
                    "price": "$1.75",
                    "isEnabled": true
                  },
                  {
                    "name": "Tikka crust",
                    "price": "$1.50",
                    "isEnabled": true
                  },
                  {
                    "name": "Chili flakes",
                    "price": "$0.99",
                    "isEnabled": true
                  }
                ]
              }
            ],
            "id": "02d9711e-2365-476c-9174-2ba463aa3636",
            "subCategory": "Breads & Flatbreads",
            "dietary": {
              "isVegan": false
            },
            "pairings": [
              "Veggie Supreme",
              " Mediterranean Veggie",
              " Spicy Veggie Volcano"
            ],
            "allergens": [
              "Contains dairy and gluten; may cause allergies in sensitive individuals."
            ]
          }]
        }
      },
      {
        "type": "PrimeCombo",
        "data": {
          "content": "<h2 class=\"text-3xl md:text-4xl font-bold text-gray-900 mb-4\">Family <span class=\"text-orange-600\">Meal Deals</span></h2><p class=\"text-gray-600 text-lg max-w-2xl mx-auto\">Perfect portions for sharing around the table - because the best meals bring people together</p>",
          "backgroundColor": "#fef5e7",
          "emptyStateContent": "<h3 class=\"text-lg sm:text-xl font-semibold mb-2\">Family Meals Coming Soon</h3><p class=\"text-sm sm:text-base max-w-md\">Great value family meal combinations will be available here.</p>",
          "combos": [{
            "combo_id": "96f8cdcb-e7dd-4355-9178-5652f6d82f84",
            "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
            "title": "Party Time Pack",
            "description": "A delightful mix of classic, flavorful, and satisfying dishes including pizzas, sides, beverages, and desserts, perfect for celebrating with friends and family in a lively, delicious party setting.",
            "products": [
              {
                "pk_id": "dcbe286c-43c2-4f27-b9aa-8a339344f0c7",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0016",
                "name": "Buffalo Chicken Blast Pizza",
                "category": "Starters & Small Plates",
                "supplier": "",
                "brand": "",
                "modifiers": "Buffalo Chicken Blast addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Buffalo Chicken Blast Pizza features a crispy crust topped with spicy buffalo sauce, tender chicken, and melty cheese, offering a bold flavor experience.",
                "comment": "",
                "cost": "",
                "price": "13.49",
                "large_price": "13.49",
                "indining_price": "13.49",
                "indining_large_price": "13.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749536945765-generated-image-1749536944781-3.png",
                "is_enabled": "true",
                "product_description": "Buffalo Chicken Blast Pizza features a crispy crust topped with spicy buffalo sauce, tender chicken, and melty cheese, offering a bold flavor experience.",
                "level1_category": "Starters & Small Plates",
                "level2_category": "Appetizers / Starters",
                "Nutrients": "Rich in protein and calcium, moderate in fats and carbs.",
                "appearance": "Golden-brown crust with vibrant red buffalo sauce, chicken pieces, and melted cheese topping.",
                "ingredients": "Pizza dough, chicken, buffalo sauce, cheese, blue cheese, celery, ranch dressing",
                "serving": "Best enjoyed hot with a side of celery sticks or ranch dressing.",
                "flavors": "Spicy, tangy, cheesy, savory",
                "variations": "Can be made with plant-based chicken or less spicy sauce.",
                "allergy_info": "Contains dairy, gluten, and possible soy; may cause allergies in sensitive individuals.",
                "Calories": "Approximately 300-400 kcal per slice",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Meat Lover's Delight Pizza,BBQ Chicken Feast Pizza,Spicy Veggie Volcano\",\"best_combo\":\"Enhances spicy and meaty flavors, creating a bold, satisfying combo.\",\"best_combo_ids\":\"PIZ0002,PIZ0005,PIZ0008\"}",
                "is_deleted": "false",
                "food_type": "non_veg",
                "is_spice_applicable": "yes",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "ee2aa8fb-01ae-4cdc-8824-843577ea49cd",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0022",
                "name": "Potato Wedges",
                "category": "Sides & Accompaniments",
                "supplier": "",
                "brand": "",
                "modifiers": "Potato Wedges addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Crispy potato wedges are thick-cut potatoes seasoned and baked or fried until golden and crunchy, perfect as a snack or side.",
                "comment": "",
                "cost": "",
                "price": "4.99",
                "large_price": "4.99",
                "indining_price": "4.99",
                "indining_large_price": "4.99",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749538548266-generated-image-1749538548266-1.png",
                "is_enabled": "true",
                "product_description": "Crispy potato wedges are thick-cut potatoes seasoned and baked or fried until golden and crunchy, perfect as a snack or side.",
                "level1_category": "Sides & Accompaniments",
                "level2_category": "Side Dishes",
                "Nutrients": "Rich in carbohydrates and vitamin C, moderate in fiber.",
                "appearance": "Golden-brown, wedge-shaped potatoes with a crispy exterior and fluffy interior.",
                "ingredients": "Potatoes, Olive oil, Salt, Pepper, Paprika, Garlic powder, Herbs",
                "serving": "Best enjoyed with ketchup, aioli, or spicy dips.",
                "flavors": "Savory, Crispy, Slightly smoky with hints of herbs.",
                "variations": "Can be seasoned with cheese, chili, or served with different dips.",
                "allergy_info": "Contains potatoes; check for cross-contamination with gluten or dairy if applicable.",
                "Calories": "Approximately 150-250 kcal per serving",
                "is_vegan": "yes",
                "best_combo": "{\"best_name\":\"Garlic Bread Supreme, Chicken Wings (6 pcs)\",\"best_combo\":\"Perfect sides with potato wedges for added flavor and variety.\",\"best_combo_ids\":\"PIZ0021\"}",
                "is_deleted": "false",
                "food_type": "veg",
                "is_spice_applicable": "yes",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "bdd585f1-40bf-43f4-adad-9e212ca583fa",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0027",
                "name": "Choco Cold Coffee",
                "category": "Beverages",
                "supplier": "",
                "brand": "",
                "modifiers": "Choco Cold Coffee addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Choco Cold Coffee is a refreshing beverage blending rich coffee, chocolate syrup, milk, and ice for a sweet, chilled drink.",
                "comment": "",
                "cost": "",
                "price": "4.49",
                "large_price": "4.49",
                "indining_price": "4.49",
                "indining_large_price": "4.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749538880748-generated-image-1749538880345-2.png",
                "is_enabled": "true",
                "product_description": "Choco Cold Coffee is a refreshing beverage blending rich coffee, chocolate syrup, milk, and ice for a sweet, chilled drink.",
                "level1_category": "Beverages",
                "level2_category": "Beverages",
                "Nutrients": "Provides energy from caffeine, sugars, and calcium from milk.",
                "appearance": "Dark brown coffee with a frothy top, topped with chocolate shavings or whipped cream.",
                "ingredients": "Coffee, chocolate syrup, milk, ice, sugar, whipped cream (optional).",
                "serving": "Best enjoyed chilled in a tall glass with a straw.",
                "flavors": "Rich chocolate, bold coffee, sweet and creamy.",
                "variations": "Can add whipped cream, chocolate chips, or caramel drizzle.",
                "allergy_info": "Contains dairy and caffeine; may affect lactose intolerant or sensitive individuals.",
                "Calories": "Approximately 150-250 kcal per serving.",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Garlic Bread Supreme, Chicken Wings (6 pcs), Potato Wedges\",\"best_combo\":\"Savory sides and wings complement the sweet, rich flavor of Choco Cold Coffee.\",\"best_combo_ids\":\"PIZ0021,PIZ0022\"}",
                "is_deleted": "false",
                "food_type": "non_veg",
                "is_spice_applicable": "no",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "d71ea6a1-cb05-4449-8495-a7fa492b6f82",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0028",
                "name": "Choco Lava Cake",
                "category": "Desserts & Sweets",
                "supplier": "",
                "brand": "",
                "modifiers": "Choco Lava Cake addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Choco Lava Cake is a rich, warm chocolate dessert with a gooey, molten center that oozes out when cut, offering a decadent treat.",
                "comment": "",
                "cost": "",
                "price": "4.99",
                "large_price": "4.99",
                "indining_price": "4.99",
                "indining_large_price": "4.99",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749538934939-generated-image-1749538934939-1.png",
                "is_enabled": "true",
                "product_description": "Choco Lava Cake is a rich, warm chocolate dessert with a gooey, molten center that oozes out when cut, offering a decadent treat.",
                "level1_category": "Desserts & Sweets",
                "level2_category": "Pastries & Cakes",
                "Nutrients": "Rich in calories and fats, provides energy and mood-boosting compounds.",
                "appearance": "Small, round cake with a slightly cracked top and a flowing chocolate center.",
                "ingredients": "Chocolate, Butter, Eggs, Sugar, Flour, Cocoa powder, Vanilla extract",
                "serving": "Best enjoyed warm with vanilla ice cream or whipped cream.",
                "flavors": "Intensely chocolatey, Sweet, Slightly bitter from cocoa",
                "variations": "Can be made dairy-free, gluten-free, or with added nuts or caramel",
                "allergy_info": "Contains dairy, eggs, and gluten; may cause allergies in sensitive individuals.",
                "Calories": "Approximately 350-450 kcal per serving",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Classic Cheeseburger Pizza, Garlic Bread Supreme, Classic Coke\",\"best_combo\":\"Savory and crunchy sides with a refreshing drink complement the sweet, rich Choco Lava Cake.\",\"best_combo_ids\":\"PIZ0025\"}",
                "is_deleted": "false",
                "food_type": "non_veg",
                "is_spice_applicable": "no",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "d3f3a400-9e90-4098-a991-33969ff1b6ea",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0030",
                "name": "Cinnamon Breadsticks",
                "category": "Starters & Small Plates",
                "supplier": "",
                "brand": "",
                "modifiers": "Cinnamon Breadsticks aadon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Cinnamon Breadsticks are soft, warm breadsticks coated with cinnamon sugar, offering a sweet and aromatic treat.",
                "comment": "",
                "cost": "",
                "price": "4.49",
                "large_price": "4.49",
                "indining_price": "4.49",
                "indining_large_price": "4.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749539017225-generated-image-1749539016801-2.png",
                "is_enabled": "true",
                "product_description": "Cinnamon Breadsticks are soft, warm breadsticks coated with cinnamon sugar, offering a sweet and aromatic treat.",
                "level1_category": "Starters & Small Plates",
                "level2_category": "Breads & Flatbreads",
                "Nutrients": "Provides carbohydrates, fats, and some protein.",
                "appearance": "Golden-brown breadsticks topped with cinnamon sugar, slightly glossy surface.",
                "ingredients": "Flour, yeast, butter, cinnamon, sugar, salt, milk, eggs.",
                "serving": "Best enjoyed warm with coffee or hot chocolate.",
                "flavors": "Sweet, spicy cinnamon, buttery notes.",
                "variations": "Can add icing or nuts for extra flavor.",
                "allergy_info": "Contains gluten, dairy, and eggs; may cause allergies.",
                "Calories": "Approximately 150-200 kcal per breadstick.",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Garlic Bread Supreme, Chicken Wings (6 pcs), Potato Wedges\",\"best_combo\":\"Rich, savory sides enhance the sweetness of cinnamon breadsticks.\",\"best_combo_ids\":\"PIZ0021,PIZ0022\"}",
                "is_deleted": "false",
                "food_type": "non_veg",
                "is_spice_applicable": "yes",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "ac33445d-18ae-4be2-942a-b0e65c7b44a4",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0014",
                "name": "Truffle Mushroom Delight Pizza",
                "category": "Starters & Small Plates",
                "supplier": "",
                "brand": "",
                "modifiers": "Truffle Mushroom Delight addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "A gourmet pizza topped with savory mushrooms and aromatic truffle oil, offering a rich, earthy flavor in a crispy crust.",
                "comment": "",
                "cost": "",
                "price": "14.49",
                "large_price": "14.49",
                "indining_price": "14.49",
                "indining_large_price": "14.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749536724052-generated-image-1749536723486-2.png",
                "is_enabled": "true",
                "product_description": "A gourmet pizza topped with savory mushrooms and aromatic truffle oil, offering a rich, earthy flavor in a crispy crust.",
                "level1_category": "Starters & Small Plates",
                "level2_category": "Breads & Flatbreads",
                "Nutrients": "Rich in antioxidants from mushrooms and healthy fats from truffle oil.",
                "appearance": "Golden-brown crust with melted cheese, sliced mushrooms, and drizzled truffle oil on top.",
                "ingredients": "Pizza dough, mushrooms, truffle oil, cheese, garlic, herbs, olive oil.",
                "serving": "Best enjoyed hot with a side of mixed greens or a light salad.",
                "flavors": "Earthy, umami, aromatic, slightly cheesy.",
                "variations": "Vegan version with plant-based cheese, or add prosciutto for non-veg.",
                "allergy_info": "Contains dairy and mushrooms; may cause allergies in sensitive individuals.",
                "Calories": "Approximately 300-400 kcal per slice.",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Veggie Supreme, Mediterranean Veggie, Spicy Veggie Volcano\",\"best_combo\":\"Complementary veggie flavors enhance the mushroom truffle profile.\",\"best_combo_ids\":\"PIZ0011,PIZ0008\"}",
                "is_deleted": "false",
                "food_type": "non_veg",
                "is_spice_applicable": "no",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "c8dee61d-9d99-407d-85c8-a2ebe87e9a14",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0006",
                "name": "Pepperoni Passion ",
                "category": "Starters & Small Plates",
                "supplier": "",
                "brand": "",
                "modifiers": "Pepperoni Passion addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Pepperoni Passion is a classic pizza topped with spicy pepperoni slices, melted cheese, and savory tomato sauce, offering a flavorful and satisfying experience.",
                "comment": "",
                "cost": "",
                "price": "12.99",
                "large_price": "12.99",
                "indining_price": "12.99",
                "indining_large_price": "12.99",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749534684345-generated-image-1749534684345-1.png",
                "is_enabled": "true",
                "product_description": "Pepperoni Passion is a classic pizza topped with spicy pepperoni slices, melted cheese, and savory tomato sauce, offering a flavorful and satisfying experience.",
                "level1_category": "Starters & Small Plates",
                "level2_category": "Appetizers / Starters",
                "Nutrients": "Rich in protein, calcium, and fats from cheese and meat toppings.",
                "appearance": "Golden-brown crust topped with vibrant red pepperoni slices and melted cheese.",
                "ingredients": "Dough, tomato sauce, mozzarella cheese, pepperoni slices, herbs.",
                "serving": "Best enjoyed hot with a side of garlic bread or salad.",
                "flavors": "Savory, spicy, cheesy, and slightly smoky.",
                "variations": "Can be made with different cheeses or vegetarian toppings.",
                "allergy_info": "Contains gluten, dairy, and processed meats; may cause allergies in sensitive individuals.",
                "Calories": "Approximately 300-400 kcal per slice.",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Meat Lover's Delight Pizza, BBQ Chicken Feast Pizza\",\"best_combo\":\"Rich, meaty flavors complement Pepperoni Passion well\",\"best_combo_ids\":\"PIZ0002,PIZ0005\"}",
                "is_deleted": "false",
                "food_type": "non_veg",
                "is_spice_applicable": "yes",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "fd637abf-0dc6-4253-b172-014f43c225cc",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0020",
                "name": " Garlic Bread Supreme",
                "category": "Starters & Small Plates",
                "supplier": "",
                "brand": "",
                "modifiers": "Garlic Bread Supreme addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Garlic Bread Supreme features toasted bread topped with garlic, herbs, melted cheese, and optional toppings for a flavorful appetizer.",
                "comment": "",
                "cost": "",
                "price": "5.49",
                "large_price": "5.49",
                "indining_price": "5.49",
                "indining_large_price": "5.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749538417077-generated-image-1749538417077-1.png",
                "is_enabled": "true",
                "product_description": "Garlic Bread Supreme features toasted bread topped with garlic, herbs, melted cheese, and optional toppings for a flavorful appetizer.",
                "level1_category": "Starters & Small Plates",
                "level2_category": "Breads & Flatbreads",
                "Nutrients": "Rich in carbohydrates, fats, and calcium from cheese.",
                "appearance": "Golden-brown toasted bread with melted cheese and sprinkled herbs on top.",
                "ingredients": "Bread, garlic, butter, cheese, herbs, optional toppings like olives or peppers.",
                "serving": "Best enjoyed warm with dips or as a side to pasta dishes.",
                "flavors": "Garlic, buttery, cheesy, herby with savory notes.",
                "variations": "Can include additional toppings like olives, peppers, or extra cheese.",
                "allergy_info": "Contains gluten, dairy, and garlic; may cause allergies in sensitive individuals.",
                "Calories": "Approximately 250-350 kcal per serving",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Classic Margherita, Four Cheese Melt Pizza, Veggie Supreme\",\"best_combo\":\"Complementary flavors and vegetarian options enhance garlic bread.\",\"best_combo_ids\":\"PIZ0001\"}",
                "is_deleted": "false",
                "food_type": "non_veg",
                "is_spice_applicable": "yes",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "3ee80a6b-a932-4ccb-a02f-377a91683824",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0024",
                "name": "Classic Pepsi ",
                "category": "Beverages",
                "supplier": "",
                "brand": "",
                "modifiers": "Classic Pepsi addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Classic Pepsi is a carbonated soft drink with a sweet, crisp flavor, known for its refreshing taste and iconic branding.",
                "comment": "",
                "cost": "",
                "price": "2.49",
                "large_price": "2.49",
                "indining_price": "2.49",
                "indining_large_price": "2.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749538665032-generated-image-1749538665032-1.png",
                "is_enabled": "true",
                "product_description": "Classic Pepsi is a carbonated soft drink with a sweet, crisp flavor, known for its refreshing taste and iconic branding.",
                "level1_category": "Beverages",
                "level2_category": "Beverages",
                "Nutrients": "Provides quick energy from sugars; no significant nutrients.",
                "appearance": "Clear, dark caramel-colored liquid in a transparent bottle or can.",
                "ingredients": "Carbonated water, high fructose corn syrup, caramel color, phosphoric acid, caffeine, natural flavors.",
                "serving": "Best served chilled in a glass or can, often with ice.",
                "flavors": "Sweet, caramel, slightly citrusy, fizzy.",
                "variations": "Diet Pepsi, Pepsi Max, flavored variants like cherry or vanilla.",
                "allergy_info": "Contains caffeine; may cause sensitivity in some individuals.",
                "Calories": "Approximately 150 kcal per 12 oz can.",
                "is_vegan": "yes",
                "best_combo": "{\"best_name\":\"Garlic Bread Supreme, Chicken Wings (6 pcs), Potato Wedges\",\"best_combo\":\"Classic Pepsi complements savory sides and crispy appetizers well.\",\"best_combo_ids\":\"PIZ0021,PIZ0022\"}",
                "is_deleted": "false",
                "food_type": "veg",
                "is_spice_applicable": "no",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "3c127c52-479a-4f61-b36f-9365af4bd8bb",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0025",
                "name": "Classic Coke",
                "category": "Beverages",
                "supplier": "",
                "brand": "",
                "modifiers": "Classic  Coke addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Classic Coke is a carbonated soft drink with a sweet, caramel flavor, known for its refreshing and bubbly taste.",
                "comment": "",
                "cost": "",
                "price": "2.49",
                "large_price": "2.49",
                "indining_price": "2.49",
                "indining_large_price": "2.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749538739474-generated-image-1749538739474-1.png",
                "is_enabled": "true",
                "product_description": "Classic Coke is a carbonated soft drink with a sweet, caramel flavor, known for its refreshing and bubbly taste.",
                "level1_category": "Beverages",
                "level2_category": "Beverages",
                "Nutrients": "Provides quick energy from sugars; no significant nutrients.",
                "appearance": "Clear, dark brown liquid with a fizzy, bubbly effervescence.",
                "ingredients": "Carbonated water, caramel color, high fructose corn syrup, phosphoric acid, natural flavors, caffeine",
                "serving": "Best served chilled in a glass or can, with ice if desired.",
                "flavors": "Sweet, caramel, slightly acidic, fizzy",
                "variations": "Diet Coke, Coca-Cola Zero Sugar, flavored variants like cherry or vanilla",
                "allergy_info": "Contains caffeine; no common allergens but not suitable for caffeine-sensitive individuals.",
                "Calories": "Approximately 140 kcal per 12 oz (355 ml) can",
                "is_vegan": "yes",
                "best_combo": "{\"best_name\":\"Classic Margherita, Garlic Bread Supreme, Chicken Wings (6 pcs)\",\"best_combo\":\"Light, savory, and crispy options complement the refreshing Classic Coke.\",\"best_combo_ids\":\"PIZ0001,PIZ0021\"}",
                "is_deleted": "false",
                "food_type": "veg",
                "is_spice_applicable": "no",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "b3d1ed75-e9df-45d0-a393-fbc1109c0aaa",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0003",
                "name": "Veggie Supreme ",
                "category": "Starters & Small Plates",
                "supplier": "",
                "brand": "",
                "modifiers": "Veggie Supreme addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Veggie Supreme is a hearty vegetarian pizza topped with a variety of fresh vegetables and melted cheese, offering a flavorful and satisfying meal.",
                "comment": "",
                "cost": "",
                "price": "12.49",
                "large_price": "12.49",
                "indining_price": "12.49",
                "indining_large_price": "12.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749534377844-generated-image-1749534377844-1.png",
                "is_enabled": "true",
                "product_description": "Veggie Supreme is a hearty vegetarian pizza topped with a variety of fresh vegetables and melted cheese, offering a flavorful and satisfying meal.",
                "level1_category": "Starters & Small Plates",
                "level2_category": "Breads & Flatbreads",
                "Nutrients": "Rich in vitamins from vegetables and calcium from cheese.",
                "appearance": "Colorful pizza with vibrant vegetable toppings and melted cheese crust.",
                "ingredients": "Tomatoes, bell peppers, onions, olives, cheese, pizza dough, herbs.",
                "serving": "Best enjoyed hot with a side of garlic bread or salad.",
                "flavors": "Savory, cheesy, with fresh vegetable notes.",
                "variations": "Can be made vegan by substituting cheese with plant-based options.",
                "allergy_info": "Contains dairy and gluten; may cause allergies in sensitive individuals.",
                "Calories": "Approximately 250-350 kcal per slice.",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Classic Margherita\",\"best_combo\":\"Both are vegetarian options with complementary flavors.\",\"best_combo_ids\":\"PIZ0001\"}",
                "is_deleted": "false",
                "food_type": "veg",
                "is_spice_applicable": "no",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              }
            ],
            "combo_price": "$74.60",
            "offer_percentage": "10.0",
            "combo_image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1750248161811-generated-image-1750248161811-1.png",
            "item_id": "",
            "is_enabled": true,
            "created_date": "2025-09-09 12-35-13"
          },
          {
            "combo_id": "50ca99a0-b58f-4761-874e-9cab164af716",
            "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
            "title": "Hunger Buster Combo",
            "description": "A satisfying selection of flavorful pizzas, crispy sides, and refreshing beverages, perfect for a hearty meal. Includes cheesy, meaty, vegetarian, and spicy options complemented by classic drinks and sides for a complete dining experience.",
            "products": [
              {
                "pk_id": "c8dee61d-9d99-407d-85c8-a2ebe87e9a14",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0006",
                "name": "Pepperoni Passion ",
                "category": "Starters & Small Plates",
                "supplier": "",
                "brand": "",
                "modifiers": "Pepperoni Passion addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Pepperoni Passion is a classic pizza topped with spicy pepperoni slices, melted cheese, and savory tomato sauce, offering a flavorful and satisfying experience.",
                "comment": "",
                "cost": "",
                "price": "12.99",
                "large_price": "12.99",
                "indining_price": "12.99",
                "indining_large_price": "12.99",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749534684345-generated-image-1749534684345-1.png",
                "is_enabled": "true",
                "product_description": "Pepperoni Passion is a classic pizza topped with spicy pepperoni slices, melted cheese, and savory tomato sauce, offering a flavorful and satisfying experience.",
                "level1_category": "Starters & Small Plates",
                "level2_category": "Appetizers / Starters",
                "Nutrients": "Rich in protein, calcium, and fats from cheese and meat toppings.",
                "appearance": "Golden-brown crust topped with vibrant red pepperoni slices and melted cheese.",
                "ingredients": "Dough, tomato sauce, mozzarella cheese, pepperoni slices, herbs.",
                "serving": "Best enjoyed hot with a side of garlic bread or salad.",
                "flavors": "Savory, spicy, cheesy, and slightly smoky.",
                "variations": "Can be made with different cheeses or vegetarian toppings.",
                "allergy_info": "Contains gluten, dairy, and processed meats; may cause allergies in sensitive individuals.",
                "Calories": "Approximately 300-400 kcal per slice.",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Meat Lover's Delight Pizza, BBQ Chicken Feast Pizza\",\"best_combo\":\"Rich, meaty flavors complement Pepperoni Passion well\",\"best_combo_ids\":\"PIZ0002,PIZ0005\"}",
                "is_deleted": "false",
                "food_type": "non_veg",
                "is_spice_applicable": "yes",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "0a3516ef-4805-4352-bc77-2c7a5c521167",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0019",
                "name": "Cheeseburger Pizza ",
                "category": "Starters & Small Plates",
                "supplier": "",
                "brand": "",
                "modifiers": "Cheeseburger Pizza addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Cheeseburger Pizza combines the flavors of a classic cheeseburger with a crispy pizza crust, topped with beef, cheese, and condiments for a savory experience.",
                "comment": "",
                "cost": "",
                "price": "14.99",
                "large_price": "14.99",
                "indining_price": "14.989",
                "indining_large_price": "14.99",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749537181694-generated-image-1749537179953-4.png",
                "is_enabled": "true",
                "product_description": "Cheeseburger Pizza combines the flavors of a classic cheeseburger with a crispy pizza crust, topped with beef, cheese, and condiments for a savory experience.",
                "level1_category": "Starters & Small Plates",
                "level2_category": "Appetizers / Starters",
                "Nutrients": "Rich in protein, calcium, and fats; provides energy and muscle support.",
                "appearance": "Golden-brown pizza crust topped with melted cheese, beef patties, and burger toppings.",
                "ingredients": "Pizza dough, beef patties, cheese, ketchup, mustard, pickles, onions, lettuce.",
                "serving": "Best enjoyed hot with a side of fries or salad.",
                "flavors": "Savory, cheesy, tangy, with beefy richness.",
                "variations": "Add bacon, jalapeños, or switch to plant-based patties.",
                "allergy_info": "Contains dairy, gluten, and beef; may cause allergies in sensitive individuals.",
                "Calories": "Approximately 600-800 kcal per slice.",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Loaded Paneer Paradise Pizza, Four Cheese Melt Pizza\",\"best_combo\":\"Rich cheesy and flavorful options complement the cheeseburger pizza well.\",\"best_combo_ids\":\"PIZ0015\"}",
                "is_deleted": "false",
                "food_type": "non_veg",
                "is_spice_applicable": "yes",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "02d9711e-2365-476c-9174-2ba463aa3636",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0015",
                "name": "Loaded Paneer Paradise Pizza",
                "category": "Starters & Small Plates",
                "supplier": "",
                "brand": "",
                "modifiers": "Loaded Paneer Paradise",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Loaded Paneer Paradise Pizza features a crispy crust topped with spiced paneer, fresh vegetables, and melted cheese, offering a flavorful vegetarian delight.",
                "comment": "",
                "cost": "",
                "price": "13.99",
                "large_price": "13.99",
                "indining_price": "13.99",
                "indining_large_price": "13.99",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749536855344-generated-image-1749536854924-2.png",
                "is_enabled": "true",
                "product_description": "Loaded Paneer Paradise Pizza features a crispy crust topped with spiced paneer, fresh vegetables, and melted cheese, offering a flavorful vegetarian delight.",
                "level1_category": "Starters & Small Plates",
                "level2_category": "Breads & Flatbreads",
                "Nutrients": "Rich in protein from paneer, calcium, vitamins from vegetables",
                "appearance": "Golden-brown crust with colorful toppings and melted cheese, garnished with herbs.",
                "ingredients": "Paneer, cheese, bell peppers, onions, tomato sauce, spices, herbs, dough",
                "serving": "Best enjoyed hot with a side of green chutney or salad.",
                "flavors": "Savory, cheesy, mildly spicy with aromatic herbs",
                "variations": "Vegan cheese, gluten-free crust, extra vegetables",
                "allergy_info": "Contains dairy and gluten; may cause allergies in sensitive individuals.",
                "Calories": "Approximately 300-400 kcal per slice",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Veggie Supreme, Mediterranean Veggie, Spicy Veggie Volcano\",\"best_combo\":\"Complementary veggie flavors enhance the paneer pizza experience.\",\"best_combo_ids\":\"PIZ0011,PIZ0008\"}",
                "is_deleted": "false",
                "food_type": "veg",
                "is_spice_applicable": "yes",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "ee2aa8fb-01ae-4cdc-8824-843577ea49cd",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0022",
                "name": "Potato Wedges",
                "category": "Sides & Accompaniments",
                "supplier": "",
                "brand": "",
                "modifiers": "Potato Wedges addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Crispy potato wedges are thick-cut potatoes seasoned and baked or fried until golden and crunchy, perfect as a snack or side.",
                "comment": "",
                "cost": "",
                "price": "4.99",
                "large_price": "4.99",
                "indining_price": "4.99",
                "indining_large_price": "4.99",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749538548266-generated-image-1749538548266-1.png",
                "is_enabled": "true",
                "product_description": "Crispy potato wedges are thick-cut potatoes seasoned and baked or fried until golden and crunchy, perfect as a snack or side.",
                "level1_category": "Sides & Accompaniments",
                "level2_category": "Side Dishes",
                "Nutrients": "Rich in carbohydrates and vitamin C, moderate in fiber.",
                "appearance": "Golden-brown, wedge-shaped potatoes with a crispy exterior and fluffy interior.",
                "ingredients": "Potatoes, Olive oil, Salt, Pepper, Paprika, Garlic powder, Herbs",
                "serving": "Best enjoyed with ketchup, aioli, or spicy dips.",
                "flavors": "Savory, Crispy, Slightly smoky with hints of herbs.",
                "variations": "Can be seasoned with cheese, chili, or served with different dips.",
                "allergy_info": "Contains potatoes; check for cross-contamination with gluten or dairy if applicable.",
                "Calories": "Approximately 150-250 kcal per serving",
                "is_vegan": "yes",
                "best_combo": "{\"best_name\":\"Garlic Bread Supreme, Chicken Wings (6 pcs)\",\"best_combo\":\"Perfect sides with potato wedges for added flavor and variety.\",\"best_combo_ids\":\"PIZ0021\"}",
                "is_deleted": "false",
                "food_type": "veg",
                "is_spice_applicable": "yes",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "7f25523c-9de7-4112-a346-55c0acefc8da",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0023",
                "name": "Tandoori Chicken Bites",
                "category": "Entrees",
                "supplier": "",
                "brand": "",
                "modifiers": "Tandoori Chicken Bites addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Tandoori Chicken Bites are tender, marinated chicken pieces cooked in a traditional tandoor, offering smoky and spicy flavors in bite-sized form.",
                "comment": "",
                "cost": "",
                "price": "7.49",
                "large_price": "7.49",
                "indining_price": "7.49",
                "indining_large_price": "7.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749538600422-generated-image-1749538599121-4.png",
                "is_enabled": "true",
                "product_description": "Tandoori Chicken Bites are tender, marinated chicken pieces cooked in a traditional tandoor, offering smoky and spicy flavors in bite-sized form.",
                "level1_category": "Entrees",
                "level2_category": "Specialty Meat Dishes",
                "Nutrients": "High in protein, rich in vitamins and minerals from spices.",
                "appearance": "Golden-brown, charred edges with vibrant red spice coating, served in small pieces.",
                "ingredients": "Chicken,Yogurt,Spices,Garlic,Ginger,Salt,Oil,Red chili powder",
                "serving": "Best enjoyed with mint chutney or yogurt dip.",
                "flavors": "Spicy,Smoky,Tangy",
                "variations": "Can be made vegan with plant-based chicken substitutes.",
                "allergy_info": "Contains dairy and spices; may cause allergies in sensitive individuals.",
                "Calories": "Approximately 150-200 kcal per serving",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Chicken Tikka Pizza, Garlic Bread Supreme\",\"best_combo\":\"Complementary flavors of tandoori spices and garlic bread enhance the meal.\",\"best_combo_ids\":\"PIZ0004\"}",
                "is_deleted": "false",
                "food_type": "non_veg",
                "is_spice_applicable": "yes",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "3ee80a6b-a932-4ccb-a02f-377a91683824",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0024",
                "name": "Classic Pepsi ",
                "category": "Beverages",
                "supplier": "",
                "brand": "",
                "modifiers": "Classic Pepsi addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Classic Pepsi is a carbonated soft drink with a sweet, crisp flavor, known for its refreshing taste and iconic branding.",
                "comment": "",
                "cost": "",
                "price": "2.49",
                "large_price": "2.49",
                "indining_price": "2.49",
                "indining_large_price": "2.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749538665032-generated-image-1749538665032-1.png",
                "is_enabled": "true",
                "product_description": "Classic Pepsi is a carbonated soft drink with a sweet, crisp flavor, known for its refreshing taste and iconic branding.",
                "level1_category": "Beverages",
                "level2_category": "Beverages",
                "Nutrients": "Provides quick energy from sugars; no significant nutrients.",
                "appearance": "Clear, dark caramel-colored liquid in a transparent bottle or can.",
                "ingredients": "Carbonated water, high fructose corn syrup, caramel color, phosphoric acid, caffeine, natural flavors.",
                "serving": "Best served chilled in a glass or can, often with ice.",
                "flavors": "Sweet, caramel, slightly citrusy, fizzy.",
                "variations": "Diet Pepsi, Pepsi Max, flavored variants like cherry or vanilla.",
                "allergy_info": "Contains caffeine; may cause sensitivity in some individuals.",
                "Calories": "Approximately 150 kcal per 12 oz can.",
                "is_vegan": "yes",
                "best_combo": "{\"best_name\":\"Garlic Bread Supreme, Chicken Wings (6 pcs), Potato Wedges\",\"best_combo\":\"Classic Pepsi complements savory sides and crispy appetizers well.\",\"best_combo_ids\":\"PIZ0021,PIZ0022\"}",
                "is_deleted": "false",
                "food_type": "veg",
                "is_spice_applicable": "no",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "aa22f37a-04c0-457c-a9d8-65a1c3abcd9e",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0032",
                "name": "Brownie Bites (4 pcs)",
                "category": "Desserts & Sweets",
                "supplier": "",
                "brand": "",
                "modifiers": "Brownie Bites",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Delicious mini chocolate brownies, moist and fudgy, served in bite-sized pieces perfect for snacking or dessert.",
                "comment": "",
                "cost": "",
                "price": "5.99",
                "large_price": "5.99",
                "indining_price": "5.99",
                "indining_large_price": "5.99",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749539240250-generated-image-1749539231138-4.png",
                "is_enabled": "true",
                "product_description": "Delicious mini chocolate brownies, moist and fudgy, served in bite-sized pieces perfect for snacking or dessert.",
                "level1_category": "Desserts & Sweets",
                "level2_category": "Pastries & Cakes",
                "Nutrients": "Provides energy from sugars and fats, contains antioxidants from chocolate.",
                "appearance": "Small, square, rich brown bites with a glossy chocolate glaze on top.",
                "ingredients": "Chocolate, Flour, Butter, Sugar, Eggs, Cocoa powder, Vanilla extract",
                "serving": "Best enjoyed with a scoop of ice cream or a glass of milk.",
                "flavors": "Rich, Chocolatey, Sweet, Fudgy",
                "variations": "Add nuts, caramel swirls, or vegan chocolate options.",
                "allergy_info": "Contains gluten, dairy, and eggs; may cause allergic reactions.",
                "Calories": "Approximately 150-200 kcal per piece",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Choco Lava Cake, Ice Cream Sundae\",\"best_combo\":\"Rich desserts complement the chocolatey brownie bites perfectly.\",\"best_combo_ids\":\"PIZ0028,PIZ0029\"}",
                "is_deleted": "false",
                "food_type": "non_veg",
                "is_spice_applicable": "no",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "179e17e7-da1c-4b6f-a792-d984cdc177fa",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0031",
                "name": " Cheesecake Slice",
                "category": "Desserts & Sweets",
                "supplier": "",
                "brand": "",
                "modifiers": "Cheesecake Slice",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "A rich, creamy dessert with a smooth cheese filling on a buttery crust, topped with fruit or glaze for added flavor.",
                "comment": "",
                "cost": "",
                "price": "5.99",
                "large_price": "5.99",
                "indining_price": "5.99",
                "indining_large_price": "5.99",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749539157355-generated-image-1749539156897-2.png",
                "is_enabled": "true",
                "product_description": "A rich, creamy dessert with a smooth cheese filling on a buttery crust, topped with fruit or glaze for added flavor.",
                "level1_category": "Desserts & Sweets",
                "level2_category": "Pastries & Cakes",
                "Nutrients": "Rich in calcium, protein, and fats; high in calories",
                "appearance": "A triangular slice with a smooth, creamy surface and a graham cracker crust base.",
                "ingredients": "Cream cheese, sugar, eggs, graham cracker crust, vanilla extract, sour cream",
                "serving": "Best enjoyed chilled, topped with fresh fruit or fruit compote.",
                "flavors": "Sweet, tangy, creamy with hints of vanilla and buttery crust",
                "variations": "Chocolate, fruit-topped, no-bake, vegan options available",
                "allergy_info": "Contains dairy and eggs; may cause allergies in sensitive individuals",
                "Calories": "Approximately 300-400 kcal per slice",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Choco Lava Cake, Ice Cream Sundae\",\"best_combo\":\"Rich desserts complement the creamy cheesecake perfectly.\",\"best_combo_ids\":\"PIZ0028,PIZ0029\"}",
                "is_deleted": "false",
                "food_type": "non_veg",
                "is_spice_applicable": "no",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              },
              {
                "pk_id": "dcbe286c-43c2-4f27-b9aa-8a339344f0c7",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0016",
                "name": "Buffalo Chicken Blast Pizza",
                "category": "Starters & Small Plates",
                "supplier": "",
                "brand": "",
                "modifiers": "Buffalo Chicken Blast addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Buffalo Chicken Blast Pizza features a crispy crust topped with spicy buffalo sauce, tender chicken, and melty cheese, offering a bold flavor experience.",
                "comment": "",
                "cost": "",
                "price": "13.49",
                "large_price": "13.49",
                "indining_price": "13.49",
                "indining_large_price": "13.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749536945765-generated-image-1749536944781-3.png",
                "is_enabled": "true",
                "product_description": "Buffalo Chicken Blast Pizza features a crispy crust topped with spicy buffalo sauce, tender chicken, and melty cheese, offering a bold flavor experience.",
                "level1_category": "Starters & Small Plates",
                "level2_category": "Appetizers / Starters",
                "Nutrients": "Rich in protein and calcium, moderate in fats and carbs.",
                "appearance": "Golden-brown crust with vibrant red buffalo sauce, chicken pieces, and melted cheese topping.",
                "ingredients": "Pizza dough, chicken, buffalo sauce, cheese, blue cheese, celery, ranch dressing",
                "serving": "Best enjoyed hot with a side of celery sticks or ranch dressing.",
                "flavors": "Spicy, tangy, cheesy, savory",
                "variations": "Can be made with plant-based chicken or less spicy sauce.",
                "allergy_info": "Contains dairy, gluten, and possible soy; may cause allergies in sensitive individuals.",
                "Calories": "Approximately 300-400 kcal per slice",
                "is_vegan": "no",
                "best_combo": "{\"best_name\":\"Meat Lover's Delight Pizza,BBQ Chicken Feast Pizza,Spicy Veggie Volcano\",\"best_combo\":\"Enhances spicy and meaty flavors, creating a bold, satisfying combo.\",\"best_combo_ids\":\"PIZ0002,PIZ0005,PIZ0008\"}",
                "is_deleted": "false",
                "food_type": "non_veg",
                "is_spice_applicable": "yes",
                "meal_time": "",
                "inventory_status": "true",
                "is_item_verified": "true",
                "account_id": ""
              }
            ],
            "combo_price": "$74.17",
            "offer_percentage": "10.0",
            "combo_image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1750249766723-generated-image-1750249761907-3.png",
            "item_id": "",
            "is_enabled": true,
            "created_date": "2025-09-09 12-35-13"
          },
          {
            "combo_id": "b902f691-9bfd-4225-aa32-aa701786bbf4",
            "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
            "title": "Spicy Crust Combo",
            "description": "The Spicy Crust Combo typically features a pizza with a flavorful, spicy crust that adds an extra kick to your favorite toppings. It often includes a variety of ingredients like spicy sausage, jalapeños, pepperoni, or other bold flavors, all served on a crust that’s seasoned with spices to enhance the heat and taste. This combo is perfect for those who enjoy a fiery twist on their pizza. For specific details or to customize your order, please check with your local pizzeria or restaurant.",
            "products": [
              {
                "pk_id": "f03c1c36-597d-4afc-ab37-3700b0f70d35",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0001",
                "name": "Classic Margherita",
                "category": "Starters & Small Plates",
                "supplier": "",
                "brand": "",
                "modifiers": "Classic Margherita addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Classic Margherita is a traditional Italian pizza featuring a thin crust topped with fresh tomatoes, mozzarella, basil, and olive oil, offering a simple yet flavorful experience.",
                "comment": "",
                "cost": "",
                "price": "10.99",
                "large_price": "10.99",
                "indining_price": "10.99",
                "indining_large_price": "10.99",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1750428613430-generated-image-1750428613430-1.png",
                "is_enabled": true,
                "product_description": "A Margherita pizza is a classic Italian dish known for its simple yet flavorful ingredients. It typically features a thin, crisp crust topped with a vibrant tomato sauce made from fresh, ripe tomatoes. The pizza is adorned with slices of fresh mozzarella cheese that melt beautifully during baking, creating a creamy texture. Fresh basil leaves are added on top, providing a fragrant, herbal aroma and a splash of color. Often finished with a drizzle of extra virgin olive oil, the Margherita pizza embodies a harmonious balance of fresh, high-quality ingredients, highlighting the essence of traditional Italian cuisine.",
                "level1_category": "Starters & Small Plates",
                "level2_category": "Breads & Flatbreads",
                "Nutrients": "Rich in calcium, protein, and antioxidants from fresh ingredients.",
                "appearance": "Golden-brown thin crust with vibrant red tomatoes, white mozzarella, and green basil leaves.",
                "ingredients": "Flour, tomatoes, mozzarella cheese, basil, olive oil, salt, yeast",
                "serving": "Best enjoyed hot with a drizzle of olive oil or fresh basil leaves.",
                "flavors": "Fresh, Savory, Herbaceous",
                "variations": "Add extra toppings like prosciutto or chili flakes for variation.",
                "allergy_info": "Contains gluten, dairy, and basil; may affect allergies.",
                "Calories": "Approximately 250-300 kcal per slice",
                "is_vegan": "no",
                "best_combo": [],
                "is_deleted": false,
                "food_type": "veg",
                "is_spice_applicable": "no",
                "meal_time": "",
                "inventory_status": true,
                "is_item_verified": true,
                "account_id": "",
                "party_orders": [
                  {
                    "name": "small",
                    "serving": "10",
                    "price": "109.90"
                  },
                  {
                    "name": "medium",
                    "serving": "25",
                    "price": "274.75"
                  },
                  {
                    "name": "large",
                    "serving": "50",
                    "price": "549.50"
                  }
                ],
                "modifiers_list": [
                  {
                    "name": "Classic Margherita addon",
                    "is_multi_select": "No",
                    "is_forced": "Yes",
                    "options": [
                      {
                        "name": "Extra cheese",
                        "price": "$1.25",
                        "isEnabled": true
                      },
                      {
                        "name": "Cherry tomatoes",
                        "price": "$0.75",
                        "isEnabled": true
                      },
                      {
                        "name": "Garlic crust",
                        "price": "$1.50",
                        "isEnabled": true
                      },
                      {
                        "name": "Arugula",
                        "price": "$0.75",
                        "isEnabled": true
                      }
                    ]
                  }
                ]
              },
              {
                "pk_id": "b3d1ed75-e9df-45d0-a393-fbc1109c0aaa",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0003",
                "name": "Veggie Supreme ",
                "category": "Starters & Small Plates",
                "supplier": "",
                "brand": "",
                "modifiers": "Veggie Supreme addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Veggie Supreme is a hearty vegetarian pizza topped with a variety of fresh vegetables and melted cheese, offering a flavorful and satisfying meal.",
                "comment": "",
                "cost": "",
                "price": "12.49",
                "large_price": "12.49",
                "indining_price": "12.49",
                "indining_large_price": "12.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749534377844-generated-image-1749534377844-1.png",
                "is_enabled": true,
                "product_description": "Veggie Supreme is a hearty vegetarian pizza topped with a variety of fresh vegetables and melted cheese, offering a flavorful and satisfying meal.",
                "level1_category": "Starters & Small Plates",
                "level2_category": "Breads & Flatbreads",
                "Nutrients": "Rich in vitamins from vegetables and calcium from cheese.",
                "appearance": "Colorful pizza with vibrant vegetable toppings and melted cheese crust.",
                "ingredients": "Tomatoes, bell peppers, onions, olives, cheese, pizza dough, herbs.",
                "serving": "Best enjoyed hot with a side of garlic bread or salad.",
                "flavors": "Savory, cheesy, with fresh vegetable notes.",
                "variations": "Can be made vegan by substituting cheese with plant-based options.",
                "allergy_info": "Contains dairy and gluten; may cause allergies in sensitive individuals.",
                "Calories": "Approximately 250-350 kcal per slice.",
                "is_vegan": "no",
                "best_combo": {
                  "best_name": "Classic Margherita",
                  "best_combo": "Both are vegetarian options with complementary flavors.",
                  "best_combo_ids": "PIZ0001"
                },
                "is_deleted": false,
                "food_type": "veg",
                "is_spice_applicable": "no",
                "meal_time": "",
                "inventory_status": true,
                "is_item_verified": true,
                "account_id": "",
                "party_orders": [
                  {
                    "name": "small",
                    "serving": "10",
                    "price": "124.90"
                  },
                  {
                    "name": "medium",
                    "serving": "25",
                    "price": "312.25"
                  },
                  {
                    "name": "large",
                    "serving": "50",
                    "price": "624.50"
                  }
                ],
                "modifiers_list": [
                  {
                    "name": "Veggie Supreme addon",
                    "is_multi_select": "No",
                    "is_forced": "Yes",
                    "options": [
                      {
                        "name": "Spinach",
                        "price": "$0.75",
                        "isEnabled": true
                      },
                      {
                        "name": "feta",
                        "price": "$1.50",
                        "isEnabled": true
                      },
                      {
                        "name": "pesto swirl",
                        "price": "$1.50",
                        "isEnabled": true
                      }
                    ]
                  }
                ]
              },
              {
                "pk_id": "4f60847b-b066-4754-81c8-330f11095786",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0007",
                "name": "Hawaiian Classic Pizza",
                "category": "Entrees",
                "supplier": "",
                "brand": "",
                "modifiers": "Hawaiian Classic addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Hawaiian Classic Pizza features a crispy crust topped with tomato sauce, cheese, ham, and pineapple chunks, offering a sweet and savory flavor profile.",
                "comment": "",
                "cost": "",
                "price": "12.49",
                "large_price": "12.49",
                "indining_price": "12.49",
                "indining_large_price": "12.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749534761684-generated-image-1749534760104-4.png",
                "is_enabled": true,
                "product_description": "Hawaiian Classic Pizza features a crispy crust topped with tomato sauce, cheese, ham, and pineapple chunks, offering a sweet and savory flavor profile.",
                "level1_category": "Entrees",
                "level2_category": "Pizzas & Flatbreads",
                "Nutrients": "Provides carbs, protein, calcium, and vitamins from toppings.",
                "appearance": "Golden-brown crust with melted cheese, ham slices, and pineapple pieces on top.",
                "ingredients": "Pizza dough, tomato sauce, mozzarella cheese, ham, pineapple, olive oil, herbs.",
                "serving": "Best enjoyed hot with a side of garlic bread or salad.",
                "flavors": "Sweet, savory, cheesy, with a hint of tang from pineapple.",
                "variations": "Can add bacon, jalapeños, or substitute ham with turkey.",
                "allergy_info": "Contains dairy, gluten, and possibly soy; check for allergies.",
                "Calories": "Approximately 250-350 kcal per slice.",
                "is_vegan": "no",
                "best_combo": {
                  "best_name": "Meat Lover's Delight Pizza, BBQ Chicken Feast Pizza",
                  "best_combo": "Rich, savory flavors complement the sweet and savory Hawaiian pizza",
                  "best_combo_ids": "PIZ0002,PIZ0005"
                },
                "is_deleted": false,
                "food_type": "non_veg",
                "is_spice_applicable": "no",
                "meal_time": "",
                "inventory_status": true,
                "is_item_verified": true,
                "account_id": "",
                "party_orders": [
                  {
                    "name": "small",
                    "serving": "10",
                    "price": "124.90"
                  },
                  {
                    "name": "medium",
                    "serving": "25",
                    "price": "312.25"
                  },
                  {
                    "name": "large",
                    "serving": "50",
                    "price": "624.50"
                  }
                ],
                "modifiers_list": [
                  {
                    "name": "Hawaiian Classic addon",
                    "is_multi_select": "No",
                    "is_forced": "Yes",
                    "options": [
                      {
                        "name": "Bacon",
                        "price": "$1.75",
                        "isEnabled": true
                      },
                      {
                        "name": "red onions",
                        "price": "$0.60",
                        "isEnabled": true
                      },
                      {
                        "name": "sweet chili drizzle",
                        "price": "$0.60",
                        "isEnabled": true
                      },
                      {
                        "name": "spicy crust",
                        "price": "$1.25",
                        "isEnabled": true
                      }
                    ]
                  }
                ]
              }
            ],
            "combo_price": "$34.17",
            "offer_percentage": "5.0",
            "combo_image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1752215177271-generated-image-1752215176604-2.png",
            "item_id": "",
            "is_enabled": true,
            "created_date": "2025-09-09 12-35-13"
          },
          {
            "combo_id": "8a1b8f6b-00cc-46e7-b54f-53e98c404317",
            "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
            "title": "Veggie supreme",
            "description": "Introducing our Veggie Supreme Pizza Combo—an irresistible feast for your senses! Dive into a flavorful medley of fresh, crisp vegetables topped with gooey, melted cheese and our signature sauce, all nestled on a perfectly baked crust. The Veggie Supreme is a vibrant celebration of wholesome ingredients, crafted to satisfy both your cravings and your health-conscious choices. Paired with our refreshing, chilled Coke, this combo offers the perfect harmony of savory and fizzy delight. Whether you're sharing with friends or treating yourself, the Veggie Supreme Pizza Combo promises a deliciously satisfying experience that will leave you craving more!",
            "products": [
              {
                "pk_id": "3c127c52-479a-4f61-b36f-9365af4bd8bb",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0025",
                "name": "Classic Coke",
                "category": "Beverages",
                "supplier": "",
                "brand": "",
                "modifiers": "Classic  Coke addon",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Classic Coke is a carbonated soft drink with a sweet, caramel flavor, known for its refreshing and bubbly taste.",
                "comment": "",
                "cost": "",
                "price": "2.49",
                "large_price": "2.49",
                "indining_price": "2.49",
                "indining_large_price": "2.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749538739474-generated-image-1749538739474-1.png",
                "is_enabled": true,
                "product_description": "Classic Coke is a carbonated soft drink with a sweet, caramel flavor, known for its refreshing and bubbly taste.",
                "level1_category": "Beverages",
                "level2_category": "Beverages",
                "Nutrients": "Provides quick energy from sugars; no significant nutrients.",
                "appearance": "Clear, dark brown liquid with a fizzy, bubbly effervescence.",
                "ingredients": "Carbonated water, caramel color, high fructose corn syrup, phosphoric acid, natural flavors, caffeine",
                "serving": "Best served chilled in a glass or can, with ice if desired.",
                "flavors": "Sweet, caramel, slightly acidic, fizzy",
                "variations": "Diet Coke, Coca-Cola Zero Sugar, flavored variants like cherry or vanilla",
                "allergy_info": "Contains caffeine; no common allergens but not suitable for caffeine-sensitive individuals.",
                "Calories": "Approximately 140 kcal per 12 oz (355 ml) can",
                "is_vegan": "yes",
                "best_combo": {
                  "best_name": "Classic Margherita, Garlic Bread Supreme, Chicken Wings (6 pcs)",
                  "best_combo": "Light, savory, and crispy options complement the refreshing Classic Coke.",
                  "best_combo_ids": "PIZ0001,PIZ0021"
                },
                "is_deleted": false,
                "food_type": "veg",
                "is_spice_applicable": "no",
                "meal_time": "",
                "inventory_status": true,
                "is_item_verified": true,
                "account_id": "",
                "party_orders": [
                  {
                    "name": "small",
                    "serving": "12",
                    "price": "29.88"
                  },
                  {
                    "name": "medium",
                    "serving": "50",
                    "price": "124.50"
                  },
                  {
                    "name": "large",
                    "serving": "100",
                    "price": "249.00"
                  }
                ],
                "modifiers_list": [
                  {
                    "name": "Classic  Coke addon",
                    "is_multi_select": "No",
                    "is_forced": "Yes",
                    "pk_id": "f7b73e50-eae9-4329-9a7c-82aac702a1ab",
                    "options": [
                      {
                        "name": "Ice-free option",
                        "price": "$0",
                        "isEnabled": true
                      },
                      {
                        "name": "lemon twist",
                        "price": "$0.50",
                        "isEnabled": true
                      }
                    ]
                  }
                ]
              },
              {
                "pk_id": "b3d1ed75-e9df-45d0-a393-fbc1109c0aaa",
                "restaurant_id": "787717ca-2a8d-46f4-9f36-357fe47650b5",
                "restaurant_parent_id": null,
                "sku_id": "PIZ0003",
                "name": "Veggie Supreme ",
                "category": "Starters & Small Plates",
                "supplier": "",
                "brand": "",
                "modifiers": "",
                "unit": "",
                "taxable": "",
                "external_id": "",
                "bar_code": "",
                "description": "Veggie Supreme is a hearty vegetarian pizza topped with a variety of fresh vegetables and melted cheese, offering a flavorful and satisfying meal.",
                "comment": "",
                "cost": "",
                "price": "13",
                "large_price": "12.49",
                "indining_price": "1",
                "indining_large_price": "12.49",
                "quantity": "",
                "min_quantity": "",
                "max_quantity": "",
                "countable": "",
                "use_weighing_scale": "",
                "item_type": "",
                "duration": "",
                "discounts": "",
                "resources": "",
                "service_providers": "",
                "printer_type": "",
                "deposit": "",
                "visibility": "",
                "favorite": "",
                "sort_index": "",
                "tags": "",
                "out_of_stock": "",
                "image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1749534377844-generated-image-1749534377844-1.png",
                "is_enabled": true,
                "product_description": "Veggie Supreme is a hearty vegetarian pizza topped with a variety of fresh vegetables and melted cheese, offering a flavorful and satisfying meal.",
                "level1_category": "Starters & Small Plates",
                "level2_category": "Breads & Flatbreads",
                "Nutrients": "Rich in vitamins from vegetables and calcium from cheese.",
                "appearance": "Colorful pizza with vibrant vegetable toppings and melted cheese crust.",
                "ingredients": "Tomatoes, bell peppers, onions, olives, cheese, pizza dough, herbs.",
                "serving": "Best enjoyed hot with a side of garlic bread or salad.",
                "flavors": "Savory, cheesy, with fresh vegetable notes.",
                "variations": "Can be made vegan by substituting cheese with plant-based options.",
                "allergy_info": "Contains dairy and gluten; may cause allergies in sensitive individuals.",
                "Calories": "Approximately 250-350 kcal per slice.",
                "is_vegan": "no",
                "best_combo": {
                  "best_name": "Classic Margherita",
                  "best_combo": "Both are vegetarian options with complementary flavors.",
                  "best_combo_ids": "PIZ0001"
                },
                "is_deleted": false,
                "food_type": "veg",
                "is_spice_applicable": "Yes",
                "meal_time": "",
                "inventory_status": true,
                "is_item_verified": true,
                "account_id": "",
                "party_orders": [
                  {
                    "name": "small",
                    "serving": "10",
                    "price": "124.90"
                  },
                  {
                    "name": "medium",
                    "serving": "25",
                    "price": "312.25"
                  },
                  {
                    "name": "large",
                    "serving": "50",
                    "price": "624.50"
                  }
                ]
              }
            ],
            "combo_price": "$14.72",
            "offer_percentage": "5.0",
            "combo_image": "https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1754874940426-generated-image-1754874932453-4.png",
            "item_id": "",
            "is_enabled": true,
            "created_date": "2025-09-09 12-35-13"
          }]
        }
      },
      {
        "type": "PrimeExperience",
        "data": {
          "headerContent": "<h2 class='text-3xl md:text-4xl font-bold text-gray-900 text-center mb-6'>Our Experience</h2><p class='text-lg text-gray-600 text-center max-w-3xl mx-auto leading-relaxed'>Discover what makes our sample business special through our approach and dedication.</p>",
          "cards": [
            {
              "id": "1",
              "title": "Quality Service",
              "description": "We provide sample service to demonstrate the layout and structure for your website.",
              "icon": "⭐"
            },
            {
              "id": "2",
              "title": "Expert Team",
              "description": "Our sample team consists of placeholder professionals showcasing this section.",
              "icon": "👥"
            },
            {
              "id": "3",
              "title": "Innovation",
              "description": "This card shows how to highlight features like innovation using placeholder text.",
              "icon": "💡"
            },
            {
              "id": "4",
              "title": "Customer Focus",
              "description": "Your satisfaction is important; this is generic text demonstrating customer focus.",
              "icon": "🎯"
            }
          ],
          "backgroundColor": "#f9fafb"
        }

      },
      {
        "type": "BasicStory",
        "data": {
          "hero": {
            "image": "https://thumbs.dreamstime.com/b/unhealthy-fast-food-delivery-menu-featuring-assorted-burgers-cheeseburgers-nuggets-french-fries-soda-high-calorie-low-356045884.jpg",
            "title": "Our Story"
          },
          "title": "The Story of Our Sample Restaurant",
          "storyContent": "<p>Once upon a time, in a small bustling town, there was a cozy little sample restaurant. This is placeholder text describing the beginnings of the restaurant for demonstration purposes.</p><p>The chef had a passion for creating delicious meals and providing a warm atmosphere. With care and dedication, they opened this sample restaurant to share good food and joy with the community.</p><p>Our approach is simple: use fresh ingredients, prepare each dish thoughtfully, and serve it with a smile. This is sample content for the story section and can be replaced with real information later.</p>"
        }

      },
      {
        "type": "BasicBlog",
        "data": {
          "title": "<h2 class='text-3xl font-bold text-gray-900 mb-4'>Latest Blog Posts</h2>",
          "subtitle": "<p class='text-gray-600 text-lg'>Discover our latest stories and insights</p>",
          "posts": [
            {
              "id": "1",
              "title": "<h3 class='text-xl font-bold text-gray-900'>Sample Blog Post One</h3>",
              "content": "<p class='text-gray-700 leading-relaxed'>This is a placeholder content for a sample blog post. Replace it with your own text for actual blog entries.</p>",
              "excerpt": "<p class='text-gray-600'>This is a sample excerpt for the blog post.</p>",
              "image": "https://images.unsplash.com/photo-1499750310107-5fef28a66643?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8YmxvZ3xlbnwwfHwwfHx8MA%3D%3D",
              "date": "2024-01-01T00:00:00.000Z",
              "readTime": "5 min",
              "category": "Sample",
              "isEnabled": true
            },
            {
              "id": "2",
              "title": "<h3 class='text-xl font-bold text-gray-900'>Sample Blog Post Two</h3>",
              "content": "<p class='text-gray-700 leading-relaxed'>Another placeholder content for a sample blog post. Use this format to display blog content in preview mode.</p>",
              "excerpt": "<p class='text-gray-600'>This is a sample excerpt for the second blog post.</p>",
              "image": "https://images.unsplash.com/photo-1488190211105-8b0e65b80b4e?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
              "date": "2024-01-02T00:00:00.000Z",
              "readTime": "3 min",
              "category": "Sample",
              "isEnabled": true
            }
          ],
          "postsPerPage": 6,
          "showCategory": true,
          "showReadTime": true,
          "showAuthor": false,
          "backgroundColor": "#ffffff",
          "textColor": "#1f2937",
          "cardBackgroundColor": "#ffffff",
          "primaryColor": "#EF4444"
        }

      },
      {
        "type": "ModernGallery",
        "data": {
          "section": {
            "title": "Culinary Artistry",
            "subtitle": "A visual celebration of our gastronomic creations",
            "description": "Each dish is a canvas where flavors, textures, and visual beauty come together in perfect harmony."
          },
          "images": [
            {
              "id": "1",
              "url": "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=500&h=500&fit=crop",
              "title": "Elegant Presentation",
              "description": "Where artistry meets gastronomy",
              "isVisible": true
            },
            {
              "id": "2",
              "url": "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=500&h=500&fit=crop",
              "title": "Chef's Precision",
              "description": "Meticulous attention to every detail",
              "isVisible": true
            },
            {
              "id": "3",
              "url": "https://images.unsplash.com/photo-1540420773420-3366772f4999?w=500&h=500&fit=crop",
              "title": "Premium Ingredients",
              "description": "Only the finest seasonal selections",
              "isVisible": true
            },
            {
              "id": "4",
              "url": "https://images.unsplash.com/photo-1574071318508-1cdbab80d002?w=500&h=500&fit=crop",
              "title": "Sophisticated Ambiance",
              "description": "An atmosphere of refined elegance",
              "isVisible": true
            }
          ],
          "cta": {
            "text": "Follow @CulinaryJourney",
            "link": "https://instagram.com/culinaryjourney"
          }
        }

      },
      {
        "type": "ModernEvents",
        "data": {
          "isEnabled": true,
          "section": {
            "title": "Upcoming Events",
            "subtitle": "Stay tuned for our upcoming events!",
            "primaryColor": "#EF4444",
            "secondaryColor": "#DC2626",
            "accentColor": "#B91C1C",
            "textColor": "#374151"
          },
          "items": [
            {
              "id": "event-1",
              "title": "Sample Event",
              "description": "This is a placeholder description for a sample event. Event details will be updated soon.",
              "image": "https://thumbs.dreamstime.com/b/buffet-dinner-restaurant-catering-food-concept-66884106.jpg",
              "date": "2024-01-01",
              "time": "18:00",
              "location": "Sample Venue",
              "isVisible": true
            }
          ]
        }

      },
      {
        "type": "ModernContactForm",
        "data": {
          "title": "Contact Us",
          "subtitle": "We’d love to hear from you. This is sample text for demonstration purposes.",
          "primaryColor": "#E7000B",
          "textColor": "#1F2937",
          "backgroundColor": "#FFFFFF",
          "formBackgroundColor": "#F9FAFB",
          "cardBackgroundColor": "#FFFFFF",
          "submitButtonText": "SUBMIT",
          "successMessage": "Thank you for reaching out! This is a sample success message.",
          "errorMessage": "Oops! Something went wrong. Please try again later.",
          "contactInfo": {
            "email": {
              "title": "Email Us",
              "description": "Send us an email",
              "address": "info@sample.com"
            },
            "phone": {
              "title": "Call Us",
              "description": "Call us directly",
              "number": "(000) 000-0000"
            },
            "address": {
              "title": "Visit Us",
              "description": "Visit our office",
              "full": "123 Sample Street, Sample City, Country"
            }
          },
          "formFields": {
            "name": {
              "enabled": true,
              "required": true,
              "label": "Name",
              "placeholder": "Your Name"
            },
            "email": {
              "enabled": true,
              "required": true,
              "label": "Email",
              "placeholder": "Your Email"
            },
            "phone": {
              "enabled": true,
              "required": false,
              "label": "Phone",
              "placeholder": "Your Phone"
            },
            "message": {
              "enabled": true,
              "required": true,
              "label": "Message",
              "placeholder": "Your Message"
            }
          }
        }

      },
      {
        "type": "PrimeFooter",
        "data": {
          "restaurantName": "Sample Restaurant",
          "description": "<p>Welcome to our <strong>sample restaurant</strong>. Enjoy a delightful dining experience with <em>delicious meals</em>, friendly service, and a cozy atmosphere.</p>",
          "phone": "(000) 000-0000",
          "email": "info@samplerestaurant.com",
          "address": "123 Sample Street, Sample City, Country 00000",
          "hours": "Opening hours not available",
          "quickLinks": [
            { "id": "1", "label": "Menu", "url": "/menu" },
            { "id": "2", "label": "About Us", "url": "/about" },
            { "id": "3", "label": "Blog", "url": "/blog" },
            { "id": "4", "label": "Gallery", "url": "/gallery" },
            { "id": "5", "label": "Events", "url": "/events" },
            { "id": "6", "label": "Contact", "url": "/contact" }
          ],
          "socialLinks": [
            { "id": "1", "platform": "facebook", "url": "https://facebook.com/sample" },
            { "id": "2", "platform": "instagram", "url": "https://instagram.com/sample" },
            { "id": "3", "platform": "twitter", "url": "https://twitter.com/sample" }
          ],
          "newsletterTitle": "<h4 class=\"text-lg font-semibold\">Stay <span class=\"text-yellow-400\">Connected</span></h4>",
          "newsletterDescription": "<p>Subscribe to our newsletter for <strong>updates</strong>, <em>special offers</em>, and <strong>news</strong>.</p>",
          "showNewsletter": true,
          "copyrightText": "<p>© 2024 <strong>Sample Restaurant</strong>. All rights reserved.</p>",
          "legalLinks": [
            {
              "id": "1",
              "label": "Privacy Policy",
              "url": "/privacy",
              "content": "<p>This is a <strong>sample privacy policy</strong>. It explains how your data might be collected and used in a demo environment.</p>"
            },
            {
              "id": "2",
              "label": "Terms of Service",
              "url": "/terms",
              "content": "<p>These are <strong>sample terms of service</strong>. By using this demo, you agree to placeholder terms.</p>"
            },
            {
              "id": "3",
              "label": "Cookie Policy",
              "url": "/cookies",
              "content": "<p>This is a <strong>sample cookie policy</strong>. It describes the use of cookies in a demo context.</p>"
            }
          ],
           "backgroundColor": "#0f172a",
          "textColor": "#f1f5f9",
          "linkColor": "#f59e0b",
          "borderColor": "#EF4322"
        }

      }
    ]
  }
};

export const getTemplateData = (templateId: string) => {
  return templateData[templateId as keyof typeof templateData] || null;
};
